/*!
* The Bronson adaptation for the Generic Design
* @version v1.0.0-beta.33
* @link https://bronson.vwfs.tools
* @author Volkswagen Financial Services Digital Solutions GmbH
* @license LicenseRef-VWFS-Standard-License
* Copyright Â©2021 Volkswagen Financial Services Digital Solutions GmbH. All rights reserved.
*/
@charset "UTF-8";
/**
* Spacings are required settings for all brands (XXSMALL - XXLARGE).
* - Required to have all scales available in all brands (multibrand & one-markup-approach).
* - Used for generating of spacing utilities.
*/
/* stylelint-disable string-quotes */
/* stylelint-enable */
/* stylelint-disable string-quotes */
/* stylelint-enable */
/* ------------------------------------*\
#FORMS
\*------------------------------------ */
/**
* Spacings are required settings for all brands (XXSMALL - XXLARGE).
* - Required to have all scales available in all brands (multibrand & one-markup-approach).
* - Used for generating of spacing utilities.
*/
/* stylelint-disable string-quotes */
/* stylelint-enable */
/* stylelint-disable string-quotes */
/* stylelint-enable */
/* ------------------------------------*\
#FORMS
\*------------------------------------ */
/* stylelint-disable scss/media-feature-value-dollar-variable */
/* stylelint-enable scss/media-feature-value-dollar-variable */
/* stylelint-disable itcss/no-at-important */
/* stylelint-enable itcss/no-at-important */
/**
* Get alignment for flexbox-based modules.
* Remaps alignment (center, left, right) to flexbox values.
*/
 /**
 * [1] `transparent` does not work in iOS
 */
 /**
 * [1] Only overwrite the bottom and top spacing if a specific
 *     `$spacing-between-modules` is defined and it is different from
  *     `$spacing-vertical`.
  * [2] Raise specificity to overwrite `:first-child` and `:last-child` selectors
  *     of spacing-container mixin.
  */
 /* stylelint-disable plugin/no-unsupported-browser-features, value-list-comma-newline-after, value-list-comma-space-after, no-extra-semicolons */
 /* stylelint-enable */
 /**
 * [1] @deprecated: Unnecessary with the new markup.
  *     Provide a solid default resetting to the vertical alignment of the
  *     badge in an inline context inside of text.
  */
 /*
 * In IE11/Edge the shadow at the top/bottom does not disappear when scrolling
  * to the very top and bottom. What is even worse is that the bottom shadow is
  * not displayed when scrolled to the very top, so the indicator that the
  * container is scrollable, is missing. Therefore, the fallback for these two
  * browser is a static bottom shadow.
  */
 /**
 * Extract play-button styles to reusable mixin to reuse
  * in other modules without altering markup.
  */
  /**
  * [1] Center icon inside button.
  * [2] Overwrite plyr default.
  */
  /* ------------------------------------*\
     #BOX-SIZING
     \*------------------------------------ */
 /**
 * More sensible default box-sizing:
  * css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice
  */
$cdnUrl: 'https://cdn.bronson.vwfs.tools/generic/v/1.0.0-beta.30';

.dh-mfc {
    box-sizing: border-box;
    font-family: sans-serif;
    /* 1 */
    line-height: 1.15;
    /* 2 */
    -ms-text-size-adjust: 100%;
    /* 3 */
    -webkit-text-size-adjust: 100%;
    min-height: 100%;
    /* [1] */
    overflow-y: initial;
    /* [2] */
    font-family: "open-sans", sans-serif;
    /* [4] */
    background-color: #ffffff;
    /* [5] */
    color: #1a1a1a;
    /* [6] */
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    scroll-behavior: smooth;
    /* [7] */
    font-size: 1em;
    /* [3] */
    line-height: 1.5;
    /* [3] */
}

.dh-mfc {
 
 *, *::before, *::after {
   box-sizing: inherit;
}
 
 /*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */
 /* Document
    ========================================================================== */
 /**
  * 1. Change the default font family in all browsers (opinionated).
  * 2. Correct the line height in all browsers.
  * 3. Prevent adjustments of font size after orientation changes in
  *    IE on Windows Phone and in iOS.
  */
 /* Sections
    ========================================================================== */
 /**
  * Remove the margin in all browsers (opinionated).
  */
 body {
   margin: 0;
 }
 
 /**
  * Add the correct display in IE 9-.
  */
 article,
 aside,
 footer,
 header,
 nav,
 section {
   display: block;
 }
 
 /**
  * Correct the font size and margin on `h1` elements within `section` and
  * `article` contexts in Chrome, Firefox, and Safari.
  */
 h1 {
   font-size: 2em;
   margin: 0.67em 0;
 }
 
 /* Grouping content
    ========================================================================== */
 /**
  * Add the correct display in IE 9-.
  * 1. Add the correct display in IE.
  */
 figcaption,
 figure,
 main {
   /* 1 */
   display: block;
 }
 
 /**
  * Add the correct margin in IE 8.
  */
 figure {
   margin: 1em 40px;
 }
 
 /**
  * 1. Add the correct box sizing in Firefox.
  * 2. Show the overflow in Edge and IE.
  */
 hr {
   box-sizing: content-box;
   /* 1 */
   height: 0;
   /* 1 */
   overflow: visible;
   /* 2 */
 }
 
 /**
  * 1. Correct the inheritance and scaling of font size in all browsers.
  *    https://github.com/necolas/normalize.css/blob/master/README.md#pre-code-kbd-samp
  * 2. Correct the odd `em` font sizing in all browsers.
  */
 pre {
   font-family: monospace, monospace;
   /* 1 */
   font-size: 1em;
   /* 2 */
 }
 
 /* Text-level semantics
    ========================================================================== */
 /**
  * 1. Remove the gray background on active links in IE 10.
  * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
  */
 a {
   background-color: transparent;
   /* 1 */
   -webkit-text-decoration-skip: objects;
   /* 2 */
 }
 
 /**
  * Remove the outline on focused links when they are also active or hovered
  * in all browsers (opinionated).
  */
 a:active,
 a:hover {
   outline-width: 0;
 }
 
 /**
  * 1. Remove the bottom border in Firefox 39-.
  * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
  */
 abbr[title] {
   border-bottom: none;
   /* 1 */
   text-decoration: underline;
   /* 2 */
   -webkit-text-decoration: underline dotted;
   text-decoration: underline dotted;
   /* 2 */
 }
 
 /**
  * Prevent the duplicate application of `bolder` by the next rule in Safari 6.
  */
 b,
 strong {
   font-weight: inherit;
 }
 
 /**
  * Add the correct font weight in Chrome, Edge, and Safari.
  */
 b,
 strong {
   font-weight: bolder;
 }
 
 /**
  * 1. Correct the inheritance and scaling of font size in all browsers.
  *    https://github.com/necolas/normalize.css/blob/master/README.md#pre-code-kbd-samp
  * 2. Correct the odd `em` font sizing in all browsers.
  */
 code,
 kbd,
 samp {
   font-family: monospace, monospace;
   /* 1 */
   font-size: 1em;
   /* 2 */
 }
 
 /**
  * Add the correct font style in Android 4.3-.
  */
 dfn {
   font-style: italic;
 }
 
 /**
  * Add the correct background and color in IE 9-.
  */
 mark {
   background-color: #ff0;
   color: #000;
 }
 
 /**
  * Add the correct font size in all browsers.
  */
 small {
   font-size: 80%;
 }
 
 /**
  * Prevent `sub` and `sup` elements from affecting the line height in
  * all browsers.
  */
 sub,
 sup {
   font-size: 75%;
   line-height: 0;
   position: relative;
   vertical-align: baseline;
 }
 
 sub {
   bottom: -0.25em;
 }
 
 sup {
   top: -0.5em;
 }
 
 /* Embedded content
    ========================================================================== */
 /**
  * Add the correct display in IE 9-.
  */
 audio,
 video {
   display: inline-block;
 }
 
 /**
  * Add the correct display in iOS 4-7.
  */
 audio:not([controls]) {
   display: none;
   height: 0;
 }
 
 /**
  * Remove the border on images inside links in IE 10-.
  */
 img {
   border-style: none;
 }
 
 /**
  * Hide the overflow in IE.
  */
 svg:not(:root) {
   overflow: hidden;
 }
 
 /* Forms
    ========================================================================== */
 /**
  * 1. Change the font styles in all browsers (opinionated).
  * 2. Remove the margin in Firefox and Safari.
  */
 button,
 input,
 optgroup,
 select,
 textarea {
   font-family: sans-serif;
   /* 1 */
   font-size: 100%;
   /* 1 */
   line-height: 1.15;
   /* 1 */
   margin: 0;
   /* 2 */
 }
 
 /**
  * Show the overflow in IE.
  * 1. Show the overflow in Edge.
  */
 button,
 input {
   /* 1 */
   overflow: visible;
 }
 
 /**
  * Remove the inheritance of text transform in Edge, Firefox, and IE.
  * 1. Remove the inheritance of text transform in Firefox.
  */
 button,
 select {
   /* 1 */
   text-transform: none;
 }
 
 /**
  * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`
  *    controls in Android 4.
  * 2. Correct the inability to style clickable types in iOS and Safari.
  */
 button,
 html [type="button"],
 [type="reset"],
 [type="submit"] {
   -webkit-appearance: button;
   /* 2 */
 }
 
 /**
  * Remove the inner border and padding in Firefox.
  */
 button::-moz-focus-inner,
 [type="button"]::-moz-focus-inner,
 [type="reset"]::-moz-focus-inner,
 [type="submit"]::-moz-focus-inner {
   border-style: none;
   padding: 0;
 }
 
 /**
  * Restore the focus styles unset by the previous rule.
  */
 button:-moz-focusring,
 [type="button"]:-moz-focusring,
 [type="reset"]:-moz-focusring,
 [type="submit"]:-moz-focusring {
   outline: 1px dotted ButtonText;
 }
 
 /**
  * Change the border, margin, and padding in all browsers (opinionated).
  */
 fieldset {
   border: 1px solid #c0c0c0;
   margin: 0 2px;
   padding: 0.35em 0.625em 0.75em;
 }
 
 /**
  * 1. Correct the text wrapping in Edge and IE.
  * 2. Correct the color inheritance from `fieldset` elements in IE.
  * 3. Remove the padding so developers are not caught out when they zero out
  *    `fieldset` elements in all browsers.
  */
 legend {
   box-sizing: border-box;
   /* 1 */
   color: inherit;
   /* 2 */
   display: table;
   /* 1 */
   max-width: 100%;
   /* 1 */
   padding: 0;
   /* 3 */
   white-space: normal;
   /* 1 */
 }
 
 /**
  * 1. Add the correct display in IE 9-.
  * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
  */
 progress {
   display: inline-block;
   /* 1 */
   vertical-align: baseline;
   /* 2 */
 }
 
 /**
  * Remove the default vertical scrollbar in IE.
  */
 textarea {
   overflow: auto;
 }
 
 /**
  * 1. Add the correct box sizing in IE 10-.
  * 2. Remove the padding in IE 10-.
  */
 [type="checkbox"],
 [type="radio"] {
   box-sizing: border-box;
   /* 1 */
   padding: 0;
   /* 2 */
 }
 
 /**
  * Correct the cursor style of increment and decrement buttons in Chrome.
  */
 [type="number"]::-webkit-inner-spin-button,
 [type="number"]::-webkit-outer-spin-button {
   height: auto;
 }
 
 /**
  * 1. Correct the odd appearance in Chrome and Safari.
  * 2. Correct the outline style in Safari.
  */
 [type="search"] {
   -webkit-appearance: textfield;
   /* 1 */
   outline-offset: -2px;
   /* 2 */
 }
 
 /**
  * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.
  */
 [type="search"]::-webkit-search-cancel-button,
 [type="search"]::-webkit-search-decoration {
   -webkit-appearance: none;
 }
 
 /**
  * 1. Correct the inability to style clickable types in iOS and Safari.
  * 2. Change font properties to `inherit` in Safari.
  */
 ::-webkit-file-upload-button {
   -webkit-appearance: button;
   /* 1 */
   font: inherit;
   /* 2 */
 }
 
 /* Interactive
    ========================================================================== */
 /*
  * Add the correct display in IE 9-.
  * 1. Add the correct display in Edge, IE, and Firefox.
  */
 details,
 menu {
   display: block;
 }
 
 /*
  * Add the correct display in all browsers.
  */
 summary {
   display: list-item;
 }
 
 /* Scripting
    ========================================================================== */
 /**
  * Add the correct display in IE 9-.
  */
 canvas {
   display: inline-block;
 }
 
 /**
  * Add the correct display in IE.
  */
 template {
   display: none;
 }
 
 /* Hidden
    ========================================================================== */
 /**
  * Add the correct display in IE 10-.
  */
 [hidden] {
   display: none;
 }
 
 /* ------------------------------------*\
     #RESET
 \*------------------------------------ */
 /**
  * Besides using normalize.css, it is often advantageous to remove all margins
  * from certain elements.
  */
 body,
 h1,
 h2,
 h3,
 h4,
 h5,
 h6,
 p,
 blockquote,
 pre,
 dl,
 dd,
 ol,
 ul,
 form,
 fieldset,
 legend,
 figure,
 table,
 th,
 td,
 caption,
 hr {
   margin: 0;
   padding: 0;
 }
 
 /**
  * Some browsers have weird default styles for the <fieldset> element.
  * E.g. Chrome has `min-width: -webkit-min-content;` as default style. We
  * definitely don't want that, so we explicitly set it to `auto` here.
  */
 fieldset {
   min-width: auto;
 }
 
 /* ------------------------------------*\
     #SHARED
 \*------------------------------------ */
 /**
  * Where `margin-bottom` is concerned, this value will be the same as the
  * `$GLOBAL-LINE-HEIGHT`. This allows us to keep a consistent vertical rhythm.
  *
  * https://csswizardry.com/2012/06/single-direction-margin-declarations
  */
 ul,
 ol,
 dl,
 blockquote,
 p,
 address,
 hr,
 table,
 pre {
   margin-bottom: 24px;
 }
 
 /* ------------------------------------*\
     #FONT-FACE
 \*------------------------------------ */
 @font-face {
   font-family: "open-sans";
   src: url($cdnUrl + "/fonts/fonts/open-sans-regular.woff2") format("woff2"), url($cdnUrl + "/fonts/fonts/open-sans-regular.woff") format("woff");
   font-weight: 400;
   font-style: normal;
   font-display: swap;
 }
 
 @font-face {
   font-family: "open-sans";
   src: url($cdnUrl + "/fonts/fonts/open-sans-light.woff2") format("woff2"), url($cdnUrl + "/fonts/fonts/open-sans-light.woff") format("woff");
   font-weight: 300;
   font-style: normal;
   font-display: swap;
 }
 
 @font-face {
   font-family: "bronson-default";
   src: url("../fonts/icon-fonts/bronson-default.woff2") format("woff2"), url("../fonts/icon-fonts/bronson-default.woff") format("woff");
   font-weight: normal;
   font-style: normal;
   font-display: block;
 }
 
 /* ------------------------------------*\
     #FORMS
 \*------------------------------------ */
 /**
  * [1] Reset border to `0`, set by normalize.css
  */
 fieldset {
   border: 0;
   /* [1] */
 }
 
 /* ------------------------------------*\
     #IMAGES
 \*------------------------------------ */
 /**
  * All our images are fluid, thus all getting `max-width: 100%`.
  * Never ever set `width` and `height` attributes in HTML on `<img>` elements!
  *
  * [1] Fluid images for responsive purposes.
  * [2] Setting `vertical-align` removes the whitespace that appears under `img`
  *     elements when they are dropped into a page as-is. This is a afer
  *     alternative to using `display: block;` for the `<img>`.
  * [3] Visually offset `alt` text from surrounding copy (useful if the image may
  *     not load properly).
  */
 img {
   max-width: 100%;
   /* [1] */
   font-style: italic;
   /* [3] */
   vertical-align: middle;
   /* [2] */
 }
 
 /* ------------------------------------*\
     #LISTS
 \*------------------------------------ */
 /**
  * [1] Align the bullets/numbers of lists horizontally with sourrounding content.
  * [2] Remove extra vertical spacing when nesting lists.
  */
 ul, ol {
   margin-left: 24px;
   /* [1] */
 }
 
 li > ul,
 li > ol {
   margin-bottom: 0;
   /* [2] */
 }
 
 /* ------------------------------------*\
     #SMALL
 \*------------------------------------ */
 /**
  * Smallprint text.
  */
 small {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
 }
 
 /* ------------------------------------*\
     #HEADINGS
 \*------------------------------------ */
 /**
  * Headings 1â€“6.
  *
  * Only font-sizes are assigned for `<h1>` â€“ `<h6>` elements.
  * Any additional cosmetic styles are bound to an extra class and never
  * directly to a heading element!
  *
  * The individual font-sizes are defined in `01-settings/_font-sizes.scss`.
  */
 h1 {
   font-size: 2.125rem;
   /* stylelint-disable-line order/order */
   line-height: 1.2;
 }
 
 @media (min-width: 721px) {
   h1 {
     font-size: 3rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 @media (min-width: 1921px) {
   h1 {
     font-size: 3.75rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 h2 {
   font-size: 1.875rem;
   /* stylelint-disable-line order/order */
   line-height: 1.2;
 }
 
 @media (min-width: 721px) {
   h2 {
     font-size: 2.25rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 @media (min-width: 1921px) {
   h2 {
     font-size: 3rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 h3 {
   font-size: 1.625rem;
   /* stylelint-disable-line order/order */
   line-height: 1.2;
 }
 
 @media (min-width: 721px) {
   h3 {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 @media (min-width: 1921px) {
   h3 {
     font-size: 2.25rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 h4 {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1.2;
 }
 
 @media (min-width: 721px) {
   h4 {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 @media (min-width: 1921px) {
   h4 {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 h5 {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1.2;
 }
 
 @media (min-width: 721px) {
   h5 {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 @media (min-width: 1921px) {
   h5 {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 h6 {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   line-height: 1.2;
 }
 
 @media (min-width: 721px) {
   h6 {
     font-size: 1.25rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 @media (min-width: 1921px) {
   h6 {
     font-size: 1.75rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 h1,
 h2,
 h3,
 h4,
 h5,
 h6 {
   margin-bottom: 24px;
   font-weight: 300;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="brand"] h1,
 .u-bg-brand h1, [data-theme="brand"]
 h2,
 .u-bg-brand
 h2, [data-theme="brand"]
 h3,
 .u-bg-brand
 h3, [data-theme="brand"]
 h4,
 .u-bg-brand
 h4, [data-theme="brand"]
 h5,
 .u-bg-brand
 h5, [data-theme="brand"]
 h6,
 .u-bg-brand
 h6 {
   color: #ffffff;
 }
 
 /* ------------------------------------*\
     #PAGE
 \*------------------------------------ */
 /**
  * High-, page-level styling.
  *
  * [1] Ensure the page always fills at least the entire height of the viewport.
  * [2] Force scrollbars to always be visible to prevent awkward â€˜jumpsâ€™ when
  *     navigating between pages that do/do not have enough content to produce
  *     scrollbars naturally.
  * [3] Set the default `font-size` and `line-height` for the entire project,
  *     sourced from our base variables. The `font-size` is calculated to exist
  *     in ems, the `line-height` is calculated to exist unitlessly.
  *     navigating between pages that do/do not have enough content to produce
  *     scrollbars naturally.
  * [4] Assign our base font-family for the whole site.
  * [5] Set our sites background color globally.
  * [6] Set our base text color globally.
  * [7] Progressively enhanced smooth scrolling.
  *     See https://developer.mozilla.org/de/docs/Web/CSS/scroll-behavior
  */
 
 /**
  * Assign the base font-size to the page. The `responsive-font-size` mixin has
  * to be assigned to the body element to work properly for all elements that get
  * their font-size via the `font-size` mixin.
  */
 body {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
 }
 
 /* ------------------------------------*\
     #DEFINITION LIST
 \*------------------------------------ */
 dt {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   font-weight: 400;
   color: #1a1a1a;
 }
 
 dd {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   font-weight: 400;
   color: #1a1a1a;
 }
 
 dd:not(:last-child) {
   margin-bottom: 16px;
 }
 
 /**
  * [1] Normalize sets a font-family. We reset it to input font.
  */
 button {
   font-family: "open-sans", sans-serif;
   /* [1] */
   cursor: pointer;
 }
 
 optgroup:-ms-input-placeholder, select:-ms-input-placeholder, input:-ms-input-placeholder, textarea:-ms-input-placeholder {
   font-family: "open-sans", sans-serif;
   /* [1] */
 }
 
 optgroup::-ms-input-placeholder, select::-ms-input-placeholder, input::-ms-input-placeholder, textarea::-ms-input-placeholder {
   font-family: "open-sans", sans-serif;
   /* [1] */
 }
 
 optgroup, optgroup::placeholder,
 select,
 select::placeholder,
 input,
 input::placeholder,
 textarea,
 textarea::placeholder {
   font-family: "open-sans", sans-serif;
   /* [1] */
 }
 
 /* ------------------------------------*\
     #LABEL
 \*------------------------------------ */
 /**
  * Native <label> HTML element.
  */
 label {
   display: inline-block;
   margin-bottom: 8px;
   color: #1a1a1a;
 }
 
 /* ------------------------------------*\
     #LISTS (SETTINGS)
 \*------------------------------------ */
 /* ------------------------------------*\
     #LISTS
 \*------------------------------------ */
 /* stylelint-disable selector-max-combinators, selector-max-compound-selectors, selector-max-type */
 /**
  * [1] Second level lists have a smaller spacing on top and
  *     a normal one at the bottom.
  * [2] Third level lists have a smaller spacing on top and
  *     at the bottom.
  * [3] Offset by one character to align container with 2 digit index
  *     and prevent cut-off.
  *     This depends on the font, font-size and global-spacing, so a flag is used
  *     to selectively set it per brand.
  */
 ul li,
 ol li {
   margin-bottom: 16px;
 }
 
 ul li > ul,
 ul li > ol,
 ol li > ul,
 ol li > ol {
   margin-top: 8px;
   /* [1] */
   margin-bottom: 16px;
   /* [1] */
 }
 
 ul li > ul li,
 ul li > ol li,
 ol li > ul li,
 ol li > ol li {
   margin-bottom: 0;
 }
 
 ul li > ul li > ul,
 ul li > ol li > ul,
 ol li > ul li > ul,
 ol li > ol li > ul {
   margin-bottom: 8px;
   /* [2] */
 }
 
 /* stylelint-enable */
 ol {
   margin-left: calc(24px + 1ch);
   /* [3] */
 }
 
 /* ------------------------------------*\
     #HR
 \*------------------------------------ */
 hr {
   display: block;
   width: 100%;
   height: 1px;
   margin-right: auto;
   margin-bottom: 32px;
   margin-left: auto;
   border: 0;
   background-color: #1a1a1a;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] hr,
 .u-bg-alternative hr {
   background-color: #1a1a1a;
 }
 
 /* ------------------------------------*\
     #ANCHOR
 \*------------------------------------ */
 a {
   text-decoration: underline;
   color: inherit;
   cursor: pointer;
   /* [2] */
 }
 
 a:hover {
   /* [2] */
 }
 
 a:focus {
   /* [2] */
 }
 
 a:active {
   /* [2] */
 }
 
 /* ------------------------------------*\
     #CHOP-APART
 \*------------------------------------ */
 /**
  * An object to push two elements away from each other vertically.
  *
  * [1] Increase specificity so that `display: flex` is not overridden in
  *     combination with component-classes.
  * [2] Prevent bottom element to take up more space than needed. Fixes
  *     bug in IE11, where unnecessary space is taken up below the last
  *     element in the container (BRON-1386).
  * [3] Always provide default declarations for flex items (for legacy
  *     browsers).
  */
 .o-chop-apart.o-chop-apart {
   /* [1] */
   display: flex;
   flex-direction: column;
   justify-content: space-between;
 }
 
 .o-chop-apart.o-chop-apart > *:last-child {
   flex-grow: 0;
   /* [2] */
   flex-shrink: 0;
   /* [3] */
   flex-basis: auto;
   /* [3] */
 }
 
 /* ------------------------------------*\
     #INLINE-GROUP
 \*------------------------------------ */
 /**
  * An object that arranges items with defined horizontal and
  * vertical spacing in a row. If the items do not fit into one row,
  * they will wrap to the next row.
  */
 /**
  * [1] We use `display: flex` instead of `display: inline-block`
  *     to avoid unnecessary white space between items.
  * [2] Create horizontal and vertical spacing between items
  *     by adding margins around all sides of the items and
  *     compensate this by adding negative margins to the container.
  * [3] Defensively reset any child elementâ€™s margins.
  * [4] Stretch items to fill the container.
  * [5] Align items to the bottom.
  * [6] Center items vertically.
  */
 .o-inline-group {
   display: flex;
   /* [1] */
   flex-wrap: wrap;
   /* [1] */
   margin-top: -12px;
   /* [2] */
   margin-right: -16px;
   /* [2] */
   margin-bottom: -12px;
   /* [2] */
   margin-left: -16px;
   /* [2] */
 }
 
 .o-inline-group__item {
   margin-top: 12px;
   /* [2] */
   margin-right: 16px;
   /* [2] */
   margin-bottom: 12px;
   /* [2] */
   margin-left: 16px;
   /* [2] */
 }
 
 .o-inline-group__item > * {
   margin: 0;
   /* [3] */
 }
 
 .o-inline-group--small {
   margin-top: -8px;
   /* [2] */
   margin-right: -12px;
   /* [2] */
   margin-bottom: -8px;
   /* [2] */
   margin-left: -12px;
   /* [2] */
 }
 
 .o-inline-group--small .o-inline-group__item {
   margin-top: 8px;
   /* [2] */
   margin-right: 12px;
   /* [2] */
   margin-bottom: 8px;
   /* [2] */
   margin-left: 12px;
   /* [2] */
 }
 
 .o-inline-group--stretch .o-inline-group__item {
   flex-grow: 1;
   /* [4] */
 }
 
 .o-inline-group--bottom {
   align-items: flex-end;
   /* [5] */
 }
 
 .o-inline-group--center {
   align-items: center;
   /* [6] */
 }
 
 /* ------------------------------------*\
     #LAYOUT
 \*------------------------------------ */
 /**
  * The layout system uses `display: inline-block` to create an extremely
  * powerful, flexible alternative to the traditional grid system. Combine the
  * layout items with the widths-classes found in
  * `10-utilities/_utilities.widths.scss`.
  *
  * [1a] These properties accept a responsive map (responsive-property).
  */
 /* [1a] */
 /* [1a] */
 /**
  * [1] Allows us to use the layout object on any type of element.
  * [2] We need to defensively reset any box-model properties.
  * [3] Use the negative margin trick for multi-row grids:
  *     https://csswizardry.com/2011/08/building-better-grid-systems/
  * [4] Workaround for the HTML-comments trick to remove any whitespace between
  *     items in the markup.
  * [4a] Redefine a font-size to compensate [4].
  * [5] Required in order to combine fluid widths with fixed gutters.
  * [6] Allows us to manipulate grids vertically, with text-level properties, etc.
  * [7] Default item alignment is top.
  * [8] By default, all layout items are full-width.
  * [9] Gutters provided by left padding:
  *     https://csswizardry.com/2011/08/building-better-grid-systems/
  * [10] Define a default vertical spacing between layout items. Use `margin-top`
  *      instead of `margin-bottom`, so if a `margin-bottom` is set on the
  *      `.o-layout` container, the margins do not collapse.
  * [11] If we use `.o-layout--flush`, we do not not want vertical spacing, too.
  * [12] When the equal-height and the center variants are combined,
  *      `text-align: center` isn't enough to center the items.
  * [13] Use alignment via flexbox when both equal-height and right modifiers
  *      are used.
  * [14] Use Flexbox to adjust adjacent items to the same height.
  * [15] Hide vertical and horizontal dividers outside of `.o-layout`.
  * [16] Use vertical divider spacing between items.
  * [17] Equalize the bottom margin of `.o-layout`.
  *      Specificity has to be increased by prefix the selector with `:root:root`
  *      to overrule overly specific rules of other components.
  * [18] Use horizontal divider spacing between items.
  * [19] Remove bottom margin of last layout item child.
  * [20] Add shared declarations for vertical and horizontal dividers.
  * [21] Use `::before` for vertical dividers.
  * [22] Position vertical dividers.
  * [23] Center vertical dividers if divider width is an odd value (1, 3, 5, â€¦).
  *      The divider position will be adjusted to the nearest full pixel
  *      in order to avoid half pixel values and anti-aliasing
  *      (depending on the screen resolution).
  * [24] Center vertical dividers if divider width is an even value (2, 4, 6, â€¦).
  * [25] Use `::after` for horizontal dividers.
  * [26] Position horizontal dividers.
  * [27] Center horizontal dividers if divider width is an odd value (1, 3, 5, â€¦).
  *      The divider position will be adjusted to the nearest full pixel
  *      in order to avoid half pixel values and anti-aliasing
  *      (depending on the screen resolution).
  * [28] Center horizontal dividers if divider width is an even value (2, 4, 6, â€¦).
  * [29] On equal-height layouts the flex-item child elements are not taking up the
  *      entire width due to the `display: flex` on the flex-items.
  *      To fix this we have to make them grow as wide as their flex-item parent.
  * [30] The compensation for vertical gaps from [10] can result in overlapping
  *      elements above the layout-object, resulting in blocked interaction
  *      (click, text-selection, etc.). Disable interaction via `pointer-events`
  *      on layout and...
  * [31] ...Restore interaction on content.
  */
 .o-layout {
   display: block;
   /* [1] */
   margin: 0;
   /* [2] */
   padding: 0;
   /* [2] */
   font-size: 0;
   /* [4] */
   text-align: left;
   list-style: none;
   /* [1] */
   pointer-events: none;
   /* [30] */
   /* stylelint-disable order/order */
   margin-top: -24px;
   /* [10] */
   margin-left: -24px;
   /* [3] */
   /* stylelint-enable order/order */
 }
 
 .o-layout > .o-layout__item {
   margin-top: 24px;
   /* [10] */
 }
 
 .o-layout.o-layout--equal-height {
   display: flex;
   flex-wrap: wrap;
 }
 
 .o-layout.o-layout--equal-height.o-layout--right {
   justify-content: flex-end;
   /* [13] */
 }
 
 .o-layout__item {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   /* [4a] */
   padding-left: 24px;
   /* [9] */
   box-sizing: border-box;
   /* [5] */
   display: inline-block;
   /* [6] */
   width: 100%;
   /* [8] */
   vertical-align: top;
   /* [7] */
   pointer-events: auto;
   /* [31] */
 }
 
 .o-layout--middle > .o-layout__item {
   vertical-align: middle;
 }
 
 .o-layout--equal-height > .o-layout__item {
   display: flex;
 }
 
 .o-layout--equal-height > .o-layout__item > * {
   flex-grow: 1;
   /* [29] */
   flex-shrink: 1;
   flex-basis: auto;
 }
 
 /**
  * Layout modifier to fill up the layout system from the center.
  */
 .o-layout--center {
   text-align: center;
 }
 
 .o-layout--center.o-layout--equal-height {
   justify-content: center;
   /* [12] */
 }
 
 .o-layout--center > .o-layout__item {
   text-align: left;
 }
 
 /**
  * Layout modifier to fill up the layout system from the right hand side.
  */
 .o-layout--right {
   text-align: right;
 }
 
 .o-layout--right > .o-layout__item {
   text-align: left;
 }
 
 /**
  * Layout modifier to eliminate the spacing between the layout items.
  */
 .o-layout--flush {
   margin-left: 0;
   margin-top: 0;
   /* [11] */
 }
 
 .o-layout--flush > .o-layout__item {
   padding-left: 0;
   margin-top: 0;
   /* [11] */
 }
 
 /**
  * Layout modifier to add horizontal and vertical divider lines
  * between layout items.
  */
 .o-layout--divider {
   display: flex;
   /* [14] */
   flex-wrap: wrap;
   /* [14] */
   overflow: hidden;
   /* [15] */
   margin-top: -24.5px;
   /* [16] */
   margin-left: -48px;
   /* [18] */
 }
 
 .o-layout--divider.o-layout--divider.o-layout--divider {
   margin-bottom: -24.5px;
   /* [17] */
 }
 
 .o-layout--divider > .o-layout__item {
   position: relative;
   margin-top: 23.5px;
   /* [16] */
   padding-left: 48px;
   /* [18] */
   padding-bottom: 24.5px;
   /* [16] */
 }
 
 .o-layout--divider > .o-layout__item > *:last-child {
   margin-bottom: 0;
   /* [19] */
 }
 
 .o-layout--divider > .o-layout__item::before, .o-layout--divider > .o-layout__item::after {
   content: "";
   /* [20] */
   position: absolute;
   /* [20] */
   border-width: 1px;
   /* [20] */
   border-color: inherit;
   /* [20] */
 }
 
 .o-layout--divider > .o-layout__item::before {
   /* [21] */
   top: -24px;
   /* [22] */
   left: 48px;
   /* [22] */
   right: 0;
   /* [22] */
   border-top-style: solid;
   transform: translateY(-1px);
   /* [23] */
 }
 
 .o-layout--divider > .o-layout__item::after {
   /* [25] */
   top: 0;
   /* [26] */
   bottom: 24px;
   /* [26] */
   right: -24px;
   /* [26] */
   border-left-style: solid;
   transform: translateX(1px);
   /* [27] */
 }
 
 /* ------------------------------------*\
     #LIST-BARE
 \*------------------------------------ */
 /**
  * The list-bare object simply removes any indents and bullet points from lists.
  *
  * If you don't want to use the class, there is also a mixin available.
  * (`02-tools/_tools.list-bare.scss`)
  */
 .o-list-bare {
   margin: 0;
   padding: 0;
   list-style: none;
 }
 
 .o-list-bare li {
   display: block;
   margin-bottom: 0;
 }
 
 /* ------------------------------------*\
     #LIST-CASUAL
 \*------------------------------------ */
 /**
  * List whose items have more space between them to make the whole list look a
  * bit more spacey.
  */
 .o-list-casual li {
   margin-bottom: 12px;
 }
 
 /* ------------------------------------*\
     #LIST-INLINE
 \*------------------------------------ */
 /**
  * The list-inline object simply removes any indents and bullet points from
  * lists and puts them in a horizontal order.
  *
  * If you don't want to use the class, there is also a mixin available.
  * (`02-tools/_tools.list-inline.scss`)
  */
 .o-list-inline {
   margin: 0;
   padding: 0;
   list-style: none;
 }
 
 .o-list-inline li {
   display: inline-block;
   margin-bottom: 0;
 }
 
 /* ------------------------------------*\
     #MEDIA
 \*------------------------------------ */
 /**
  * An adaption of the famous media object.
  * (http://www.stubbornella.org/content/2010/06/25/the-media-object-saves-hundreds-of-lines-of-code/)
  *
  * We rewrite the original one with `display: flex` to be more flexible.
  */
 /**
  * [1] Make sure the media body takes up all the available space it needs if
  *     its content is not that long.
  * [2] Legacy browser support.
  * [3] Fix to make text truncate possible inside of media body (needed for the
  *     contact list).
  */
 .o-media {
   display: flex;
   flex-direction: row;
   /**
      * Stack the image on top of the media content on small screen.
      */
 }
 
 .o-media.o-media--reversed {
   flex-direction: row-reverse;
 }
 
 @media (max-width: 720px) {
   .o-media.o-media--column\@s {
     flex-direction: column;
   }
 }
 
 @media (max-width: 720px) {
   .o-media.o-media--column-reverse\@s {
     flex-direction: column-reverse;
   }
 }
 
 .o-media__img {
   flex-grow: 0;
   flex-shrink: 0;
   align-self: flex-start;
   margin-right: 24px;
 }
 
 .o-media--small .o-media__img {
   margin-right: 16px;
 }
 
 .o-media--large .o-media__img {
   margin-right: 32px;
 }
 
 .o-media--xlarge .o-media__img {
   margin-right: 64px;
 }
 
 .o-media--reversed .o-media__img {
   margin-right: 0;
   margin-left: 24px;
 }
 
 .o-media--reversed.o-media--small .o-media__img {
   margin-left: 16px;
 }
 
 .o-media--reversed.o-media--large .o-media__img {
   margin-left: 32px;
 }
 
 .o-media--reversed.o-media--xlarge .o-media__img {
   margin-left: 64px;
 }
 
 .o-media--middle .o-media__img {
   -ms-grid-row-align: center;
   align-self: center;
 }
 
 .o-media--bottom .o-media__img {
   align-self: flex-end;
 }
 
 @media (max-width: 720px) {
   .o-media--column\@s .o-media__img {
     margin-left: auto;
     margin-right: auto;
     margin-bottom: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .o-media--column-reverse\@s .o-media__img {
     margin-left: auto;
     margin-right: auto;
     margin-bottom: 0;
     margin-top: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .o-media--reversed.o-media--column\@s .o-media__img {
     margin-left: auto;
     margin-right: auto;
   }
 }
 
 @media (max-width: 720px) {
   .o-media--reversed.o-media--column-reverse\@s .o-media__img {
     margin-left: auto;
     margin-right: auto;
   }
 }
 
 .o-media__body {
   flex-grow: 1;
   /* [1] */
   flex-shrink: 1;
   /* [2] */
   flex-basis: auto;
   /* [2] */
   min-width: 0;
   /* [3] */
 }
 
 .o-media__body > *:last-child {
   margin-bottom: 0;
 }
 
 .o-media--middle .o-media__body {
   -ms-grid-row-align: center;
   align-self: center;
 }
 
 .o-media--bottom .o-media__body {
   align-self: flex-end;
 }
 
 @media (max-width: 720px) {
   .o-media--column-reverse\@s .o-media__body {
     margin-bottom: 24px;
   }
 }
 
 /* ------------------------------------*\
     #RATIO
 \*------------------------------------ */
 /**
  * With the Ratio object .o-ratio you can set fixed intrinsic aspect ratios for
  * certain elements (e.g. images, videos, iframes or embedded content) that will
  * be kept regardless of the content even when scaled.
  *
  * See http://alistapart.com/article/creating-intrinsic-ratios-for-video
  */
 /**
  * 1. Create ratio-bound content block, to keep media (e.g. images, videos) in
  *    their correct aspect ratios.
  *    We only set a ratio if a `.o-ratio--` modifier class is set as well to
  *    avoid unwanted layout errors when no specific ratio was specified with the
  *    `.o-ratio--` modifier.
  * 2. The `.o-ratio` container will be used as a box with an intrinsic ratio by
  *    adding a `padding-bottom` with the `.o-ratio--` modifier class which sets
  *    the ratio.
  * 3. The child element will be positioned absolutely so that it covers the
  *    entire width and height of `.o-ratio`.
  */
 .o-ratio[class*="o-ratio--"] {
   /* [1] */
   position: relative;
   /* [2] */
   display: block;
   /* [2] */
 }
 
 .o-ratio[class*="o-ratio--"]::before {
   content: "";
   /* [2] */
   display: block;
   /* [2] */
   width: 100%;
   /* [2] */
 }
 
 .o-ratio[class*="o-ratio--"] > .o-ratio__content,
 .o-ratio[class*="o-ratio--"] > iframe,
 .o-ratio[class*="o-ratio--"] > embed,
 .o-ratio[class*="o-ratio--"] > object {
   position: absolute;
   /* [3] */
   top: 0;
   /* [3] */
   bottom: 0;
   /* [3] */
   left: 0;
   /* [3] */
   right: 0;
   /* [3] */
   width: 100%;
   /* [3] */
   height: 100%;
   /* [3] */
 }
 
 /**
  * Ratio variants.
  * Generate a series of ratio classes to be used like so:
  *
  *   <div class="o-ratio  o-ratio--16:9">
  *
  */
 .o-ratio--1\:1:before {
   padding-bottom: 100%;
   /* [2] */
 }
 
 .o-ratio--4\:3:before {
   padding-bottom: 75%;
   /* [2] */
 }
 
 .o-ratio--16\:9:before {
   padding-bottom: 56.25%;
   /* [2] */
 }
 
 /* ------------------------------------*\
     #SPLIT
 \*------------------------------------ */
 /**
  * An object to put two elements beside each other.
  *
  * [1] ~~Clearfix for float fallback. (BÃ¶sebÃ¶se!)~~
  *     This results in cutting off content (e.g. box-shadows) that overlap the
  *     containers edges. DO NOT COMMENT THIS IN AGAIN!
  * [2] Non flexbox fallback.
  */
 .o-split {
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-items: center;
 }
 
 .o-split.o-split--top {
   align-items: flex-start;
 }
 
 .o-split > *:nth-child(1) {
   float: left;
   /* [2] */
 }
 
 .o-split > *:nth-child(2) {
   float: right;
   /* [2] */
 }
 
 .o-split > *:not(:last-child) {
   margin-right: 24px;
 }
 
 .o-split.o-split--reversed {
   flex-direction: row-reverse;
 }
 
 .o-split.o-split--reversed > *:not(:last-child) {
   margin-right: 0;
 }
 
 .o-split.o-split--reversed > *:last-child {
   margin-right: 24px;
 }
 
 @media (max-width: 720px) {
   .o-split.o-split--collapse\@s {
     display: block;
   }
 }
 
 @media (max-width: 720px) {
   .o-split.o-split--collapse\@s > * {
     display: block;
     float: none;
   }
 }
 
 /* ------------------------------------*\
     #PAGE-WRAP
 \*------------------------------------ */
 /**
  * [1] Add variants, e.g. `.o-page-wrap--small`.
  */
 .o-page-wrap {
   max-width: calc(1280px + 64px);
   padding-left: 32px;
   padding-right: 32px;
   margin-right: auto;
   margin-left: auto;
   /* [1] */
 }
 
 @media (max-width: 960px) {
   .o-page-wrap {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .o-page-wrap {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .o-page-wrap {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 .o-page-wrap.o-page-wrap--medium {
   max-width: calc(1280px + 64px);
 }
 
 @media (max-width: 960px) {
   .o-page-wrap.o-page-wrap--medium {
     max-width: calc(1280px + 48px);
   }
 }
 
 @media (max-width: 720px) {
   .o-page-wrap.o-page-wrap--medium {
     max-width: calc(1280px + 32px);
   }
 }
 
 @media (max-width: 480px) {
   .o-page-wrap.o-page-wrap--medium {
     max-width: calc(1280px + 16px);
   }
 }
 
 .o-page-wrap.o-page-wrap--small {
   max-width: calc(1066.66667px + 64px);
 }
 
 @media (max-width: 960px) {
   .o-page-wrap.o-page-wrap--small {
     max-width: calc(1066.66667px + 48px);
   }
 }
 
 @media (max-width: 720px) {
   .o-page-wrap.o-page-wrap--small {
     max-width: calc(1066.66667px + 32px);
   }
 }
 
 @media (max-width: 480px) {
   .o-page-wrap.o-page-wrap--small {
     max-width: calc(1066.66667px + 16px);
   }
 }
 
 .o-page-wrap.o-page-wrap--xsmall {
   max-width: calc(853.33333px + 64px);
 }
 
 @media (max-width: 960px) {
   .o-page-wrap.o-page-wrap--xsmall {
     max-width: calc(853.33333px + 48px);
   }
 }
 
 @media (max-width: 720px) {
   .o-page-wrap.o-page-wrap--xsmall {
     max-width: calc(853.33333px + 32px);
   }
 }
 
 @media (max-width: 480px) {
   .o-page-wrap.o-page-wrap--xsmall {
     max-width: calc(853.33333px + 16px);
   }
 }
 
 .o-page-wrap.o-page-wrap--xxsmall {
   max-width: calc(640px + 64px);
 }
 
 @media (max-width: 960px) {
   .o-page-wrap.o-page-wrap--xxsmall {
     max-width: calc(640px + 48px);
   }
 }
 
 @media (max-width: 720px) {
   .o-page-wrap.o-page-wrap--xxsmall {
     max-width: calc(640px + 32px);
   }
 }
 
 @media (max-width: 480px) {
   .o-page-wrap.o-page-wrap--xxsmall {
     max-width: calc(640px + 16px);
   }
 }
 
 /* ------------------------------------*\
     #MAIN-CONTAINER
 \*------------------------------------ */
 /**
  * [1] Enable the footer to be positioned at the bottom of the viewport
  *     if the content is not as high as the remaining space.
  * [2] This won't work in IE11 and therefore the footer is not
  *     bottom positioned.
 */
 @supports not ((-ms-high-contrast: none) and (-ms-ime-align: auto)) {
   .o-root {
     /* [2] */
     display: flex;
     /* [1] */
     flex-direction: column;
     min-height: 100vh;
     /* [1] */
   }
 }
 
 /* ------------------------------------*\
     #MAIN-WRAPPER
 \*------------------------------------ */
 /**
  * [1] Stretch the content of the main selector to push
  *     down the footer, when the content is too shallow.
 */
 .o-main {
   flex-grow: 1;
   /* [1] */
   flex-shrink: 1;
   /* [1] */
   flex-basis: auto;
   /* [1] */
 }
 
 /* ------------------------------------*\
     #FIELDSET
 \*------------------------------------ */
 /**
  * Handle spacings between form elements in form sets.
  */
 .o-fieldset:not(:last-child) {
   margin-bottom: 24px;
 }
 
 .o-fieldset__row:not(:last-child) {
   margin-bottom: 24px;
 }
 
 /* ------------------------------------*\
     #BUTTON-CONTAINER
 \*------------------------------------ */
 /**
  * [1] Clearfix for fallback float solution.
  * [2] Reset clearfix for grid-supporting browsers. Otherwise, the pseudo-
  *     element thatâ€™s created by the clearfix is considered as an individual
  *     grid item.
  * [3] Reset fallback declarations on grid-supporting browsers.
  * [4] Manages vertical spacing between buttons after collapsing.
  * [5] Flex-fallback for older browsers.
  * [6] Manually collapse items in fallback solution.
  * [7] Compensate item spacings.
  * [8] Force wrap (auto instead of 100% for legacy browsers).
  * [9] Override specificity, prevent multiple, scoped styles (setting &
  *     unsetting).
  * [10] If the button container only has one single child, center it.
  * [11] If itâ€™s the only button, limit its width on larger screens.
  * [12] Show last button (usally CTA) on top when buttons are stacked vertically.
  * [13] Combine positioning options for nav modifier based on defined alignment.
  *      This allows flexibility for brands with one-markup.
  * [14] Reset `grid-gap` as flexbox will have a `gap` property in future versions.
  *      This fixes inconsistent spaces being applied in browsers that already
  *      support `gap` for flexbox (currently only Firefox).
  * [15] Make sure that the buttons in a navigational context collapse to its content.
  * [16] Set a max-width for the nav buttons as we allow them to grow via its content.
  *      Allow full width buttons for small viewports as they are stacked on top each other
  *      but limit them on bigger viewports.
  */
 .o-button-container {
   /* [1] */
   display: flex;
   /* [5] */
   justify-content: center;
   /* [5] */
   width: 100%;
   /* [5] */
   margin-top: -16px;
   /* [4] */
 }
 
 .o-button-container::after {
   content: "" !important;
   display: block !important;
   clear: both !important;
 }
 
 @supports (display: grid) {
   .o-button-container {
     display: -ms-grid;
     display: grid;
     /* autoprefixer: ignore next */
     grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
     /* autoprefixer: ignore next */
     justify-items: center;
     /* [10] */
     /* autoprefixer: ignore next */
     grid-gap: 16px;
     margin-top: 0;
     /* [3] */
   }
   .o-button-container::after {
     display: none !important;
     /* [2] */
     /* stylelint-disable-line itcss/no-at-important */
   }
 }
 
 .o-button-container--center, .o-button-container--nav,
 .o-button-container--left,
 .o-button-container--right,
 .o-button-container--nav {
   display: flex;
   /* autoprefixer: ignore next */
   grid-gap: 0;
   /* [14] */
   justify-content: space-between;
 }
 
 @media (max-width: 720px) {
   .o-button-container--center, .o-button-container--nav,
   .o-button-container--left,
   .o-button-container--right,
   .o-button-container--nav {
     flex-direction: column;
     align-items: center;
   }
 }
 
 .o-button-container--center .o-button-container__button, .o-button-container--nav .o-button-container__button,
 .o-button-container--left .o-button-container__button,
 .o-button-container--right .o-button-container__button,
 .o-button-container--nav .o-button-container__button {
   flex-grow: 0;
   flex-shrink: 1;
   flex-basis: auto;
   max-width: 300px;
 }
 
 @media (max-width: 720px) {
   .o-button-container--center .o-button-container__button, .o-button-container--nav .o-button-container__button,
   .o-button-container--left .o-button-container__button,
   .o-button-container--right .o-button-container__button,
   .o-button-container--nav .o-button-container__button {
     margin-right: 0 !important;
     /* stylelint-disable-line itcss/no-at-important */
     /* [7] */
   }
   .o-button-container--center .o-button-container__button:not(:first-child), .o-button-container--nav .o-button-container__button:not(:first-child),
   .o-button-container--left .o-button-container__button:not(:first-child),
   .o-button-container--right .o-button-container__button:not(:first-child),
   .o-button-container--nav .o-button-container__button:not(:first-child) {
     margin-top: 16px;
   }
   .o-button-container--center .o-button-container__button:last-child, .o-button-container--nav .o-button-container__button:last-child,
   .o-button-container--left .o-button-container__button:last-child,
   .o-button-container--right .o-button-container__button:last-child,
   .o-button-container--nav .o-button-container__button:last-child {
     margin-left: 0;
   }
 }
 
 .o-button-container--center .o-button-container__button:not(:last-child), .o-button-container--nav .o-button-container__button:not(:last-child),
 .o-button-container--left .o-button-container__button:not(:last-child),
 .o-button-container--right .o-button-container__button:not(:last-child),
 .o-button-container--nav .o-button-container__button:not(:last-child) {
   margin-right: 16px;
 }
 
 .o-button-container--center .o-button-container__button:last-child, .o-button-container--nav .o-button-container__button:last-child,
 .o-button-container--left .o-button-container__button:last-child,
 .o-button-container--right .o-button-container__button:last-child,
 .o-button-container--nav .o-button-container__button:last-child {
   margin-left: auto;
 }
 
 .o-button-container--center-wrap {
   display: flex;
   flex-direction: column;
   align-items: center;
   /* autoprefixer: ignore next */
   grid-gap: 0;
   /* [14] */
 }
 
 .o-button-container--center-wrap .o-button-container__button {
   max-width: 300px;
 }
 
 .o-button-container--center-wrap .o-button-container__button:not(:first-child) {
   margin-top: 16px;
 }
 
 .o-button-container--center, .o-button-container--nav {
   justify-content: center;
   padding-left: 16px;
   /* [7] */
 }
 
 @media (max-width: 720px) {
   .o-button-container--center, .o-button-container--nav {
     padding-left: 0;
   }
 }
 
 .o-button-container--center .o-button-container__button, .o-button-container--nav .o-button-container__button {
   margin-right: 16px;
   /* [7] */
   margin-left: 0 !important;
   /* stylelint-disable-line itcss/no-at-important */
   /* [9] */
 }
 
 .o-button-container--left {
   justify-content: flex-start;
 }
 
 .o-button-container--left .o-button-container__button {
   margin-right: 0;
   margin-left: 0 !important;
   /* stylelint-disable-line itcss/no-at-important */
   /* [9] */
 }
 
 .o-button-container--right {
   justify-content: flex-end;
 }
 
 .o-button-container--right .o-button-container__button {
   margin-right: 0;
   margin-left: 0 !important;
   /* stylelint-disable-line itcss/no-at-important */
   /* [9] */
 }
 
 .o-button-container--nav {
   /* stylelint-disable-line scss/at-extend-no-missing-placeholder */
   /* [13] */
 }
 
 @media (max-width: 720px) {
   .o-button-container--nav .o-button-container__button {
     margin-bottom: 0;
     /* stylelint-disable-next-line */
   }
   .o-button-container--nav .o-button-container__button:last-child {
     order: -1;
     /* [12] */
     margin-top: 0;
     margin-bottom: 16px;
   }
   .o-button-container--nav .o-button-container__button + .o-button-container--nav .o-button-container__button {
     margin-top: 16px;
   }
 }
 
 @media (min-width: 721px) {
   .o-button-container--nav .o-button-container__button {
     width: -webkit-max-content;
     width: max-content;
     /* [15] */
     max-width: 50%;
     /* [16] */
   }
 }
 
 .o-button-container__button {
   float: left;
   /* [5] */
   width: calc(50% - 8px);
   /* [5] */
   margin-top: 16px;
   /* [4] */
 }
 
 @supports (display: grid) {
   .o-button-container__button {
     width: 100%;
     /* [3] */
     margin-top: 0;
     /* [3] */
   }
 }
 
 @media (max-width: 720px) {
   .o-button-container__button {
     width: 100%;
     /* [6] */
   }
 }
 
 @media (min-width: 721px) {
   .o-button-container__button:only-child {
     max-width: 50%;
     /* [11] */
   }
 }
 
 .o-button-container__button:not(:last-child) {
   margin-right: 16px;
 }
 
 @supports (display: grid) {
   .o-button-container__button:not(:last-child) {
     margin-right: 0;
     /* [3] */
   }
 }
 
 /* ------------------------------------*\
     #CONTENT-SECTION
 \*------------------------------------ */
 /**
  * An object wrapping the content of entire sections to ensure a consistent
  * spacing around the sections content.
  */
 .o-content-section {
   padding-top: 32px;
   padding-bottom: 32px;
 }
 
 /* ------------------------------------*\
     #COMPONENT-WRAPPER
 \*------------------------------------ */
 /**
  * The component-wrapper is an object that needs to be the container of every
  * component, which sits directly in a content section. It makes sure that the
  * spacing between the components is always correct.
  */
 .o-component-wrapper:not(:last-child) {
   margin-bottom: 32px;
 }
 
 /* ------------------------------------*\
     #FLICKITY
 \*------------------------------------ */
 /**
  * Flickity v2.0.10
  * (https://flickity.metafizzy.co)
  */
 /**
  * [1] Reset default list styles.
  * [2] Horizontally center page-dots.
  * [3] Hide default Flickity icon.
  * [4] Remove focus ring styles for the exit button.
  * [5] Hide Flickityâ€™s injected SVG icon.
  * [6] Hide the reveal button when presenting in fullscreen.
  * [7] Set minimal pointer size for the dots.
  * [8] Make space for the dots in the fullscreen mode.
  * [9] Height is set to 0 before being overwritten by min-height to vertically center
  *     the dots in IE11. Otherwise align-items: center would not work in IE11.
  */
 .flickity-enabled {
   position: relative;
   padding-right: 0;
   padding-left: 0;
   /**
      * Draggable.
      */
   /**
      * Fullscreen.
      */
 }
 
 .flickity-enabled:focus {
   outline: none;
 }
 
 .flickity-enabled.is-draggable {
   -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
   /* [1] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
   /* stylelint-disable selector-max-class */
   /* stylelint-enable */
 }
 
 .flickity-enabled.is-draggable .flickity-viewport {
   cursor: grab;
 }
 
 .flickity-enabled.is-draggable .flickity-viewport.is-pointer-down {
   cursor: grabbing;
 }
 
 .flickity-enabled.is-fullscreen {
   position: fixed;
   z-index: 4500;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   padding-bottom: 44px;
   /* [8] */
   background-color: #ffffff;
 }
 
 .flickity-enabled.is-fullscreen .flickity-fullscreen-button-exit {
   display: block;
 }
 
 .flickity-enabled.is-fullscreen .flickity-fullscreen-button-exit::before {
   content: "\e963";
 }
 
 .flickity-enabled.is-fullscreen .flickity-fullscreen-button-view {
   display: none;
   /* [6] */
 }
 
 .flickity-enabled .flickity-fullscreen-button {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   position: absolute;
   top: 0;
   right: 0;
   width: 44px;
   height: 44px;
   border: 0;
   border-radius: 0;
   background-color: #ffffff;
   /* stylelint-disable-next-line order/order */
 }
 
 .flickity-enabled .flickity-fullscreen-button::before {
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   content: "\e95e";
   display: flex;
   align-items: center;
   justify-content: center;
   color: #1a1a1a;
   cursor: pointer;
 }
 
 .flickity-enabled .flickity-fullscreen-button:focus {
   outline: 0;
   /* [4] */
 }
 
 .flickity-enabled .flickity-fullscreen-button-exit {
   display: none;
   /* [3] */
 }
 
 .flickity-enabled .flickity-button-icon {
   display: none;
   /* [5] */
 }
 
 .flickity-viewport {
   position: relative;
   height: 100%;
   overflow: hidden;
 }
 
 .flickity-slider {
   position: absolute;
   width: 100%;
   height: 100%;
 }
 
 /**
  * Previous/next buttons.
  */
 .flickity-prev-next-button {
   position: absolute;
   top: 50%;
   width: 48px;
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   height: 48px;
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   padding: 0;
   transform: translateY(-50%);
   border: none;
   border-radius: 0;
   background-color: transparent;
   cursor: pointer;
 }
 
 .flickity-prev-next-button::before {
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   position: relative;
   z-index: 10;
   color: #1a1a1a;
 }
 
 .flickity-prev-next-button::after {
   content: "";
   position: absolute;
   z-index: 3;
   top: 0;
   display: block;
   width: calc(100% + 4px);
   height: 100%;
 }
 
 .flickity-prev-next-button:focus {
   outline: 0;
 }
 
 .flickity-prev-next-button.previous {
   left: 0;
   text-align: left;
 }
 
 .flickity-prev-next-button.previous::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   content: "\e945";
 }
 
 .flickity-prev-next-button.previous::after {
   right: 0;
 }
 
 .flickity-prev-next-button.next {
   right: 0;
   text-align: right;
 }
 
 .flickity-prev-next-button.next::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   content: "\e946";
 }
 
 .flickity-prev-next-button.next::after {
   left: 0;
 }
 
 .flickity-prev-next-button svg {
   display: none;
 }
 
 .flickity-prev-next-button:disabled {
   cursor: auto;
 }
 
 .flickity-prev-next-button:disabled::before {
   color: #afb5ab;
 }
 
 .flickity-page-dots {
   display: flex;
   /* [2] */
   align-items: center;
   justify-content: center;
   /* [2] */
   margin: 0;
   /* [1] */
   padding: 0;
   /* [1] */
 }
 
 .flickity-page-dots .dot {
   display: inline-flex;
   align-items: center;
   justify-content: center;
   height: 0;
   /* [9] */
   min-height: 44px;
   /* [7] */
   margin-right: 4px;
   margin-bottom: 0;
   margin-left: 4px;
   cursor: pointer;
 }
 
 .flickity-page-dots .dot::after {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   content: "";
   display: block;
   width: 12px;
   height: 12px;
   border: 1px solid #1a1a1a;
   border-radius: 50%;
   background-color: #ffffff;
 }
 
 .flickity-page-dots .dot.is-selected::after {
   border-color: #187085;
   background-color: #187085;
 }
 
 /* ------------------------------------*\
     #TIPPYJS
 \*------------------------------------ */
 /**
  * This is a custom adaptation of the Tippy.js Sass file to make it
  * themable for other brands.
  */
 /**
  * [1] Align with arrow reference element.
  */
 /**
  * [1] Reference for the arrow.
  * [2] If the browser supports `filter: drop-shadow`, apply this declaration to
  *     include the arrow in the shadow as well.
  * [3] Defensively reset any spacing-bottom of the last element in the body.
  * [4] Limit the height of the tooltip for large content and make it scrollable.
  * [5] Make sure that â€œnormalâ€ HTML elements like `<h1>` etc. all get the
  *     correct text color, when they are placed inside of the tooltip.
  * [6] Check if the tooltip will have a border and render the triangle differently
  *     as the original approach uses `border` itself to render the triangle.
  * [7] Overwrite the default hover link border color.
  * [8] Fix issue where the drop shadow was sometimes missing in some versions
  *     of Safari. Unfortunately, we do not have a reliable CSS-only solution
  *     to intercept the Safari browser. Therefore, we add `will-change: transform`
  *     only when a drop shadow is set.
  */
 [data-tippy-root] {
   max-width: 320px;
 }
 
 .tippy-box {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   position: relative;
   /* [1] */
   border-radius: 0;
   background-color: #3e4547;
 }
 
 .tippy-box:focus {
   outline-color: transparent;
   outline-style: solid;
   outline-width: 0;
 }
 
 .tippy-box,
 .tippy-box * {
   font-weight: 400;
   color: #ffffff;
   /* [5] */
 }
 
 .tippy-box[data-state="visible"] {
   opacity: 1;
 }
 
 .tippy-box[data-state="hidden"] {
   opacity: 0;
 }
 
 .tippy-box a:hover {
   /* [7] */
 }
 
 .tippy-arrow {
   width: 20px;
   height: 20px;
 }
 
 .tippy-arrow::before {
   content: "";
   position: absolute;
 }
 
 .tippy-content {
   position: relative;
   z-index: 1;
   max-height: 300px;
   /* [4] */
   overflow: auto;
   /* [4] */
   padding: 16px 16px;
   line-height: 1.5;
 }
 
 .tippy-content > *:last-child {
   margin-bottom: 0;
   /* [3] */
 }
 
 .tippy-box[data-placement^="top"] {
   transform: translateY(-10px);
 }
 
 .tippy-box[data-placement^="top"] .tippy-arrow {
   bottom: 0;
 }
 
 .tippy-box[data-placement^="top"] .tippy-arrow::before {
   border-top: 10px solid #3e4547;
   border-right: 10px solid transparent;
   border-left: 10px solid transparent;
   bottom: -10px;
   left: 0;
   /* [1] */
   /* stylelint-disable-next-line order/order */
   transform-origin: 50% 0%;
 }
 
 .tippy-box[data-placement^="bottom"] {
   transform: translateY(10px);
 }
 
 .tippy-box[data-placement^="bottom"] .tippy-arrow {
   top: 0;
 }
 
 .tippy-box[data-placement^="bottom"] .tippy-arrow::before {
   border-bottom: 10px solid #3e4547;
   border-right: 10px solid transparent;
   border-left: 10px solid transparent;
   top: -10px;
   left: 0;
   /* [1] */
   /* stylelint-disable-next-line order/order */
   transform-origin: 50% 100%;
 }
 
 .tippy-box[data-placement^="left"] {
   transform: translateX(-10px);
 }
 
 .tippy-box[data-placement^="left"] .tippy-arrow {
   right: 0;
 }
 
 .tippy-box[data-placement^="left"] .tippy-arrow::before {
   border-left: 10px solid #3e4547;
   border-top: 10px solid transparent;
   border-bottom: 10px solid transparent;
   /* stylelint-disable-next-line order/order */
   right: -10px;
   transform-origin: 0% 50%;
 }
 
 .tippy-box[data-placement^="right"] {
   transform: translateX(10px);
 }
 
 .tippy-box[data-placement^="right"] .tippy-arrow {
   left: 0;
 }
 
 .tippy-box[data-placement^="right"] .tippy-arrow::before {
   border-right: 10px solid #3e4547;
   border-top: 10px solid transparent;
   border-bottom: 10px solid transparent;
   /* stylelint-disable-next-line order/order */
   left: -10px;
   transform-origin: 100% 50%;
 }
 
 /* ------------------------------------*\
     #FLATPICKR-OVERRIDES
 \*------------------------------------ */
 /**
  * [1] Set 'important' to override inline CSS styles set by flatpickr and prevent
  *     rendering issues (especially in Firefox and Internet Explorer 11).
  * [2] Prevent outline if user clicks on the space between root element and inner
  *     container.
  * [3] Remove border which is displayed on focus.
  * [4] Optimize the size and position of the calendar for small mobile devices
  * [5] Add a rectangle that points from the open calendar to the corresponding
  *     input element.
  * [6] Show cursor pointer in IE11.
  * [7] Prevent calendar on mobile devices from being wider than on the desktop.
  * [8] Remove native input spin box.
  * [9] Don't show outline when clicking on arrows.
  * [10] Correct wrong positioning of `.flatpickr-time` in Internet Explorer 11
  *      caused by negative margin.
  * [11] Use `line-height` to set the `height` of the timepicker and to ensure
  *      the `inputs` fill the entire space.
  * [12] Only apply the font colors to days in different months if the day is in
  *      "default state". If hover/selected is active the color might collide
  *      with the font color defined here, making the day unreadable.
  * [13] Hide closed datepicker to prevent taking up space.
  * [14] Manages the position of the calendar when opening to top.
  * [15] Make transitions optional.
  * [16] Allows centering the controls for all viewports.
  * [17] Center strike-through above number.
  */
 /**
  * GENERAL FLATPICKR STYLES
  */
 .flatpickr-calendar {
   position: absolute;
   z-index: 4800;
   display: flex;
   flex-direction: column;
   flex-grow: 1;
   flex-shrink: 0;
   flex-basis: auto;
   width: 314px !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   max-width: 314px;
   /* [7] */
   padding: 16px 16px;
   border: 1px solid #1a1a1a;
   text-align: center;
   background-color: #ffffff;
   visibility: hidden;
   outline: 0;
   /* [2] */
   opacity: 0;
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
 }
 
 @media (max-width: 480px) {
   .flatpickr-calendar {
     /* [4] */
     left: 50% !important;
     /* [1] */
     /* stylelint-disable-line itcss/no-at-important */
     width: 90vw !important;
     /* [1] */
     /* stylelint-disable-line itcss/no-at-important */
     transform: translateX(-50%);
   }
 }
 
 .flatpickr-calendar:not(.open) {
   display: none;
   /* [13] */
 }
 
 .flatpickr-calendar.open {
   visibility: visible;
   opacity: 1;
 }
 
 .flatpickr-calendar.arrowBottom {
   margin-top: -34px;
   /* [14] */
 }
 
 .flatpickr-innerContainer {
   width: 280px;
 }
 
 @media (max-width: 480px) {
   .flatpickr-innerContainer {
     /* [4] */
     width: 100%;
     /* [1] */
     /* stylelint-disable-line itcss/no-at-important */
   }
 }
 
 .flatpickr-input, .flatpickr-input[readonly] {
   cursor: pointer;
 }
 
 .flatpickr-input[disabled] ~ .c-input__addon .c-icon {
   color: rgba(26, 26, 26, 0.5);
 }
 
 /**
  * FLATPICKR INPUT WRAPPER STYLES
  */
 .numInputWrapper {
   position: relative;
 }
 
 .numInputWrapper:hover {
   background-color: #f2f2f2;
 }
 
 .numInputWrapper:hover .arrowUp,
 .numInputWrapper:hover .arrowDown {
   opacity: 1;
   background-color: #f2f2f2;
 }
 
 .flatpickr-months .numInputWrapper {
   display: inline-block;
   width: 3.5em;
 }
 
 .flatpickr-months .numInputWrapper .arrowUp,
 .flatpickr-months .numInputWrapper .arrowDown {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   right: -15px;
   width: 15px;
 }
 
 .flatpickr-time .numInputWrapper {
   display: flex;
   flex-grow: 1;
 }
 
 .flatpickr-time .numInputWrapper .arrowUp,
 .flatpickr-time .numInputWrapper .arrowDown {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   line-height: 24px;
   right: 0;
   width: 24px;
   color: #1a1a1a;
 }
 
 .numInputWrapper .arrowUp,
 .numInputWrapper .arrowDown {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   position: absolute;
   display: flex;
   align-items: center;
   justify-content: center;
   height: 50%;
   overflow: hidden;
   color: #1a1a1a;
   opacity: 0;
 }
 
 .numInputWrapper .arrowUp:hover,
 .numInputWrapper .arrowDown:hover {
   color: #1a1a1a;
   cursor: pointer;
   /* [6] */
   background-color: #495651;
 }
 
 .numInputWrapper .arrowUp::before,
 .numInputWrapper .arrowDown::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
 }
 
 .numInputWrapper .arrowUp {
   top: 0;
 }
 
 .numInputWrapper .arrowUp::before {
   content: "\e947";
 }
 
 .numInputWrapper .arrowDown {
   bottom: 0;
 }
 
 .numInputWrapper .arrowDown::before {
   content: "\e944";
 }
 
 .numInputWrapper input[type="number"] {
   -webkit-appearance: textfield;
   appearance: textfield;
   /* [8] */
 }
 
 .numInputWrapper input::-ms-clear {
   display: none;
   /* [8] */
 }
 
 .numInputWrapper input::-webkit-outer-spin-button,
 .numInputWrapper input::-webkit-inner-spin-button {
   margin: 0;
   /* [8] */
   -webkit-appearance: none;
   appearance: none;
   /* [8] */
 }
 
 .numInput {
   width: 100%;
   margin: 0;
   padding: 0;
   border: 0;
   font-weight: 400;
   text-align: center;
   background-color: transparent;
   color: #1a1a1a;
 }
 
 .numInput:focus {
   outline: 0;
 }
 
 .flatpickr-time .numInput {
   color: #1a1a1a;
 }
 
 /**
  * FLATPICKR MONTH STYLES
  */
 .flatpickr-months {
   display: flex;
   align-items: center;
   /* [16] */
 }
 
 .flatpickr-month {
   flex-grow: 1;
   flex-shrink: 0;
   flex-basis: auto;
   line-height: 1;
   text-align: center;
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
 }
 
 .flatpickr-current-month {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   line-height: 1.33333;
   font-weight: 400;
   color: #1a1a1a;
 }
 
 .flatpickr-prev-month,
 .flatpickr-next-month {
   width: 40px;
   line-height: 1;
   cursor: pointer;
 }
 
 .flatpickr-prev-month .c-icon,
 .flatpickr-next-month .c-icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   color: #1a1a1a;
 }
 
 .flatpickr-prev-month:hover .c-icon,
 .flatpickr-next-month:hover .c-icon {
   color: #afb5ab;
 }
 
 /**
  * FLATPICKR WEEKDAY STYLES
  */
 .flatpickr-weekdays {
   overflow: hidden;
   background-color: transparent;
 }
 
 .flatpickr-weekdaycontainer {
   display: flex;
   justify-content: center;
 }
 
 .flatpickr-weekday {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 40px;
   width: 40px;
   height: 40px;
   margin: 0 0;
   font-weight: 400;
   color: #1a1a1a;
   cursor: default;
 }
 
 @media (max-width: 480px) {
   .flatpickr-weekday {
     /* [4] */
     width: 14.28571%;
     height: 14.28571%;
   }
 }
 
 /**
  * FLATPICKR DAY STYLES
  */
 .dayContainer {
   display: flex;
   flex-wrap: wrap;
   justify-content: center;
   overflow: hidden;
 }
 
 .flatpickr-day {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 40px;
   position: relative;
   width: 40px;
   height: 40px;
   margin: 0 0;
   border-radius: 0;
   font-weight: 400;
   color: #1a1a1a;
   cursor: pointer;
   /* stylelint-disable selector-max-specificity */
   /* stylelint-enable */
 }
 
 @media (max-width: 480px) {
   .flatpickr-day {
     /* [4] */
     width: 14.28571%;
     height: 14.28571%;
   }
 }
 
 .flatpickr-day:hover {
   font-weight: 400;
   background-color: #f2f2f2;
   color: #1a1a1a;
 }
 
 .flatpickr-day.inRange {
   background-color: #f2f2f2;
 }
 
 .flatpickr-day.inRange:hover {
   background-color: #afb5ab;
 }
 
 .flatpickr-day.startRange {
   background-color: #1a1a1a;
   color: #ffffff;
 }
 
 .flatpickr-day.endRange {
   background-color: #1a1a1a;
   color: #ffffff;
 }
 
 .flatpickr-day.flatpickr-disabled {
   color: #1a1a1a;
   pointer-events: none;
 }
 
 .flatpickr-day.flatpickr-disabled::before {
   content: "";
   position: absolute;
   z-index: 1;
   top: 50%;
   /* [17] */
   left: 50%;
   /* [17] */
   display: block;
   width: 20px;
   height: 1px;
   transform: rotate(-30deg) translate(-50%, -50%);
   /* [17] */
   transform-origin: 0;
   /* [17] */
   background-color: currentColor;
 }
 
 .flatpickr-day:not(.inRange):not(.startRange):not(.endRange):not(:hover):not(:focus) {
   /* [12] */
 }
 
 .flatpickr-day:not(.inRange):not(.startRange):not(.endRange):not(:hover):not(:focus).prevMonthDay, .flatpickr-day:not(.inRange):not(.startRange):not(.endRange):not(:hover):not(:focus).nextMonthDay {
   color: #afb5ab;
 }
 
 .flatpickr-day.today:not(.flatpickr-disabled) {
   font-weight: 400;
   border: 1px solid #1a1a1a;
   color: #187085;
 }
 
 .flatpickr-day.selected:not(.flatpickr-disabled) {
   font-weight: 400;
   background-color: #1a1a1a;
   color: #ffffff;
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
   outline: 0;
   /* [3] */
 }
 
 .flatpickr-day.selected:not(.flatpickr-disabled):hover {
   background-color: #1a1a1a;
   color: #ffffff;
 }
 
 /**
  * FLATPICKR TIME STYLES
  */
 .flatpickr-time {
   display: flex;
   margin: -16px -16px;
   /* [10] */
   color: #1a1a1a;
 }
 
 .flatpickr-time:focus {
   outline: 0;
   /* [9] */
 }
 
 .flatpickr-hour,
 .flatpickr-minute,
 .flatpickr-second {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 48px;
   flex-grow: 1;
   flex-shrink: 1;
   flex-basis: auto;
   width: 100%;
   /* [10] */
   border: 0;
   text-align: center;
   background-color: transparent;
 }
 
 .flatpickr-hour:focus, .flatpickr-hour:hover,
 .flatpickr-minute:focus,
 .flatpickr-minute:hover,
 .flatpickr-second:focus,
 .flatpickr-second:hover {
   outline: 0;
 }
 
 .flatpickr-time-separator {
   line-height: 48px;
   pointer-events: none;
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
 }
 
 .flatpickr-am-pm {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 48px;
   display: block;
   min-width: 90px;
   cursor: pointer;
 }
 
 .flatpickr-am-pm:hover {
   background-color: #f2f2f2;
 }
 
 @keyframes plyr-progress {
   to {
     background-position: 25px 0;
   }
 }
 
 @keyframes plyr-popup {
   0% {
     opacity: 0.5;
     transform: translateY(10px);
   }
   to {
     opacity: 1;
     transform: translateY(0);
   }
 }
 
 @keyframes plyr-fade-in {
   from {
     opacity: 0;
   }
   to {
     opacity: 1;
   }
 }
 
 .plyr {
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   align-items: center;
   direction: ltr;
   display: flex;
   flex-direction: column;
   font-family: "open-sans", sans-serif;
   font-variant-numeric: tabular-nums;
   font-weight: 400;
   line-height: 24px;
   max-width: 100%;
   min-width: 200px;
   position: relative;
   text-shadow: none;
   transition: box-shadow 0.3s ease;
   z-index: 0;
 }
 
 .plyr video,
 .plyr audio,
 .plyr iframe {
   display: block;
   height: 100%;
   width: 100%;
 }
 
 .plyr button {
   font: inherit;
   line-height: inherit;
   width: auto;
 }
 
 .plyr:focus {
   outline: 0;
 }
 
 .plyr--full-ui {
   box-sizing: border-box;
 }
 
 .plyr--full-ui *,
 .plyr--full-ui *::after,
 .plyr--full-ui *::before {
   box-sizing: inherit;
 }
 
 .plyr--full-ui a,
 .plyr--full-ui button,
 .plyr--full-ui input,
 .plyr--full-ui label {
   touch-action: manipulation;
 }
 
 .plyr__badge {
   background: #187085;
   border-radius: 0;
   color: #ffffff;
   font-size: 10px;
   line-height: 1;
   padding: 3px 4px;
 }
 
 .plyr--full-ui ::-webkit-media-text-track-container {
   display: none;
 }
 
 .plyr__captions {
   animation: plyr-fade-in 0.3s ease;
   bottom: 0;
   display: none;
   font-size: 14px;
   left: 0;
   padding: 16px;
   position: absolute;
   text-align: center;
   transition: transform 0.4s ease-in-out;
   width: 100%;
 }
 
 .plyr__captions span:empty {
   display: none;
 }
 
 @media (min-width: 480px) {
   .plyr__captions {
     font-size: 16px;
     padding: calc(16px * 2);
   }
 }
 
 @media (min-width: 720px) {
   .plyr__captions {
     font-size: 24px;
   }
 }
 
 .plyr--captions-active .plyr__captions {
   display: block;
 }
 
 .plyr:not(.plyr--hide-controls) .plyr__controls:not(:empty) ~ .plyr__captions {
   transform: translateY(calc(16px * -4));
 }
 
 .plyr__caption {
   background: rgba(26, 26, 26, 0.5);
   border-radius: 2px;
   -webkit-box-decoration-break: clone;
   box-decoration-break: clone;
   color: #ffffff;
   line-height: 185%;
   padding: 0.2em 0.5em;
   white-space: pre-wrap;
 }
 
 .plyr__caption div {
   display: inline;
 }
 
 .plyr__control {
   background: transparent;
   border: 0;
   border-radius: 0;
   color: inherit;
   cursor: pointer;
   flex-shrink: 0;
   overflow: visible;
   padding: 16px;
   position: relative;
   transition: all 0.3s ease;
 }
 
 .plyr__control svg {
   display: block;
   fill: currentColor;
   height: 24px;
   pointer-events: none;
   width: 24px;
 }
 
 .plyr__control:focus {
   outline: 0;
 }
 
 .plyr__control.plyr__tab-focus {
   outline-color: #187085;
   outline-offset: 2px;
   outline-style: dotted;
   outline-width: 3px;
 }
 
 a.plyr__control {
   text-decoration: none;
 }
 
 a.plyr__control::after, a.plyr__control::before {
   display: none;
 }
 
 .plyr__control:not(.plyr__control--pressed) .icon--pressed,
 .plyr__control.plyr__control--pressed .icon--not-pressed,
 .plyr__control:not(.plyr__control--pressed) .label--pressed,
 .plyr__control.plyr__control--pressed .label--not-pressed {
   display: none;
 }
 
 .plyr--full-ui ::-webkit-media-controls {
   display: none;
 }
 
 .plyr__controls {
   align-items: center;
   display: flex;
   justify-content: flex-end;
   text-align: center;
 }
 
 .plyr__controls .plyr__progress__container {
   flex: 1;
   min-width: 0;
 }
 
 .plyr__controls .plyr__controls__item {
   margin-left: calc(16px / 4);
 }
 
 .plyr__controls .plyr__controls__item:first-child {
   margin-left: 0;
   margin-right: auto;
 }
 
 .plyr__controls .plyr__controls__item.plyr__progress__container {
   padding-left: calc(16px / 4);
 }
 
 .plyr__controls .plyr__controls__item.plyr__time {
   padding: 0 calc(16px / 2);
 }
 
 .plyr__controls .plyr__controls__item.plyr__progress__container:first-child, .plyr__controls .plyr__controls__item.plyr__time:first-child,
 .plyr__controls .plyr__controls__item.plyr__time + .plyr__time {
   padding-left: 0;
 }
 
 .plyr__controls:empty {
   display: none;
 }
 
 .plyr [data-plyr='captions'],
 .plyr [data-plyr='pip'],
 .plyr [data-plyr='airplay'],
 .plyr [data-plyr='fullscreen'] {
   display: none;
 }
 
 .plyr--captions-enabled [data-plyr='captions'],
 .plyr--pip-supported [data-plyr='pip'],
 .plyr--airplay-supported [data-plyr='airplay'],
 .plyr--fullscreen-enabled [data-plyr='fullscreen'] {
   display: inline-block;
 }
 
 .plyr__menu {
   display: flex;
   position: relative;
 }
 
 .plyr__menu .plyr__control svg {
   transition: transform 0.3s ease;
 }
 
 .plyr__menu .plyr__control[aria-expanded='true'] svg {
   transform: rotate(90deg);
 }
 
 .plyr__menu .plyr__control[aria-expanded='true'] .plyr__tooltip {
   display: none;
 }
 
 .plyr__menu__container {
   animation: plyr-popup 0.2s ease;
   background: rgba(255, 255, 255, 0.9);
   border-radius: 4px;
   bottom: 100%;
   box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.4);
   color: #187085;
   font-size: 16px;
   margin-bottom: 10px;
   position: absolute;
   right: -3px;
   text-align: left;
   white-space: nowrap;
   z-index: 3;
 }
 
 .plyr__menu__container > div {
   overflow: hidden;
   transition: height 0.35s cubic-bezier(0.4, 0, 0.2, 1), width 0.35s cubic-bezier(0.4, 0, 0.2, 1);
 }
 
 .plyr__menu__container::after {
   border: 6px solid transparent;
   border-top-color: rgba(255, 255, 255, 0.9);
   content: '';
   height: 0;
   position: absolute;
   right: calc(((24px / 2) + 16px) - (6px / 2));
   top: 100%;
   width: 0;
 }
 
 .plyr__menu__container [role='menu'] {
   padding: 16px;
 }
 
 .plyr__menu__container [role='menuitem'],
 .plyr__menu__container [role='menuitemradio'] {
   margin-top: 2px;
 }
 
 .plyr__menu__container [role='menuitem']:first-child,
 .plyr__menu__container [role='menuitemradio']:first-child {
   margin-top: 0;
 }
 
 .plyr__menu__container .plyr__control {
   align-items: center;
   color: #187085;
   display: flex;
   font-size: 14px;
   padding-bottom: calc(16px / 1.5);
   padding-left: calc(16px * 1.5);
   padding-right: calc(16px * 1.5);
   padding-top: calc(16px / 1.5);
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
   width: 100%;
 }
 
 .plyr__menu__container .plyr__control > span {
   align-items: inherit;
   display: flex;
   width: 100%;
 }
 
 .plyr__menu__container .plyr__control::after {
   border: 6px solid transparent;
   content: '';
   position: absolute;
   top: 50%;
   transform: translateY(-50%);
 }
 
 .plyr__menu__container .plyr__control--forward {
   padding-right: calc(16px * 4);
 }
 
 .plyr__menu__container .plyr__control--forward::after {
   border-left-color: #187085;
   right: calc((16px * 1.5) - 6px);
 }
 
 .plyr__menu__container .plyr__control--forward.plyr__tab-focus::after, .plyr__menu__container .plyr__control--forward:hover::after {
   border-left-color: currentColor;
 }
 
 .plyr__menu__container .plyr__control--back {
   font-weight: 400;
   margin: 16px;
   margin-bottom: calc(16px / 2);
   padding-left: calc(16px * 4);
   position: relative;
   width: calc(100% - (16px * 2));
 }
 
 .plyr__menu__container .plyr__control--back::after {
   border-right-color: #187085;
   left: calc((16px * 1.5) - 6px);
 }
 
 .plyr__menu__container .plyr__control--back::before {
   background: #187085;
   box-shadow: 0 1px 0 #ffffff;
   content: '';
   height: 1px;
   left: 0;
   margin-top: calc(16px / 2);
   overflow: hidden;
   position: absolute;
   right: 0;
   top: 100%;
 }
 
 .plyr__menu__container .plyr__control--back.plyr__tab-focus::after, .plyr__menu__container .plyr__control--back:hover::after {
   border-right-color: currentColor;
 }
 
 .plyr__menu__container .plyr__control[role='menuitemradio'] {
   padding-left: 16px;
 }
 
 .plyr__menu__container .plyr__control[role='menuitemradio']::before, .plyr__menu__container .plyr__control[role='menuitemradio']::after {
   border-radius: 100%;
 }
 
 .plyr__menu__container .plyr__control[role='menuitemradio']::before {
   background: rgba(0, 0, 0, 0.1);
   content: '';
   display: block;
   flex-shrink: 0;
   height: 16px;
   margin-right: 16px;
   transition: all 0.3s ease;
   width: 16px;
 }
 
 .plyr__menu__container .plyr__control[role='menuitemradio']::after {
   background: #fff;
   border: 0;
   height: 6px;
   left: 12px;
   opacity: 0;
   top: 50%;
   transform: translateY(-50%) scale(0);
   transition: transform 0.3s ease, opacity 0.3s ease;
   width: 6px;
 }
 
 .plyr__menu__container .plyr__control[role='menuitemradio'][aria-checked='true']::before {
   background: #187085;
 }
 
 .plyr__menu__container .plyr__control[role='menuitemradio'][aria-checked='true']::after {
   opacity: 1;
   transform: translateY(-50%) scale(1);
 }
 
 .plyr__menu__container .plyr__control[role='menuitemradio'].plyr__tab-focus::before, .plyr__menu__container .plyr__control[role='menuitemradio']:hover::before {
   background: rgba(35, 40, 47, 0.1);
 }
 
 .plyr__menu__container .plyr__menu__value {
   align-items: center;
   display: flex;
   margin-left: auto;
   margin-right: calc((16px - 2px) * -1);
   overflow: hidden;
   padding-left: calc(16px * 3.5);
   pointer-events: none;
 }
 
 .plyr--full-ui input[type='range'] {
   -webkit-appearance: none;
   /* stylelint-disable-line */
   background: transparent;
   border: 0;
   border-radius: calc(20px * 2);
   color: #187085;
   display: block;
   height: calc((3px * 2) + 20px);
   margin: 0;
   min-width: 0;
   padding: 0;
   transition: box-shadow 0.3s ease;
   width: 100%;
 }
 
 .plyr--full-ui input[type='range']::-webkit-slider-runnable-track {
   background: transparent;
   border: 0;
   border-radius: calc(2px / 2);
   height: 2px;
   -webkit-transition: box-shadow 0.3s ease;
   transition: box-shadow 0.3s ease;
   -webkit-user-select: none;
   user-select: none;
   background-image: linear-gradient(to right, currentColor 0%, transparent 0%);
 }
 
 .plyr--full-ui input[type='range']::-webkit-slider-thumb {
   background: #187085;
   border: 0;
   border-radius: 100%;
   box-shadow: none;
   height: 20px;
   position: relative;
   -webkit-transition: all 0.2s ease;
   transition: all 0.2s ease;
   width: 20px;
   -webkit-appearance: none;
   /* stylelint-disable-line */
   margin-top: calc(((20px - 2px) / 2) * -1);
 }
 
 .plyr--full-ui input[type='range']::-moz-range-track {
   background: transparent;
   border: 0;
   border-radius: calc(2px / 2);
   height: 2px;
   -moz-transition: box-shadow 0.3s ease;
   transition: box-shadow 0.3s ease;
   user-select: none;
 }
 
 .plyr--full-ui input[type='range']::-moz-range-thumb {
   background: #187085;
   border: 0;
   border-radius: 100%;
   box-shadow: none;
   height: 20px;
   position: relative;
   -moz-transition: all 0.2s ease;
   transition: all 0.2s ease;
   width: 20px;
 }
 
 .plyr--full-ui input[type='range']::-moz-range-progress {
   background: currentColor;
   border-radius: calc(2px / 2);
   height: 2px;
 }
 
 .plyr--full-ui input[type='range']::-ms-track {
   background: transparent;
   border: 0;
   border-radius: calc(2px / 2);
   height: 2px;
   -ms-transition: box-shadow 0.3s ease;
   transition: box-shadow 0.3s ease;
   -ms-user-select: none;
   user-select: none;
   color: transparent;
 }
 
 .plyr--full-ui input[type='range']::-ms-fill-upper {
   background: transparent;
   border: 0;
   border-radius: calc(2px / 2);
   height: 2px;
   -ms-transition: box-shadow 0.3s ease;
   transition: box-shadow 0.3s ease;
   -ms-user-select: none;
   user-select: none;
 }
 
 .plyr--full-ui input[type='range']::-ms-fill-lower {
   background: transparent;
   border: 0;
   border-radius: calc(2px / 2);
   height: 2px;
   -ms-transition: box-shadow 0.3s ease;
   transition: box-shadow 0.3s ease;
   -ms-user-select: none;
   user-select: none;
   background: currentColor;
 }
 
 .plyr--full-ui input[type='range']::-ms-thumb {
   background: #187085;
   border: 0;
   border-radius: 100%;
   box-shadow: none;
   height: 20px;
   position: relative;
   -ms-transition: all 0.2s ease;
   transition: all 0.2s ease;
   width: 20px;
   margin-top: 0;
 }
 
 .plyr--full-ui input[type='range']::-ms-tooltip {
   display: none;
 }
 
 .plyr--full-ui input[type='range']:focus {
   outline: 0;
 }
 
 .plyr--full-ui input[type='range']::-moz-focus-outer {
   border: 0;
 }
 
 .plyr--full-ui input[type='range'].plyr__tab-focus::-webkit-slider-runnable-track {
   outline-color: #187085;
   outline-offset: 2px;
   outline-style: dotted;
   outline-width: 3px;
 }
 
 .plyr--full-ui input[type='range'].plyr__tab-focus::-moz-range-track {
   outline-color: #187085;
   outline-offset: 2px;
   outline-style: dotted;
   outline-width: 3px;
 }
 
 .plyr--full-ui input[type='range'].plyr__tab-focus::-ms-track {
   outline-color: #187085;
   outline-offset: 2px;
   outline-style: dotted;
   outline-width: 3px;
 }
 
 .plyr__poster {
   background-color: #000000;
   background-position: 50% 50%;
   background-repeat: no-repeat;
   background-size: contain;
   height: 100%;
   left: 0;
   opacity: 0;
   position: absolute;
   top: 0;
   transition: opacity 0.2s ease;
   width: 100%;
   z-index: 1;
 }
 
 .plyr--stopped.plyr__poster-enabled .plyr__poster {
   opacity: 1;
 }
 
 .plyr__time {
   font-size: 14px;
 }
 
 .plyr__time + .plyr__time::before {
   content: '\2044';
   margin-right: 16px;
 }
 
 @media (max-width: 719px) {
   .plyr__time + .plyr__time {
     display: none;
   }
 }
 
 .plyr__tooltip {
   background: rgba(24, 112, 133, 0.75);
   border-radius: 0;
   bottom: 100%;
   box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.4);
   color: #ffffff;
   font-size: 14px;
   font-weight: 400;
   left: 50%;
   line-height: 1.3;
   margin-bottom: calc(16px * 2);
   opacity: 0;
   padding: 16px calc(16px * 1.5);
   pointer-events: none;
   position: absolute;
   transform: translate(-50%, 10px) scale(0.8);
   transform-origin: 50% 100%;
   transition: transform 0.2s 0.1s ease, opacity 0.2s 0.1s ease;
   white-space: nowrap;
   z-index: 2;
 }
 
 .plyr__tooltip::before {
   border-left: 4px solid transparent;
   border-right: 4px solid transparent;
   border-top: 4px solid rgba(24, 112, 133, 0.75);
   bottom: calc(4px * -1);
   content: '';
   height: 0;
   left: 50%;
   position: absolute;
   transform: translateX(-50%);
   width: 0;
   z-index: 2;
 }
 
 .plyr .plyr__control:hover .plyr__tooltip,
 .plyr .plyr__control.plyr__tab-focus .plyr__tooltip,
 .plyr__tooltip--visible {
   opacity: 1;
   transform: translate(-50%, 0) scale(1);
 }
 
 .plyr .plyr__control:hover .plyr__tooltip {
   z-index: 3;
 }
 
 .plyr__controls > .plyr__control:first-child .plyr__tooltip,
 .plyr__controls > .plyr__control:first-child + .plyr__control .plyr__tooltip {
   left: 0;
   transform: translate(0, 10px) scale(0.8);
   transform-origin: 0 100%;
 }
 
 .plyr__controls > .plyr__control:first-child .plyr__tooltip::before,
 .plyr__controls > .plyr__control:first-child + .plyr__control .plyr__tooltip::before {
   left: calc((24px / 2) + 16px);
 }
 
 .plyr__controls > .plyr__control:last-child .plyr__tooltip {
   left: auto;
   right: 0;
   transform: translate(0, 10px) scale(0.8);
   transform-origin: 100% 100%;
 }
 
 .plyr__controls > .plyr__control:last-child .plyr__tooltip::before {
   left: auto;
   right: calc((24px / 2) + 16px);
   transform: translateX(50%);
 }
 
 .plyr__controls > .plyr__control:first-child:hover .plyr__tooltip,
 .plyr__controls > .plyr__control:first-child.plyr__tab-focus .plyr__tooltip,
 .plyr__controls > .plyr__control:first-child .plyr__tooltip--visible,
 .plyr__controls > .plyr__control:first-child + .plyr__control:hover .plyr__tooltip,
 .plyr__controls > .plyr__control:first-child + .plyr__control.plyr__tab-focus .plyr__tooltip,
 .plyr__controls > .plyr__control:first-child + .plyr__control .plyr__tooltip--visible,
 .plyr__controls > .plyr__control:last-child:hover .plyr__tooltip,
 .plyr__controls > .plyr__control:last-child.plyr__tab-focus .plyr__tooltip,
 .plyr__controls > .plyr__control:last-child .plyr__tooltip--visible {
   transform: translate(0, 0) scale(1);
 }
 
 .plyr__progress {
   left: calc(20px * 0.5);
   margin-right: 20px;
   position: relative;
 }
 
 .plyr__progress input[type='range'], .plyr__progress__buffer {
   margin-left: calc(20px * -0.5);
   margin-right: calc(20px * -0.5);
   width: calc(100% + 20px);
 }
 
 .plyr__progress input[type='range'] {
   position: relative;
   z-index: 2;
 }
 
 .plyr__progress .plyr__tooltip {
   font-size: 14px;
   left: 0;
 }
 
 .plyr__progress__buffer {
   -webkit-appearance: none;
   /* stylelint-disable-line */
   background: transparent;
   border: 0;
   border-radius: 100px;
   height: 2px;
   left: 0;
   margin-top: calc((2px / 2) * -1);
   padding: 0;
   position: absolute;
   top: 50%;
 }
 
 .plyr__progress__buffer::-webkit-progress-bar {
   background: transparent;
 }
 
 .plyr__progress__buffer::-webkit-progress-value {
   background: currentColor;
   border-radius: 100px;
   min-width: 2px;
   -webkit-transition: width 0.2s ease;
   transition: width 0.2s ease;
 }
 
 .plyr__progress__buffer::-moz-progress-bar {
   background: currentColor;
   border-radius: 100px;
   min-width: 2px;
   -moz-transition: width 0.2s ease;
   transition: width 0.2s ease;
 }
 
 .plyr__progress__buffer::-ms-fill {
   border-radius: 100px;
   -ms-transition: width 0.2s ease;
   transition: width 0.2s ease;
 }
 
 .plyr--loading .plyr__progress__buffer {
   animation: plyr-progress 1s linear infinite;
   background-image: linear-gradient(-45deg, rgba(26, 26, 26, 0.25) 25%, transparent 25%, transparent 50%, rgba(26, 26, 26, 0.25) 50%, rgba(26, 26, 26, 0.25) 75%, transparent 75%, transparent);
   background-repeat: repeat-x;
   background-size: 25px 25px;
   color: transparent;
 }
 
 .plyr--video.plyr--loading .plyr__progress__buffer {
   background-color: rgba(255, 255, 255, 0.75);
 }
 
 .plyr--audio.plyr--loading .plyr__progress__buffer {
   background-color: rgba(255, 255, 255, 0.75);
 }
 
 .plyr__volume {
   align-items: center;
   display: flex;
   max-width: 110px;
   min-width: 80px;
   position: relative;
   width: 20%;
 }
 
 .plyr__volume input[type='range'] {
   margin-left: calc(16px / 2);
   margin-right: calc(16px / 2);
   position: relative;
   z-index: 2;
 }
 
 .plyr--is-ios .plyr__volume {
   min-width: 0;
   width: auto;
 }
 
 .plyr--audio {
   display: block;
 }
 
 .plyr--audio .plyr__controls {
   background: #ffffff;
   border-radius: inherit;
   color: #187085;
   padding: 16px;
 }
 
 .plyr--audio .plyr__control.plyr__tab-focus, .plyr--audio .plyr__control:hover, .plyr--audio .plyr__control[aria-expanded='true'] {
   background: transparent;
   color: #1a1a1a;
 }
 
 .plyr--full-ui.plyr--audio input[type='range']::-webkit-slider-runnable-track {
   background-color: rgba(255, 255, 255, 0.75);
 }
 
 .plyr--full-ui.plyr--audio input[type='range']::-moz-range-track {
   background-color: rgba(255, 255, 255, 0.75);
 }
 
 .plyr--full-ui.plyr--audio input[type='range']::-ms-track {
   background-color: rgba(255, 255, 255, 0.75);
 }
 
 .plyr--full-ui.plyr--audio input[type='range']:active::-webkit-slider-thumb {
   box-shadow: none, 0 0 0 3px rgba(26, 26, 26, 0.9);
 }
 
 .plyr--full-ui.plyr--audio input[type='range']:active::-moz-range-thumb {
   box-shadow: none, 0 0 0 3px rgba(26, 26, 26, 0.9);
 }
 
 .plyr--full-ui.plyr--audio input[type='range']:active::-ms-thumb {
   box-shadow: none, 0 0 0 3px rgba(26, 26, 26, 0.9);
 }
 
 .plyr--audio .plyr__progress__buffer {
   color: rgba(255, 255, 255, 0.75);
 }
 
 .plyr--video {
   background: #000000;
   overflow: hidden;
 }
 
 .plyr--video.plyr--menu-open {
   overflow: visible;
 }
 
 .plyr__video-wrapper {
   background: #000000;
   height: 100%;
   margin: auto;
   overflow: hidden;
   position: relative;
   width: 100%;
 }
 
 .plyr__video-embed,
 .plyr__video-wrapper--fixed-ratio {
   height: 0;
   padding-bottom: 56.25%;
 }
 
 .plyr__video-embed iframe,
 .plyr__video-wrapper--fixed-ratio video {
   border: 0;
   left: 0;
   position: absolute;
   top: 0;
 }
 
 .plyr--full-ui .plyr__video-embed > .plyr__video-embed__container {
   padding-bottom: 240%;
   position: relative;
   transform: translateY(-38.28125%);
 }
 
 .plyr--video .plyr__controls {
   background: #1a1a1a;
   border-bottom-left-radius: inherit;
   border-bottom-right-radius: inherit;
   bottom: 0;
   color: #187085;
   left: 0;
   padding: calc(16px / 2);
   padding-top: calc(16px * 2);
   position: absolute;
   right: 0;
   transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
   z-index: 3;
 }
 
 @media (min-width: 480px) {
   .plyr--video .plyr__controls {
     padding: 16px;
     padding-top: calc(16px * 3.5);
   }
 }
 
 .plyr--video.plyr--hide-controls .plyr__controls {
   opacity: 0;
   pointer-events: none;
   transform: translateY(100%);
 }
 
 .plyr--video .plyr__control.plyr__tab-focus, .plyr--video .plyr__control:hover, .plyr--video .plyr__control[aria-expanded='true'] {
   background: transparent;
   color: #ffffff;
 }
 
 .plyr__control--overlaid {
   background: transparent;
   border: 0;
   border-radius: 100%;
   color: #187085;
   display: none;
   left: 50%;
   opacity: 0.9;
   padding: calc(16px * 1.5);
   position: absolute;
   top: 50%;
   transform: translate(-50%, -50%);
   transition: 0.3s;
   z-index: 2;
 }
 
 .plyr__control--overlaid svg {
   left: 2px;
   position: relative;
 }
 
 .plyr__control--overlaid:hover, .plyr__control--overlaid:focus {
   opacity: 1;
 }
 
 .plyr--playing .plyr__control--overlaid {
   opacity: 0;
   visibility: hidden;
 }
 
 .plyr--full-ui.plyr--video .plyr__control--overlaid {
   display: block;
 }
 
 .plyr--full-ui.plyr--video input[type='range']::-webkit-slider-runnable-track {
   background-color: rgba(255, 255, 255, 0.75);
 }
 
 .plyr--full-ui.plyr--video input[type='range']::-moz-range-track {
   background-color: rgba(255, 255, 255, 0.75);
 }
 
 .plyr--full-ui.plyr--video input[type='range']::-ms-track {
   background-color: rgba(255, 255, 255, 0.75);
 }
 
 .plyr--full-ui.plyr--video input[type='range']:active::-webkit-slider-thumb {
   box-shadow: none, 0 0 0 3px rgba(255, 255, 255, 0.9);
 }
 
 .plyr--full-ui.plyr--video input[type='range']:active::-moz-range-thumb {
   box-shadow: none, 0 0 0 3px rgba(255, 255, 255, 0.9);
 }
 
 .plyr--full-ui.plyr--video input[type='range']:active::-ms-thumb {
   box-shadow: none, 0 0 0 3px rgba(255, 255, 255, 0.9);
 }
 
 .plyr--video .plyr__progress__buffer {
   color: rgba(255, 255, 255, 0.75);
 }
 
 .plyr:-webkit-full-screen {
   background: #000;
   border-radius: 0 !important;
   height: 100%;
   margin: 0;
   width: 100%;
 }
 
 .plyr:-ms-fullscreen {
   background: #000;
   border-radius: 0 !important;
   height: 100%;
   margin: 0;
   width: 100%;
 }
 
 .plyr:fullscreen {
   background: #000;
   border-radius: 0 !important;
   height: 100%;
   margin: 0;
   width: 100%;
 }
 
 .plyr:-webkit-full-screen video {
   height: 100%;
 }
 
 .plyr:-ms-fullscreen video {
   height: 100%;
 }
 
 .plyr:fullscreen video {
   height: 100%;
 }
 
 .plyr:-webkit-full-screen .plyr__video-wrapper {
   height: 100%;
   position: static;
 }
 
 .plyr:-ms-fullscreen .plyr__video-wrapper {
   height: 100%;
   position: static;
 }
 
 .plyr:fullscreen .plyr__video-wrapper {
   height: 100%;
   position: static;
 }
 
 .plyr:-webkit-full-screen.plyr--vimeo .plyr__video-wrapper {
   height: 0;
   position: relative;
 }
 
 .plyr:-ms-fullscreen.plyr--vimeo .plyr__video-wrapper {
   height: 0;
   position: relative;
 }
 
 .plyr:fullscreen.plyr--vimeo .plyr__video-wrapper {
   height: 0;
   position: relative;
 }
 
 .plyr:-webkit-full-screen .plyr__control .icon--exit-fullscreen {
   display: block;
 }
 
 .plyr:-ms-fullscreen .plyr__control .icon--exit-fullscreen {
   display: block;
 }
 
 .plyr:fullscreen .plyr__control .icon--exit-fullscreen {
   display: block;
 }
 
 .plyr:-webkit-full-screen .plyr__control .icon--exit-fullscreen + svg {
   display: none;
 }
 
 .plyr:-ms-fullscreen .plyr__control .icon--exit-fullscreen + svg {
   display: none;
 }
 
 .plyr:fullscreen .plyr__control .icon--exit-fullscreen + svg {
   display: none;
 }
 
 .plyr:-webkit-full-screen.plyr--hide-controls {
   cursor: none;
 }
 
 .plyr:-ms-fullscreen.plyr--hide-controls {
   cursor: none;
 }
 
 .plyr:fullscreen.plyr--hide-controls {
   cursor: none;
 }
 
 @media (min-width: 1280px) {
   .plyr:-webkit-full-screen .plyr__captions {
     font-size: 32px;
   }
   .plyr:-ms-fullscreen .plyr__captions {
     font-size: 32px;
   }
   .plyr:fullscreen .plyr__captions {
     font-size: 32px;
   }
 }
 
 /* stylelint-disable-next-line */
 .plyr:-webkit-full-screen {
   background: #000;
   border-radius: 0 !important;
   height: 100%;
   margin: 0;
   width: 100%;
 }
 
 .plyr:-webkit-full-screen video {
   height: 100%;
 }
 
 .plyr:-webkit-full-screen .plyr__video-wrapper {
   height: 100%;
   position: static;
 }
 
 .plyr:-webkit-full-screen.plyr--vimeo .plyr__video-wrapper {
   height: 0;
   position: relative;
 }
 
 .plyr:-webkit-full-screen .plyr__control .icon--exit-fullscreen {
   display: block;
 }
 
 .plyr:-webkit-full-screen .plyr__control .icon--exit-fullscreen + svg {
   display: none;
 }
 
 .plyr:-webkit-full-screen.plyr--hide-controls {
   cursor: none;
 }
 
 @media (min-width: 1280px) {
   .plyr:-webkit-full-screen .plyr__captions {
     font-size: 32px;
   }
 }
 
 /* stylelint-disable-next-line */
 .plyr:-moz-full-screen {
   background: #000;
   border-radius: 0 !important;
   height: 100%;
   margin: 0;
   width: 100%;
 }
 
 .plyr:-moz-full-screen video {
   height: 100%;
 }
 
 .plyr:-moz-full-screen .plyr__video-wrapper {
   height: 100%;
   position: static;
 }
 
 .plyr:-moz-full-screen.plyr--vimeo .plyr__video-wrapper {
   height: 0;
   position: relative;
 }
 
 .plyr:-moz-full-screen .plyr__control .icon--exit-fullscreen {
   display: block;
 }
 
 .plyr:-moz-full-screen .plyr__control .icon--exit-fullscreen + svg {
   display: none;
 }
 
 .plyr:-moz-full-screen.plyr--hide-controls {
   cursor: none;
 }
 
 @media (min-width: 1280px) {
   .plyr:-moz-full-screen .plyr__captions {
     font-size: 32px;
   }
 }
 
 /* stylelint-disable-next-line */
 .plyr:-ms-fullscreen {
   background: #000;
   border-radius: 0 !important;
   height: 100%;
   margin: 0;
   width: 100%;
 }
 
 .plyr:-ms-fullscreen video {
   height: 100%;
 }
 
 .plyr:-ms-fullscreen .plyr__video-wrapper {
   height: 100%;
   position: static;
 }
 
 .plyr:-ms-fullscreen.plyr--vimeo .plyr__video-wrapper {
   height: 0;
   position: relative;
 }
 
 .plyr:-ms-fullscreen .plyr__control .icon--exit-fullscreen {
   display: block;
 }
 
 .plyr:-ms-fullscreen .plyr__control .icon--exit-fullscreen + svg {
   display: none;
 }
 
 .plyr:-ms-fullscreen.plyr--hide-controls {
   cursor: none;
 }
 
 @media (min-width: 1280px) {
   .plyr:-ms-fullscreen .plyr__captions {
     font-size: 32px;
   }
 }
 
 .plyr--fullscreen-fallback {
   background: #000;
   border-radius: 0 !important;
   height: 100%;
   margin: 0;
   width: 100%;
   bottom: 0;
   display: block;
   left: 0;
   position: fixed;
   right: 0;
   top: 0;
   z-index: 10000000;
 }
 
 .plyr--fullscreen-fallback video {
   height: 100%;
 }
 
 .plyr--fullscreen-fallback .plyr__video-wrapper {
   height: 100%;
   position: static;
 }
 
 .plyr--fullscreen-fallback.plyr--vimeo .plyr__video-wrapper {
   height: 0;
   position: relative;
 }
 
 .plyr--fullscreen-fallback .plyr__control .icon--exit-fullscreen {
   display: block;
 }
 
 .plyr--fullscreen-fallback .plyr__control .icon--exit-fullscreen + svg {
   display: none;
 }
 
 .plyr--fullscreen-fallback.plyr--hide-controls {
   cursor: none;
 }
 
 @media (min-width: 1280px) {
   .plyr--fullscreen-fallback .plyr__captions {
     font-size: 32px;
   }
 }
 
 .plyr__ads {
   border-radius: inherit;
   bottom: 0;
   cursor: pointer;
   left: 0;
   overflow: hidden;
   position: absolute;
   right: 0;
   top: 0;
   z-index: -1;
 }
 
 .plyr__ads > div,
 .plyr__ads > div iframe {
   height: 100%;
   position: absolute;
   width: 100%;
 }
 
 .plyr__ads::after {
   background: #23282f;
   border-radius: 2px;
   bottom: 16px;
   color: #fff;
   content: attr(data-badge-text);
   font-size: 11px;
   padding: 2px 6px;
   pointer-events: none;
   position: absolute;
   right: 16px;
   z-index: 3;
 }
 
 .plyr__ads::after:empty {
   display: none;
 }
 
 .plyr__cues {
   background: currentColor;
   display: block;
   height: 2px;
   left: 0;
   margin: -1px 0 0;
   opacity: 0.8;
   position: absolute;
   top: 50%;
   width: 3px;
   z-index: 3;
 }
 
 .plyr__preview-thumb {
   background-color: rgba(24, 112, 133, 0.75);
   border-radius: 3px;
   bottom: 100%;
   box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.4);
   margin-bottom: calc(16px * 2);
   opacity: 0;
   padding: 0;
   pointer-events: none;
   position: absolute;
   transform: translate(0, 10px) scale(0.8);
   transform-origin: 50% 100%;
   transition: transform 0.2s 0.1s ease, opacity 0.2s 0.1s ease;
   z-index: 2;
 }
 
 .plyr__preview-thumb--is-shown {
   opacity: 1;
   transform: translate(0, 0) scale(1);
 }
 
 .plyr__preview-thumb::before {
   border-left: 4px solid transparent;
   border-right: 4px solid transparent;
   border-top: 4px solid rgba(24, 112, 133, 0.75);
   bottom: calc(4px * -1);
   content: '';
   height: 0;
   left: 50%;
   position: absolute;
   transform: translateX(-50%);
   width: 0;
   z-index: 2;
 }
 
 .plyr__preview-thumb__image-container {
   background: #c1c8d1;
   border-radius: calc(0px - 1px);
   overflow: hidden;
   position: relative;
   z-index: 0;
 }
 
 .plyr__preview-thumb__image-container img {
   height: 100%;
   left: 0;
   max-height: none;
   max-width: none;
   position: absolute;
   top: 0;
   width: 100%;
 }
 
 .plyr__preview-thumb__time-container {
   bottom: 6px;
   left: 0;
   position: absolute;
   right: 0;
   white-space: nowrap;
   z-index: 3;
 }
 
 .plyr__preview-thumb__time-container span {
   background-color: rgba(0, 0, 0, 0.55);
   border-radius: calc(0px - 1px);
   color: #fff;
   font-size: 14px;
   padding: 3px 6px;
 }
 
 .plyr__preview-scrubbing {
   bottom: 0;
   filter: blur(1px);
   height: 100%;
   left: 0;
   margin: auto;
   opacity: 0;
   overflow: hidden;
   pointer-events: none;
   position: absolute;
   right: 0;
   top: 0;
   transition: opacity 0.3s ease;
   width: 100%;
   z-index: 1;
 }
 
 .plyr__preview-scrubbing--is-shown {
   opacity: 1;
 }
 
 .plyr__preview-scrubbing img {
   height: 100%;
   left: 0;
   max-height: none;
   max-width: none;
   object-fit: contain;
   position: absolute;
   top: 0;
   width: 100%;
 }
 
 .plyr--no-transition {
   transition: none !important;
 }
 
 .plyr__sr-only {
   clip: rect(1px, 1px, 1px, 1px);
   overflow: hidden;
   border: 0 !important;
   height: 1px !important;
   padding: 0 !important;
   position: absolute !important;
   width: 1px !important;
 }
 
 .plyr [hidden] {
   display: none !important;
 }
 
 /* ------------------------------------*\
     #ICONS
 \*------------------------------------ */
 /**
  * [1] In case the icon is an `<a>` element, this gives us an easy way of
  *     eliminating an underline appearing in IE11. In case you actually want
  *     any text-decoration, you can override the `$icon-text-decoration`
  *     variable.
  */
 .c-icon {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   padding: 0;
   border: 0;
   background-color: transparent;
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   text-decoration: none;
   /* [1] */
   color: currentColor;
 }
 
 .c-icon:focus {
   outline: 0;
 }
 
 .c-icon::before {
   display: inline-block;
   transition: all 250ms ease;
 }
 
 /**
  * Generate fallback-icons.
  * Use key as name and value as icon content.
  */
 /**
  * Generate icon-classes.
  */
 .c-icon--\[air-filter\]::before {
   content: "\e900";
 }
 
 .c-icon--\[arrow-bottom\]::before {
   content: "\e901";
 }
 
 .c-icon--\[arrow-left\]::before {
   content: "\e902";
 }
 
 .c-icon--\[arrow-right\]::before {
   content: "\e903";
 }
 
 .c-icon--\[arrow-up\]::before {
   content: "\e904";
 }
 
 .c-icon--\[attention\]::before {
   content: "\e905";
 }
 
 .c-icon--\[bell\]::before {
   content: "\e906";
 }
 
 .c-icon--\[brake-fluid\]::before {
   content: "\e907";
 }
 
 .c-icon--\[briefcase\]::before {
   content: "\e908";
 }
 
 .c-icon--\[calculator-03\]::before {
   content: "\e909";
 }
 
 .c-icon--\[car\]::before {
   content: "\e90a";
 }
 
 .c-icon--\[car-configurator\]::before {
   content: "\e90b";
 }
 
 .c-icon--\[car-door\]::before {
   content: "\e90c";
 }
 
 .c-icon--\[car-seat\]::before {
   content: "\e90d";
 }
 
 .c-icon--\[car-side\]::before {
   content: "\e90e";
 }
 
 .c-icon--\[car-three-stars\]::before {
   content: "\e90f";
 }
 
 .c-icon--\[chevron-bottom\]::before {
   content: "\e910";
 }
 
 .c-icon--\[chevron-left\]::before {
   content: "\e911";
 }
 
 .c-icon--\[chevron-right\]::before {
   content: "\e912";
 }
 
 .c-icon--\[chevron-up\]::before {
   content: "\e913";
 }
 
 .c-icon--\[clock\]::before {
   content: "\e914";
 }
 
 .c-icon--\[dealer\]::before {
   content: "\e915";
 }
 
 .c-icon--\[details\]::before {
   content: "\e916";
 }
 
 .c-icon--\[diesel\]::before {
   content: "\e917";
 }
 
 .c-icon--\[document\]::before {
   content: "\e918";
 }
 
 .c-icon--\[doors-double\]::before {
   content: "\e919";
 }
 
 .c-icon--\[electricity-plug\]::before {
   content: "\e91a";
 }
 
 .c-icon--\[emission\]::before {
   content: "\e91b";
 }
 
 .c-icon--\[engine\]::before {
   content: "\e91c";
 }
 
 .c-icon--\[engine-oil\]::before {
   content: "\e91d";
 }
 
 .c-icon--\[finger-arrows\]::before {
   content: "\e91e";
 }
 
 .c-icon--\[floppy-disc\]::before {
   content: "\e91f";
 }
 
 .c-icon--\[four-wheel-drive\]::before {
   content: "\e920";
 }
 
 .c-icon--\[front-wheel-drive\]::before {
   content: "\e921";
 }
 
 .c-icon--\[gear\]::before {
   content: "\e922";
 }
 
 .c-icon--\[gear-oil\]::before {
   content: "\e923";
 }
 
 .c-icon--\[hand-circle-eurosign\]::before {
   content: "\e924";
 }
 
 .c-icon--\[hybrid\]::before {
   content: "\e925";
 }
 
 .c-icon--\[list-badge-lines-1\]::before {
   content: "\e926";
 }
 
 .c-icon--\[list-badge-lines-3\]::before {
   content: "\e927";
 }
 
 .c-icon--\[list-badge-lines-5\]::before {
   content: "\e928";
 }
 
 .c-icon--\[list-view\]::before {
   content: "\e929";
 }
 
 .c-icon--\[lock\]::before {
   content: "\e92a";
 }
 
 .c-icon--\[magazin\]::before {
   content: "\e92b";
 }
 
 .c-icon--\[mobile\]::before {
   content: "\e92c";
 }
 
 .c-icon--\[natural-gas\]::before {
   content: "\e92d";
 }
 
 .c-icon--\[offers\]::before {
   content: "\e92e";
 }
 
 .c-icon--\[performance\]::before {
   content: "\e92f";
 }
 
 .c-icon--\[petrol\]::before {
   content: "\e930";
 }
 
 .c-icon--\[piggybank\]::before {
   content: "\e931";
 }
 
 .c-icon--\[pin\]::before {
   content: "\e932";
 }
 
 .c-icon--\[quality\]::before {
   content: "\e933";
 }
 
 .c-icon--\[quality-medal\]::before {
   content: "\e934";
 }
 
 .c-icon--\[safety-check\]::before {
   content: "\e935";
 }
 
 .c-icon--\[save-cloud\]::before {
   content: "\e936";
 }
 
 .c-icon--\[save-local\]::before {
   content: "\e937";
 }
 
 .c-icon--\[shield-car\]::before {
   content: "\e938";
 }
 
 .c-icon--\[spark-plug\]::before {
   content: "\e939";
 }
 
 .c-icon--\[speech-bubble-question-mark\]::before {
   content: "\e93a";
 }
 
 .c-icon--\[steering-wheel\]::before {
   content: "\e93b";
 }
 
 .c-icon--\[tow-bar\]::before {
   content: "\e93c";
 }
 
 .c-icon--\[transmission-automatic\]::before {
   content: "\e93d";
 }
 
 .c-icon--\[transmission-manual\]::before {
   content: "\e93e";
 }
 
 .c-icon--\[two-bubbles\]::before {
   content: "\e93f";
 }
 
 .c-icon--\[wallet\]::before {
   content: "\e940";
 }
 
 .c-icon--\[workshop\]::before {
   content: "\e941";
 }
 
 .c-icon--\[control-account-detail\]::before {
   content: "\e942";
 }
 
 .c-icon--\[control-adress-book\]::before {
   content: "\e943";
 }
 
 .c-icon--\[control-arrow-bottom\]::before {
   content: "\e944";
 }
 
 .c-icon--\[control-arrow-left\]::before {
   content: "\e945";
 }
 
 .c-icon--\[control-arrow-right\]::before {
   content: "\e946";
 }
 
 .c-icon--\[control-arrow-top\]::before {
   content: "\e947";
 }
 
 .c-icon--\[control-arrow-up-and-down\]::before {
   content: "\e948";
 }
 
 .c-icon--\[control-bankey-appli\]::before {
   content: "\e949";
 }
 
 .c-icon--\[control-bigger\]::before {
   content: "\e94a";
 }
 
 .c-icon--\[control-bin\]::before {
   content: "\e94b";
 }
 
 .c-icon--\[control-bookmark\]::before {
   content: "\e94c";
 }
 
 .c-icon--\[control-burger\]::before {
   content: "\e94d";
 }
 
 .c-icon--\[control-calendar\]::before {
   content: "\e94e";
 }
 
 .c-icon--\[control-caption\]::before {
   content: "\e94f";
 }
 
 .c-icon--\[control-captions-closed-off\]::before {
   content: "\e950";
 }
 
 .c-icon--\[control-captions-closed-on\]::before {
   content: "\e951";
 }
 
 .c-icon--\[control-checkmark\]::before {
   content: "\e952";
 }
 
 .c-icon--\[control-circle-ellipsis\]::before {
   content: "\e953";
 }
 
 .c-icon--\[control-comments\]::before {
   content: "\e954";
 }
 
 .c-icon--\[control-cross-filled\]::before {
   content: "\e955";
 }
 
 .c-icon--\[control-data-protection\]::before {
   content: "\e956";
 }
 
 .c-icon--\[control-divide\]::before {
   content: "\e957";
 }
 
 .c-icon--\[control-document-car\]::before {
   content: "\e958";
 }
 
 .c-icon--\[control-document-cross\]::before {
   content: "\e959";
 }
 
 .c-icon--\[control-documents\]::before {
   content: "\e95a";
 }
 
 .c-icon--\[control-download\]::before {
   content: "\e95b";
 }
 
 .c-icon--\[control-drag-drop\]::before {
   content: "\e95c";
 }
 
 .c-icon--\[control-engine\]::before {
   content: "\e95d";
 }
 
 .c-icon--\[control-enter-fullscreen\]::before {
   content: "\e95e";
 }
 
 .c-icon--\[control-equal\]::before {
   content: "\e95f";
 }
 
 .c-icon--\[control-eurosign\]::before {
   content: "\e960";
 }
 
 .c-icon--\[control-exclamation-mark\]::before {
   content: "\e961";
 }
 
 .c-icon--\[control-exclamation-mark-circle\]::before {
   content: "\e962";
 }
 
 .c-icon--\[control-exit-fullscreen\]::before {
   content: "\e963";
 }
 
 .c-icon--\[control-eye\]::before {
   content: "\e964";
 }
 
 .c-icon--\[control-eye-crossed\]::before {
   content: "\e965";
 }
 
 .c-icon--\[control-faq\]::before {
   content: "\e966";
 }
 
 .c-icon--\[control-favorite\]::before {
   content: "\e967";
 }
 
 .c-icon--\[control-filter-01\]::before {
   content: "\e968";
 }
 
 .c-icon--\[control-filter-02\]::before {
   content: "\e969";
 }
 
 .c-icon--\[control-floppy-disk\]::before {
   content: "\e96a";
 }
 
 .c-icon--\[control-full-arrow-left\]::before {
   content: "\e96b";
 }
 
 .c-icon--\[control-full-arrow-right\]::before {
   content: "\e96c";
 }
 
 .c-icon--\[control-gear\]::before {
   content: "\e96d";
 }
 
 .c-icon--\[control-globe\]::before {
   content: "\e96e";
 }
 
 .c-icon--\[control-graph-view\]::before {
   content: "\e96f";
 }
 
 .c-icon--\[control-house\]::before {
   content: "\e970";
 }
 
 .c-icon--\[control-info\]::before {
   content: "\e971";
 }
 
 .c-icon--\[control-info-circle\]::before {
   content: "\e972";
 }
 
 .c-icon--\[control-lightbulb\]::before {
   content: "\e973";
 }
 
 .c-icon--\[control-list-view\]::before {
   content: "\e974";
 }
 
 .c-icon--\[control-logout\]::before {
   content: "\e975";
 }
 
 .c-icon--\[control-magazine\]::before {
   content: "\e976";
 }
 
 .c-icon--\[control-magnifying-glass\]::before {
   content: "\e977";
 }
 
 .c-icon--\[control-mail\]::before {
   content: "\e978";
 }
 
 .c-icon--\[control-minus-filled\]::before {
   content: "\e979";
 }
 
 .c-icon--\[control-money-transfer\]::before {
   content: "\e97a";
 }
 
 .c-icon--\[control-money-transfer-02\]::before {
   content: "\e97b";
 }
 
 .c-icon--\[control-no-sound\]::before {
   content: "\e97c";
 }
 
 .c-icon--\[control-pause\]::before {
   content: "\e97d";
 }
 
 .c-icon--\[control-pen\]::before {
   content: "\e97e";
 }
 
 .c-icon--\[control-performance\]::before {
   content: "\e97f";
 }
 
 .c-icon--\[control-phone\]::before {
   content: "\e980";
 }
 
 .c-icon--\[control-play\]::before {
   content: "\e981";
 }
 
 .c-icon--\[control-plus-filled\]::before {
   content: "\e982";
 }
 
 .c-icon--\[control-printer\]::before {
   content: "\e983";
 }
 
 .c-icon--\[control-reload\]::before {
   content: "\e984";
 }
 
 .c-icon--\[control-repeat-transaction\]::before {
   content: "\e985";
 }
 
 .c-icon--\[control-revoke-transaction\]::before {
   content: "\e986";
 }
 
 .c-icon--\[control-share\]::before {
   content: "\e987";
 }
 
 .c-icon--\[control-share-02\]::before {
   content: "\e988";
 }
 
 .c-icon--\[control-sound\]::before {
   content: "\e989";
 }
 
 .c-icon--\[control-star\]::before {
   content: "\e98a";
 }
 
 .c-icon--\[control-stop\]::before {
   content: "\e98b";
 }
 
 .c-icon--\[control-stop-watch\]::before {
   content: "\e98c";
 }
 
 .c-icon--\[control-support\]::before {
   content: "\e98d";
 }
 
 .c-icon--\[control-transaction-list\]::before {
   content: "\e98e";
 }
 
 .c-icon--\[control-triangle-paragraph-sign\]::before {
   content: "\e98f";
 }
 
 .c-icon--\[control-upload\]::before {
   content: "\e990";
 }
 
 .c-icon--\[control-user\]::before {
   content: "\e991";
 }
 
 .c-icon--\[control-xls-doc\]::before {
   content: "\e992";
 }
 
 .c-icon--\[social-facebook\]::before {
   content: "\e993";
 }
 
 .c-icon--\[social-instagram\]::before {
   content: "\e994";
 }
 
 .c-icon--\[social-linkedin\]::before {
   content: "\e995";
 }
 
 .c-icon--\[social-pinterest\]::before {
   content: "\e996";
 }
 
 .c-icon--\[social-rss\]::before {
   content: "\e997";
 }
 
 .c-icon--\[social-twitter\]::before {
   content: "\e998";
 }
 
 .c-icon--\[social-vimeo\]::before {
   content: "\e999";
 }
 
 .c-icon--\[social-xing\]::before {
   content: "\e99a";
 }
 
 .c-icon--\[social-youtube\]::before {
   content: "\e99b";
 }
 
 .c-icon--\[semantic-accessoires\]::before {
   content: "\e924";
 }
 
 .c-icon--\[semantic-add\]::before {
   content: "\e982";
 }
 
 .c-icon--\[semantic-air-filter\]::before {
   content: "\e900";
 }
 
 .c-icon--\[semantic-arrow-right\]::before {
   content: "\e946";
 }
 
 .c-icon--\[semantic-back\]::before {
   content: "\e945";
 }
 
 .c-icon--\[semantic-benefit-finance\]::before {
   content: "\e931";
 }
 
 .c-icon--\[semantic-brake-fluid\]::before {
   content: "\e907";
 }
 
 .c-icon--\[semantic-briefcase\]::before {
   content: "\e908";
 }
 
 .c-icon--\[semantic-brochure\]::before {
   content: "\e92b";
 }
 
 .c-icon--\[semantic-calculator\]::before {
   content: "\e909";
 }
 
 .c-icon--\[semantic-calendar\]::before {
   content: "\e94e";
 }
 
 .c-icon--\[semantic-car-door\]::before {
   content: "\e90c";
 }
 
 .c-icon--\[semantic-car-handover\]::before {
   content: "\e938";
 }
 
 .c-icon--\[semantic-car-seat\]::before {
   content: "\e90d";
 }
 
 .c-icon--\[semantic-car-side\]::before {
   content: "\e90e";
 }
 
 .c-icon--\[semantic-car-tow-bar\]::before {
   content: "\e93c";
 }
 
 .c-icon--\[semantic-car-value\]::before {
   content: "\e90f";
 }
 
 .c-icon--\[semantic-car\]::before {
   content: "\e90a";
 }
 
 .c-icon--\[semantic-chat\]::before {
   content: "\e98d";
 }
 
 .c-icon--\[semantic-checkmark\]::before {
   content: "\e952";
 }
 
 .c-icon--\[semantic-clock\]::before {
   content: "\e914";
 }
 
 .c-icon--\[semantic-close\]::before {
   content: "\e955";
 }
 
 .c-icon--\[semantic-collapse\]::before {
   content: "\e947";
 }
 
 .c-icon--\[semantic-configuration-details\]::before {
   content: "\e90b";
 }
 
 .c-icon--\[semantic-contact\]::before {
   content: "\e93f";
 }
 
 .c-icon--\[semantic-crossed-out\]::before {
   content: "\e955";
 }
 
 .c-icon--\[semantic-dealer\]::before {
   content: "\e915";
 }
 
 .c-icon--\[semantic-delete\]::before {
   content: "\e94b";
 }
 
 .c-icon--\[semantic-details\]::before {
   content: "\e916";
 }
 
 .c-icon--\[semantic-diesel\]::before {
   content: "\e917";
 }
 
 .c-icon--\[semantic-download\]::before {
   content: "\e95b";
 }
 
 .c-icon--\[semantic-edit\]::before {
   content: "\e97e";
 }
 
 .c-icon--\[semantic-electric\]::before {
   content: "\e91a";
 }
 
 .c-icon--\[semantic-emission\]::before {
   content: "\e91b";
 }
 
 .c-icon--\[semantic-engine-oil\]::before {
   content: "\e91d";
 }
 
 .c-icon--\[semantic-engine\]::before {
   content: "\e91c";
 }
 
 .c-icon--\[semantic-enter-fullscreen\]::before {
   content: "\e95e";
 }
 
 .c-icon--\[semantic-equalsign\]::before {
   content: "\e95f";
 }
 
 .c-icon--\[semantic-error\]::before {
   content: "\e955";
 }
 
 .c-icon--\[semantic-exit-fullscreen\]::before {
   content: "\e963";
 }
 
 .c-icon--\[semantic-expand\]::before {
   content: "\e944";
 }
 
 .c-icon--\[semantic-faq\]::before {
   content: "\e93a";
 }
 
 .c-icon--\[semantic-file\]::before {
   content: "\e918";
 }
 
 .c-icon--\[semantic-filter\]::before {
   content: "\e968";
 }
 
 .c-icon--\[semantic-forward\]::before {
   content: "\e946";
 }
 
 .c-icon--\[semantic-four-wheel-drive\]::before {
   content: "\e920";
 }
 
 .c-icon--\[semantic-front-wheel-drive\]::before {
   content: "\e921";
 }
 
 .c-icon--\[semantic-fs-payment\]::before {
   content: "\e940";
 }
 
 .c-icon--\[semantic-fuel-natural-gas\]::before {
   content: "\e92d";
 }
 
 .c-icon--\[semantic-fuel\]::before {
   content: "\e930";
 }
 
 .c-icon--\[semantic-gear-oil\]::before {
   content: "\e923";
 }
 
 .c-icon--\[semantic-guarantee\]::before {
   content: "\e934";
 }
 
 .c-icon--\[semantic-hybrid\]::before {
   content: "\e925";
 }
 
 .c-icon--\[semantic-info\]::before {
   content: "\e972";
 }
 
 .c-icon--\[semantic-like\]::before {
   content: "\e967";
 }
 
 .c-icon--\[semantic-list\]::before {
   content: "\e929";
 }
 
 .c-icon--\[semantic-location\]::before {
   content: "\e932";
 }
 
 .c-icon--\[semantic-lock\]::before {
   content: "\e92a";
 }
 
 .c-icon--\[semantic-login\]::before {
   content: "\e991";
 }
 
 .c-icon--\[semantic-mail\]::before {
   content: "\e978";
 }
 
 .c-icon--\[semantic-menu\]::before {
   content: "\e94d";
 }
 
 .c-icon--\[semantic-minus\]::before {
   content: "\e979";
 }
 
 .c-icon--\[semantic-mobility\]::before {
   content: "\e938";
 }
 
 .c-icon--\[semantic-more\]::before {
   content: "\e953";
 }
 
 .c-icon--\[semantic-news\]::before {
   content: "\e92b";
 }
 
 .c-icon--\[semantic-notification\]::before {
   content: "\e906";
 }
 
 .c-icon--\[semantic-offers\]::before {
   content: "\e92e";
 }
 
 .c-icon--\[semantic-pause\]::before {
   content: "\e97d";
 }
 
 .c-icon--\[semantic-performance\]::before {
   content: "\e92f";
 }
 
 .c-icon--\[semantic-petrol\]::before {
   content: "\e930";
 }
 
 .c-icon--\[semantic-phone\]::before {
   content: "\e980";
 }
 
 .c-icon--\[semantic-play\]::before {
   content: "\e981";
 }
 
 .c-icon--\[semantic-plus\]::before {
   content: "\e982";
 }
 
 .c-icon--\[semantic-premium-l\]::before {
   content: "\e928";
 }
 
 .c-icon--\[semantic-premium-m\]::before {
   content: "\e927";
 }
 
 .c-icon--\[semantic-premium-s\]::before {
   content: "\e926";
 }
 
 .c-icon--\[semantic-quality\]::before {
   content: "\e933";
 }
 
 .c-icon--\[semantic-reload\]::before {
   content: "\e984";
 }
 
 .c-icon--\[semantic-safety-check\]::before {
   content: "\e935";
 }
 
 .c-icon--\[semantic-save-cloud\]::before {
   content: "\e936";
 }
 
 .c-icon--\[semantic-save-local\]::before {
   content: "\e91f";
 }
 
 .c-icon--\[semantic-search\]::before {
   content: "\e977";
 }
 
 .c-icon--\[semantic-service\]::before {
   content: "\e941";
 }
 
 .c-icon--\[semantic-settings\]::before {
   content: "\e922";
 }
 
 .c-icon--\[semantic-smartphone\]::before {
   content: "\e92c";
 }
 
 .c-icon--\[semantic-social-facebook\]::before {
   content: "\e993";
 }
 
 .c-icon--\[semantic-social-instagram\]::before {
   content: "\e994";
 }
 
 .c-icon--\[semantic-social-linkedin\]::before {
   content: "\e995";
 }
 
 .c-icon--\[semantic-social-pinterest\]::before {
   content: "\e996";
 }
 
 .c-icon--\[semantic-social-rss\]::before {
   content: "\e997";
 }
 
 .c-icon--\[semantic-social-twitter\]::before {
   content: "\e998";
 }
 
 .c-icon--\[semantic-social-vimeo\]::before {
   content: "\e999";
 }
 
 .c-icon--\[semantic-social-xing\]::before {
   content: "\e99a";
 }
 
 .c-icon--\[semantic-social-youtube\]::before {
   content: "\e99b";
 }
 
 .c-icon--\[semantic-sort-asc\]::before {
   content: "\e947";
 }
 
 .c-icon--\[semantic-sort-desc\]::before {
   content: "\e944";
 }
 
 .c-icon--\[semantic-spark-plug\]::before {
   content: "\e939";
 }
 
 .c-icon--\[semantic-steering-wheel\]::before {
   content: "\e93b";
 }
 
 .c-icon--\[semantic-stop\]::before {
   content: "\e98b";
 }
 
 .c-icon--\[semantic-success\]::before {
   content: "\e952";
 }
 
 .c-icon--\[semantic-switch\]::before {
   content: "\e91e";
 }
 
 .c-icon--\[semantic-transmission-automatic\]::before {
   content: "\e93d";
 }
 
 .c-icon--\[semantic-transmission-manual\]::before {
   content: "\e93e";
 }
 
 .c-icon--\[semantic-up\]::before {
   content: "\e947";
 }
 
 .c-icon--\[semantic-upload\]::before {
   content: "\e982";
 }
 
 .c-icon--\[semantic-user\]::before {
   content: "\e991";
 }
 
 .c-icon--\[semantic-volume-down\]::before {
   content: "\e97c";
 }
 
 .c-icon--\[semantic-volume-up\]::before {
   content: "\e989";
 }
 
 .c-icon--\[semantic-volume\]::before {
   content: "\e989";
 }
 
 .c-icon--\[semantic-warning\]::before {
   content: "\e955";
 }
 
 .c-icon--\[semantic-zoom-in\]::before {
   content: "\e982";
 }
 
 .c-icon--\[semantic-zoom-out\]::before {
   content: "\e979";
 }
 
 /**
  * Generate sizing modifiers.
  */
 .c-icon--xxsmall {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-icon--xsmall {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-icon--small {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-icon--large {
   font-size: 3.375rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-icon--xlarge {
   font-size: 3.375rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-icon--xxlarge {
   font-size: 3.375rem;
   /* stylelint-disable-line order/order */
 }
 
 /* ------------------------------------*\
     #HEADER
 \*------------------------------------ */
 /**
  * [1] Use `auto` instead of `0` in case there are other fixed elements above
  *     the header component (e.g. notifications).
  * [2] Only output a background-color if a color is defined. This way, if you
  *     donâ€™t want any background on the header (i.e. transparent), no CSS is
  *     generated.
  * [3] Variant to force a `position: static`. Useful if your default header
  *     is absolute or sticky, but you also need a variant that provides a
  *     static header that sits in the normal flow of the page.
  * [4] Only apply a spacing-bottom if itâ€™s not absolute or fixed positioned.
  * [5] Make sure that all elements of the header are aligned to the outer edges.
  * [6] If the default spacing-bottom for the static header alters on small
  *     screen, assign it for that specific media-query.
  * [7] Position `.c-header__nav` after `.c-header__notification-center` in
  *     small viewports.
  */
 .c-header__wrapper {
   position: relative;
   z-index: 2000;
 }
 
 .c-header {
   width: 100%;
   height: 100px;
   margin-bottom: 0;
   /* [4] */
   background-color: #ffffff;
   /* [2] */
 }
 
 @media (max-width: 720px) {
   .c-header {
     height: 60px;
   }
 }
 
 .c-header.c-header--static {
   /* [3] */
   position: static;
   margin-bottom: 0;
   /* [4] */
 }
 
 .c-header__content-wrapper {
   max-width: calc(1280px + 64px);
   padding-left: 32px;
   padding-right: 32px;
   margin-right: auto;
   margin-left: auto;
   position: relative;
   display: flex;
   align-items: center;
   justify-content: space-between;
   /* [5] */
   height: 100px;
 }
 
 @media (max-width: 960px) {
   .c-header__content-wrapper {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .c-header__content-wrapper {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .c-header__content-wrapper {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 720px) {
   .c-header__content-wrapper {
     height: 60px;
   }
 }
 
 .c-header__logo {
   margin-right: 16px;
 }
 
 .c-header__nav {
   display: flex;
   /* [6] */
 }
 
 @media (min-width: 721px) {
   .c-header__nav {
     flex-grow: 1;
     flex-shrink: 1;
     flex-basis: auto;
   }
 }
 
 @media (max-width: 720px) {
   .c-header__nav {
     order: 1;
     /* [7] */
   }
 }
 
 .c-header__notification-center {
   position: relative;
   height: 100%;
 }
 
 /* ------------------------------------*\
     #FOOTER
 \*------------------------------------ */
 /**
  * [1] If no breadcrumb is included in the footer, hide the container.
  * [2] If the meta nav has a deviating background color, assign it.
  * [3] If the footnotes have a deviating background color, assign it.
  * [4] Manage automatic vertical spacing between nav columns when stacked.
  * [5] Responsive behaviour without media-queries, i.e. donâ€™t let the columns
  *     shrink under a width of `$footer-nav-column-min-width`...
  * [6] ...but force a one-column layout at breakpoint and below.
  * [7] Only hide the accordion panel when the JS is loaded.
  * [8] Make sure to just provide the whole accordion-on-small-screen
  *     shizzle-dizzle, when JS is loaded.
  * [9] Reset potential browser default margin for certain HTML elements and
  *     instead assign the bottom spacing to `.c-footer-nav__title`.
  * [10] Make sure that the presented HTML elements make sense for accessibility.
  *      The `.is-heading`/`.is-button` classes are added dynamically via JS, so
  *      with this progressive mechanism we make sure that this all happens just
  *      when JS is loaded.
  * [11] Align meta bar content at the top edge of the flex container.
  * [12] If the meta nav has a deviating background color, we need to add a
  *      padding to the top to give it some space to the footer nav.
  * [13] If the footer nav has a border, we need to add a padding to the top to
  *      give it some space to the footer nav.
  * [14] If the meta nav is the first element inside the footer, it needs a
  *      top padding.
  * [15] If the meta nav is the last element inside the footer, we set the
  *      padding bottom equal to the superior footer padding-bottom.
  * [16] If the meta nav is the only child of the footer, we want the same
  *      padding at the top and the bottom.
  * [17] If the meta nav is the direct following element of the breadcrumb
  *      (i.e. the footer nav is missing), we need to offset the meta nav from
  *      the breadcrumb.
  * [18] If the breadcrumb is hidden, so the meta nav is _visually_ the first
  *      element in the footer, replace the margin with a padding, so the meta
  *      nav items are not stuck at the top of the footer.
  * [19] Align meta nav bar content to the left on small screens. Fixes issues e.g.
  *      in IE11 where the content was placed in the center.
  * [20] Enable meta nav bar to occupy relatively more space if necessary.
  * [21] Ensure that social media link spans and thus is clickable over the whole
  *      size of the social media icon.
  * [22] Align sign and text (media-object like).
  * [23] Enforce line break for '.c-footer-copyright' and ensure that full width
  *      of the container is used.
  * [24] Reset potential browser default margin for social media element and links.
  * [25] Set all flex-item properties for legacy browser support.
  * [26] Ensure wrapping (column layout).
  */
 .c-footer {
   background-color: #3e4547;
   color: #ffffff;
 }
 
 .c-footer-breadcrumb {
   padding-top: 16px;
   padding-bottom: 16px;
   border-bottom: 1px solid #1a1a1a;
 }
 
 .c-footer-nav {
   padding-top: 24px;
   padding-bottom: 24px;
 }
 
 .c-footer-nav__columns {
   display: flex;
   flex-wrap: wrap;
   margin-top: -16px;
   /* [4] */
 }
 
 .c-footer-nav__column {
   flex-grow: 1;
   /* [5] */
   flex-shrink: 1;
   /* [5] */
   flex-basis: 200px;
   /* [5] */
   margin-top: 16px;
   /* [4] */
   margin-right: 16px;
 }
 
 @media (max-width: 720px) {
   .c-footer-nav__column {
     flex-basis: 100%;
     /* [6] */
     margin-right: 0;
   }
 }
 
 .c-footer-nav__list {
   margin: 0;
   padding: 0;
   list-style: none;
 }
 
 .c-footer-nav__list li {
   display: block;
   margin-bottom: 0;
 }
 
 @media (max-width: 720px) {
   .c-footer-nav__list.js-is-ready.is-closed {
     display: none;
     /* [7] */
   }
 }
 
 .c-footer-nav__title {
   margin-bottom: 0;
 }
 
 @media (max-width: 720px) {
   .c-footer-nav__title {
     /* stylelint-disable selector-max-specificity, selector-max-class */
     /* stylelint-enable */
   }
   .js-footer-accordion.js-is-ready .c-footer-nav__title {
     /* [8] */
     display: flex;
     justify-content: space-between;
     align-items: center;
     cursor: pointer;
   }
   .js-footer-accordion.js-is-ready .c-footer-nav__title::after {
     display: inline-block;
     font-family: "bronson-default" !important;
     /* [1] */
     /* stylelint-disable-line itcss/no-at-important */
     font-weight: normal;
     font-style: normal;
     line-height: 1;
     font-variant: normal;
     text-transform: none;
     -moz-osx-font-smoothing: grayscale;
     -webkit-font-smoothing: antialiased;
     content: "\e944";
     font-size: 24px;
     color: #ffffff;
   }
   .js-footer-accordion.js-is-ready .c-footer-nav__title.is-active::after {
     content: "\e947";
   }
 }
 
 .c-footer-nav__title-label {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 1.71429;
   padding: 0;
   border: 0;
   background-color: transparent;
   margin-bottom: 0;
   /* [9] */
   font-family: "open-sans", sans-serif;
   font-weight: 400;
   color: #ffffff;
 }
 
 .c-footer-nav__title-label:focus {
   outline: 0;
 }
 
 @media (max-width: 720px) {
   .c-footer-nav__title-label.is-heading {
     display: none;
     /* [10] */
   }
 }
 
 @media (min-width: 721px) {
   .c-footer-nav__title-label.is-button {
     display: none;
     /* [10] */
   }
 }
 
 .c-footer-nav__link {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 1.71429;
   text-decoration: none;
   color: #ffffff;
 }
 
 .c-footer-nav__link:hover, .c-footer-nav__link:focus, .c-footer-nav__link:active {
   color: #ffffff;
 }
 
 .c-footer-meta-bar {
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   align-items: flex-start;
   /* [11] */
   padding-bottom: 16px;
 }
 
 @media (max-width: 720px) {
   .c-footer-meta-bar {
     align-items: stretch;
     /* [19] */
   }
   .c-footer-meta-bar > * {
     flex-basis: 100%;
     /* [26] */
   }
 }
 
 .c-footer__module--meta-nav:first-child .c-footer-meta-bar {
   padding-top: 16px;
   /* [14] */
 }
 
 .c-footer__module--meta-nav:last-child .c-footer-meta-bar {
   padding-bottom: 32px;
   /* [15] */
 }
 
 .c-footer__module--meta-nav:last-child:only-child .c-footer-meta-bar {
   padding-bottom: 16px;
   /* [16] */
 }
 
 .c-footer__module--breadcrumb + .c-footer__module--meta-nav .c-footer-meta-bar {
   margin-top: 16px;
   /* [17] */
 }
 
 .c-footer-meta-nav {
   margin: 0;
   padding: 0;
   list-style: none;
   display: flex;
   flex-wrap: wrap;
   flex-grow: 1;
   /* [20] */
   flex-shrink: 1;
   /* [25] */
   flex-basis: auto;
   /* [25] */
   padding-bottom: 16px;
 }
 
 .c-footer-meta-nav li {
   display: block;
   margin-bottom: 0;
 }
 
 @media (max-width: 720px) {
   .c-footer-meta-nav {
     flex-direction: column;
   }
 }
 
 .c-footer-meta-nav__item:not(:last-child) {
   margin-right: 16px;
 }
 
 .c-footer-meta-nav__link {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 1.71429;
   display: block;
   text-decoration: none;
   color: #ffffff;
 }
 
 .c-footer-meta-nav__link:hover, .c-footer-meta-nav__link:focus, .c-footer-meta-nav__link:active {
   color: #ffffff;
 }
 
 .c-footer-social-media {
   display: flex;
   flex-wrap: wrap;
   justify-content: flex-end;
   margin: 0;
   /* [24] */
   padding-bottom: 16px;
   list-style: none;
 }
 
 @media (max-width: 720px) {
   .c-footer-social-media {
     justify-content: center;
   }
 }
 
 .c-footer-social-media__item {
   margin-bottom: 0;
   /* [24] */
 }
 
 .c-footer-social-media__item:not(:last-child) {
   margin-right: 24px;
 }
 
 .c-footer-social-media__link {
   display: inline-block;
   /* [21] */
 }
 
 .c-footer-social-media__icon {
   text-decoration: none;
   color: #ffffff;
 }
 
 .c-footer-social-media__icon:hover, .c-footer-social-media__icon:focus, .c-footer-social-media__icon:active {
   color: #ffffff;
 }
 
 .c-footer-social-media__icon::before {
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
 }
 
 .c-footer-copyright {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   display: inline-flex;
   /* [22] */
   flex-grow: 0;
   /* [25] */
   flex-shrink: 1;
   /* [25] */
   flex-basis: 100%;
   /* [23] */
 }
 
 .c-footer-copyright__sign {
   margin-right: 0.25em;
 }
 
 .c-footer-footnotes {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   padding-top: 16px;
   padding-bottom: 32px;
   border-top: #ffffff;
 }
 
 .c-footer-footnotes a {
   color: inherit;
 }
 
 .c-footer-footnotes a:hover, .c-footer-footnotes a:focus, .c-footer-footnotes a:active {
   color: inherit;
 }
 
 /* ------------------------------------*\
     #BADGE
 \*------------------------------------ */
 /**
  * [1] Display the badge in line with the label and other badges, even if
  *     the badge contains an icon and handles correct wrapping when available
  *     space is exceeded.
  *     Resolves inline-block space issue that can occur for example when
  *     markup is minified.
  * [2] Vertically center the icon inside the badge.
  * [3] Vertically center the label next to the badge.
  * [4] @deprecated: Only used to override the deprecated `top`-
  *     property of the badge mixin.
  * [5] Prevent distortion (keep 1:1 size).
  * [6] Apply all flexbox properties with default values (legacy support).
  */
 .c-badge__wrapper {
   display: inline-flex;
   /* [1] */
   align-items: baseline;
 }
 
 .c-badge__wrapper .c-badge__label {
   margin-left: 4px;
   vertical-align: middle;
   /* [3] */
 }
 
 .c-badge__wrapper .c-badge {
   top: 0;
   /* [4] */
   flex-grow: 1;
   /* [5] */
   flex-shrink: 0;
   /* [5] */
   flex-basis: auto;
   /* [6] */
 }
 
 .c-badge {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 24px;
   position: relative;
   top: -0.1em;
   /* [1] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   display: inline-block;
   width: 24px;
   height: 24px;
   border-radius: 50%;
   font-weight: 400;
   text-align: center;
   background-color: #1a1a1a;
   color: #ffffff;
   vertical-align: middle;
   /* [1] */
 }
 
 .c-badge.c-badge--success, .c-badge.c-badge--positive {
   background-color: #00783c;
   color: #ffffff;
 }
 
 .c-badge.c-badge--warning {
   background-color: #efc938;
   color: #1a1a1a;
 }
 
 .c-badge.c-badge--notification {
   background-color: #ba2525;
   color: #ffffff;
 }
 
 .c-badge.c-badge--error, .c-badge.c-badge--negative {
   background-color: #ba2525;
   color: #ffffff;
 }
 
 .c-badge .c-badge__icon {
   font-size: 18px;
   line-height: inherit;
   /* [2] */
   vertical-align: top;
   /* [3] */
   color: inherit;
 }
 
 /* ------------------------------------*\
     #BUTTONS
 \*------------------------------------ */
 /* stylelint-disable scss/no-duplicate-dollar-variables */
 /* stylelint-disable-line scss/dollar-variable-default */
 /* stylelint-disable-line scss/dollar-variable-default */
 /* stylelint-disable-line scss/dollar-variable-default */
 /* stylelint-enable scss/no-duplicate-dollar-variables */
 /* [17] */
 /**
  * [1] `inline-flex` is a good method to center elements vertically inside of
  *     the button.
  * [2] Center text, and text to icon horizontally and vertically inside of the
  *     button.
  * [3] Make the cursor behaviour the same for `<button>` and `<a>` elements.
  * [4] `<a>` elements are left aligned by default. Override this to match
  *     `<button>` and `<a>` elements.
  * [5] Text left, icon right.
  * [6] Icon left, text right.
  * [7] Increase specificity, so that the styles donâ€™t get overridden later on by different themes.
  *      @TODO: This is definitely a code smell and should be refactored.
  *             https://jira.platform.vwfs.io/browse/BRON-6709
  * [8] Fix for iOS bug, where the button text is not centered (BRON-534). Just
  *     occurs in iOS 10 or lower (every browser), for the full-width button and
  *     only, if it's a `<button>` element.
  * [9] Prevent text selection on all button (sub-) elements, especially for
  *      touch-devices, i.e. a `<span>` element in the button.
  * [10] Prevent the padding from becoming negative.
  * [11] Although this declaration is in an if-condition that only matches for
  *      fixed height buttons, it is still a sensible idea to assign a
  *      min-height rather than a fixed height, so the button grows if the text
  *      does not fit vertically.
  * [12] Since IE11 does not present the button text properly with the
  *      fixed-height version of the button, we have to reset the padding here,
  *      so the button grows even with two lines of text in it. On top of that,
  *      IE11 adds the border-width automatically to the padding, so we must not
  *      subtract the border-width from the padding to yield the correct height.
  * [13] Remove transition causing delay with animation of the inner icon of the
  *      `.c-btn--icon` variant on hover. This effect would be visible if the
  *      text- and icon-color would change on hover.
  * [14] Limit the height of `.c-btn--link`, so it does not inherit its height
  *      from `.c-btn` and only takes up the height it needs.
  * [15] Override line-height, set by default button component. This is needed, so
  *      that the icon gets its correct height.
  * [16] Align the content left for link buttons. This only has an effect if
  *      the button is larger than its content, e.g. when combining a
  *      `.c-btn--link` with `.c-btn--full`.
  * [17] If the icon only variant needs a special border-radius, i.e. VW6.
  * [18] Also apply focus styles when an element is focused that is a child
  *      of a shared parent element. This is needed for buttons in the
  *      upload component (`.c-upload`).
  * [19] The native `disabled` attribute prevents`:hover` and `:active` events,
  *      but we need to proactively exclude synthetic `.is-disabled` selectors
  *      from receiving `:active` styles.
  * [20] Without a transparent border the link will "jump" on hover.
  * [21] Raise the specificity to prevent leaks from `.c-btn--secondary` in a theme context.
  *      @TODO: This is definitely a code smell and should be refactored.
  *             https://jira.platform.vwfs.io/browse/BRON-6709
  */
 .c-btn {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   display: inline-flex;
   /* [1] */
   align-items: center;
   /* [2] */
   justify-content: center;
   /* [2] */
   border-radius: 0 0 0 0;
   font-family: "open-sans", sans-serif;
   font-weight: 400;
   text-decoration: none;
   text-transform: uppercase;
   line-height: 24px;
   text-align: center;
   /* [4] */
   vertical-align: middle;
   cursor: pointer;
   /* [3] */
   min-height: 48px;
   /* [11] */
   padding: 0 32px;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
   /* stylelint-disable-next-line selector-max-class */
 }
 
 @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .c-btn {
     padding: 12px 32px;
     /* [12] */
   }
 }
 
 .c-btn {
   border: 0;
   background-color: #3e4547;
   color: #ffffff;
   /* stylelint-disable selector-max-class */
   /* stylelint-enable selector-max-class */
   /* stylelint-disable selector-max-class */
   /* stylelint-enable  selector-max-class */
 }
 
 .c-btn:hover, .c-btn:focus,
 label.focus-within .c-btn {
   /* [18] */
   background-color: #187085;
   color: #ffffff;
   outline: none;
 }
 
 .c-btn:hover, .c-btn:focus,
 label:focus-within .c-btn {
   /* [18] */
   background-color: #187085;
   color: #ffffff;
   outline: none;
 }
 
 .c-btn:not(.is-disabled):active {
   /* [19] */
   background-color: #3e4547;
   color: #ffffff;
 }
 
 .c-btn[disabled], .c-btn.is-disabled {
   border: 0;
   background-color: #afb5ab;
   color: #3e4547;
 }
 
 .c-btn.c-btn--link {
   justify-content: flex-start;
   /* [16] */
 }
 
 .c-btn.c-btn--link:hover, .c-btn.c-btn--link:focus {
   background: none;
   box-shadow: none;
 }
 
 .c-btn.c-btn--link:not(.is-disabled):active {
   /* [19] */
 }
 
 .c-btn.c-btn--link .c-btn__text {
   color: #1a1a1a;
 }
 
 .c-btn.c-btn--link .c-btn__icon {
   color: #1a1a1a;
 }
 
 .c-btn.c-btn--link[disabled] .c-btn__text, .c-btn.c-btn--link.is-disabled .c-btn__text {
   /* stylelint-disable-line selector-max-class */
   color: #afb5ab;
 }
 
 .c-btn.c-btn--link[disabled] .c-btn__icon, .c-btn.c-btn--link.is-disabled .c-btn__icon {
   /* stylelint-disable-line selector-max-class */
   color: #afb5ab;
 }
 
 .c-btn.c-btn--simple.c-btn--simple {
   /* [7] */
 }
 
 .c-btn.c-btn--simple.c-btn--simple .c-btn__icon::before {
   padding: 0;
   border: 0;
   background: none;
 }
 
 .c-btn.c-btn--icon-only.c-btn--icon-only {
   /* [7] */
   border: 0 solid;
 }
 
 .c-btn.c-btn--icon-only.c-btn--icon-only:hover, .c-btn.c-btn--icon-only.c-btn--icon-only:focus {
   border: 0 solid;
 }
 
 .c-btn.c-btn--icon-only.c-btn--icon-only:not(.is-disabled):active {
   /* [19] */
   border: 0 solid;
 }
 
 .c-btn.c-btn--icon-only.c-btn--icon-only[disabled], .c-btn.c-btn--icon-only.c-btn--icon-only.is-disabled {
   background-color: #afb5ab;
 }
 
 .c-btn.c-btn--icon-only.c-btn--icon-only[disabled] .c-btn__icon, .c-btn.c-btn--icon-only.c-btn--icon-only.is-disabled .c-btn__icon {
   color: #3e4547;
 }
 
 .c-btn.c-btn--secondary {
   border: 0;
   background-color: #ffffff;
   color: #1a1a1a;
   box-shadow: inset 0 0 0 1px currentColor;
   /* stylelint-disable selector-max-class */
   /* stylelint-enable selector-max-class */
   /* stylelint-disable selector-max-class */
   /* stylelint-enable  selector-max-class */
 }
 
 .c-btn.c-btn--secondary:hover, .c-btn.c-btn--secondary:focus,
 label.focus-within .c-btn.c-btn--secondary {
   /* [18] */
   box-shadow: inset 0 0 0 2px currentColor;
   outline: none;
 }
 
 .c-btn.c-btn--secondary:hover, .c-btn.c-btn--secondary:focus,
 label:focus-within .c-btn.c-btn--secondary {
   /* [18] */
   box-shadow: inset 0 0 0 2px currentColor;
   outline: none;
 }
 
 .c-btn.c-btn--secondary:not(.is-disabled):active {
   /* [19] */
   background-color: #ffffff;
   color: #1a1a1a;
   box-shadow: inset 0 0 0 1px currentColor;
 }
 
 .c-btn.c-btn--secondary[disabled], .c-btn.c-btn--secondary.is-disabled {
   background-color: #afb5ab;
   color: #3e4547;
   box-shadow: none;
 }
 
 .c-btn.c-btn--secondary.c-btn--link {
   justify-content: flex-start;
   /* [16] */
 }
 
 .c-btn.c-btn--secondary.c-btn--link:hover, .c-btn.c-btn--secondary.c-btn--link:focus {
   background: none;
   box-shadow: none;
 }
 
 .c-btn.c-btn--secondary.c-btn--link:not(.is-disabled):active {
   /* [19] */
 }
 
 .c-btn.c-btn--secondary.c-btn--link[disabled] .c-btn__text, .c-btn.c-btn--secondary.c-btn--link.is-disabled .c-btn__text {
   /* stylelint-disable-line selector-max-class */
 }
 
 .c-btn.c-btn--secondary.c-btn--link[disabled] .c-btn__icon, .c-btn.c-btn--secondary.c-btn--link.is-disabled .c-btn__icon {
   /* stylelint-disable-line selector-max-class */
 }
 
 .c-btn.c-btn--secondary.c-btn--simple.c-btn--simple {
   /* [7] */
 }
 
 .c-btn.c-btn--secondary.c-btn--simple.c-btn--simple .c-btn__icon::before {
   padding: 0;
   border: 0;
   background: none;
 }
 
 .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only {
   /* [7] */
   border: 0 solid;
 }
 
 .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only:hover, .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only:focus {
   border: 0 solid;
 }
 
 .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only:not(.is-disabled):active {
   /* [19] */
   border: 0 solid;
 }
 
 .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only[disabled], .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only.is-disabled {
   background-color: #afb5ab;
 }
 
 .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only[disabled] .c-btn__icon, .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only.is-disabled .c-btn__icon {
   color: #3e4547;
 }
 
 /* [1] */
 [data-theme="brand"] .c-btn,
 .u-bg-brand .c-btn {
   border: 0;
   background-color: #ffffff;
   color: #1a1a1a;
   /* stylelint-disable selector-max-class */
   /* stylelint-enable selector-max-class */
   /* stylelint-disable selector-max-class */
   /* stylelint-enable  selector-max-class */
 }
 
 [data-theme="brand"] .c-btn:hover, [data-theme="brand"] .c-btn:focus,
 label.focus-within [data-theme="brand"] .c-btn,
 .u-bg-brand .c-btn:hover,
 .u-bg-brand .c-btn:focus,
 label.focus-within
 .u-bg-brand .c-btn {
   /* [18] */
   background-color: #187085;
   color: #ffffff;
   outline: none;
 }
 
 [data-theme="brand"] .c-btn:hover, [data-theme="brand"] .c-btn:focus,
 label:focus-within [data-theme="brand"] .c-btn,
 .u-bg-brand .c-btn:hover,
 .u-bg-brand .c-btn:focus,
 label:focus-within
 .u-bg-brand .c-btn {
   /* [18] */
   background-color: #187085;
   color: #ffffff;
   outline: none;
 }
 
 [data-theme="brand"] .c-btn:not(.is-disabled):active,
 .u-bg-brand .c-btn:not(.is-disabled):active {
   /* [19] */
   background-color: #ffffff;
   color: #1a1a1a;
 }
 
 [data-theme="brand"] .c-btn[disabled], [data-theme="brand"] .c-btn.is-disabled,
 .u-bg-brand .c-btn[disabled],
 .u-bg-brand .c-btn.is-disabled {
   border: 0;
   background-color: #afb5ab;
   color: #3e4547;
 }
 
 [data-theme="brand"] .c-btn.c-btn--link,
 .u-bg-brand .c-btn.c-btn--link {
   justify-content: flex-start;
   /* [16] */
 }
 
 [data-theme="brand"] .c-btn.c-btn--link:hover, [data-theme="brand"] .c-btn.c-btn--link:focus,
 .u-bg-brand .c-btn.c-btn--link:hover,
 .u-bg-brand .c-btn.c-btn--link:focus {
   background: none;
   box-shadow: none;
 }
 
 [data-theme="brand"] .c-btn.c-btn--link:not(.is-disabled):active,
 .u-bg-brand .c-btn.c-btn--link:not(.is-disabled):active {
   /* [19] */
 }
 
 [data-theme="brand"] .c-btn.c-btn--link .c-btn__text,
 .u-bg-brand .c-btn.c-btn--link .c-btn__text {
   color: #ffffff;
 }
 
 [data-theme="brand"] .c-btn.c-btn--link .c-btn__icon,
 .u-bg-brand .c-btn.c-btn--link .c-btn__icon {
   color: #ffffff;
 }
 
 [data-theme="brand"] .c-btn.c-btn--link[disabled] .c-btn__text, [data-theme="brand"] .c-btn.c-btn--link.is-disabled .c-btn__text,
 .u-bg-brand .c-btn.c-btn--link[disabled] .c-btn__text,
 .u-bg-brand .c-btn.c-btn--link.is-disabled .c-btn__text {
   /* stylelint-disable-line selector-max-class */
   color: #afb5ab;
 }
 
 [data-theme="brand"] .c-btn.c-btn--link[disabled] .c-btn__icon, [data-theme="brand"] .c-btn.c-btn--link.is-disabled .c-btn__icon,
 .u-bg-brand .c-btn.c-btn--link[disabled] .c-btn__icon,
 .u-bg-brand .c-btn.c-btn--link.is-disabled .c-btn__icon {
   /* stylelint-disable-line selector-max-class */
   color: #afb5ab;
 }
 
 [data-theme="brand"] .c-btn.c-btn--simple.c-btn--simple,
 .u-bg-brand .c-btn.c-btn--simple.c-btn--simple {
   /* [7] */
 }
 
 [data-theme="brand"] .c-btn.c-btn--simple.c-btn--simple .c-btn__icon::before,
 .u-bg-brand .c-btn.c-btn--simple.c-btn--simple .c-btn__icon::before {
   padding: 0;
   border: 0;
   background: none;
 }
 
 [data-theme="brand"] .c-btn.c-btn--icon-only.c-btn--icon-only,
 .u-bg-brand .c-btn.c-btn--icon-only.c-btn--icon-only {
   /* [7] */
   border: 0 solid;
 }
 
 [data-theme="brand"] .c-btn.c-btn--icon-only.c-btn--icon-only:hover, [data-theme="brand"] .c-btn.c-btn--icon-only.c-btn--icon-only:focus,
 .u-bg-brand .c-btn.c-btn--icon-only.c-btn--icon-only:hover,
 .u-bg-brand .c-btn.c-btn--icon-only.c-btn--icon-only:focus {
   border: 0 solid;
 }
 
 [data-theme="brand"] .c-btn.c-btn--icon-only.c-btn--icon-only:not(.is-disabled):active,
 .u-bg-brand .c-btn.c-btn--icon-only.c-btn--icon-only:not(.is-disabled):active {
   /* [19] */
   border: 0 solid;
 }
 
 [data-theme="brand"] .c-btn.c-btn--icon-only.c-btn--icon-only[disabled], [data-theme="brand"] .c-btn.c-btn--icon-only.c-btn--icon-only.is-disabled,
 .u-bg-brand .c-btn.c-btn--icon-only.c-btn--icon-only[disabled],
 .u-bg-brand .c-btn.c-btn--icon-only.c-btn--icon-only.is-disabled {
   background-color: #afb5ab;
 }
 
 [data-theme="brand"] .c-btn.c-btn--icon-only.c-btn--icon-only[disabled] .c-btn__icon, [data-theme="brand"] .c-btn.c-btn--icon-only.c-btn--icon-only.is-disabled .c-btn__icon,
 .u-bg-brand .c-btn.c-btn--icon-only.c-btn--icon-only[disabled] .c-btn__icon,
 .u-bg-brand .c-btn.c-btn--icon-only.c-btn--icon-only.is-disabled .c-btn__icon {
   color: #3e4547;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary,
 .u-bg-brand .c-btn.c-btn--secondary {
   border: 0;
   background-color: #1a1a1a;
   color: #ffffff;
   box-shadow: inset 0 0 0 1px currentColor;
   /* stylelint-disable selector-max-class */
   /* stylelint-enable selector-max-class */
   /* stylelint-disable selector-max-class */
   /* stylelint-enable  selector-max-class */
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary:hover, [data-theme="brand"] .c-btn.c-btn--secondary:focus,
 label.focus-within [data-theme="brand"] .c-btn.c-btn--secondary,
 .u-bg-brand .c-btn.c-btn--secondary:hover,
 .u-bg-brand .c-btn.c-btn--secondary:focus,
 label.focus-within
 .u-bg-brand .c-btn.c-btn--secondary {
   /* [18] */
   box-shadow: inset 0 0 0 2px currentColor;
   outline: none;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary:hover, [data-theme="brand"] .c-btn.c-btn--secondary:focus,
 label:focus-within [data-theme="brand"] .c-btn.c-btn--secondary,
 .u-bg-brand .c-btn.c-btn--secondary:hover,
 .u-bg-brand .c-btn.c-btn--secondary:focus,
 label:focus-within
 .u-bg-brand .c-btn.c-btn--secondary {
   /* [18] */
   box-shadow: inset 0 0 0 2px currentColor;
   outline: none;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary:not(.is-disabled):active,
 .u-bg-brand .c-btn.c-btn--secondary:not(.is-disabled):active {
   /* [19] */
   background-color: #1a1a1a;
   color: #ffffff;
   box-shadow: inset 0 0 0 1px currentColor;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary[disabled], [data-theme="brand"] .c-btn.c-btn--secondary.is-disabled,
 .u-bg-brand .c-btn.c-btn--secondary[disabled],
 .u-bg-brand .c-btn.c-btn--secondary.is-disabled {
   background-color: #afb5ab;
   color: #3e4547;
   box-shadow: none;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--link,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--link {
   justify-content: flex-start;
   /* [16] */
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--link:hover, [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--link:focus,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--link:hover,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--link:focus {
   background: none;
   box-shadow: none;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--link:not(.is-disabled):active,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--link:not(.is-disabled):active {
   /* [19] */
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--link .c-btn__text,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--link .c-btn__text {
   color: #ffffff;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--link .c-btn__icon,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--link .c-btn__icon {
   color: #ffffff;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--link[disabled] .c-btn__text, [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--link.is-disabled .c-btn__text,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--link[disabled] .c-btn__text,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--link.is-disabled .c-btn__text {
   /* stylelint-disable-line selector-max-class */
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--link[disabled] .c-btn__icon, [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--link.is-disabled .c-btn__icon,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--link[disabled] .c-btn__icon,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--link.is-disabled .c-btn__icon {
   /* stylelint-disable-line selector-max-class */
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--simple.c-btn--simple,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--simple.c-btn--simple {
   /* [7] */
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--simple.c-btn--simple .c-btn__icon::before,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--simple.c-btn--simple .c-btn__icon::before {
   padding: 0;
   border: 0;
   background: none;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only {
   /* [7] */
   border: 0 solid;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only:hover, [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only:focus,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only:hover,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only:focus {
   border: 0 solid;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only:not(.is-disabled):active,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only:not(.is-disabled):active {
   /* [19] */
   border: 0 solid;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only[disabled], [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only.is-disabled,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only[disabled],
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only.is-disabled {
   background-color: #afb5ab;
 }
 
 [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only[disabled] .c-btn__icon, [data-theme="brand"] .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only.is-disabled .c-btn__icon,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only[disabled] .c-btn__icon,
 .u-bg-brand .c-btn.c-btn--secondary.c-btn--icon-only.c-btn--icon-only.is-disabled .c-btn__icon {
   color: #3e4547;
 }
 
 .c-btn[disabled], .c-btn.is-disabled {
   pointer-events: none;
   cursor: default;
 }
 
 .c-btn.c-btn--full {
   width: 100%;
 }
 
 .c-btn.c-btn--link.c-btn--link.c-btn--link {
   /* [21] */
   min-height: auto;
   /* [14] */
   padding: 0;
   border: 1px solid transparent;
   /* [20] */
   background: none;
   box-shadow: none;
 }
 
 .c-btn.c-btn--icon-only {
   min-height: auto;
   padding: 0;
   border: 0;
   /* stylelint-disable selector-max-class */
   /* stylelint-enable */
 }
 
 .c-btn.c-btn--icon-only:not(.c-btn-round) {
   width: 60px;
   height: 60px;
 }
 
 .c-btn.c-btn--icon-only:not(.c-btn-round).c-btn--small {
   width: 44px;
   height: 44px;
 }
 
 .c-btn.c-btn--icon-only.c-btn--round {
   width: 60px;
   height: 60px;
   border-radius: 50%;
 }
 
 .c-btn.c-btn--icon-only.c-btn--round.c-btn--small {
   width: 36px;
   height: 36px;
 }
 
 .c-btn.c-btn--truncate {
   max-width: 100%;
 }
 
 .c-btn * {
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
   /* [9] */
 }
 
 .c-btn__text:not(:last-child) {
   margin-right: 8px;
   /* [5] */
 }
 
 .c-btn__text:last-child:not(:only-child) {
   margin-left: 8px;
   /* [6] */
 }
 
 .c-btn.c-btn--full .c-btn__text {
   display: block;
   /* [8] */
   margin-right: auto;
   /* [8] */
   margin-left: auto;
   /* [8] */
 }
 
 @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .c-btn.c-btn--full .c-btn__text {
     margin-right: 0;
     margin-left: 0;
   }
 }
 
 .c-btn.c-btn--link .c-btn__text {
   font-weight: 400;
   text-transform: none;
   text-align: left;
 }
 
 .c-btn.c-btn--truncate .c-btn__text {
   display: inline-block;
   max-width: 100%;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
 }
 
 /* stylelint-disable selector-max-specificity, selector-max-class */
 .c-btn__icon.c-btn__icon {
   /* [7] */
   color: inherit;
   font-size: 18px;
 }
 
 .c-btn.c-btn--icon .c-btn__icon.c-btn__icon::before {
   transition: none;
   /* [13] */
 }
 
 .c-btn.c-btn--link .c-btn__icon.c-btn__icon {
   line-height: 1;
   /* [15] */
 }
 
 .c-btn.c-btn--link .c-btn__icon.c-btn__icon::before {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
 }
 
 .c-btn.c-btn--link.c-btn--round.c-btn--small.c-btn--link.c-btn--round.c-btn--small .c-btn__icon.c-btn__icon {
   /* [7] */
 }
 
 .c-btn.c-btn--link.c-btn--small.c-btn--link.c-btn--small .c-btn__icon.c-btn__icon {
   /* [7] */
 }
 
 .c-btn.c-btn--icon-only .c-btn__icon.c-btn__icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-btn.c-btn--icon-only.c-btn--small .c-btn__icon.c-btn__icon {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
 }
 
 /* stylelint-enable */
 /**
  * [1] Add bottom border to link buttons.
  */
 .c-btn--link {
   /* [1] */
 }
 
 .c-btn--link:hover span::after, .c-btn--link:active span::after, .c-btn--link:focus span::after {
   width: 100%;
 }
 
 .c-btn--link span {
   position: relative;
   display: inline-block;
 }
 
 .c-btn--link span::after {
   content: "";
   position: absolute;
   bottom: 0;
   left: 50%;
   display: block;
   width: 0;
   height: 1px;
   transform: translateX(-50%);
   background-color: currentColor;
   transition: all 250ms ease;
   /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
 }
 
 @media (pointer: coarse) {
   .c-btn--link span::after {
     display: none;
   }
 }
 
 /* ------------------------------------*\
    #BACK-TO-TOP
 \*------------------------------------ */
 /**
  * [1] Make sure that both text and icon have a transition.
  * [2] Overwrite unwanted default button `.c-btn` styles.
  * [3] Flexible left or right alignment of the component.
  * [4] Modifier class for the button variant currently without any styles.
  * [5] Allow click-through events if click-targets are behind the sticky
  *     back-to-top container.
  * [6] Reset `pointer-events: none` to be able to click the back-to-top button.
  */
 .c-back-to-top {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   pointer-events: none;
   /* [5] */
   background-color: #f2f2f2;
   padding-top: 16px;
   padding-bottom: 16px;
 }
 
 .c-back-to-top__pagewrap {
   text-align: right;
   /* [3] */
   max-width: calc(1280px + 64px);
   padding-left: 32px;
   padding-right: 32px;
   margin-right: auto;
   margin-left: auto;
 }
 
 @media (max-width: 960px) {
   .c-back-to-top__pagewrap {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .c-back-to-top__pagewrap {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .c-back-to-top__pagewrap {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 .c-back-to-top__trigger {
   display: inline-flex;
   align-items: center;
   justify-content: flex-end;
   text-decoration: none;
   pointer-events: auto;
   /* [6] */
   flex-direction: row;
 }
 
 .c-back-to-top__trigger.c-btn.c-btn, .c-back-to-top__trigger.c-btn.c-btn:hover {
   min-height: 0;
   /* [2] */
   padding: 0;
   /* [2] */
   border: none;
   /* [2] */
   border-radius: 0;
   /* [2] */
   font-weight: normal;
   /* [2] */
   text-transform: inherit;
   /* [2] */
   letter-spacing: inherit;
   /* [2] */
   vertical-align: baseline;
   /* [2] */
   background-color: transparent;
   /* [2] */
   color: #1a1a1a;
   /* [2] */
 }
 
 .c-back-to-top__text {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   /* [1] */
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   margin-right: 16px;
   margin-left: 16px;
   text-decoration: none;
   color: #1a1a1a;
 }
 
 .c-back-to-top__text:hover, .c-back-to-top__text:focus {
   color: #1a1a1a;
 }
 
 .c-back-to-top__trigger:hover .c-back-to-top__text {
   color: #ffffff;
   box-shadow: none;
 }
 
 .c-back-to-top__icon {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   color: #ffffff;
 }
 
 .c-back-to-top__icon::before {
   border-radius: 0;
   padding: 0px;
 }
 
 .c-back-to-top__icon::before {
   border: 1px solid transparent;
   background-color: transparent;
 }
 
 .c-back-to-top__icon::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   /* [1] */
   content: "\e947";
 }
 
 .c-back-to-top__trigger:hover .c-back-to-top__icon {
   color: #ffffff;
   box-shadow: none;
 }
 
 /* ------------------------------------*\
    #BACK-TO-TOP
 \*------------------------------------ */
 /**
  * [1] Reset the box-shadow from the secondary button styles.
  * [2] Apply primary button styles and override the secondary ones.
  *     The initial background color is set to transparent in the component settings.
  * [3] Center the icon and set the height/width to the global button size.
  *     This allows us to separate the icon size from the icon square size.
  */
 .c-back-to-top__trigger {
   box-shadow: none !important;
   /* [1] */
 }
 
 .c-back-to-top__trigger:hover, .c-back-to-top__trigger:focus {
   box-shadow: none !important;
   /* [1] */
 }
 
 .c-back-to-top__trigger:hover .c-back-to-top__icon, .c-back-to-top__trigger:focus .c-back-to-top__icon {
   background-color: #187085;
   /* [2] */
 }
 
 .c-back-to-top__trigger:hover .c-back-to-top__text, .c-back-to-top__trigger:focus .c-back-to-top__text {
   color: #187085;
   /* [2] */
 }
 
 .c-back-to-top__trigger:active {
   box-shadow: none !important;
   /* [1] */
 }
 
 .c-back-to-top__trigger:active .c-back-to-top__icon {
   background-color: #3e4547;
   /* [2] */
 }
 
 .c-back-to-top__trigger:active .c-back-to-top__text {
   color: #3e4547;
   /* [2] */
 }
 
 .c-back-to-top__icon {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   display: inline-flex;
   /* [3] */
   align-items: center;
   /* [3] */
   justify-content: center;
   /* [3] */
   width: 48px;
   /* [3] */
   height: 48px;
   /* [3] */
   background-color: #3e4547;
   /* [2] */
 }
 
 /**
  * @TODO
  * Settings taken from default/components.buttons
  * This should be unified for common button styles per package.
  * BRON-6253
  */
 /* ------------------------------------*\
     #BUTTON-GROUP
 \*------------------------------------ */
 /**
  * The button group component is a set of buttons to choose between several
  * options in forms. So, technically speaking, it's actually radio buttons
  * or checkboxes, just in the look of a bunch of buttons.
  */
 /* stylelint-disable-line scss/no-duplicate-dollar-variables */
 /**
  * [1] Better alignment management.
  * [2] Defensively default it to row direction.
  * [3] Items should collapse into multiple rows when the horizontal space
  *     isn't enough. This simplifies the responsive styling enormously.
  * [4] When the items do have spacing beneath each other, make sure to take care
  *     of the vertical spacing between the items (when multiline) and to
  *     surrounding components.
  * [5] If the browser supports CSS grid, all the alignment management is done
  *     further down and we don't want the margin declarations to interfere
  *     with the `grid-gap` declarations.
  * [6] Defensively default to `display: flex`.
  * [7] Allow items to grow and shrink.
  * [8] Center text inside items.
  * [9] If the items do have spacing beneath each other, give each item, except
  *      the last one, a spacing.
  * [10] The component stretches over the whole available horizontal width, by
  *      default. The `--auto` modifier, however, just takes the space it needs.
  *      Overwrite other flex-grow styles.
  * [11] Make it blocky so it can take up 100% width of its parent.
  * [12] When the items don't have spacing beneath each other, their borders
  *      need to collapse. This is achieved by dividing the amount of the
  *      border-width by two and assigning it partly through a border and partly
  *      through a box-shadow. This way, the â€˜inner halfâ€™ of the border sits
  *      inside the items box (through `border`) and the â€˜outside halfâ€™ sits
  *      outside the items box (through `box-shadow`).
  * [13] Hide the original radio-button.
  * [14] Reset margin-bottom to 0 (set by `<label>` declaration).
  * [15] Overwrite default icon `transition`
  *      to be in sync with button-group transition.
  * [16] Minimum item width before items wrap.
  * [17] Stretch to the highest item in row.
  * [18] Subtract (compensate) margins to prevent unnecessary wrapping (100+%).
  * [19] Allow growing/shrinking if max-count is not reached (quantity queries).
  * [20] Vertically center item content.
  * [21] Get a min-width of `$button-group-item-min-size` and a max width of
  *      `1fr` for each grid-item.
  * [22] Get equal-height grid-rows.
  * [23] The display of icons in button group items is optional.
  */
 .c-button-group {
   display: flex;
   /* [1] */
   flex-direction: row;
   /* [2] */
   flex-wrap: wrap;
   /* [3] */
   margin-top: -24px;
   /* [4] */
 }
 
 @supports (display: grid) {
   .c-button-group {
     margin-top: 0;
     /* [5] */
   }
 }
 
 .c-button-group__item {
   flex-grow: 0;
   /* [7] */
   flex-shrink: 0;
   /* [7] */
   min-width: 152px;
   /* [16] */
   margin-top: 24px;
   /* [4] */
 }
 
 @supports (display: grid) {
   .c-button-group__item {
     margin-top: 0;
     /* [5] */
   }
 }
 
 .c-button-group__item:not(:last-child) {
   margin-right: 24px;
   /* [9] */
 }
 
 @supports (display: grid) {
   .c-button-group__item:not(:last-child) {
     margin-right: 0;
     /* [5] */
   }
 }
 
 @media (max-width: 720px) {
   .c-button-group__item {
     flex-basis: calc(50% - 24px);
     /* [18] */
     /* [19] */
   }
   .c-button-group__item:nth-last-child(-n + 2):first-child,
   .c-button-group__item:nth-last-child(-n + 2):first-child ~ .c-button-group__item {
     flex-grow: 1;
     flex-shrink: 1;
   }
 }
 
 @media (min-width: 721px) {
   .c-button-group__item {
     flex-basis: calc(33.33333% - 24px);
     /* [18] */
     /* [19] */
   }
   .c-button-group__item:nth-last-child(-n + 3):first-child,
   .c-button-group__item:nth-last-child(-n + 3):first-child ~ .c-button-group__item {
     flex-grow: 1;
     flex-shrink: 1;
   }
 }
 
 @media (min-width: 961px) {
   .c-button-group__item {
     flex-basis: calc(16.66667% - 24px);
     /* [18] */
     /* [19] */
   }
   .c-button-group__item:nth-last-child(-n + 6):first-child,
   .c-button-group__item:nth-last-child(-n + 6):first-child ~ .c-button-group__item {
     flex-grow: 1;
     flex-shrink: 1;
   }
 }
 
 .c-button-group--auto .c-button-group__item {
   flex-grow: 0 !important;
   /* [10] */
   /* stylelint-disable-line itcss/no-at-important */
 }
 
 /* autoprefixer: ignore next */
 .c-button-group {
   display: grid;
   /* [1] */
   grid-template-columns: repeat(auto-fit, minmax(152px, 1fr));
   /* [21] */
   grid-auto-rows: 1fr;
   /* [22] */
   grid-row-gap: 24px;
   /* [4] */
   grid-column-gap: 24px;
   /* [4] */
 }
 
 .c-button-group.c-button-group--auto {
   /* autoprefixer: ignore next */
   grid-template-columns: repeat(auto-fill, minmax(152px, 1fr));
   /* [9] */
 }
 
 .c-button-group__item {
   display: flex;
   /* [6] */
   margin-bottom: 0;
   /* [14] */
   text-align: center;
   /* [8] */
 }
 
 .c-button-group__label {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 24px;
   position: relative;
   display: inline-flex;
   /* [11] */
   flex-direction: column;
   justify-content: center;
   /* [20] */
   width: 100%;
   /* [11] */
   height: 100%;
   /* [17] */
   padding: 11px 24px;
   border: 1px solid #495651;
   border-radius: 0;
   background-color: transparent;
   color: #1a1a1a;
   cursor: pointer;
 }
 
 .c-button-group__item.focus-within .c-button-group__label,
 .c-button-group__input:hover + .c-button-group__label,
 .c-button-group__input:focus + .c-button-group__label, .c-button-group__label:hover, .c-button-group__label:focus {
   z-index: 1;
   border-color: #afb5ab;
   border-radius: 0;
   background-color: transparent;
   color: #1a1a1a;
 }
 
 .c-button-group__item:focus-within .c-button-group__label,
 .c-button-group__input:hover + .c-button-group__label,
 .c-button-group__input:focus + .c-button-group__label, .c-button-group__label:hover, .c-button-group__label:focus {
   z-index: 1;
   border-color: #afb5ab;
   border-radius: 0;
   background-color: transparent;
   color: #1a1a1a;
 }
 
 .c-button-group__input:checked + .c-button-group__label {
   z-index: 1;
   border-color: #1a1a1a;
   background-color: #1a1a1a;
   color: #ffffff;
 }
 
 .c-button-group__input[disabled] + .c-button-group__label {
   border-color: rgba(175, 181, 171, 0.5);
   background-color: rgba(175, 181, 171, 0.5);
   color: rgba(26, 26, 26, 0.5);
   cursor: default;
 }
 
 .c-button-group__icon {
   /* 22 */
   margin-bottom: 8px;
 }
 
 .c-button-group__icon::before {
   font-size: 36px;
   transition: none;
   /* [15] */
 }
 
 .c-button-group__input {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
   /* [13] */
 }
 
 /* ------------------------------------*\
     #DEFINITION-LIST-SPLIT
 \*------------------------------------ */
 /**
  * This definition lists' title and content are stacked and multiple items
  * are layed out next to each other (50/50).
  */
 /**
  * [1] By default, the distribution of the two columns is 50/50.
  * [2] Make sure that the content inside of the grid items is always
  *     top-aligned. `align-items: start;` on the grid container does not work.
  * [3] Group the `<dt>`/`<dd>` pairs in groups of two.
  * [4] Add horizontal spacing to avoid overlapping.
  * [5] Reset [4] in responsive mode.
  * [6] Disable autoprefixer for supports block to prevent 'transpiling' issues
  *     which can result in invalid CSS.
  */
 /* [6] */
 @supports (display: grid) {
   /* autoprefixer: off */
   .c-dl-split {
     display: grid;
     grid-template-columns: repeat(2, 50%);
     /* [1] */
     grid-auto-flow: column;
   }
   .c-dl-split dt,
   .c-dl-split dd {
     align-self: start;
     /* [2] */
   }
   .c-dl-split dt:nth-of-type(odd),
   .c-dl-split dd:nth-of-type(odd) {
     grid-column-start: 1;
     /* [3] */
   }
   .c-dl-split dt:nth-of-type(even),
   .c-dl-split dd:nth-of-type(even) {
     grid-column-start: 2;
     /* [3] */
     margin-left: 24px;
     /* [4] */
   }
   @media (max-width: 720px) {
     .c-dl-split--responsive {
       display: block;
     }
     .c-dl-split--responsive dt:nth-of-type(even),
     .c-dl-split--responsive dd:nth-of-type(even) {
       margin-left: 0;
       /* [5] */
     }
   }
 }
 
 /* ------------------------------------*\
     #LIST-NESTED-COUNTER
 \*------------------------------------ */
 /**
  * [1] Selector applies to either an ordered list with nested list class (e.g.
  *     `<ol class="c-list-nested-counter">` or to an ordered list with the
  *     nested list classes added to one of it's parents, e.g.
  *     ```
  *     <div class="c-list-nested-counter">
  *         <ol>
  *             ...
  *         </ol>
  *     </div>
  *     ```.
  */
 ol.c-list-nested-counter,
 .c-list-nested-counter ol {
   /* [1] */
   margin-left: 0;
   list-style-type: none;
   counter-reset: section;
 }
 
 ol.c-list-nested-counter ol,
 .c-list-nested-counter ol ol {
   margin-left: 32px;
   /* stylelint-disable */
   /* stylelint-enable */
 }
 
 ol.c-list-nested-counter ol li,
 .c-list-nested-counter ol ol li {
   margin-bottom: 16px;
 }
 
 ol.c-list-nested-counter li::before,
 .c-list-nested-counter ol li::before {
   counter-increment: section;
   content: counters(section, ".") ". ";
   font-weight: bold;
 }
 
 /* ------------------------------------*\
     #DEFINITION-LIST-HORIZONTAL
 \*------------------------------------ */
 /**
  * This definition lists' title and content are always floated side by side (on
  * large screen).
  */
 /**
  * [1] Since the title and description are stacked on small screen, eliminate the
  *     spacing between them.
  * [2] If the title is multiline but the description is not, align the description to the
  *     bottom of the title.
  * [3] Set `width` instead of flex-basis to fix an issue with
  *     flexbox + `calc()` in IE.
  *     Using `width` & `flex-basis` works as a workaround.
  *     Reference: https://github.com/philipwalton/flexbugs#flexbug-8
  * [4] Ensure that no unwanted spacing is created at the bottom of the
  *     component.
  */
 .c-dl-horizontal {
   display: flex;
   flex-wrap: wrap;
 }
 
 @media (max-width: 960px) {
   .c-dl-horizontal {
     display: block;
   }
 }
 
 @media (min-width: 961px) {
   .c-dl-horizontal.c-dl-horizontal--33-to-66 .c-dl-horizontal__title, .c-dl-horizontal.c-dl-horizontal--33-to-66
   dt {
     width: 33.33333%;
   }
   .c-dl-horizontal.c-dl-horizontal--66-to-33 .c-dl-horizontal__title, .c-dl-horizontal.c-dl-horizontal--66-to-33
   dt {
     width: 66.66667%;
   }
   .c-dl-horizontal.c-dl-horizontal--50-to-50 .c-dl-horizontal__title, .c-dl-horizontal.c-dl-horizontal--50-to-50
   dt {
     width: 50%;
   }
   .c-dl-horizontal.c-dl-horizontal--33-to-66 .c-dl-horizontal__item, .c-dl-horizontal.c-dl-horizontal--33-to-66
   dd {
     width: 66.66667%;
   }
   .c-dl-horizontal.c-dl-horizontal--66-to-33 .c-dl-horizontal__item, .c-dl-horizontal.c-dl-horizontal--66-to-33
   dd {
     width: 33.33333%;
   }
   .c-dl-horizontal.c-dl-horizontal--50-to-50 .c-dl-horizontal__item, .c-dl-horizontal.c-dl-horizontal--50-to-50
   dd {
     width: 50%;
   }
 }
 
 .c-dl-horizontal__title,
 .c-dl-horizontal dt {
   flex-grow: 0;
   flex-shrink: 0;
   flex-basis: auto;
   /* [3] */
   width: 180px;
   /* [3] */
   padding-right: 16px;
 }
 
 @media (max-width: 960px) {
   .c-dl-horizontal__title,
   .c-dl-horizontal dt {
     width: 100%;
     margin-bottom: 0;
     /* [1] */
     padding-right: 0;
     /* [1] */
   }
 }
 
 .c-dl-horizontal__title:last-of-type,
 .c-dl-horizontal dt:last-of-type {
   margin-bottom: 0;
   /* [4] */
 }
 
 .c-dl-horizontal__item,
 .c-dl-horizontal dd {
   flex-grow: 1;
   flex-shrink: 1;
   flex-basis: auto;
   /* [3] */
   align-self: flex-end;
   /* [2] */
   width: calc(100% - 180px);
   /* [3] */
 }
 
 @media (max-width: 960px) {
   .c-dl-horizontal__item,
   .c-dl-horizontal dd {
     width: 100%;
   }
 }
 
 .c-dl-horizontal__item:last-of-type,
 .c-dl-horizontal dd:last-of-type {
   margin-bottom: 0;
   /* [4] */
 }
 
 /* ------------------------------------*\
     #ORDERED-LIST
 \*------------------------------------ */
 .c-ol,
 .c-ol ol {
   /* [1] */
   counter-reset: li;
   list-style-type: decimal;
 }
 
 .c-ol > li,
 .c-ol ol > li {
   margin-bottom: 16px;
   /* stylelint-disable selector-max-combinators, selector-max-compound-selectors, selector-max-type */
   /* stylelint-enable */
 }
 
 .c-ol > li > ol,
 .c-ol ol > li > ol {
   margin-top: 16px;
   margin-left: 32px;
 }
 
 /* ------------------------------------*\
     #UNORDERED-LIST
 \*------------------------------------ */
 /**
  * [1] Make sure the selector is also applied to nested `<ul>` elements.
  * [2] If a custom list icon is set, we explicitly set the listâ€™s `list-style` to `none`,
  *     otherwise we do fall back to the inherited `list-style` of the `ul`.
  * [2] Unset the initial `margin-left` from the `ul`.
  * [3] Check if a custom list icon is set. If so, disable `list-style` on the list
  *     and apply a custom icon via pseudo element.
  * [4] Whether to use an icon from the icon set or (a) custom char(s).
  *     In the case of custom char(s) any text-level styling should happen in the brand itself,
  *     as the default component cannot augment any possible style combination.
  * [5] Style only unordered list items.
  */
 .c-ul,
 .c-ul ul {
   /* [1] */
   /* [2] */
   /* [3] */
 }
 
 .c-ul > li,
 .c-ul ul > li {
   /* [5] */
 }
 
 /* ------------------------------------*\
     #SECTION-HEADINGS
 \*------------------------------------ */
 /**
  * [1] Provide fallback class to prevent a potential severe breaking change.
  * [2] Reset margin bottom for text and manage it over
  *     `$section-headings-spacing-bottom` on `.c-section-heading`.
  * [3] Wrap text and possible inline elements in `<span>` because of parent's
  *     flex setting. Left empty here for documentation and prospective usage.
  */
 .c-section-heading {
   margin-bottom: 32px;
 }
 
 .c-section-heading.c-section-heading--center {
   text-align: center;
 }
 
 .c-section-heading.c-section-heading--center .c-section-heading__title {
   justify-content: center;
 }
 
 .c-section-heading.c-section-heading--small, .c-section-heading.c-section-heading--small-spacing {
   margin-bottom: 24px;
 }
 
 .c-section-heading__icon {
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   margin-right: 16px;
   color: #1a1a1a;
 }
 
 .c-section-heading__title {
   font-size: 1.625rem;
   /* stylelint-disable-line order/order */
   line-height: 1.2;
   display: flex;
   margin-bottom: 0;
   font-weight: 300;
   color: #1a1a1a;
 }
 
 @media (min-width: 721px) {
   .c-section-heading__title {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 @media (min-width: 1921px) {
   .c-section-heading__title {
     font-size: 2.25rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 .c-section-heading--primary .c-section-heading__title {
   font-size: 2.125rem;
   /* stylelint-disable-line order/order */
   line-height: 1.2;
   margin-bottom: 24px;
   padding-bottom: 24px;
 }
 
 @media (min-width: 721px) {
   .c-section-heading--primary .c-section-heading__title {
     font-size: 3rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 @media (min-width: 1921px) {
   .c-section-heading--primary .c-section-heading__title {
     font-size: 3.75rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 .c-section-heading--subtitle .c-section-heading__title {
   margin-bottom: 24px;
 }
 
 .c-section-heading__title-text {
   /* [3] */
 }
 
 .c-section-heading__subtitle {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   margin-bottom: 0;
   /* [2] */
   color: #1a1a1a;
 }
 
 /* ------------------------------------*\
     #FORM-HEADING (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #FORM-HEADING
 \*------------------------------------ */
 /**
  * [1] Reset margin bottom for text and manage it over
  *     `$form-headings-spacing` on `.c-form-heading`.
  * [2] Make sure that an (optional) icon is centered vertically.
  * [3] Nesting required to overrule `.c-icon` selector.
  * [4] Wrap text and possible inline elements in `<span>` because of parent's
  *     flex setting. Left empty here for documentation and prospective usage.
  * [5] Hide icon if disabled.
  * [6] Add bottom spacing to title only if there is no additional sibling element.
  */
 .c-form-heading {
   margin-bottom: 16px;
 }
 
 .c-form-heading__title {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
   display: flex;
   /* [2] */
   align-items: center;
   /* [2] */
   font-weight: 400;
   color: #1a1a1a;
 }
 
 @media (min-width: 721px) {
   .c-form-heading__title {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-form-heading__title {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-form-heading__title:not(:only-child) {
   margin-bottom: 8px;
   /* [6] */
 }
 
 .c-form-heading__title .c-form-heading__icon {
   /* [3] */
   margin-right: 8px;
   font-size: 36px;
 }
 
 .c-form-heading__text {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   display: block;
   margin-bottom: 0;
   /* [1] */
   color: #1a1a1a;
 }
 
 .c-form-heading__title-text {
   /* [4] */
 }
 
 /* ------------------------------------*\
     #FORM-FIELD (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #FORM-FIELD
 \*------------------------------------ */
 /**
  * [1] Sets transform origin to left/top for text area and bottom left for all
  *     other inputs. This also fixes the blurry text issue when
  *     scale is used (https://stackoverflow.com/questions/29037176/preventing-blurry-rendering-with-transform-scale/29037803).
  * [2] We have to scale up the label when floated in and not vice versa.
  *     Otherwise, the box of the floated out label would be larger than the
  *     content itself. This causes e.g. an unwanted spacings between the
  *     content of the label and siblings like info icons.
  * [3] Since the text is scaled up using transform, reduce the max-width
  *     of the label accordingly. Important for labels that break into multiple
  *     lines.
  * [4] `:not(.c-form-field--no-floating)` was added here to increase the
  *     specificity. From a logical standpoint, combining the classes
  *     `.c-form-field--floating-textarea` and `.c-form-field--no-floating` does
  *     not make sense.
  * [5] Let clicks go through in order to be able to select the input element when
  *     clicking on the label.
  * [6] Allow all pointer-events on the label when its parent is active or has focus.
  * [7] Position the side-link to the right on larger viewports and flush left on smaller ones.
  * [8] Change the order for the side link and make all other elements appear
  *     in their order before the side link or hint label.
  * [9] Remove any bottom spacing to place an optional error message below
  *     the hint message with the correct margin.
  * [10] Propagate input state styles to the form-field element.
  *      We force those styles over all other with `!important` here.
  * [11] Only display the input hint message if it was explicitly configured.
  */
 .c-form-field {
   display: flex;
   flex-direction: column;
 }
 
 .c-form-field__side-link {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   align-self: flex-end;
   /* [7] */
   order: 1;
   margin-top: 8px;
 }
 
 @media (max-width: 720px) {
   .c-form-field__side-link {
     align-self: flex-start;
   }
 }
 
 .c-form-field__side-link ~ .c-form-field__label,
 .c-form-field__side-link ~ .c-form-field__box {
   order: 0;
   /* [8] */
 }
 
 .c-form-field__label {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   position: relative;
   display: inline-block;
   margin-bottom: 8px;
   font-weight: 700;
   text-align: left;
   color: #1a1a1a;
 }
 
 /* ------------------------------------*\
     #FORM-SECTION
 \*------------------------------------ */
 /**
  * [1] Border below the last accordion item.
  * [2] Reset various browser and general button styles that would interfere
  *     with form section header or title styles.
  * [3] Max line-length of title.
  * [4] Remove bottom margin of either title, subtitle or last content element.
  * [5] Prevent shifting position on focus/active @ IE.
  * [6] Add spacing between sections, except if it is the only/last item
  *     within its wrapper.
  * [7] Hide button link icon if brand needs it based on variable setting.
  * [8] Reset button link margin if no icon is shown. High specificity needed
  *     in order to overwrite default button styles.
  * [9] Properly align link button vertically with title.
  * [10] Span title wrapper to full width to be able to place the link element
  *      more flexible (e.g. to the right).
  * [11] Cut off title and subtitle only when section is collapsed.
  * [12] Align item to top on small screens to prevent vertical movement upon
  *      opening/closing the section with truncated title and subtitle.
  * [13] Prevent unwanted vertical movement when truncating is triggered upon
  *      opening/closing the section.
  * [14] Align link button vertically with title baseline as the default setting
  *      varies from browser to browser (e.g. Google Chrome).
  * [15] Collapse/expand panel with CSS only by utilizing the `animate-height`
  *      mixin.
  * [16] Covering overlay in disabled state. To also disable all form fields on a
  *      markup level, add the `disabled` attribute to the `fieldset` element.
  *      See https://codepen.io/stevef/post/short-note-on-the-disabled-attribute
  * [17] Stack overlay above stacked elements inside form-section.
  *      Use arbitrary/scoped value as it's not relevant in global stacking
  *      context and therefore not in `$Z-LAYERS`.
  * [18] Grayscale / desaturate via overlay to emphasize the disabled state.
  *      Works only in browsers supporting CSS filter.
  * [19] Disable visual focus indicator in disabled state.
  * [20] "Stack" header (triggers toggle) above disabled section in order to
  *      allow expanding/collapsing form section.
  *      The value is a magic number and only works > 10.
  *      Not in global stacking context and therefore not in `$Z-LAYERS`.
  * [21] Reset heading styles.
  * [22] Make the overflow visible for open form sections to make sure, that
  *      tippy boxes can be displayed outside the bounds of the
  *      form section panel. If JS animations are activated, the JS code sets
  *      this behavior.
  */
 .c-form-section[aria-disabled="true"],
 .c-form-section[aria-disabled="true"] .c-form-section__header {
   position: relative;
   outline: 0;
   /* [19] */
   filter: grayscale(1);
   /* [18] */
 }
 
 .c-form-section[aria-disabled="true"]::after,
 .c-form-section[aria-disabled="true"] .c-form-section__header::after {
   /* [16] */
   content: "";
   position: absolute;
   z-index: 10;
   /* [17] */
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background-color: rgba(255, 255, 255, 0.75);
 }
 
 .c-form-section[aria-disabled="true"] .c-form-section__header {
   z-index: 20;
   /* [20] */
   box-shadow: none;
   /* [19] */
 }
 
 .c-form-section {
   position: relative;
   background-color: #f2f2f2;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-form-section,
 .u-bg-alternative .c-form-section {
   background-color: #ffffff;
 }
 
 .c-form-section:not(.js-is-fx) {
   overflow: hidden;
 }
 
 .c-form-section:not(.js-is-fx).is-open {
   overflow: visible;
   /* [22] */
 }
 
 .c-form-section:not(:last-child) {
   margin-bottom: 24px;
   /* [6] */
 }
 
 .c-form-section__header {
   padding: 0;
   border: 0;
   background-color: transparent;
   /* [2] */
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   padding-top: 24px;
   padding-right: 24px;
   padding-bottom: 24px;
   padding-left: 24px;
   display: flex;
   align-items: center;
   justify-content: space-between;
   width: 100%;
   margin: 0;
   font-family: inherit;
   /* [2] */
   line-height: inherit;
   /* [2] */
   text-align: left;
   /* [2] */
   cursor: pointer;
 }
 
 .c-form-section__header:focus {
   outline: 0;
 }
 
 .c-form-section__header.focus-within:not(.is-active) {
   box-shadow: 0 0 0 1px #187085 inset;
 }
 
 .c-form-section__header:focus-within:not(.is-active) {
   box-shadow: 0 0 0 1px #187085 inset;
 }
 
 .c-form-section__header:hover:not(.is-active) {
   box-shadow: 0 0 0 1px #187085 inset;
 }
 
 .c-form-section__header-content {
   flex-grow: 1;
   overflow: hidden;
   padding-right: 16px;
 }
 
 .c-form-section__header-content > *:last-child {
   margin-bottom: 0;
   /* [4] */
 }
 
 .c-form-section__title {
   padding: 0;
   border: 0;
   background-color: transparent;
   /* [2] */
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 24px;
   display: flex;
   align-items: baseline;
   /* [14] */
   width: 100%;
   /* [10] */
   margin-bottom: 0;
   font-family: inherit;
   /* [21] */
   font-weight: 400;
   letter-spacing: inherit;
   /* [21] */
   text-align: left;
   /* [2] */
   color: #1a1a1a;
   outline: none;
   /* [2] */
   cursor: pointer;
 }
 
 .c-form-section__title:focus {
   outline: 0;
 }
 
 @media (min-width: 721px) {
   .c-form-section__title {
     font-size: 1.125rem;
     /* stylelint-disable-line order/order */
     line-height: 24px;
   }
 }
 
 @media (min-width: 1921px) {
   .c-form-section__title {
     font-size: 1.5rem;
     /* stylelint-disable-line order/order */
     line-height: 24px;
   }
 }
 
 .c-form-section__title-text {
   position: relative;
   /* [5] */
   max-width: 30em;
   /* [3] */
 }
 
 .c-form-section__header[aria-expanded='false']:not(.c-form-section__header--no-truncate) .c-form-section__title-text {
   display: inline-block;
   max-width: 100%;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   /* [11] */
 }
 
 .c-form-section__title-link {
   margin-left: 16px;
 }
 
 @media (max-width: 720px) {
   .c-form-section__title-link {
     display: none;
   }
 }
 
 .c-form-section__subtitle {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 24px;
   display: inline-block;
   /* [13] */
   overflow: hidden;
   /* [13] */
   font-weight: 400;
   color: #1a1a1a;
 }
 
 .c-form-section__header[aria-expanded='false']:not(.c-form-section__header--no-truncate) .c-form-section__subtitle {
   display: inline-block;
   max-width: 100%;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   /* [11] */
 }
 
 @media (max-width: 720px) {
   .c-form-section__header-icon {
     align-self: flex-start;
     /* [12] */
   }
 }
 
 .c-form-section__header-icon::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   content: "\e944";
   transform: rotateX(0deg);
   color: #1a1a1a;
   transition: transform 0.33333s ease;
 }
 
 @media (max-width: 480px) {
   .c-form-section__header-icon::before {
     font-size: 1.5rem;
     /* stylelint-disable-line order/order */
     line-height: 1;
   }
 }
 
 .c-form-section--success .c-form-section__header-icon::before {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   content: "\e952";
   transform: none;
   color: #00783c;
 }
 
 @media (max-width: 480px) {
   .c-form-section--success .c-form-section__header-icon::before {
     font-size: 1.5rem;
     /* stylelint-disable-line order/order */
     line-height: 1;
   }
 }
 
 .c-form-section__header[aria-expanded='true'] .c-form-section__header-icon::before {
   content: "\e944";
   transform: rotateX(-180deg);
 }
 
 .c-form-section--success .c-form-section__header[aria-expanded='true'] .c-form-section__header-icon::before {
   content: "\e952";
   transform: none;
 }
 
 .c-form-section.js-is-fx .c-form-section__panel {
   transition: height 0.5s ease, visibility 1s;
 }
 
 .c-form-section:not(.js-is-fx) .c-form-section__panel[aria-hidden='false'] {
   /* [15] */
   /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
 }
 
 @media screen and (prefers-reduced-motion: reduce), (update: slow) {
   .c-form-section:not(.js-is-fx) .c-form-section__panel[aria-hidden='false'] {
     /* stylelint-disable-next-line declaration-no-important */
     animation: none !important;
   }
 }
 
 .c-form-section:not(.js-is-fx) .c-form-section__panel[aria-hidden='false'] {
   max-height: 0;
 }
 
 .c-form-section:not(.js-is-fx) .c-form-section__panel[aria-hidden='false'] {
   max-height: 100%;
   animation-name: animateheight0;
   animation-duration: 0.5s;
   animation-timing-function: ease-out;
   animation-fill-mode: none;
 }
 
 @keyframes animateheight0 {
   0% {
     max-height: 0;
   }
   100% {
     max-height: 100vh;
   }
 }
 
 .c-form-section:not(.js-is-fx) .c-form-section__panel[aria-hidden='true'] {
   /* [15] */
   /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
 }
 
 @media screen and (prefers-reduced-motion: reduce), (update: slow) {
   .c-form-section:not(.js-is-fx) .c-form-section__panel[aria-hidden='true'] {
     /* stylelint-disable-next-line declaration-no-important */
     animation: none !important;
   }
 }
 
 .c-form-section:not(.js-is-fx) .c-form-section__panel[aria-hidden='true'] {
   max-height: 100vh;
 }
 
 .c-form-section:not(.js-is-fx) .c-form-section__panel[aria-hidden='true'] {
   max-height: 0;
   animation-name: animateheight1;
   animation-duration: 0.5s;
   animation-timing-function: ease-in;
   animation-fill-mode: forwards;
 }
 
 @keyframes animateheight1 {
   0% {
     max-height: 100vh;
   }
   100% {
     max-height: 0;
   }
 }
 
 .c-form-section__content {
   padding-top: 24px;
   padding-right: 24px;
   padding-bottom: 24px;
   padding-left: 24px;
 }
 
 .c-form-section__content > *:last-child {
   margin-bottom: 0;
   /* [4] */
 }
 
 /* ------------------------------------*\
     #INPUT-TEXT
 \*------------------------------------ */
 /**
  * [1] Allow us to style box model properties.
  * [2] Line different sized inputs up a little nicer.
  * [3] Only change border for non-background addons.
  * [4] If the input has rounded borders, the fake line's `width` must have the
  *     same value as the `border-radius` to totally cover the border. The
  *     input's border must be replaced by a border attached to the fake line.
  * [5] With the previously used variant with only `flex-basis` IE11 added
  *     horizontal padding. It was used because a `min-width` only variant
  *     was causing some cutoff. Now we combine `min-width` and `flex-basis`
  *     for better IE11 compatibility without side effects.
  * [6] Reset default label spacing.
  * [7] Border-depends on the position of symbol.
  * [8] Control position of addon via CSS - not markup order.
  * [9] Set input height (minus vertical borders).
  * [10] Reset default button-style.
  * [11] Chrome needs a reset appearance, otherwise it sets a default
  *      border-radius, in case it's a `<select>`.
  * [12] Textareas must not get a fixed height and a corresponding line-height...
  * [13] ...but instead get a custom padding-top and -bottom to offset the text
  *      content from the top edge of the textarea.
  * [14] Defensively reset border-radius.
  * [15] Create complete border-radius when there is no `.c-input__addon`.
  * [16] Perfectly align the icon inside of `.c-input__addon`.
  * [17] When the input is a `<select>`, the addon is taken out of the documents
  *      flow, so the border-radius needs to be set explicitly here.
  * [18] Since the the icon is laying on top of the select, a click on the arrow
  *      has to be ignored and looped through to the select itself.
  * [19] If it's a `<select>`, don't let long select input text overflow the
  *      dropdown arrow.
  * [20] Vertical center the icon.
  * [21] Firefox won't hide its dotted outline on focus on select elements. This
  *      fixes it. Be aware: Although it works, it's still a hack!
  * [22] Reset styles of input and `.c-input__addon` for readonly state to
  *      prevent focus styles from being used here.
  * [23] Reset styles of input and `.c-input__addon` for disabled state to
  *      prevent default styles from being used here
  * [24] Prevent IE 11 and Edge from showing a browser default cross icon to clear
  *      the text input.
  * [25] Fixes Firefox issue. Firefox grows the input when an input addon is
  *      present. `min-width: 0` fixes that issue. (https://github.com/philipwalton/flexbugs/tree/38fdbe408e2ae6dcf32bff1e29db41c6ab964f55#flexbug-1)
  * [26] Hide the native dropdown icon in IE11.
  * [27] When the dropdown icon is hidden at disabled state, stack the select
  *      above the dropdown. This is done as there is no way
  *      (due to missing parent selector) to select the icon (pseudo element on parent)
  *      when the select is disabled.
  * [28] Inherit the color assigned to `.c-input__addon` instead of applying the
  *      default icon color.
  * [29] If the border width is different on focus, add a pseudo element to fake
  *      a thicker border. This is necessary, as changing the border width would
  *      also change the element's height.
  * [30] Explicitly override the border set if text inputs only have a
  *      `border-bottom`. Due to a lack of specificity, the border has to be
  *      reset for the reversed modifier explicitly.
  * [31] Check if textareas should be included in the border-bottom-only
  *      styling and modify the selector accordingly.
  * [32] Add horizontal padding to textareas if they donâ€™t have
  *      border-bottom-only styling.
  * [33] The fake line to cover the border between input and addon is not needed
  *      in Bronson-Audi, because there is not border to cover.
  * [34] Horizontal centering of fake border focus animation.
  * [35] Required to display the border color correct on iOS.
  * [36] Enable flex wrap to allow positioning of the character counter below
  *      textareas.
  * [37] Fix positioning of (non-textarea) input fields (with addon) because
  *      of [36].
  * [38] In the markup we add the counter before the textarea because it makes
  *      more sense for accessibility when a potential character limit gets
  *      announced before filling out a textarea. Therefore we position the
  *      counter below textarea via Flexbox `order` below the textarea.
  * [39] Stretch the counter to full width to ensure it will be displayed below
  *      textarea.
  * [40] Hide counter for disabled and read-only input fields.
  * [41] Styles for the counter alert state.
  * [42] Add space below textarea or input field and move the counter and
  *      error message upwards to display them side by side.
  * [43] Add a save space after the error message for the counter.
  * [44] Fix Safari faded input text for disabled and readonly inputs.
  *      The `-webkit-text-fill-color` sets foreground fill color of
  *      the element's text content.
  * [45] Requires state-class to be applied to input wrapper (`.c-input`)
  *      instead of actual input. This derives on how state classes are
  *      set on other types of inputs.
  *      But due to the limited styling possibilities of native select,
  *      this is a workaround and can be seen as "progressive enhancement".
  */
 .c-input {
   position: relative;
   display: flex;
   flex-wrap: wrap;
   /* [36] */
 }
 
 .c-input.c-input--select {
   /* [45] */
 }
 
 .c-input.c-input--select::after {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   content: "\e944";
   position: absolute;
   top: 50%;
   /* [20] */
   right: 16px;
   transform: translateY(-50%);
   /* [20] */
   border: 0;
   color: #1a1a1a;
   pointer-events: none;
   /* [18] */
 }
 
 .c-input.c-input--select.is-disabled::after {
   color: rgba(26, 26, 26, 0.5);
 }
 
 .c-input.c-input--select .c-input__input:-moz-focusring {
   color: transparent;
   /* [21] */
   text-shadow: 0 0 0 #1a1a1a;
   /* [21] */
 }
 
 .c-input.c-input--select .c-input__input::-ms-expand {
   display: none;
   /* [26] */
 }
 
 .c-input .c-icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   vertical-align: middle;
 }
 
 .c-input__input {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   flex-grow: 1;
   /* [37] */
   flex-shrink: 1;
   /* [37] */
   flex-basis: 0;
   /* [37] */
   width: 100%;
   min-width: 0;
   /* [25] */
   padding: 0 16px;
   border: 1px solid #495651;
   border-radius: 0;
   /* [14] */
   font-weight: 400;
   background: #ffffff;
   color: #1a1a1a;
   box-shadow: none;
   -webkit-appearance: none;
   appearance: none;
   /* [11] */
   /**
          * Hover state styles
          */
   /**
          * Focus state styles
          */
   /**
          * Disabled state styles
          */
   /**
          * Readonly state styles
          */
   /**
          * Input status themes
          */
   /* stylelint-disable-next-line order/order */
 }
 
 .c-input__input:not(textarea) {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 48px;
   /* [12] */
   height: 48px;
   /* [12] */
 }
 
 textarea.c-input__input {
   flex-basis: auto;
   /* [37] */
   padding-top: 16px;
   /* [13] */
   padding-bottom: 16px;
   /* [13] */
 }
 
 select.c-input__input {
   border-top-right-radius: 0;
   /* [17] */
   border-bottom-right-radius: 0;
   /* [17] */
 }
 
 .c-input--select .c-input__input {
   padding-right: 56px;
   /* [19] */
 }
 
 @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .c-input--select .c-input__input {
     padding-right: 0;
     /* [26] */
   }
 }
 
 .c-input--reversed .c-input__input {
   border-right: 1px solid #495651;
   border-left: 0;
   /* [7] */
 }
 
 .c-input__input:-ms-input-placeholder {
   font-weight: 400;
   color: #afb5ab;
   opacity: 1;
 }
 
 .c-input__input::-ms-input-placeholder {
   font-weight: 400;
   color: #afb5ab;
   opacity: 1;
 }
 
 .c-input__input::placeholder {
   font-weight: 400;
   color: #afb5ab;
   opacity: 1;
 }
 
 .c-input__input::-ms-clear {
   display: none;
   /* [24] */
 }
 
 .c-input__input:hover {
   border-color: #187085;
 }
 
 .c-input__input:hover ~ .c-input__addon {
   border-color: #187085;
   /* [3] */
 }
 
 .c-input__input:focus {
   border-color: #187085;
   outline: none;
 }
 
 .c-input__input:focus ~ .c-input__addon {
   border-color: #187085;
   /* [3] */
 }
 
 .c-input__input.is-disabled, .c-input__input[disabled] {
   border-color: #afb5ab;
   background-color: #f2f2f2;
   color: #afb5ab;
   pointer-events: none;
   cursor: default;
   -webkit-text-fill-color: #afb5ab;
   opacity: 1;
   /* [35] */
 }
 
 .c-input__input.is-disabled ~ .c-input__addon, .c-input__input[disabled] ~ .c-input__addon {
   border-color: #afb5ab !important;
   /* [23] */
   /* stylelint-disable-line itcss/no-at-important */
   background-color: #f2f2f2;
   /* [23] */
   color: rgba(26, 26, 26, 0.5);
   /* [23] */
   pointer-events: none;
   cursor: default;
   /* stylelint-disable-next-line selector-max-class */
 }
 
 .c-input__input.is-disabled ~ .c-input__addon:not(.c-input__addon--no-background), .c-input__input[disabled] ~ .c-input__addon:not(.c-input__addon--no-background) {
   background-color: #afb5ab;
   /* [23] */
   color: rgba(26, 26, 26, 0.5);
   /* [23] */
 }
 
 .c-input__input.is-disabled ~ .c-input__addon.c-input__addon--no-background, .c-input__input[disabled] ~ .c-input__addon.c-input__addon--no-background {
   color: rgba(26, 26, 26, 0.5);
 }
 
 .c-input__input.is-readonly, .c-input__input[readonly] {
   border-color: #afb5ab;
   background-color: #ffffff;
   color: #afb5ab;
   pointer-events: none;
   cursor: default;
   -webkit-text-fill-color: #afb5ab;
 }
 
 .c-input__input.is-readonly ~ .c-input__addon, .c-input__input[readonly] ~ .c-input__addon {
   border-color: #afb5ab;
   /* [22] */
   background-color: #ffffff;
   /* [22] */
   color: rgba(26, 26, 26, 0.5);
   /* [22] */
   pointer-events: none;
   cursor: default;
 }
 
 .c-input__input.is-readonly ~ .c-input__addon:not(.c-input__addon--no-background), .c-input__input[readonly] ~ .c-input__addon:not(.c-input__addon--no-background) {
   background-color: #afb5ab;
   /* [22] */
 }
 
 .c-input__input.is-readonly:focus, .c-input__input[readonly]:focus {
   border-color: #afb5ab;
   /* [22] */
 }
 
 .c-input__input.is-readonly:focus ~ .c-input__addon, .c-input__input[readonly]:focus ~ .c-input__addon {
   border-color: #afb5ab;
   /* [22] */
 }
 
 .c-input__input.is-error {
   border-color: #ba2525;
   color: #ba2525;
 }
 
 .c-input__input.is-error:focus ~ .c-input__addon,
 .c-input__input.is-error:focus ~ .c-input__state-icon {
   border-color: #ba2525;
 }
 
 .c-input__input.is-error:hover {
   border-color: #ba2525;
 }
 
 .c-input__input.is-error:hover ~ .c-input__addon,
 .c-input__input.is-error:hover ~ .c-input__state-icon {
   border-color: #ba2525;
 }
 
 .c-input__input.is-error ~ .c-input__addon {
   border-color: #ba2525;
   color: #1a1a1a;
   /* stylelint-disable-next-line selector-max-class */
 }
 
 .c-input__input.is-error ~ .c-input__addon.c-input__addon--no-background {
   color: #ba2525;
 }
 
 .c-input__input.is-success {
   border-color: #00783c;
   color: #00783c;
 }
 
 .c-input__input.is-success:focus ~ .c-input__addon,
 .c-input__input.is-success:focus ~ .c-input__state-icon {
   border-color: #00783c;
 }
 
 .c-input__input.is-success:hover {
   border-color: #00783c;
 }
 
 .c-input__input.is-success:hover ~ .c-input__addon,
 .c-input__input.is-success:hover ~ .c-input__state-icon {
   border-color: #00783c;
 }
 
 .c-input__input.is-success ~ .c-input__addon {
   border-color: #00783c;
   color: #1a1a1a;
   /* stylelint-disable-next-line selector-max-class */
 }
 
 .c-input__input.is-success ~ .c-input__addon.c-input__addon--no-background {
   color: #00783c;
 }
 
 .c-input__addon {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   position: relative;
   display: flex;
   /* [16] */
   align-items: center;
   /* [16] */
   justify-content: center;
   /* [16] */
   flex-grow: 0;
   flex-shrink: 0;
   /* [5] */
   flex-basis: auto;
   /* [5] */
   order: 5;
   /* [8] */
   margin-bottom: 0;
   /* [6] */
   padding-right: 16px;
   padding-left: 16px;
   border: 1px solid #495651;
   /* [7] */
   border-left: 0;
   /* [7] */
   text-align: center;
   background-color: #f2f2f2;
   color: #1a1a1a;
   /**
          * Modify fake line to cover up border between input and addon
          * when `.c-input--reversed` modifier is used.
          */
 }
 
 .c-input__addon:not(.c-input__addon--no-background) {
   min-width: 42px;
   /* [5] */
 }
 
 .c-input__addon .c-icon {
   color: inherit;
   /* [28] */
 }
 
 .c-input--reversed .c-input__addon {
   order: -5;
   /* [8] */
   border: 1px solid #495651;
   /* [7] */
   border-right: 0;
   /* [7] */
 }
 
 .c-input--reversed .c-input__addon::before {
   right: auto;
   left: 100%;
 }
 
 button.c-input__addon {
   padding-top: 0;
   /* [10] */
   padding-bottom: 0;
   /* [10] */
   -webkit-appearance: none;
   appearance: none;
   /* [10] */
   cursor: pointer;
 }
 
 button.c-input__addon:focus {
   outline: 0;
   /* [10] */
 }
 
 .c-input__addon--no-background {
   position: relative;
   background-color: #ffffff;
   color: #1a1a1a;
 }
 
 .c-input__state-icon {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   /* [9] */
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 46px;
   position: relative;
   padding-right: 16px;
   padding-left: 16px;
   border: 1px solid #495651;
   background: #ffffff;
   /* stylelint-disable-next-line order/order */
   /**
          * Modify fake line to cover up the ROUNDED border between input and state icon.
          */
 }
 
 .c-input--reversed .c-input__state-icon, .c-input__state-icon:last-child {
   border-top-right-radius: 0;
   border-bottom-right-radius: 0;
 }
 
 .c-input__input.is-error ~ .c-input__state-icon {
   border-color: #ba2525;
   color: #ba2525;
 }
 
 .c-input__input.is-error ~ .c-input__state-icon::after {
   content: "\e955";
 }
 
 .c-input__input.is-success ~ .c-input__state-icon {
   border-color: #00783c;
   color: #00783c;
 }
 
 .c-input__input.is-success ~ .c-input__state-icon::after {
   content: "\e952";
 }
 
 .c-input__addon,
 .c-input__state-icon {
   /**
             * Fake line to cover up the border between input and addon or state icon.
             * This can not be achieved with sibling selector as this would have to affect
             * the input BEFORE the addon or state icon.
             */
 }
 
 .c-input__addon::before,
 .c-input__state-icon::before {
   content: "";
   position: absolute;
   top: 0;
   right: 100%;
   bottom: 0;
   display: block;
   width: 2px;
   background-color: inherit;
 }
 
 .c-input__counter {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   order: 1;
   /* [38] */
   width: 100%;
   /* [39] */
   margin-top: -1rem;
   /* [42] */
   padding-top: 2px;
   font-weight: 400;
   line-height: 1;
   text-align: right;
   color: #3e4547;
 }
 
 .c-input__input.is-disabled + .c-input__counter,
 .c-input__input[disabled] + .c-input__counter,
 .c-input__input.is-readonly + .c-input__counter,
 .c-input__input[readonly] + .c-input__counter {
   display: none;
   /* [40] */
 }
 
 .c-input__counter + .c-input__input {
   margin-bottom: 1rem;
   /* [42] */
 }
 
 .c-input__counter ~ .c-error-message {
   position: relative;
   /* [42] */
   top: -1rem;
   /* [42] */
   margin-right: 4rem;
   /* [43] */
 }
 
 .c-input__counter--alert {
   /* [41] */
   color: #ba2525;
 }
 
 /* ------------------------------------*\
     #ERROR-MESSAGE
 \*------------------------------------ */
 /**
  * [1] Just output the declaration when it's != 0.
  * [2] Hide messages without content. Selector only matches for NO content,
  *     whitespaces & comments are not considered as empty.
  * [3] Match selector even with whitespaces & comments,
  *     analogue to `:blank` (firefox only).
  * [4] Move error message visually to the end in a flexbox context to make it
  *     work properly with `.c-input__counter`.
  */
 .c-error-message {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   order: 1;
   color: #ba2525;
 }
 
 .c-error-message:empty, .c-error-message:-moz-only-whitespace {
   display: none;
 }
 
 .c-error-message a {
   color: currentColor;
 }
 
 /* ------------------------------------*\
     #CHECKBOX
 \*------------------------------------ */
 /**
  * [1] Defensively reset any `margin-bottom`.
  * [2] Hide original checkbox.
  * [3] Make it block so everything behaves as expected.
  * [4] Setting the height of the label text to a minimum of the checkbox
  *     size makes the text clickable on its entire height, i.e.: It increases
  *     the click area.
  * [5] Align the first (or only) row of label text vertically centered to the
  *     checkbox.
  * [6] Keep the spacing between checkbox and label text consistent,
  *     independent from the checkbox size.
  * [7] Relation for the checkbox.
  * [8] Vertically center the icon inside of the checkbox.
  * [9] The overlay has the same dimensions as the box but transparent borders
  *     and `background-clip: content-box;` to avoid sometimes invisible borders
  *     in smaller browser zoom levels.
  * [10] Animate the positioning of the overlay over the icon.
  */
 .c-checkbox {
   -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
   /* [1] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   margin-bottom: 0;
   /* [1] */
 }
 
 .c-checkbox__input {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
   /* [2] */
 }
 
 .c-checkbox__label {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 24px;
   position: relative;
   /* [7] */
   display: block;
   /* [3] */
   min-height: 28px;
   /* [4] */
   padding-top: 2px;
   /* [5] */
   padding-left: 44px;
   /* [6] */
   color: #1a1a1a;
   cursor: pointer;
 }
 
 .c-checkbox__input:focus + .c-checkbox__label::before {
   border-color: #187085;
 }
 
 .c-checkbox__input[disabled] + .c-checkbox__label {
   color: rgba(26, 26, 26, 0.5);
   cursor: default;
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
 }
 
 .c-checkbox__input.is-error + .c-checkbox__label {
   color: #ba2525;
 }
 
 .c-checkbox__label::before {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   content: "";
   position: absolute;
   top: 0;
   left: 0;
   display: block;
   width: 28px;
   height: 28px;
   border: 1px solid #495651;
   border-radius: 0;
   background-color: #ffffff;
   /* stylelint-disable selector-max-specificity */
   /* stylelint-enable */
 }
 
 .c-checkbox__input:checked + .c-checkbox__label::before {
   border-color: #495651;
   background-color: #ffffff;
 }
 
 .c-checkbox__input[disabled] + .c-checkbox__label::before {
   border-color: rgba(175, 181, 171, 0.5);
   background-color: #afb5ab;
 }
 
 .c-checkbox__input.is-error + .c-checkbox__label::before {
   border-color: #ba2525;
   background-color: #ffffff;
 }
 
 .c-checkbox__label::after {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   content: "\e952";
   position: absolute;
   top: 0;
   /* [9] */
   left: 0;
   /* [9] */
   width: 28px;
   /* [9] */
   height: 28px;
   /* [9] */
   transform: scale(0);
   transform-origin: center center;
   font-size: 18px;
   line-height: 28px;
   /* [8] */
   text-align: center;
   background-clip: content-box;
   /* [9] */
   background-color: transparent;
   /* [9] */
   color: #1a1a1a;
   visibility: hidden;
 }
 
 .c-checkbox__input:checked + .c-checkbox__label::after {
   transform: scale(1);
   visibility: visible;
 }
 
 .c-checkbox__input.is-error + .c-checkbox__label::after {
   color: #1a1a1a;
 }
 
 /* ------------------------------------*\
     #CUSTOM-SELECT
 \*------------------------------------ */
 /**
  * [1] Reference for the dropdown container.
  * [2] Toggle visibility for open/closed state.
  * [3] Place it directly under the select label.
  * [4] Since it's positioned absolute, make sure to place it on top of any
  *     content.
  * [5] If the max-height of the dropdown container is exceeded, make it
  *     scrollable.
  * [6] The dropdown container of the â€˜adaptiveâ€™ variant takes up actual
  *     vertical space, instead of covering the following content.
  * [8] Create the border between the dropdown items with a pseudo-element, so
  *     we can better handle the padding + :hover on the items.
  * [10] In case it's a select, flip the dropdown arrow upside-down.
  * [11] In case the standard form inputs carry a `border-radius`, reset them
  *      here.
  * [12] Do not assign any horizontal padding as it would interfere with the
  *      :hover on the items as they are not full-width anymore.
  * [13] Prevent overflowing input content.
  * [14] Fallback to 100% in cases where the horizontal padding value is 0.
  *      This is necessary because the calc() function does not accept 0 as
  *      the divisior and is then ignored.
  * [15] Fallback for markup with old icon.
  */
 .c-custom-select {
   position: relative;
   /* [1] */
 }
 
 .c-custom-select .c-input {
   overflow: hidden;
   /* [13] */
 }
 
 .c-custom-select .c-icon--\[control-arrow-bottom\],
 .c-custom-select .c-icon--\[semantic-expand\] {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
 }
 
 .c-custom-select.is-open .c-input__input,
 .c-custom-select.is-open .c-input__addon {
   border-color: #1a1a1a;
 }
 
 .c-custom-select.is-open .c-icon--\[control-arrow-bottom\],
 .c-custom-select.is-open .c-icon--\[semantic-expand\] {
   transform: rotateX(180deg);
   /* [10] */
 }
 
 .c-custom-select__dropdown {
   margin: 0;
   padding: 0;
   list-style: none;
   position: absolute;
   z-index: 1700;
   /* [4] */
   top: 100%;
   /* [3] */
   left: 0;
   display: none;
   /* [2] */
   width: 100%;
   max-height: 240px;
   overflow-y: auto;
   /* [5] */
   padding: 0 0;
   /* [12] */
   border: 1px solid #495651;
   background-color: #ffffff;
   border-top-width: 0;
   border-bottom-left-radius: 0;
   border-bottom-right-radius: 0;
 }
 
 .c-custom-select__item {
   display: block;
   margin-bottom: 0;
 }
 
 .c-custom-select--adaptive .c-custom-select__dropdown {
   position: relative;
   /* [6] */
 }
 
 .c-custom-select.is-open .c-custom-select__dropdown {
   display: block;
   /* [2] */
   border-color: #1a1a1a;
 }
 
 .c-custom-select__item {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   position: relative;
   padding: 8px 16px;
   color: #1a1a1a;
   cursor: pointer;
 }
 
 .c-custom-select__item:hover {
   background-color: #f2f2f2;
   color: #1a1a1a;
 }
 
 .c-custom-select__item.is-active {
   background-color: #1a1a1a;
   color: #ffffff;
 }
 
 .c-custom-select__item:not(:first-child)::after {
   /* [8] */
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   content: "";
   position: absolute;
   z-index: 1;
   top: 0;
   left: 16px;
   display: block;
   width: 100%;
   /* [14] */
   width: calc(100% - 32px);
   /* [14] */
   /* stylelint-disable-line declaration-block-no-duplicate-properties */
   height: 1px;
   background-color: #495651;
 }
 
 /* ------------------------------------*\
    #TILE-SELECT (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #TILE-SELECT
 \*------------------------------------ */
 /*
  *  Mixin defines some common styling declarations for the various component
  *  states.
  */
 /**
  * [1] Compensate for the additional space required for the check mark at the
  *     top.
  * [2] Ensure tile icon foreground and background use common position.
  * [3] Ensure that check icon is centered.
  * [4] Make `.c-tile-select__body-top` take up all available space to push
  *     `.c-tile-select__body-bottom` to the very bottom of the body.
  * [5] Add half the size of the check mark to the top padding to compensate for
  *     the space the check mark takes up.
  * [6] Apply margin if the element is not the first child in it's container.
  * [7] If the icon is hidden on small screens, the title below it should not
  *     have a top margin.
  * [8] Place the pseudo element at the top center of the `.c-tile-select__body`
  *     And translate it back by half it's width and height for it to be
  *     centered.
  */
 .c-tile-select {
   width: 100%;
   height: 100%;
   padding-top: 16px;
   /* [1] */
 }
 
 .c-tile-select__input {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
 }
 
 .c-tile-select__label {
   display: block;
   width: 100%;
   height: 100%;
   margin: 0;
 }
 
 .c-tile-select__body {
   padding-top: 40px;
   padding-left: 24px;
   padding-bottom: 24px;
   padding-right: 24px;
   position: relative;
   /* [1] */
   display: flex;
   flex-direction: column;
   height: 100%;
   border: 1px solid #f2f2f2;
   background-color: #ffffff;
   transition-property: color, background-color;
   transition-duration: 250ms;
   transition-timing-function: ease;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-tile-select__body::before, .c-tile-select__body::after {
   /* [2] */
   content: "";
   position: absolute;
   top: 0;
   /* [8] */
   left: 50%;
   /* [8] */
   display: block;
   width: 32px;
   height: 32px;
   transform: translate(-50%, -50%);
   /* [8] */
   transition-property: color, background-color;
   transition-duration: 250ms;
   transition-timing-function: ease;
 }
 
 .c-tile-select__body::before {
   border: 1px solid #f2f2f2;
   border-radius: 50%;
   background-color: #ffffff;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-tile-select__body::after {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   content: "\e952";
   line-height: 32px;
   /* [3] */
   text-align: center;
   /* [3] */
   color: transparent;
 }
 
 .c-tile-select__input + .c-tile-select__body:hover,
 .c-tile-select__input:focus + .c-tile-select__body {
   border-color: #1a1a1a;
   cursor: pointer;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-tile-select__input + .c-tile-select__body:hover::before,
 .c-tile-select__input:focus + .c-tile-select__body::before {
   border-color: #1a1a1a;
   background-color: #ffffff;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-tile-select__input + .c-tile-select__body:hover::after,
 .c-tile-select__input:focus + .c-tile-select__body::after {
   color: transparent;
 }
 
 .c-tile-select__input:checked + .c-tile-select__body {
   border-color: #1a1a1a;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-tile-select__input:checked + .c-tile-select__body::before {
   border-color: #1a1a1a;
   background-color: #1a1a1a;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-tile-select__input:checked + .c-tile-select__body::after {
   color: #ffffff;
 }
 
 .c-tile-select__input:disabled + .c-tile-select__body {
   border-color: #f2f2f2;
   opacity: 0.5;
   cursor: auto;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-tile-select__input:disabled + .c-tile-select__body::before {
   border-color: #f2f2f2;
   background-color: #ffffff;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-tile-select__input:disabled + .c-tile-select__body::after {
   color: transparent;
 }
 
 .c-tile-select__input:checked:disabled + .c-tile-select__body {
   border-color: #f2f2f2;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-tile-select__input:checked:disabled + .c-tile-select__body::before {
   border-color: #f2f2f2;
   background-color: #f2f2f2;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-tile-select__input:checked:disabled + .c-tile-select__body::after {
   color: #ffffff;
 }
 
 .is-error .c-tile-select__body {
   border-color: #ba2525;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .is-error .c-tile-select__body::before {
   border-color: #ba2525;
   background-color: #ffffff;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .is-error .c-tile-select__body::after {
   color: transparent;
 }
 
 .is-error .c-tile-select__input:hover + .c-tile-select__body,
 .is-error .c-tile-select__input:focus + .c-tile-select__body {
   border-color: #ba2525;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .is-error .c-tile-select__input:hover + .c-tile-select__body::before,
 .is-error .c-tile-select__input:focus + .c-tile-select__body::before {
   border-color: #ba2525;
   background-color: #ffffff;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .is-error .c-tile-select__input:hover + .c-tile-select__body::after,
 .is-error .c-tile-select__input:focus + .c-tile-select__body::after {
   color: transparent;
 }
 
 .is-error .c-tile-select__input:checked + .c-tile-select__body {
   border-color: #ba2525;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .is-error .c-tile-select__input:checked + .c-tile-select__body::before {
   border-color: #ba2525;
   background-color: #ba2525;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .is-error .c-tile-select__input:checked + .c-tile-select__body::after {
   color: #ffffff;
 }
 
 .c-tile-select__body-top {
   flex-grow: 1;
   /* [4] */
   flex-shrink: 1;
   flex-basis: auto;
   text-align: center;
 }
 
 .c-tile-select__body-bottom {
   text-align: center;
 }
 
 .c-tile-select__icon {
   display: block;
   font-size: 54px;
 }
 
 @media (max-width: 480px) {
   .c-tile-select__icon--hidden-on-small-screens {
     display: none;
   }
 }
 
 .c-tile-select__title,
 .c-tile-select__text {
   display: block;
 }
 
 .c-tile-select__title {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
   font-weight: 400;
   line-height: 1.2;
 }
 
 @media (min-width: 721px) {
   .c-tile-select__title {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-tile-select__title {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-tile-select__button {
   margin-top: 32px;
 }
 
 @media (max-width: 720px) {
   .c-tile-select__button {
     margin-top: 24px;
   }
 }
 
 @media (max-width: 480px) {
   .c-tile-select__button {
     display: none;
   }
 }
 
 * + .c-tile-select__title {
   /* [6] */
   margin-top: 24px;
 }
 
 @media (max-width: 720px) {
   * + .c-tile-select__title {
     margin-top: 16px;
   }
 }
 
 .c-tile-select__icon--hidden-on-small-screens + .c-tile-select__title {
   /* [7] */
 }
 
 @media (max-width: 480px) {
   .c-tile-select__icon--hidden-on-small-screens + .c-tile-select__title {
     margin-top: 0;
   }
 }
 
 * + .c-tile-select__text {
   /* [6] */
   margin-top: 24px;
 }
 
 @media (max-width: 720px) {
   * + .c-tile-select__text {
     margin-top: 16px;
   }
 }
 
 /* ------------------------------------*\
     #RADIO-BUTTON
 \*------------------------------------ */
 /**
  * [1] Defaulting to inline-block gives us the most flexibility.
  * [2] Defensively reset any margin-bottom.
  * [3] Hide original radio button.
  * [4] Make it blocky so everything behaves as expected.
  * [5] Setting the height of the label text to a minimum of the radio button
  *     size makes the text clickable on its entire height, i.e.: It increases
  *     the click area.
  * [6] Align the first (or only) row of label text vertically centered to the
  *     radio button.
  * [7] Keep the spacing between radio button and label text consistent,
  *     independent from the radio button size.
  * [8] Relation for the radio button.
  * [9] Horizontally center the dot inside of the radio button.
  * [10] Scaling seems to be the most efficient and only â€œniceâ€ method that
  *      works across all browsers. Other methods brought yanky, jumpy
  *      animation artifacts.
  * [11] `.c-radio__label-container` could be an additional container for the
  *      label. For example, it is used by the â€œCompare and Selectâ€ component to
  *      change radio button styles.
  */
 .c-radio {
   -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
   /* [1] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   display: inline-block;
   /* [1] */
   margin-bottom: 0;
   /* [2] */
   cursor: pointer;
 }
 
 .c-radio__input {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
   /* [3] */
 }
 
 .c-radio__label {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 24px;
   position: relative;
   /* [8] */
   display: block;
   /* [4] */
   min-height: 28px;
   /* [5] */
   padding-top: 2px;
   /* [6] */
   padding-left: 44px;
   /* [7] */
   color: #1a1a1a;
   /* stylelint-disable selector-max-class, selector-max-specificity */
   /* stylelint-enable */
 }
 
 .c-radio__label:hover {
   color: #1a1a1a;
 }
 
 .c-radio__input:hover + .c-radio__label::before {
   border-color: #495651;
 }
 
 .c-radio__input:focus + .c-radio__label::before {
   border-color: #187085;
 }
 
 .c-radio__input[disabled] + .c-radio__label {
   color: rgba(26, 26, 26, 0.5);
   cursor: default;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-radio__input[disabled] + .c-radio__label,
 .u-bg-alternative .c-radio__input[disabled] + .c-radio__label {
   color: rgba(26, 26, 26, 0.5);
 }
 
 .c-radio__input.is-error + .c-radio__label {
   color: #ba2525;
 }
 
 .c-radio__label::before, .c-radio__label::after {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   content: "";
   position: absolute;
   display: block;
   border-radius: 50%;
 }
 
 .c-radio__label::before {
   top: 0;
   left: 0;
   width: 28px;
   height: 28px;
   border: 1px solid #495651;
   background-color: transparent;
 }
 
 .c-radio__input:checked + .c-radio__label::before,
 .c-radio__input:checked + .c-radio__label-container .c-radio__label::before {
   /* [11] */
   border-color: #495651;
   background-color: transparent;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-radio__input:checked + .c-radio__label::before,
 .u-bg-alternative .c-radio__input:checked + .c-radio__label::before, [data-theme="alternative"]
 .c-radio__input:checked + .c-radio__label-container .c-radio__label::before,
 .u-bg-alternative
 .c-radio__input:checked + .c-radio__label-container .c-radio__label::before {
   background-color: transparent;
 }
 
 .c-radio__input:checked:hover + .c-radio__label::before {
   border-color: #495651;
 }
 
 .c-radio__input[disabled] + .c-radio__label::before,
 .c-radio__input[disabled] + .c-radio__label-container .c-radio__label::before {
   /* [11] */
   border-color: rgba(175, 181, 171, 0.5);
   background-color: transparent;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-radio__input[disabled] + .c-radio__label::before,
 .u-bg-alternative .c-radio__input[disabled] + .c-radio__label::before, [data-theme="alternative"]
 .c-radio__input[disabled] + .c-radio__label-container .c-radio__label::before,
 .u-bg-alternative
 .c-radio__input[disabled] + .c-radio__label-container .c-radio__label::before {
   border-color: rgba(175, 181, 171, 0.5);
   background-color: transparent;
 }
 
 .c-radio__input.is-error + .c-radio__label::before,
 .c-radio__input.is-error + .c-radio__label-container .c-radio__label::before {
   /* [11] */
   border-color: #ba2525;
 }
 
 .c-radio__label::after {
   top: 6px;
   /* [6] */
   left: 6px;
   /* [9] */
   width: 16px;
   height: 16px;
   transform: scale(0);
   /* [10] */
   background-color: #1a1a1a;
 }
 
 :hover + .c-radio__label::after {
   background-color: #1a1a1a;
 }
 
 .c-radio__input:checked + .c-radio__label::after,
 .c-radio__input:checked + .c-radio__label-container .c-radio__label::after {
   /* [11] */
   transform: scale(1);
   /* [10] */
 }
 
 .c-radio__input[disabled] + .c-radio__label::after,
 .c-radio__input[disabled] + .c-radio__label-container .c-radio__label::after {
   /* [11] */
   background-color: rgba(26, 26, 26, 0.5);
 }
 
 .c-radio__input.is-error + .c-radio__label::after,
 .c-radio__input.is-error + .c-radio__label-container .c-radio__label::after {
   /* [11] */
   background-color: #ba2525;
 }
 
 /* ------------------------------------*\
     #RANGE-SLIDER
 \*------------------------------------ */
 /**
  * The native HTML range input element.
  */
 /**
  * [1] Remove default browser styles.
  * [2] Remove the outline, when the handle is dragged.
  * [3] Firefox creates a nasty dotted outline, when the handle is dragged.
  *     Removing the outline like above doesn't suffice, so we'are forcing it.
  * [4] Vertically center the thumb on the track.
  * [5] The `box-sizing` has to be explicitly set for Firefox.
  * [6] The `box-sizing` has to be explicitly set for IE.
  * [7] Weird fix for weird IE issue. Don't ask, just swallow it!
  * [8] â€˜Correctâ€™ spacing below the range slider. Default `display` styling
  *      leads to gap between range slider and the following element.
  * [9] Remove the native value indicator (internet explorer only).
  */
 .c-range-slider {
   position: relative;
   height: 60px;
 }
 
 .c-range-slider__input {
   display: block;
   /* [8] */
   width: 100%;
   height: 60px;
   margin: 0;
   padding: 0;
   background-color: transparent;
   -webkit-appearance: none;
   appearance: none;
   /* [1] */
 }
 
 .c-range-slider__input:focus {
   outline: none;
   /* [2] */
 }
 
 /**
      * Webkit styles:
      */
 .c-range-slider__input::-webkit-slider-runnable-track {
   width: 100%;
   height: 2px;
   border-radius: 10px;
   background-color: #afb5ab;
   cursor: pointer;
 }
 
 .c-range-slider__input[disabled]::-webkit-slider-runnable-track {
   background-color: #afb5ab;
   cursor: default;
 }
 
 .c-range-slider__input::-webkit-slider-thumb {
   -webkit-transition-property: all;
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   width: 58px;
   height: 58px;
   box-shadow: 0 0 0 1px #187085;
   border: 21px solid #ffffff;
   background: #1a1a1a;
   margin-top: -29px;
   /* [4] */
   border-radius: 50%;
   cursor: pointer;
   -webkit-appearance: none;
   appearance: none;
   /* [1] */
 }
 
 .c-range-slider__input[disabled]::-webkit-slider-thumb {
   box-shadow: 0 0 0 1px #afb5ab;
   /* [6] */
   border: 21px solid #ffffff;
   background: #afb5ab;
   cursor: default;
 }
 
 /**
      * Moz styles:
      */
 .c-range-slider__input::-moz-range-track {
   width: 100%;
   height: 2px;
   border-radius: 10px;
   background-color: #afb5ab;
   cursor: pointer;
 }
 
 .c-range-slider__input[disabled]::-moz-range-track {
   background-color: #afb5ab;
   cursor: default;
 }
 
 .c-range-slider__input::-moz-range-thumb {
   -moz-transition-property: all;
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   width: 58px;
   height: 58px;
   box-shadow: 0 0 0 1px #187085;
   border: 21px solid #ffffff;
   background: #1a1a1a;
   margin-top: -29px;
   /* [4] */
   border-radius: 50%;
   cursor: pointer;
   appearance: none;
   /* [1] */
   box-sizing: border-box;
   /* [5] */
 }
 
 .c-range-slider__input[disabled]::-moz-range-thumb {
   box-shadow: 0 0 0 1px #afb5ab;
   /* [6] */
   border: 21px solid #ffffff;
   background: #afb5ab;
   pointer-events: none;
   cursor: default;
 }
 
 .c-range-slider__input::-moz-range-progress {
   height: 2px;
   background-color: #1a1a1a;
   box-sizing: border-box;
   /* [6] */
 }
 
 .c-range-slider__input[disabled]::-moz-range-progress {
   background: #afb5ab;
 }
 
 .c-range-slider__input::-moz-focus-outer {
   border: 0;
   /* [3] */
 }
 
 /**
      * Microsoft styles (IE):
      */
 .c-range-slider__input::-ms-track {
   width: 100%;
   height: 2px;
   border-radius: 10px;
   border-color: transparent;
   /* [7] */
   border-width: 2px 0;
   /* [7] */
   background: transparent;
   /* [1] */
   color: transparent;
   /* [1] */
   box-sizing: border-box;
   /* [6] */
 }
 
 .c-range-slider__input::-ms-fill-lower {
   height: 2px;
   background-color: #1a1a1a;
   box-sizing: border-box;
   /* [6] */
   border-radius: 10px;
 }
 
 .c-range-slider__input[disabled]::-ms-fill-lower {
   background: #afb5ab;
 }
 
 .c-range-slider__input::-ms-fill-upper {
   height: 2px;
   background: #afb5ab;
   box-sizing: border-box;
   /* [6] */
   border-radius: 10px;
 }
 
 .c-range-slider__input[disabled]::-ms-fill-upper {
   background: #afb5ab;
 }
 
 .c-range-slider__input::-ms-thumb {
   -ms-transition-property: all;
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   width: 58px;
   height: 58px;
   box-shadow: 0 0 0 1px #187085;
   border: 21px solid #ffffff;
   background: #1a1a1a;
   margin-top: 0;
   /* [1] */
   border-radius: 50%;
   appearance: none;
   /* [1] */
   box-sizing: border-box;
   /* [6] */
 }
 
 .c-range-slider__input[disabled]::-ms-thumb {
   box-shadow: 0 0 0 1px #afb5ab;
   /* [6] */
   border: 21px solid #ffffff;
   background: #afb5ab;
 }
 
 .c-range-slider__input::-ms-tooltip {
   display: none;
   /* [9] */
 }
 
 /* ------------------------------------*\
     #MODAL
 \*------------------------------------ */
 /**
  * [1]  Modal has to sit on top of everything else.
  * [2]  Fix wobbling inline elements when hovering buttons in the modal
  *      (e.g. macOS Chrome 78 on non-retina displays).
  * [3]  Center the modal content in the middle of the viewport.
  * [4]  If the modal content exceeds the viewport height, this still makes the
  *      content accessible (i.e. scrollable).
  * [5]  The modal title should always be semantically a `<h1>`, but of course
  *      have a smaller font-size.
  * [6]  Add a near-logarithmic gradient at bottom of content.
  * [7]  Allow click through.
  * [8]  Avoid showing gradient when not necessary and override the default
  *      margin-bottom of the last element in the modal content (e.g. `<p>`
  *      has margin-bottom by default).
  * [9]  Reset default heading element spacing.
  * [10] Compensate action item spacing.
  * [11] Place close-button before title (alter visual order).
  * [12] Position close-button (push to right).
  * [13] If $modal-content-padding-horizontal is a map, we need to divide the
  *      values in half for each breakpoint.
  * [14] Loop through paddings, take half of each value and push to new map
  *      $content-padding-horizontal-half.
  * [15] The gradient should not overlay the scrollbar.
  * [16] Indicate interaction on non-interactive elements.
  * [17] Prevent elements inside the modal-trigger catching any events
  *      due to event delegation.
  * [18] Overwrite settings to enable `.c-modal--stretch` modal.
  * [19] Position the `.c-modal--stretch` modal in the center without transition.
  * [20] Add some bottom spacing.
  * [21] Prevent interaction with modal content when closed.
  * [22] Use negative margin on footer instead of resetting padding on content
  *      as this would result on missing spacing below content
  *      due to the footer being optional.
  * [23] Take available space in order for alignment on the parent to take effect.
  * [24] This allows scrolling (e.g. when modal height exceeds viewport height)
  *      while pointer is on the overlay.
  */
 .c-modal {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   position: fixed;
   z-index: 4500;
   /* [1] */
   top: 0;
   right: 0;
   bottom: 0;
   left: 0;
   opacity: 1;
   visibility: visible;
   -webkit-backface-visibility: hidden;
   backface-visibility: hidden;
   /* [2] */
 }
 
 .c-modal[aria-hidden="true"] {
   pointer-events: none;
   /* [21] */
   opacity: 0;
   visibility: hidden;
 }
 
 .c-modal--center .c-modal__title__wrapper {
   justify-content: center;
 }
 
 .c-modal--center .c-modal__content,
 .c-modal--center .c-modal__title__wrapper {
   text-align: center;
 }
 
 .c-modal--left .c-modal__title__wrapper {
   justify-content: flex-start;
 }
 
 .c-modal--left .c-modal__content,
 .c-modal--left .c-modal__title__wrapper {
   text-align: left;
 }
 
 .c-modal--stretch .c-modal__wrapper,
 .c-modal--video .c-modal__wrapper {
   position: relative;
   /* [18] */
   top: 32px;
   left: auto;
   max-height: 90vh;
   overflow-y: auto;
   margin: auto;
   margin-bottom: 32px;
   transform: none !important;
   /* [18] */
   /* stylelint-disable-line itcss/no-at-important */
   /* [18] */
   /* [19] */
   /* [20] */
 }
 
 .c-modal--stretch .c-modal__content,
 .c-modal--video .c-modal__content {
   max-height: none;
 }
 
 .c-modal--large .c-modal__wrapper,
 .c-modal--video .c-modal__wrapper {
   width: 78vw;
   max-width: 78vw;
 }
 
 @media (max-width: 720px) {
   .c-modal--large .c-modal__wrapper,
   .c-modal--video .c-modal__wrapper {
     width: calc(100vw - 48px);
     max-width: calc(100vw - 48px);
   }
 }
 
 .c-modal--no-scroll-shadow .c-modal__footer {
   margin-top: -1.5em;
   /* [22] */
 }
 
 .c-modal--no-scroll-shadow .c-modal__footer::before {
   content: none;
 }
 
 .c-modal--video .c-modal__footer {
   margin-top: -1.5em;
   /* [22] */
 }
 
 .c-modal--video .c-modal__footer::before {
   content: none;
 }
 
 .c-modal--video .c-modal__content {
   margin-right: 0;
   margin-left: 0;
   padding-right: 0;
   padding-left: 0;
 }
 
 /**
  * Styles applied to a js-hook (which is a no-no) is an exception as the trigger
  * can be applied to arbitrary elements but need those additional styles to
  * work properly.
  */
 .js-modal-trigger {
   cursor: pointer;
   /* [16] */
 }
 
 .js-modal-trigger * {
   pointer-events: none;
   /* [17] */
 }
 
 .c-modal__overlay {
   position: fixed;
   top: 0;
   right: 0;
   bottom: 0;
   left: 0;
   background-color: rgba(255, 255, 255, 0.6);
   z-index: -1;
   /* [24] */
 }
 
 .c-modal__wrapper {
   width: 40vw;
   max-width: 40vw;
   position: fixed;
   /* [3] */
   top: 50%;
   /* [3] */
   left: 50%;
   /* [3] */
   transform: translate(-50%, -50%);
   /* [3] */
   background-color: #ffffff;
   box-shadow: 5px 5px 40px rgba(0, 0, 0, 0.3);
 }
 
 @media (max-width: 720px) {
   .c-modal__wrapper {
     width: calc(100vw - 48px);
     max-width: calc(100vw - 48px);
   }
 }
 
 .c-modal__header {
   padding-top: 24px;
   padding-left: 24px;
   padding-right: 24px;
   padding-bottom: 24px;
   display: flex;
 }
 
 .c-modal__title__wrapper {
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   flex-grow: 1;
   flex-shrink: 1;
   flex-basis: auto;
   text-align: left;
 }
 
 .c-modal__status-icon {
   margin-right: 24px;
   font-size: 36px;
   /* stylelint-disable-next-line order/order */
 }
 
 .c-modal__status-icon::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
 }
 
 .c-modal--info .c-modal__status-icon {
   color: #187085;
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-modal--info .c-modal__status-icon::before {
   border-radius: 50%;
   padding: 11px;
 }
 
 .c-modal--info .c-modal__status-icon::before {
   border: 1px solid currentColor;
 }
 
 .c-modal--info .c-modal__status-icon::before {
   content: "\e971";
 }
 
 .c-modal--success .c-modal__status-icon {
   color: #00783c;
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-modal--success .c-modal__status-icon::before {
   border-radius: 50%;
   padding: 11px;
 }
 
 .c-modal--success .c-modal__status-icon::before {
   border: 1px solid currentColor;
 }
 
 .c-modal--success .c-modal__status-icon::before {
   content: "\e952";
 }
 
 .c-modal--warning .c-modal__status-icon {
   color: #efc938;
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-modal--warning .c-modal__status-icon::before {
   border-radius: 50%;
   padding: 11px;
 }
 
 .c-modal--warning .c-modal__status-icon::before {
   border: 1px solid currentColor;
 }
 
 .c-modal--warning .c-modal__status-icon::before {
   content: "\e955";
 }
 
 .c-modal--error .c-modal__status-icon {
   color: #ba2525;
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-modal--error .c-modal__status-icon::before {
   border-radius: 50%;
   padding: 11px;
 }
 
 .c-modal--error .c-modal__status-icon::before {
   border: 1px solid currentColor;
 }
 
 .c-modal--error .c-modal__status-icon::before {
   content: "\e955";
 }
 
 .c-modal__title {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
   /* [5] */
   margin-bottom: 0;
   /* [9] */
   /* [23] */
 }
 
 @media (min-width: 721px) {
   .c-modal__title {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-modal__title {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-modal__close-btn {
   padding: 0;
   border: 0;
   background-color: transparent;
   line-height: 1;
   cursor: pointer;
 }
 
 .c-modal__close-btn:focus {
   outline: 0;
 }
 
 .c-modal__close-btn::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   content: "\e955";
 }
 
 .c-modal__header {
   flex-wrap: wrap;
 }
 
 .c-modal__close-btn {
   order: -1;
   /* [11] */
   margin-left: auto;
   /* [12] */
 }
 
 .c-modal__title__wrapper {
   flex-shrink: 0;
   flex-basis: 100%;
 }
 
 .c-modal__content {
   padding-left: 12px;
   margin-left: 12px;
   padding-right: 12px;
   margin-right: 12px;
   max-height: 45vh;
   /* [4] */
   overflow-y: auto;
   /* [4] */
   text-align: left;
   color: #1a1a1a;
 }
 
 .c-modal__content > *:last-child {
   margin-bottom: 1.5em;
   /* [8] */
 }
 
 .c-modal__footer {
   padding-top: 24px;
   padding-left: 24px;
   padding-right: 24px;
   padding-bottom: 24px;
   position: relative;
   text-align: left;
 }
 
 .c-modal__footer::before {
   right: 24px;
   /* [15] */
   content: "";
   position: absolute;
   top: -1.5em;
   /* [6] */
   left: 0;
   height: 1.5em;
   background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.9), #ffffff);
   /* [6] */
   pointer-events: none;
   /* [7] */
 }
 
 .c-modal__actions {
   display: flex;
   flex-wrap: wrap;
   justify-content: center;
   margin-right: -8px;
   margin-bottom: -16px;
   /* [10] */
   margin-left: -8px;
 }
 
 .c-modal__actions__item {
   flex-shrink: 1;
   flex-basis: 180px;
   margin-right: 8px;
   margin-bottom: 16px;
   margin-left: 8px;
   flex-grow: 0;
 }
 
 .c-modal__actions__item > * {
   width: 100%;
   height: 100%;
 }
 
 /* ------------------------------------*\
     #ACCORDION
 \*------------------------------------ */
 /**
  * [1]  Border below and above the accordion component.
  * [2]  Reset browser-default button styles.
  * [3]  Max line-length.
  * [4]  ~~Improve rendering performance by using GPL acceleration.~~
         WARNING: Currently commented out due to conflict with z-index`
         of accordion title element when e.g. a custom select is overflowing
         the accordion panel content.
  * [5]  Lower duration for collapsing to focus on the expanding content.
  * [6]  Prevent shifting position on focus/active @ IE.
  * [7]  Remove whitespace from heading (`h*`), `line-height` is set on button.
  * [8]  Do not use `border-top` on first item, because itâ€™s set with
        `$accordion-border-top`.
  * [9]  Collapse/expand panel with CSS only by utilizing the `animate-height`
  *      mixin.`
  * [10] Add offset for CSS-generated icons to accommodate for different
  *      `stroke-width`.
  * [11] Disable the top border for sibling accordions only if there is no bottom border.
  * [12] Align `.c-accordion__title-label` to the left and right via flexbox.
  * [13] Stack `.c-accordion__title-label`s vertically in small viewports.
  * [14] Add vertical space between `.c-accordion__title-label` in small
  * [15] Align `.c-accordion__title-label` to the left and right via flexbox.
  * [16] Stack `.c-accordion__title-label`s vertically in small viewports.
  * [17] Add vertical space between `.c-accordion__title-label` in small
  *      viewports.
  * [18] Push info icon to the left in splitted header titles.
  * [19] Add a space between both splitted header title parts.
  * [20] Defines the indentation width of the header.
  * [21] Resolves the z-index problem of the tooltip.
  * [22] Since [role=button] does not inherit any button styles we need to
  *      manually set them here. They correspondent with the styles set
  *      in generic.normalize.scss:257-259.
  */
 .c-accordion {
   position: relative;
   border-top: none;
   /* [1] */
   border-bottom: 1px solid #1a1a1a;
   /* [1] */
 }
 
 .c-accordion__header {
   padding-top: 16px;
   padding-right: 72px;
   padding-bottom: 16px;
   padding-left: 0;
   position: relative;
   width: 100%;
   margin: 0;
   cursor: pointer;
 }
 
 * + .c-accordion__header {
   border-top: 1px solid #1a1a1a;
   /* [8] */
 }
 
 .c-accordion__header > *:last-child {
   margin-bottom: 0;
 }
 
 .c-accordion__title {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 24px;
   margin-bottom: 0;
 }
 
 .c-accordion__title-label {
   padding: 0;
   border: 0;
   background-color: transparent;
   /* [2] */
   display: inline-flex;
   /* [22] */
   max-width: 50em;
   /* [3] */
   font-family: "open-sans", sans-serif;
   /* [22] */
   font-weight: 400;
   letter-spacing: normal;
   /* [22] */
   line-height: 1.15;
   /* [22] */
   text-align: left;
   color: #1a1a1a;
   cursor: pointer;
 }
 
 .c-accordion__title-label:focus {
   outline: 0;
 }
 
 .c-accordion__title-info-icon {
   margin-right: auto;
   /* [18] */
 }
 
 @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .c-accordion__title-label-text {
     position: relative;
     /* [6] */
   }
 }
 
 .c-accordion__title-icon {
   top: 16px;
   right: 24px;
   left: auto;
   position: absolute;
   width: 24px;
   height: 24px;
 }
 
 .c-accordion__title-icon::before, .c-accordion__title-icon::after {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   content: "";
   position: absolute;
   top: 50%;
   width: 12px;
   height: 2px;
   transform-origin: bottom;
   background-color: #1a1a1a;
 }
 
 .c-accordion__header.is-active .c-accordion__title-icon::before, .c-accordion__header.is-active .c-accordion__title-icon::after {
   transform-origin: top;
 }
 
 .c-accordion__title-icon::before {
   right: 50%;
   transform: translateY(-50%) translateX(1px) rotate(45deg);
   /* [10] */
 }
 
 .c-accordion__header.is-active .c-accordion__title-icon::before {
   transform: translateY(-50%) translateX(1px) rotate(-45deg);
   /* [10] */
 }
 
 .c-accordion__title-icon::after {
   left: 50%;
   transform: translateY(-50%) translateX(-1px) rotate(-45deg);
   /* [10] */
 }
 
 .c-accordion__header.is-active .c-accordion__title-icon::after {
   transform: translateY(-50%) translateX(-1px) rotate(45deg);
   /* [10] */
 }
 
 .c-accordion__panel {
   overflow-y: hidden;
   margin-left: -0.5rem;
   /* [12] */
   padding-left: 0.5rem;
   /* [12] */
 }
 
 .c-accordion.js-is-fx .c-accordion__panel {
   transition: height 0.5s ease, visibility 1s, padding-top 0.25s 0.25s;
   /* [13] */
 }
 
 .c-accordion.js-is-fx .c-accordion__panel:not(.is-closed) {
   transition: height 0.5s ease, visibility 1s, padding-top 0s;
   /* [14] */
 }
 
 .c-accordion:not(.js-is-fx) .c-accordion__panel[aria-hidden='true'] {
   /* [9] */
   /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
 }
 
 @media screen and (prefers-reduced-motion: reduce), (update: slow) {
   .c-accordion:not(.js-is-fx) .c-accordion__panel[aria-hidden='true'] {
     /* stylelint-disable-next-line declaration-no-important */
     animation: none !important;
   }
 }
 
 .c-accordion:not(.js-is-fx) .c-accordion__panel[aria-hidden='true'] {
   max-height: 100vh;
 }
 
 .c-accordion:not(.js-is-fx) .c-accordion__panel[aria-hidden='true'] {
   max-height: 0;
   animation-name: animateheight2;
   animation-duration: 0.25s;
   animation-timing-function: ease-in;
   animation-fill-mode: forwards;
 }
 
 @keyframes animateheight2 {
   0% {
     max-height: 100vh;
   }
   100% {
     max-height: 0;
   }
 }
 
 .c-accordion:not(.js-is-fx) .c-accordion__panel[aria-hidden='false'] {
   /* [9] */
   /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
 }
 
 @media screen and (prefers-reduced-motion: reduce), (update: slow) {
   .c-accordion:not(.js-is-fx) .c-accordion__panel[aria-hidden='false'] {
     /* stylelint-disable-next-line declaration-no-important */
     animation: none !important;
   }
 }
 
 .c-accordion:not(.js-is-fx) .c-accordion__panel[aria-hidden='false'] {
   max-height: 0;
 }
 
 .c-accordion:not(.js-is-fx) .c-accordion__panel[aria-hidden='false'] {
   max-height: 100%;
   animation-name: animateheight3;
   animation-duration: 0.75s;
   animation-timing-function: ease-out;
   animation-fill-mode: none;
 }
 
 @keyframes animateheight3 {
   0% {
     max-height: 0;
   }
   100% {
     max-height: 100vh;
   }
 }
 
 .c-accordion__panel:not(.is-closed) {
   padding-top: 0.5rem;
   /* [12] */
 }
 
 .c-accordion__content {
   padding-top: 0;
   padding-right: 24px;
   padding-bottom: 24px;
   padding-left: 0;
   border-top: none;
 }
 
 .c-accordion--bg-panel .c-accordion__content {
   padding-top: 24px;
   padding-right: 16px;
   padding-bottom: 24px;
   padding-left: 16px;
   border-top: none;
   background-color: #f2f2f2;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-accordion--bg-panel .c-accordion__content,
 .u-bg-alternative .c-accordion--bg-panel .c-accordion__content {
   background-color: #ffffff;
 }
 
 .c-accordion__content > *:last-child {
   margin-bottom: 0;
 }
 
 .c-accordion--header-split .c-accordion__header {
   padding-right: 72px;
   padding-left: 0;
 }
 
 .c-accordion--header-split .c-accordion__title-label {
   display: inline-flex;
   /* [15] */
   flex-direction: row;
   /* [15] */
   justify-content: space-between;
   /* [15] */
   align-items: flex-start;
   /* [15] */
   width: 100%;
   /* [15] */
   max-width: none;
   /* [15] */
 }
 
 @media (max-width: 720px) {
   .c-accordion--header-split .c-accordion__title-label {
     flex-direction: column;
     /* [16] */
   }
 }
 
 .c-accordion--header-split .c-accordion__title-label-text + .c-accordion__title-label-text {
   margin-left: 16px;
   /* [19] */
 }
 
 @media (max-width: 720px) {
   .c-accordion--header-split .c-accordion__title-label-text + .c-accordion__title-label-text {
     margin-top: 8px;
     /* [17] */
     margin-left: 0;
     /* [19] */
   }
 }
 
 /* ------------------------------------*\
     #BREADCRUMB
 \*------------------------------------ */
 /**
  * [1] Reset default list styles.
  * [2] Easier management of alignment.
  * [3] Let the breadcrumb items wrap into multiline when they don't fit on
  *     screen anymore.
  * [4] Align the items center on the y-axis to each other.
  * [5] Vertically center the item text with the icon.
  * [6] Set spacing between delimiter and following items text.
  * [7] Set spacing between text and delimiter of the same breadcrumb item.
  * [8] If the delimiter is a custom text.
  * [9] If the delimiter is an icon of the icon set.
  */
 .c-breadcrumb {
   padding-top: 0;
   padding-left: 0;
   padding-right: 0;
   padding-bottom: 0;
   display: flex;
   /* [2] */
   flex-wrap: wrap;
   /* [3] */
   align-items: center;
   /* [4] */
   margin: 0;
   /* [1] */
   line-height: 2;
   list-style: none;
   /* [1] */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-breadcrumb__item {
   display: flex;
   /* [5] */
   align-items: center;
   /* [5] */
   margin-bottom: 0;
   /* [1] */
 }
 
 .c-breadcrumb__item:not(:last-child) {
   margin-right: 16px;
   /* [6] */
 }
 
 .c-breadcrumb__item:not(:last-child)::after {
   margin-left: 16px;
   /* [7] */
   color: #ffffff;
   /* [9] */
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   content: "\e946";
 }
 
 .c-breadcrumb__link {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   text-decoration: none;
   color: #ffffff;
 }
 
 .c-breadcrumb__link.is-disabled {
   pointer-events: none;
 }
 
 /* ------------------------------------*\
     #FOOTNOTES
 \*------------------------------------ */
 /**
  * [1] Define * as default content.
  * [2] Show index instead of character.
  * [3] Show data-bullet instead of default character, if attribute
  *     data-footnote-bullet is given.
  * [4] Overwrite default `<li>` margin.
  */
 .c-footnotes {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   margin: 0;
   padding: 0;
   list-style: none;
   padding-left: 16px;
   counter-reset: footnotes-raised-counter;
   color: #1a1a1a;
 }
 
 .c-footnotes li {
   display: block;
   margin-bottom: 0;
 }
 
 .c-footnotes__item,
 .c-footnotes li {
   position: relative;
   margin-bottom: 0;
   /* [4] */
 }
 
 .c-footnotes__item::before,
 .c-footnotes li::before {
   /* [1] */
   content: "*";
   position: absolute;
   left: -16px;
   font-size: 0.8em;
 }
 
 ol.c-footnotes,
 .c-footnotes--numbered {
   /* [2] */
 }
 
 ol.c-footnotes .c-footnotes__item::before,
 ol.c-footnotes > li::before,
 .c-footnotes--numbered .c-footnotes__item::before,
 .c-footnotes--numbered > li::before {
   content: counter(footnotes-raised-counter);
   font-size: 0.8em;
   counter-increment: footnotes-raised-counter;
 }
 
 ul.c-footnotes {
   /* [3] */
 }
 
 ul.c-footnotes .c-footnotes__item[data-footnote-bullet]::before,
 ul.c-footnotes > li[data-footnote-bullet]::before {
   content: attr(data-footnote-bullet);
 }
 
 /* ------------------------------------*\
     #LINK
 \*------------------------------------ */
 /**
  * The link component comprises itself of an icon to the left and a text to
  * the right.
  */
 /**
  * [1] Use only necessary space opposed to full width of `display: flex`.
  * [2] Position icon _visually_ to the right side.
  * [3] Reset spacing of default direction and apply to opposite.
  * [4] Reset default styles from elements (e.g. `<a>`).
  * [5] If the link component is a simple `<span>` etc., make it appear
  *     clickable.
  * [6] Control individual alignment of icon.
  */
 .c-link {
   padding: 0;
   border: 0;
   background-color: transparent;
   /* [4] */
   display: inline-flex;
   /* [1] */
   align-items: center;
   text-decoration: none;
   /* [4] */
   text-align: left;
   /* [4] */
   cursor: pointer;
   /* [5] */
 }
 
 .c-link:focus {
   outline: 0;
 }
 
 .c-link__icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   align-self: baseline;
   /* [6] */
   margin-right: 16px;
 }
 
 .c-link.c-link--reversed .c-link__icon {
   order: 10;
   /* [2] */
   margin-right: 0;
   /* [3] */
   margin-left: 16px;
   /* [3] */
 }
 
 .c-link__body {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   -ms-grid-row-align: center;
   align-self: center;
   font-weight: 400;
   text-transform: none;
 }
 
 /* ------------------------------------*\
    #TABLES (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #TABLES
 \*------------------------------------ */
 /*
  * [1] Use pseudo elements for horizontal table cell borders (`::before` for the
  *     top border and `::after` for the bottom border) to allow visual spacing
  *     between columns without the side effects that you have with
  *     `border-spacing`. This only applies to non-ms-legacy browsers.
  * [2] Tables are always full-width by default.
  * [3] Set all columns to an equal width for the fixed width table variant.
  * [4] To make sure the styling of first row is correct when not using `<thead>`
  *     element, as well as when `<thead>` is correctly used.
  * [5] Provide a simple responsive table mechanism by just enabling horizontal
  *     scrolling below a specific breakpoint.
  * [6] Let the auto-width table be wide/narrow as it is.
  * [7] Auto tables are not full-width.
  * [8] Ensure that table is centered.
  * [9] Each column can be as wide as their content.
  * [10] Remove default spacing bottom.
  * [11] Make sure to add a bottom spacing if there is some content following
  *      the table.
  * [12] Styles for sortables in the table header.
  * [14] Keep icon and text combination inline in the data control table.
  * [15] Overwrite the border and spacing settings for buttons.
  * [16] Apply the highlight variant style to certain columns.
  * [17] Wrap text and possible inline elements in `<span>` because of parent's
  *      flex setting. Left empty here for documentation and prospective usage.
  *      @NOTE: deprecated.
  * [18] Table modifier for wide and narrow variants.
  * [19] Collapse cell borders to eliminate visible space between cell borders.
  * [20] Set overflow to `visible` to allow sticky positioning in the first
  *      place.
  * [21] Cover the following rows with the cells of the head row.
  * [22] Cover the following columns with the cells of the first column.
  * [23] Cover the following columns with the first `thead` cell if the table has
  *      sticky a head row and a sticky first column.
  * [24] For zebra style tables inherit the background color of the table row.
  * [25] Do not render a left border on any first children in the top-most rows.
  * [26] Enables borders styles for merged cells.
  * [27] Table variant with data controls and sortable header.
  * [28] Unused, for prospective future usage and avoid BEM errors.
  * [29] Flex helper to align multiple content inside a cell.
  * [30] Provide the required minimum height for each cell.
  * [31] Cell icon colors differ across brands in color and need scoping in
  *      `thead` and `tbody`.
  * [32] Increase specificity because of high `.c-button` specificity.
  * [33] Ascending and descending sort icons.
  * [34] Increase specificity and exclude `.c-info-icon` from table icon styling.
  * [35] Ensure same size and avoid distortion when text exceeds cell width.
  * [36] Apply shadow to ensure visibility when indicator is on colorized
  *      background (e.g. red on red). It barely changes the visual appearance
  *      when no background is set but visually sets it apart when a background
  *      is applied.
  * [37] Avoid borders being cutoff if table gets scrollable.
  * [38] Disable all pointer-events to prevent hover-styles for table cell and
  *      row elements only.
  * [39] Re-enable all pointer-events for all table elements that are not
  *      affected via [38].
  * [40] Responsive variant: Increase specificity to be able to override
  *      `min-width` that is being used for the more simple responsive overscroll
  *      effect.
  * [41] Responsive variant: reset `min-width`.
  * [42] Responsive variant: Set all table elements to `display: block`. Note
  *      that the roles of the individual elements must be restored with
  *      aria-roles attributes for accessibility reasons.
  * [43] Responsive variant: Hide `thead` in an accessible way so that users can
  *      still access all content in it with assistive technologies.
  * [44] Responsive variant: Reset some `th`/`td` styles.
  * [45] Responsive variant: Hide bottom border of the last cell in a `tr`.
  * [46] Responsive variant: `[data-columnheader]` is used to repeat the column
  *      header before each cell as pseudo element.
  * [47] Responsive variant: Display the value of `[data-columnheader]` before
  *      each cell as a pseudo element.
  * [48] Responsive variant: Set position to `static` to reset absolute
  *      positioning that is needed for horizontal borders in larger viewports.
  *      See [1].
  * [49] Responsive variant: Enable hyphenation for column headers before each
  *      cell, as there often is not enough width for longer words, especially
  *      in small viewports.
  * [50] Responsive variant: If a background color is set for the responsive
  *      column header, the header should be displayed over the entire row height.
  * [51] @deprecated: Responsive variant: For IE11 (and browsers without CSS grid support) the
  *      responsive layout is implemented with paddings and negative margins.
  *      This is not quite as robust as the grid layout for modern browsers.
  * [52] Responsive variant: Use CSS grid in modern browsers to layout the
  *      column header and cells side by side.
  * [53] Responsive variant: Disable background color change on hover.
  * [54] Responsive variant: To make sure that really only the first `th` in a
  *      row is used as row header, we use the `:first-child` pseudo class.
  * [55] Responsive variant: Add spacing and border between `tr`s.
  */
 .c-table-wrapper .c-icon.c-icon.c-icon:not(.c-info-icon) {
   /* [34] */
   /* stylelint-disable-line selector-max-class, selector-max-specificity */
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
 }
 
 .c-table-wrapper:not(:last-child) {
   margin-bottom: 24px;
   /* [11] */
 }
 
 @media (max-width: 960px) {
   .c-table-wrapper:not(.c-table-wrapper--no-scroll):not([class*="c-table--sticky"]) {
     overflow-x: auto;
     /* [5] */
   }
   .c-table-wrapper:not(.c-table-wrapper--no-scroll):not([class*="c-table--sticky"]) table {
     margin-left: 0px;
     /* [37] */
   }
 }
 
 .c-table-wrapper.c-table-wrapper--auto {
   width: auto;
   /* [6] */
 }
 
 .c-table-wrapper th,
 .c-table-wrapper td {
   position: relative;
   /* [1] */
   padding: 8px 16px;
   font-size: 16px;
   line-height: 1.2;
   text-align: left;
   /* [1] */
 }
 
 @supports not ((-ms-high-contrast: none) and (-ms-ime-align: auto)) {
   .c-table-wrapper th::before, .c-table-wrapper th::after,
   .c-table-wrapper td::before,
   .c-table-wrapper td::after {
     content: "";
     position: absolute;
     right: 0;
     left: 0;
   }
   .c-table-wrapper th::before,
   .c-table-wrapper td::before {
     top: 0;
   }
   .c-table-wrapper th::after,
   .c-table-wrapper td::after {
     bottom: 0;
   }
 }
 
 .c-table-wrapper th {
   vertical-align: middle;
 }
 
 .c-table-wrapper th .c-icon:not(.c-info-icon)::before {
   color: #1a1a1a;
   /* [31] */
 }
 
 .c-table-wrapper td {
   height: 32px;
   /* [30] */
   vertical-align: middle;
   color: #000000;
 }
 
 .c-table-wrapper td .c-icon:not(.c-info-icon)::before {
   color: #1a1a1a;
   /* [31] */
 }
 
 .c-table-wrapper table {
   width: 100%;
   /* [2] */
   margin-bottom: 0;
   /* [10] */
   border-collapse: collapse;
   /* [19] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   /* stylelint-disable selector-max-compound-selectors, selector-max-combinators, selector-max-type */
   /* stylelint-enable */
   /* stylelint-disable selector-max-compound-selectors, selector-max-combinators, selector-max-type */
   /* stylelint-enable */
   /* stylelint-disable selector-max-compound-selectors, selector-max-combinators, selector-max-type */
   /* stylelint-enable */
 }
 
 @media (max-width: 960px) {
   .c-table-wrapper:not(.c-table-wrapper--no-scroll) table {
     min-width: 720px;
     /* [5] */
   }
 }
 
 .c-table-wrapper--auto table {
   width: auto;
   /* [7] */
   margin-right: auto;
   /* [8] */
   margin-left: auto;
   /* [8] */
   table-layout: auto;
   /* [9] */
 }
 
 @media (max-width: 960px) {
   .c-table-wrapper--auto table {
     margin-left: 0;
   }
 }
 
 .c-table-wrapper table caption {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
 }
 
 .c-table-wrapper table :not(thead) + tbody tr:first-child,
 .c-table-wrapper table thead {
   /* [4] */
 }
 
 .c-table-wrapper table :not(thead) + tbody tr:first-child th,
 .c-table-wrapper table :not(thead) + tbody tr:first-child td,
 .c-table-wrapper table thead th,
 .c-table-wrapper table thead td {
   vertical-align: middle;
   color: #000000;
 }
 
 .c-table-wrapper table :not(thead) + tbody tr:first-child th,
 .c-table-wrapper table thead th {
   font-weight: 700;
 }
 
 .c-table-wrapper table tbody {
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable max-nesting-depth */
   /* stylelint-enable max-nesting-depth */
   /* stylelint-disable max-nesting-depth */
   /* stylelint-enable max-nesting-depth */
 }
 
 .c-table-wrapper table tbody th,
 .c-table-wrapper table tbody td {
   transition: all 250ms ease;
   border-bottom: 1px solid #1a1a1a;
 }
 
 @supports not ((-ms-high-contrast: none) and (-ms-ime-align: auto)) {
   .c-table-wrapper table tbody th,
   .c-table-wrapper table tbody td {
     border-bottom: 0;
   }
   .c-table-wrapper table tbody th::after,
   .c-table-wrapper table tbody td::after {
     border-bottom: 1px solid #1a1a1a;
   }
 }
 
 .c-table-wrapper table tbody tr:hover th,
 .c-table-wrapper table tbody tr:hover td {
   background-color: #fafafa;
 }
 
 .c-table-wrapper table tbody tr.is-selected th,
 .c-table-wrapper table tbody tr.is-selected td {
   background-color: #f2f2f2;
 }
 
 .c-table-wrapper table tbody tr.is-selected th::after,
 .c-table-wrapper table tbody tr.is-selected td::after {
   border-color: currentColor;
 }
 
 .c-table-wrapper table tbody tr.is-selected:hover th,
 .c-table-wrapper table tbody tr.is-selected:hover td {
   background-color: #fafafa;
 }
 
 .c-table-wrapper table tbody tr.is-success th,
 .c-table-wrapper table tbody tr.is-success td {
   color: #00783c;
 }
 
 .c-table-wrapper table tbody tr.is-success th::after,
 .c-table-wrapper table tbody tr.is-success td::after {
   border-width: 1px;
   border-color: currentColor;
 }
 
 .c-table-wrapper table tbody tr.is-success th .c-icon::before,
 .c-table-wrapper table tbody tr.is-success td .c-icon::before {
   color: #00783c;
 }
 
 .c-table-wrapper table tbody tr.is-success:hover th,
 .c-table-wrapper table tbody tr.is-success:hover td {
   color: #00783c;
 }
 
 .c-table-wrapper table tbody tr.is-error th,
 .c-table-wrapper table tbody tr.is-error td {
   color: #ba2525;
 }
 
 .c-table-wrapper table tbody tr.is-error th::after,
 .c-table-wrapper table tbody tr.is-error td::after {
   border-width: 1px;
   border-color: currentColor;
 }
 
 .c-table-wrapper table tbody tr.is-error th .c-icon::before,
 .c-table-wrapper table tbody tr.is-error td .c-icon::before {
   color: #ba2525;
 }
 
 .c-table-wrapper table tbody tr.is-disabled th,
 .c-table-wrapper table tbody tr.is-disabled td, .c-table-wrapper table tbody [aria-disabled='true'] th,
 .c-table-wrapper table tbody [aria-disabled='true'] td {
   color: #afb5ab;
 }
 
 .c-table-wrapper table tbody tr.is-disabled th::after,
 .c-table-wrapper table tbody tr.is-disabled td::after, .c-table-wrapper table tbody [aria-disabled='true'] th::after,
 .c-table-wrapper table tbody [aria-disabled='true'] td::after {
   border-width: 1px;
   border-color: currentColor;
 }
 
 .c-table-wrapper table tbody tr th.is-success,
 .c-table-wrapper table tbody tr td.is-success {
   color: #00783c;
 }
 
 .c-table-wrapper table tbody tr th.is-success::after,
 .c-table-wrapper table tbody tr td.is-success::after {
   border-width: 1px;
   border-color: currentColor;
 }
 
 .c-table-wrapper table tbody tr th.is-success .c-icon::before,
 .c-table-wrapper table tbody tr td.is-success .c-icon::before {
   color: #00783c;
 }
 
 .c-table-wrapper table tbody tr th.is-error,
 .c-table-wrapper table tbody tr td.is-error {
   color: #ba2525;
 }
 
 .c-table-wrapper table tbody tr th.is-error::after,
 .c-table-wrapper table tbody tr td.is-error::after {
   border-width: 1px;
   border-color: currentColor;
 }
 
 .c-table-wrapper table tbody tr th.is-error .c-icon::before,
 .c-table-wrapper table tbody tr td.is-error .c-icon::before {
   color: #ba2525;
 }
 
 .c-table-wrapper table tbody tr th.is-disabled, .c-table-wrapper table tbody tr [aria-disabled='true'],
 .c-table-wrapper table tbody tr td.is-disabled, .c-table-wrapper table tbody tr [aria-disabled='true'] {
   color: #afb5ab;
 }
 
 .c-table-wrapper table tbody tr th.is-disabled::after, .c-table-wrapper table tbody tr [aria-disabled='true']::after,
 .c-table-wrapper table tbody tr td.is-disabled::after, .c-table-wrapper table tbody tr [aria-disabled='true']::after {
   border-width: 1px;
   border-color: currentColor;
 }
 
 .c-table-wrapper table tbody tr:hover th.is-success,
 .c-table-wrapper table tbody tr:hover td.is-success {
   color: #00783c;
 }
 
 .c-table-wrapper table tbody tr,
 .c-table-wrapper table tbody th,
 .c-table-wrapper table tbody td {
   /* stylelint-disable-next-line max-nesting-depth */
 }
 
 .c-table-wrapper table tbody tr.is-disabled, .c-table-wrapper table tbody tr[aria-disabled="true"],
 .c-table-wrapper table tbody th.is-disabled,
 .c-table-wrapper table tbody th[aria-disabled="true"],
 .c-table-wrapper table tbody td.is-disabled,
 .c-table-wrapper table tbody td[aria-disabled="true"] {
   pointer-events: none;
 }
 
 .c-table-wrapper table tbody th {
   font-weight: 400;
 }
 
 .c-table-wrapper table tbody > tr:first-child {
   border-left: none;
   /* [25] */
 }
 
 .c-table-wrapper table tfoot th {
   font-weight: 400;
 }
 
 .c-table--narrow {
   /* [18] */
 }
 
 .c-table--narrow th,
 .c-table--narrow td {
   padding: 4px 16px;
   font-size: 13px;
 }
 
 .c-table--wide {
   /* [18] */
 }
 
 .c-table--wide th,
 .c-table--wide td {
   padding: 10px 16px;
   font-size: 16px;
 }
 
 .c-table__content--info {
   /* [27] */
   display: inline-block;
   width: 8px;
   height: 8px;
   margin-right: 4px;
   border-radius: 50%;
   background-color: #187085;
 }
 
 .c-table__content--success {
   /* [27] */
   display: inline-block;
   width: 8px;
   height: 8px;
   margin-right: 4px;
   border-radius: 50%;
   background-color: #00783c;
 }
 
 .c-table__content--warning {
   /* [27] */
   display: inline-block;
   width: 8px;
   height: 8px;
   margin-right: 4px;
   border-radius: 50%;
   background-color: #efc938;
 }
 
 .c-table__content--error {
   /* [27] */
   display: inline-block;
   width: 8px;
   height: 8px;
   margin-right: 4px;
   border-radius: 50%;
   background-color: #ba2525;
 }
 
 .c-table__layout--fixed,
 .c-table--layout-fixed {
   /* [3] */
 }
 
 .c-table__layout--fixed table,
 .c-table--layout-fixed table {
   table-layout: fixed;
 }
 
 .c-table__btn {
   /* [15] */
 }
 
 .c-table__btn, .c-table__btn:hover, .c-table__btn:focus, .c-table__btn:active {
   margin: 0;
   padding: 0;
   border: 0 !important;
   /* stylelint-disable-line itcss/no-at-important */
   border-radius: 0 !important;
   /* stylelint-disable-line itcss/no-at-important */
   box-shadow: none;
 }
 
 /* stylelint-disable selector-max-class, selector-max-specificity */
 .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort {
   /* [32] */
 }
 
 .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort, .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort:hover, .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort:focus, .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort:active {
   justify-content: flex-start;
   min-height: 0;
   border: none;
   font-size: inherit;
   font-weight: inherit;
   letter-spacing: inherit;
   line-height: inherit;
   text-transform: inherit;
   background: none;
   /* 35 */
   color: inherit;
 }
 
 .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort .c-btn__icon, .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort:hover .c-btn__icon, .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort:focus .c-btn__icon, .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort:active .c-btn__icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
 }
 
 .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort .c-btn__icon::before, .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort:hover .c-btn__icon::before, .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort:focus .c-btn__icon::before, .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort:active .c-btn__icon::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   vertical-align: bottom;
   color: #1a1a1a;
 }
 
 .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort, .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort[data-sort-order="asc"] {
   /* [33] */
 }
 
 .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort .c-btn__icon::before, .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort[data-sort-order="asc"] .c-btn__icon::before {
   content: "\e947";
 }
 
 .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort[data-sort-order="desc"] {
   /* [33] */
 }
 
 .c-table__btn-sort.c-table__btn-sort.c-table__btn-sort.c-table__btn-sort[data-sort-order="desc"] .c-btn__icon::before {
   content: "\e944";
 }
 
 /* stylelint-enable */
 .c-table__sortable-header-text {
   /* [17] */
 }
 
 .c-table__cell {
   /* [28] */
 }
 
 .c-table__cell__icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   margin-right: 8px;
 }
 
 .c-table__cell-align {
   /* [29] */
   display: flex;
   flex-direction: row;
   align-items: center;
 }
 
 /**
  * Each table variant has its own min-height.
 */
 .c-table--narrow td {
   height: 24px;
   /* [30] */
 }
 
 .c-table--wide td {
   height: 64px;
   /* [30] */
 }
 
 .c-table--no-hover {
   /* stylelint-disable selector-max-combinators, selector-max-type, selector-max-compound-selectors,  sh-waqar/declaration-use-variable */
   /* stylelint-enable */
 }
 
 .c-table--no-hover td,
 .c-table--no-hover td td,
 .c-table--no-hover td th,
 .c-table--no-hover td tr,
 .c-table--no-hover th,
 .c-table--no-hover th td,
 .c-table--no-hover th th,
 .c-table--no-hover th tr,
 .c-table--no-hover tr,
 .c-table--no-hover tr td,
 .c-table--no-hover tr th,
 .c-table--no-hover tr tr {
   pointer-events: none !important;
   /* [38] */
 }
 
 .c-table--no-hover td > *:not(td):not(th):not(tr),
 .c-table--no-hover th > *:not(td):not(th):not(tr),
 .c-table--no-hover tr > *:not(td):not(th):not(tr) {
   pointer-events: all !important;
   /* [39] */
 }
 
 /**
  * Status indicator in data control tables
 */
 .c-table__indicator {
   display: inline-block;
   flex-grow: 0;
   flex-shrink: 0;
   /* [35] */
   flex-basis: auto;
   width: 8px;
   height: 8px;
   margin-right: 8px;
   border-radius: 50%;
   box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);
   /* [36] */
 }
 
 .c-table__indicator--info {
   background-color: #187085;
 }
 
 .c-table__indicator--success {
   background-color: #00783c;
 }
 
 .c-table__indicator--warning {
   background-color: #efc938;
 }
 
 .c-table__indicator--error {
   background-color: #ba2525;
 }
 
 /**
  * Individual table cells can be highlighted via the
  * `.c-table__content--highlight` class.
 */
 .c-table--highlight tr > :nth-child(n+3):not(th) {
   /* [16] */
   background-color: #f2f2f2;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-table--highlight tr > :nth-child(n+3):not(th),
 .u-bg-alternative .c-table--highlight tr > :nth-child(n+3):not(th) {
   background-color: #ffffff;
 }
 
 .c-table--highlight tr > :nth-child(n+3):not(th):not(:last-child) {
   border-right: 16px solid #ffffff;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-table--highlight tr > :nth-child(n+3):not(th):not(:last-child),
 .u-bg-alternative .c-table--highlight tr > :nth-child(n+3):not(th):not(:last-child) {
   border-right: 16px solid #f2f2f2;
 }
 
 /**
  * Table with color scheme
  */
 .c-table--colored tbody tr:nth-of-type(odd) {
   background-color: #f2f2f2;
 }
 
 .c-table--colored tbody tr:nth-of-type(even) {
   background-color: #ffffff;
 }
 
 /**
  * Table with border scheme and joined cells and rows
  */
 .c-table--bordered {
   border-spacing: 16px 0;
 }
 
 .c-table--bordered td {
   padding-top: 8px;
   padding-right: 16px;
   padding-bottom: 8px;
   padding-left: 16px;
 }
 
 .c-table--bordered td + td,
 .c-table--bordered th + td {
   border-left: 1px solid #1a1a1a;
 }
 
 /**
 * Table with sticky head row
 */
 .c-table--sticky-head {
   overflow: visible;
   /* [20] */
 }
 
 .c-table--sticky-head thead th,
 .c-table--sticky-head thead td {
   position: -webkit-sticky;
   position: sticky;
   z-index: 1;
   /* [21] */
   top: 0;
   background-color: #ffffff;
   /* [21] */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-table--sticky-head thead th,
 .u-bg-alternative .c-table--sticky-head thead th, [data-theme="alternative"]
 .c-table--sticky-head thead td,
 .u-bg-alternative
 .c-table--sticky-head thead td {
   background-color: #f2f2f2;
 }
 
 /**
 * Table with sticky first column
 */
 .c-table--sticky-column {
   overflow: visible;
   /* [20] */
 }
 
 .c-table--sticky-column th:first-child,
 .c-table--sticky-column td:first-child {
   position: -webkit-sticky;
   position: sticky;
   z-index: 1;
   /* [22] */
   left: 0;
   background-color: #ffffff;
   /* [22] */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-table--sticky-column th:first-child,
 .u-bg-alternative .c-table--sticky-column th:first-child, [data-theme="alternative"]
 .c-table--sticky-column td:first-child,
 .u-bg-alternative
 .c-table--sticky-column td:first-child {
   background-color: #f2f2f2;
 }
 
 .c-table--sticky-column thead th:first-child,
 .c-table--sticky-column thead td:first-child {
   z-index: 2;
   /* [23] */
 }
 
 .c-table--sticky-column.c-table--colored tbody th:first-child,
 .c-table--sticky-column.c-table--colored tbody td:first-child {
   background-color: inherit;
   /* [24] */
 }
 
 /**
 * Responsive table
 */
 @media (max-width: 720px) {
   .c-table--responsive {
     /* Column Header */
     /* Row Header */
   }
   .c-table--responsive.c-table--responsive > table {
     /* [40] */
     min-width: 0;
     /* [41] */
   }
   .c-table--responsive table,
   .c-table--responsive thead,
   .c-table--responsive tbody,
   .c-table--responsive tfoot,
   .c-table--responsive tr,
   .c-table--responsive th,
   .c-table--responsive td {
     display: block;
     /* [42] */
   }
   .c-table--responsive thead {
     position: absolute !important;
     /* stylelint-disable-line itcss/no-at-important */
     width: 1px;
     height: 1px;
     overflow: hidden;
     clip: rect(1px, 1px, 1px, 1px);
     /* [43] */
   }
   .c-table--responsive th,
   .c-table--responsive td {
     height: auto;
     /* [44] */
     padding-right: 0;
     /* [44] */
     padding-left: 0;
     /* [44] */
   }
   .c-table--responsive th:last-child::after,
   .c-table--responsive td:last-child::after {
     display: none;
     /* [45] */
   }
   .c-table--responsive [data-columnheader] {
     /* [46] */
     /* stylelint-disable */
     /* IE11 */
     padding-left: 50%;
     /* [51] */
     /* IE11 */
     /* stylelint-enable */
     /* For browsers with modern grid support */
   }
   .c-table--responsive [data-columnheader]::before {
     content: attr(data-columnheader);
     /* [47] */
     position: static;
     /* [48] */
     font-weight: 700;
     vertical-align: top;
     -webkit-hyphens: auto;
     -ms-hyphens: auto;
     hyphens: auto;
     /* [49] */
     color: #000000;
   }
   .c-table--responsive [data-columnheader]::before {
     display: inline-block;
     /* [51] */
     width: 100%;
     /* [51] */
     margin-left: -100%;
     /* [51] */
     margin-right: 16px;
     /* [51] */
   }
   @supports (display: grid) {
     .c-table--responsive [data-columnheader] {
       /* [52] */
       display: -ms-grid;
       display: grid;
       -ms-grid-columns: 1fr 1fr;
       grid-template-columns: 1fr 1fr;
       grid-column-gap: 16px;
       padding-left: 0;
     }
     .c-table--responsive [data-columnheader]::before {
       width: auto;
       margin-left: 0;
       margin-right: 0;
     }
   }
   .c-table--responsive tr:hover th,
   .c-table--responsive tr:hover td {
     background-color: initial;
     /* [53] */
   }
   .c-table--responsive th:first-child {
     /* [54] */
     padding-bottom: 24px;
     font-weight: 700;
     color: #1a1a1a;
   }
   .c-table--responsive tr + tr {
     margin-top: 24px;
     /* [55] */
     padding-top: 24px;
     /* [55] */
     border-top: 1px solid #697677;
     /* [55] */
   }
 }
 
 /* ------------------------------------*\
     #TOGGLE
 \*------------------------------------ */
 /* stylelint-disable selector-max-specificity */
 /**
  * [1] Hide native checkbox.
  * [2] Give space for the (absolute positioned) toggle.
  * [3] Vertical alignment for toggle and text.
  * [4] Correct alignment.
  * [5] Relative labels to help position the pseudo elements.
  *	   The z-index will be handy later, when the labels that overlap the visual
  *     toggle UI need to be adjusted
  *	   to allow for a user to toggle the toggle without having to move their
  *     mouse/finger to the different sides of the UI.
  * [6] The large padding is used to position the labels on top of the visual UI,
  *     so the toggle UI itself can be mouse clicked or finger tapped to toggle
  *     the current option.
  * [7] Move the 2nd label to have a lower z-index, so when that option is
  *     toggled, the first label will overlay on top of the toggle ui, and the
  *     toggle can be pressed again to toggle back to the prevoius state.
  * [8] Prevent text selection on fast double clicks.
  */
 .c-toggle {
   -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
   /* [1] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
 }
 
 .c-toggle__input {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
   /* [1] */
 }
 
 .c-toggle__input:checked + .c-toggle__text:last-child {
   /**
                  * :checked state.
                  */
 }
 
 .c-toggle__input:checked + .c-toggle__text:last-child::after {
   transform: translateX(8px);
   background-color: #1a1a1a;
 }
 
 .c-toggle--on-off .c-toggle__input:checked + .c-toggle__text:last-child {
   /**
                  * :checked state.
                  */
 }
 
 .c-toggle--on-off .c-toggle__input:checked + .c-toggle__text:last-child::after {
   background-color: #187085;
 }
 
 .c-toggle--a-b .c-toggle__input + .c-toggle__text:last-child::after {
   background-color: #1a1a1a;
 }
 
 .c-toggle__text {
   position: relative;
   display: inline-block;
   /* [2] */
   line-height: 24px;
   /* [3] */
   cursor: pointer;
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
   /* [8] */
 }
 
 .c-toggle__text:first-child {
   margin-right: 16px;
 }
 
 .c-toggle__text:last-child {
   padding-left: 48px;
   /* [2] */
   /**
              * The toggle bar.
              */
   /**
              * The toggle handle.
              */
 }
 
 .c-toggle__text:last-child::before, .c-toggle__text:last-child::after {
   content: "";
   position: absolute;
   display: block;
 }
 
 .c-toggle__text:last-child::before {
   top: 0;
   left: 0;
   width: 32px;
   height: 24px;
   border: 1px solid #afb5ab;
   border-radius: 4px;
   background-color: transparent;
   transition: 83.33333ms;
 }
 
 .c-toggle__text:last-child::after {
   top: 4px;
   /* [4] */
   left: 9px;
   /* [4] */
   width: 6px;
   height: 16px;
   border-radius: 4px;
   background-color: #afb5ab;
   transition: 250ms;
   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.85);
   border: 2px dotted #495651;
 }
 
 .c-toggle--a-b .c-toggle__text {
   z-index: 2;
   /* [5] */
 }
 
 .c-toggle--a-b .c-toggle__text:first-of-type {
   padding-right: 64px;
   /* [6] */
 }
 
 .c-toggle--a-b .c-toggle__text:last-child {
   margin-left: -48px;
   padding-left: 48px;
   /* [6] */
 }
 
 .c-toggle--a-b .c-toggle__input:not(:checked) + .c-toggle__text {
   color: #495651;
 }
 
 .c-toggle--a-b .c-toggle__input:last-of-type:checked ~ .c-toggle__text:last-of-type {
   z-index: 1;
   /* [7] */
 }
 
 /* stylelint-enable */
 /* ------------------------------------*\
     #PROGRESS
 \*------------------------------------ */
 /**
  * [1] Reset browser-default styles.
  * [2] IE takes the `color` property for styling the background color of the
  *     bar.
  */
 .c-progress {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   display: block;
   -webkit-appearance: none;
   appearance: none;
   /* [1] */
   width: 100%;
   height: 4px;
   border: 0;
   /* [1] */
   color: #187085;
   /* [2] */
 }
 
 .c-progress.is-success {
   color: #00783c;
 }
 
 .c-progress.is-error {
   color: #ba2525;
 }
 
 /**
      * The whole progress bar.
      */
 .c-progress::-webkit-progress-bar {
   -webkit-transition-property: all;
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   background-color: #495651;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-progress::-webkit-progress-bar,
 .u-bg-alternative .c-progress::-webkit-progress-bar {
   background-color: #ffffff;
 }
 
 /**
      * The "filled" part of the progress bar.
      */
 .c-progress::-webkit-progress-value {
   -webkit-transition-property: all;
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   background-color: #187085;
 }
 
 .is-success.c-progress::-webkit-progress-value {
   background-color: #00783c;
 }
 
 .is-error.c-progress::-webkit-progress-value {
   background-color: #ba2525;
 }
 
 /**
      * Firefox-specific styling.
      *
      * Firefox just has one pseude element, which unfortunately prevents us from
      * styling the background container of the progress bar.
      */
 .c-progress::-moz-progress-bar {
   background-color: #187085;
 }
 
 .is-success.c-progress::-moz-progress-bar {
   background-color: #00783c;
 }
 
 .is-error.c-progress::-moz-progress-bar {
   background-color: #ba2525;
 }
 
 /* ------------------------------------*\
     #PRICE-BOX (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #PRICE-BOX
 \*------------------------------------ */
 /**
  * [1] Reset default margin.
  * [2] Ensure crossed-out text if `<del>` is not used or
  *     User-Agent styles are not applied.
  * [3] Ensure price not getting wrapped.
  * [4] Limit the additional info text-length when container
  *     is displayed with a large width to
     *     a) improve readability
     *     b) keep "visual connection" to price information above
  * [5] Allow wrapping incase discount value & price can not be displayed
  *     side-by-side.
  * [6] Wrap text in extra container to avoid overflow in IE11 and still maintain
  *     text limitation via `max-length`.
  * [7] Set `max-width: 100%` to avoid text overflow.
  *     https://github.com/philipwalton/flexbugs#flexbug-2
  * [8] Conditionally output only shadow (overwrite) when shadow is set initially
  *     set in base variant.
  */
 .c-price-box.c-price-box--integrated {
   /* [8] */
 }
 
 .c-price-box__header {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   padding: 8px 24px;
   font-weight: 400;
   text-align: center;
   background-color: #1a1a1a;
   color: #ffffff;
 }
 
 .c-price-box--integrated .c-price-box__header {
   border-bottom: 1px solid #1a1a1a;
   background-color: transparent;
   color: #1a1a1a;
 }
 
 .c-price-box__body {
   display: flex;
   flex-direction: column;
   align-items: center;
   padding: 24px;
   text-align: center;
   background-color: #f2f2f2;
   color: #1a1a1a;
 }
 
 .c-price-box--integrated .c-price-box__body {
   background-color: transparent;
 }
 
 .c-price-box__body__content {
   text-align: left;
 }
 
 .c-price-box__discount {
   display: flex;
   flex-wrap: wrap;
   /* [5] */
   align-items: center;
 }
 
 .c-price-box__discount__value {
   margin-right: 8px;
 }
 
 .c-price-box__discount__old-price {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   text-decoration: line-through;
   /* [2] */
 }
 
 @media (min-width: 721px) {
   .c-price-box__discount__old-price {
     font-size: 1.125rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-price-box__discount__old-price {
     font-size: 1.5rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-price-box__price {
   font-size: 1.625rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   display: block;
   margin-top: 4px;
   margin-bottom: 4px;
   font-weight: 400;
 }
 
 @media (min-width: 721px) {
   .c-price-box__price {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
     line-height: 1;
   }
 }
 
 @media (min-width: 1921px) {
   .c-price-box__price {
     font-size: 2.25rem;
     /* stylelint-disable-line order/order */
     line-height: 1;
   }
 }
 
 .c-price-box__price,
 .c-price-box__discount__old-price {
   white-space: nowrap;
   /* [3] */
 }
 
 .c-price-box__additional-info {
   max-width: 100%;
   /* [7] */
 }
 
 /* [6] */
 .c-price-box__additional-info__text {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   max-width: 50ch;
   /* [4] */
   text-align: left;
 }
 
 .c-price-box__additional-info__text:last-child {
   margin-bottom: 0;
   /* [1] */
 }
 
 /* ------------------------------------*\
     #UPLOAD (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #UPLOAD
 \*------------------------------------ */
 /**
  * Upload component which utilizes the native `<input type="file">` element.
  * Itâ€™s prepared to be used with drag-and-drop JS extensions in providing
  * a `.has-mouseover` state class when a file is dragged upon the upload
  * container.
  */
 /**
  * [1] Reset default `<label>` spacing.
  * [2] Reference for the mouseover element.
  * [3] Disable the input (i.e. upload function) when loading or disabled.
  * [4] Hide original `<input>` but keep it accessible.
  * [5] Just hide visually, so the height of the container does not change.
  * [6] Create a padding for the mouseover element by using the calc function
  *     for the width property. Since this element is positioned `absolute`,
  *     a width of `100%` wouldnâ€™t work. Thatâ€™s why we subtract the the padding
  *     value off of both sides.
  * [7] Center the mouseover elements inside the upload container.
  * [8] Override the buttons default transition so it doesnâ€™t look weird.
  * [9] It would work to omit the `left` declaration, however it is advised to
  *     always apply a `left` (or `right`) value to an `absolute` positioned
  *     element. A value of `0` wouldnâ€™t work correctly, so we use the padding
  *     value instead.
  * [10] Place `.c-upload__input` over the entire upload component to allow drag
  *      and drop of files onto the file input field. This is only done when no
  *      hovering takes place to allow interacting with buttons (or other
  *      elements) inside the component.
  */
 .c-upload {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   position: relative;
   /* [2] */
   display: block;
   margin-bottom: 0;
   /* [1] */
   padding: 24px 24px;
   text-align: center;
   background-color: rgba(24, 112, 133, 0.05);
   cursor: pointer;
   border: 2px dashed #187085;
 }
 
 .c-upload:hover {
   border-color: #187085;
 }
 
 .c-upload.has-mouseover {
   border-color: #187085;
 }
 
 .c-upload.is-loading, .c-upload.is-disabled {
   pointer-events: none;
   /* [3] */
 }
 
 .c-upload.is-disabled {
   background-color: rgba(24, 112, 133, 0.05);
   border-color: #187085;
 }
 
 .c-upload__input {
   position: absolute;
   /* [4] */
   z-index: -1;
   /* [4] */
   width: 0.1px;
   /* [4] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   height: 0.1px;
   /* [4] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   opacity: 0;
   /* [4] */
   overflow: hidden;
   /* [4] */
 }
 
 .c-upload:not(:hover) .c-upload__input {
   z-index: 1;
   /* [10] */
   top: 0;
   /* [10] */
   left: 0;
   /* [10] */
   width: 100%;
   /* [10] */
   height: 100%;
   /* [10] */
 }
 
 .c-upload__description {
   display: block;
 }
 
 .c-upload.has-mouseover .c-upload__description {
   visibility: hidden;
   /* [5] */
 }
 
 .c-upload.is-loading .c-upload__description {
   display: none;
 }
 
 .c-upload.is-disabled .c-upload__description {
   display: none;
 }
 
 .c-upload__description-text {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   display: block;
   margin-bottom: 0;
   font-weight: 400;
   color: inherit;
 }
 
 .c-upload__description-text:not(:last-child) {
   margin-bottom: 8px;
 }
 
 .c-upload__description-supplementary-text {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   display: block;
   margin-bottom: 0;
   font-weight: 400;
   color: #495651;
 }
 
 .c-upload__icon {
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   display: block;
   margin-bottom: 16px;
   color: inherit;
 }
 
 .c-upload__icon::before {
   content: "\e982";
 }
 
 .c-upload__mouseover {
   position: absolute;
   /* [7] */
   top: 50%;
   /* [7] */
   left: 24px;
   /* [9] */
   display: block;
   width: calc(100% - (48px));
   /* [6] */
   transform: translateY(-50%);
   /* [7] */
   color: inherit;
 }
 
 .c-upload:not(.has-mouseover) .c-upload__mouseover {
   display: none;
 }
 
 .c-upload__mouseover > *:last-child {
   margin-bottom: 0;
 }
 
 .c-upload__mouseover-icon {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1.33333;
   color: #187085;
 }
 
 .c-upload__mouseover-icon::before {
   content: "\e982";
 }
 
 .c-upload__mouseover-text {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   display: block;
   font-weight: 400;
 }
 
 .c-upload__loader {
   display: block;
 }
 
 .c-upload:not(.is-loading) .c-upload__loader {
   display: none;
 }
 
 .c-upload__loader-text {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   display: block;
   margin-top: 16px;
   color: #afb5ab;
 }
 
 .c-upload__disabled {
   display: none;
   color: #afb5ab;
 }
 
 .c-upload.is-disabled .c-upload__disabled {
   display: block;
 }
 
 .c-upload__disabled-icon {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   color: #afb5ab;
 }
 
 .c-upload__disabled-icon::before {
   content: "\e955";
 }
 
 .c-upload__disabled-text {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   display: block;
   margin-bottom: 0;
   font-weight: 400;
 }
 
 .c-upload__disabled-text:not(:last-child) {
   margin-bottom: 8px;
 }
 
 .c-upload__disabled-supplementary-text {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   display: block;
   margin-bottom: 0;
   color: #afb5ab;
 }
 
 .c-upload__actions {
   display: flex;
   justify-content: center;
   align-items: center;
   margin-top: 16px;
 }
 
 .c-upload.has-mouseover .c-upload__actions {
   visibility: hidden;
   /* [5] */
 }
 
 .c-upload.is-loading .c-upload__actions {
   display: none;
 }
 
 .c-upload.is-disabled .c-upload__actions {
   display: none;
 }
 
 .c-upload__button {
   margin-bottom: 0;
 }
 
 .has-mouseover .c-upload__button {
   transition: 0s;
   /* [8] */
 }
 
 /* ------------------------------------*\
     #UPLOAD-ITEM
 \*------------------------------------ */
 /**
  * [1] Always stretch the content to full-width.
  * [2] Break long file names into multiline.
  * [3] Don't wrap icons into multiline.
  * [4] Hide file icon if `$upload-item-icon-is-hidden: true`.
  * [5] Fix for non wrapping content in IE11.
  */
 .c-upload-item {
   display: flex;
   align-items: stretch;
   padding-top: 24px;
   padding-bottom: 24px;
   padding-left: 24px;
   padding-right: 24px;
   border: 2px solid #f2f2f2;
   border-radius: 5px;
 }
 
 .c-upload-item__icon {
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   margin-right: 16px;
   color: #1a1a1a;
 }
 
 .c-upload-item__content {
   flex-grow: 1;
   /* [1] */
   flex-shrink: 1;
   flex-basis: auto;
   overflow: hidden;
   /* [5] */
 }
 
 .c-upload-item__title-row {
   display: flex;
   justify-content: space-between;
 }
 
 .c-upload-item__title {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   flex-grow: 0;
   flex-shrink: 1;
   flex-basis: auto;
   margin-bottom: 16px;
   font-weight: 400;
   word-break: break-all;
   /* [2] */
 }
 
 .c-upload-item__progress {
   display: none;
   margin-top: 16px;
   margin-bottom: 16px;
 }
 
 .c-upload-item.is-loading .c-upload-item__progress,
 .c-upload-item.is-success .c-upload-item__progress,
 .c-upload-item.is-error .c-upload-item__progress {
   display: block;
 }
 
 .c-upload-item__subtitle-row {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 1.5;
   margin-bottom: 0;
 }
 
 .c-upload-item__interaction-icons {
   flex-grow: 0;
   flex-shrink: 0;
   /* [3] */
   flex-basis: auto;
   margin-left: 16px;
 }
 
 @media (max-width: 720px) {
   .c-upload-item__interaction-icons {
     margin-left: 8px;
   }
 }
 
 .c-upload-item__interaction-icon,
 .c-upload-item__status-icon {
   padding: 0;
   border: 0;
   background-color: transparent;
 }
 
 .c-upload-item__interaction-icon:focus,
 .c-upload-item__status-icon:focus {
   outline: 0;
 }
 
 .c-upload-item__interaction-icon::after,
 .c-upload-item__status-icon::after {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   color: #1a1a1a;
 }
 
 .c-upload-item__interaction-icon:not(:first-child),
 .c-upload-item__status-icon:not(:first-child) {
   margin-left: 16px;
 }
 
 @media (max-width: 720px) {
   .c-upload-item__interaction-icon:not(:first-child),
   .c-upload-item__status-icon:not(:first-child) {
     margin-left: 8px;
   }
 }
 
 .c-upload-item.is-error .c-upload-item__interaction-icon--main,
 .c-upload-item.is-success .c-upload-item__interaction-icon--main {
   display: none;
 }
 
 .c-upload-item__interaction-icon--main::after {
   content: "\e977";
 }
 
 .c-upload-item.is-loading .c-upload-item__interaction-icon--main::after {
   content: "\e955";
 }
 
 .c-upload-item.is-loading .c-upload-item__interaction-icon--secondary,
 .c-upload-item.is-error .c-upload-item__interaction-icon--secondary,
 .c-upload-item.is-success .c-upload-item__interaction-icon--secondary {
   display: none;
 }
 
 .c-upload-item__interaction-icon--secondary::after {
   content: "\e94b";
 }
 
 .c-upload-item__status-icon {
   display: none;
 }
 
 .c-upload-item.is-success .c-upload-item__status-icon {
   display: inline-block;
 }
 
 .c-upload-item.is-success .c-upload-item__status-icon::after {
   content: "\e952";
   color: #00783c;
 }
 
 .c-upload-item.is-error .c-upload-item__status-icon {
   display: inline-block;
 }
 
 .c-upload-item.is-error .c-upload-item__status-icon::after {
   content: "\e955";
   color: #ba2525;
 }
 
 .c-upload-item__filesize-progress {
   display: none;
 }
 
 .c-upload-item.is-loading .c-upload-item__filesize-progress,
 .c-upload-item.is-success .c-upload-item__filesize-progress {
   display: inline;
 }
 
 .c-upload-item.is-error .c-upload-item__filesize {
   display: none;
 }
 
 .c-upload-item__message {
   display: block;
 }
 
 .c-upload-item.is-success .c-upload-item__message,
 .c-upload-item.is-success .c-upload-item__message a {
   color: #00783c;
 }
 
 .c-upload-item.is-error .c-upload-item__message,
 .c-upload-item.is-error .c-upload-item__message a {
   color: #ba2525;
 }
 
 /**
  * Switch file icon by file types
  */
 /* ------------------------------------*\
     #UPLOAD-CONTAINER
 \*------------------------------------ */
 /**
  * [1] Reset default list styling.
  * [2] Reset default `<li>` styling.
  */
 .c-upload-container__field {
   margin-bottom: 24px;
 }
 
 .c-upload-container__itemlist {
   margin: 0;
   padding: 0;
   list-style: none;
   /* [1] */
 }
 
 .c-upload-container__itemlist li {
   display: block;
   margin-bottom: 0;
 }
 
 .c-upload-container__item {
   margin-bottom: 0;
   /* [2] */
 }
 
 .c-upload-container__item:not(:last-child) {
   margin-bottom: 24px;
 }
 
 /* ------------------------------------*\
     #ICON-LIST
 \*------------------------------------ */
 /**
  * [1] Create spacing between icon and text...
  * [2] Reset default list stylings. We do not use the `@include list-bare()`
  *     mixin, since we explicitly do want the margin between the `<li>`s, which
  *     list-bare removes.
  * [3] Magic number to _properly_ align the icon vertically to the text.
  * [4] If the design specifies a spacing between icon list items, set it.
  *     This applies to all items except the first one.
  * [5] Set positioning context for `.c-icon-list__icon`. This helps to make
  *     the icon stay in place in overflow contexts, see BRON-6699.
  */
 .c-icon-list {
   margin: 0;
   padding-left: 32px;
   /* [1] */
   text-align: left;
   list-style: none;
   /* [2] */
 }
 
 .c-icon-list li {
   position: relative;
   /* [5] */
 }
 
 .c-icon-list li + li {
   /* [4] */
 }
 
 .c-icon-list__icon {
   position: absolute;
   line-height: inherit;
 }
 
 .c-icon-list__icon::before {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   position: absolute;
   top: 0.25em;
   /* [3] */
   left: -32px;
 }
 
 /* ------------------------------------*\
     #TABS
 \*------------------------------------ */
 /* [8] */
 /**
  * [1] We need to defensively reset any default list-style properties.
  * [2] Remove whitespace for inline(-block) elements.
  * [3] Draw the line through, it will be hidden by parents overflow hidden.
  *     This is the line that exceeds to the right.
  * [4] Divide the amount of spacing by two, so that the sum of both paddings
  *     equals the variable.
  * [5] The ::before pseudo element represents the border-bottom below each item.
  * [6] The ::after pseudo element represents the border that exceeds all the
  *     way to the right. To make this component comliant to the Bluelable
  *     design, this exceeding border cannot be build with a border-bottom on the
  *     list element.
  * [7] Make the border long enough.
  * [8] Eliminate any additional margin inside the tab content.
  * [9] Place the text out of the viewport so that is still accessible.
  */
 .c-tabs__nav {
   margin: 0;
   padding: 0;
   list-style: none;
   overflow: hidden;
   margin: 0;
   /* [1] */
   padding: 0;
   /* [1] */
   font-size: 0;
   /* [2] */
   background-color: transparent;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 .c-tabs__nav li {
   display: inline-block;
   margin-bottom: 0;
 }
 
 /* [1] */
 .c-tabs__nav .flickity-prev-next-button {
   height: 100%;
   /* [7] */
   margin-top: -2px;
   /* [8] */
   pointer-events: auto;
   /* [10] */
 }
 
 .c-tabs__nav .flickity-prev-next-button.next {
   background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, white 40%);
   /* [9] */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-tabs__nav .flickity-prev-next-button.next,
 .u-bg-alternative .c-tabs__nav .flickity-prev-next-button.next {
   background: linear-gradient(90deg, rgba(242, 242, 242, 0) 0%, #f2f2f2 40%);
   /* [9] */
 }
 
 .c-tabs__nav .flickity-prev-next-button.previous {
   background: linear-gradient(90deg, white 60%, rgba(255, 255, 255, 0) 100%);
   /* [9] */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-tabs__nav .flickity-prev-next-button.previous,
 .u-bg-alternative .c-tabs__nav .flickity-prev-next-button.previous {
   background: linear-gradient(90deg, #f2f2f2 40%, rgba(242, 242, 242, 0) 100%);
   /* [9] */
 }
 
 .c-tabs__nav .flickity-prev-next-button:disabled {
   pointer-events: none;
   /* [10] */
   opacity: 0;
 }
 
 .c-tabs__nav .flickity-prev-next-button::before {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   line-height: 1.33333;
 }
 
 .c-tabs__nav-item {
   white-space: nowrap;
 }
 
 .c-tabs__nav-link {
   padding: 0;
   border: 0;
   background-color: transparent;
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 32px;
   padding-left: 16px;
   padding-right: 16px;
   position: relative;
   display: inline-block;
   font-weight: 400;
   text-decoration: none;
   text-transform: none;
   color: #1a1a1a;
 }
 
 .c-tabs__nav-link:focus {
   outline: 0;
 }
 
 .c-tabs__nav-link:hover, .c-tabs__nav-link:focus {
   background-color: transparent;
   color: #1a1a1a;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-tabs__nav-link:hover,
 .u-bg-alternative .c-tabs__nav-link:hover, [data-theme="alternative"] .c-tabs__nav-link:focus,
 .u-bg-alternative .c-tabs__nav-link:focus {
   background-color: #ffffff;
 }
 
 .c-tabs__nav-link.is-active {
   font-weight: 400;
   color: #1a1a1a;
 }
 
 .c-tabs__nav-link.is-active::before {
   height: 2px;
   background-color: #187085;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-tabs__nav-link.is-active::before,
 .u-bg-alternative .c-tabs__nav-link.is-active::before {
   background-color: #ffffff;
 }
 
 .c-tabs__nav-link::before {
   /* [5] */
   content: "";
   position: absolute;
   bottom: 0;
   left: 0;
   display: block;
   width: 100%;
   height: 1px;
   background-color: #afb5ab;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-tabs__nav-link::before,
 .u-bg-alternative .c-tabs__nav-link::before {
   background-color: #1a1a1a;
 }
 
 .c-tabs__nav-link::after {
   /* [3] */
   /* [6] */
 }
 
 .c-tabs__nav-item:last-child .c-tabs__nav-link::after {
   content: "";
   position: absolute;
   bottom: 0;
   left: 100%;
   display: block;
   width: 99999px;
   /* [7] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   height: 1px;
   background-color: #afb5ab;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-tabs__nav-item:last-child .c-tabs__nav-link::after,
 .u-bg-alternative .c-tabs__nav-item:last-child .c-tabs__nav-link::after {
   background-color: #1a1a1a;
 }
 
 .c-tabs__nav-link.is-disabled {
   color: #afb5ab;
   cursor: default;
   pointer-events: none;
 }
 
 .c-tabs__nav-link.is-disabled::before {
   background-color: #afb5ab;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-tabs__nav-link.is-disabled::before,
 .u-bg-alternative .c-tabs__nav-link.is-disabled::before {
   background-color: #afb5ab;
 }
 
 .c-tabs__nav.c-tabs__nav--icons .c-tabs__nav-link {
   display: flex;
   align-items: center;
 }
 
 .c-tabs__nav.c-tabs__nav--icons-stacked .c-tabs__nav-link {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   display: flex;
   flex-direction: column;
   align-items: center;
   padding-bottom: 8px;
 }
 
 .c-tabs__nav--icons-only .c-tabs__nav-link {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   padding-top: 8px;
   padding-bottom: 8px;
 }
 
 .c-tabs__nav--icons-only .c-tabs__nav-link .c-tabs__text,
 .c-tabs__nav--icons-only .c-tabs__nav-link span {
   position: absolute;
   left: -100vw;
   /* [9] */
 }
 
 .c-tabs__nav.c-tabs__nav--icons .c-tabs__icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   margin-right: 8px;
 }
 
 .c-tabs__nav.c-tabs__nav--icons-stacked .c-tabs__icon {
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   margin-top: 8px;
   margin-bottom: 8px;
 }
 
 .c-tabs__content {
   display: block;
   padding: 24px 0;
 }
 
 .c-tabs__content > *:last-child {
   margin-bottom: 0;
   /* [8] */
 }
 
 .c-tabs__content[aria-hidden="true"] {
   display: none;
 }
 
 /* ------------------------------------*\
    #CARD (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
    #CARD
 \*------------------------------------ */
 /**
  * [1] Fill horizontal space of parent.
  * [2] Calculate the space needed of 100% of the content by subtracting the
  *     needed space from the icon.
  * [3] Defensively reset any potential spacing that comes with plain HTML
  *     elements.
  * [4] The logical and therefore reading order of flex items is separate from
  *     the visual order. In this case the order property can allow patterns to
  *     be easily implemented in position needed.
  * [5] Reset ordering set by [4].
  * [6] Prevent too much spacing below below image in IE.
  * [7] To prevent unwanted stacking spacing at the bottom of the body, remove
  *     any unwanted spacing, no matter what element the last element in
  *     `.c-card__body` is.
  * [8] Place footer at the bottom. This only works in context, where the card
  *     is larger than the actual content, e.g. manually set height or
  *     equal-height with other items in a row.
  * [9] Center horizontally.
  * [10] Add additional `padding-right` to the element following `.c-card__icon`
  *      if [14a] the icon is placed on the left for the `.c-card--states`
  *      variant and this is  NOT the `.c-card--states` variant or [14b] if the
  *      icon is placed on the right for all variants.
  * [11] Add a `padding-top` that matches the card's outer padding to the element
  *      which is following `.c-card__icon` if the icon was taken out of the flow
  *      and moved to the right.
  * [12] Add additional `padding-left` for card-header if the state icon
  *      is placed on the left.
  * [13] Remove outer padding for images.
  * [14] Make the image always take up the entire width for cards.
  * [15] Vertical alignment for icon to title.
  * [16] Reset all spacings for `<hr>`.
  * [17] The variant `Card Offer` needs additional alignment settings.
  * [18] Make sure there is enough spacing for the badge to the right and also
  *      left when multiple badges are used.
  * [19] Ensure that `<hr>` wraps into a new line.
  * [20] Empty class for special card variant `Card Expandable`.
  * [21] Enable enough spacing when displayed on small devices.
  * [22] Reduce the size of the wrapper accordion icon if wanted.
  * [23] Animate the wrapper accordion icon when parent has class `.is-active`.
  * [24] Set the display context for items inside the expandable body.
  * [25] Move the expandable trigger to the right-hand side.
  * [26] Set custom alignments for expandable cards.
  */
 .c-card {
   position: relative;
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   width: 100%;
   /* [1] */
   text-align: left;
   background-color: #ffffff;
   box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 .c-card > * {
   padding-top: 16px;
   padding-right: 24px;
   padding-bottom: 16px;
   padding-left: 24px;
   /* [1] */
 }
 
 .c-card > *:first-child {
   padding-top: 24px;
 }
 
 .c-card > *:last-child {
   padding-bottom: 24px;
 }
 
 /* [1] */
 .c-card > *:not(.c-card__icon):not(.c-price-box) {
   width: 100%;
 }
 
 .c-card__image {
   padding-right: 0;
   padding-left: 0;
   /* [13] */
   flex-grow: 0;
   /* [6] */
   flex-shrink: 0;
   /* [6] */
   flex-basis: auto;
   /* [6] */
   text-align: center;
   /* [9] */
 }
 
 .c-card__image:first-child {
   padding-top: 0;
 }
 
 .c-card__image:last-child {
   padding-bottom: 0;
 }
 
 .c-card__image > img {
   width: 100%;
   /* [14] */
 }
 
 .c-card__badge {
   display: flex;
   justify-content: flex-end;
   flex-direction: row;
   margin-right: 16px;
   /* [18] */
 }
 
 .c-card__icon {
   display: block;
   flex-grow: 0;
   flex-shrink: 0;
   flex-basis: 54px;
 }
 
 .c-card--states.c-card--states-success .c-card__icon .c-icon {
   color: #00783c;
 }
 
 .c-card--states.c-card--states-warning .c-card__icon .c-icon {
   color: #efc938;
 }
 
 .c-card--states.c-card--states-error .c-card__icon .c-icon {
   color: #ba2525;
 }
 
 .c-card__icon .c-icon {
   font-size: 3.375rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   color: #1a1a1a;
 }
 
 .c-card__header {
   flex-grow: 0;
   flex-shrink: 1;
   flex-basis: auto;
 }
 
 .c-card__title {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   margin-bottom: 0;
   font-weight: 400;
 }
 
 @media (min-width: 721px) {
   .c-card__title {
     font-size: 1.25rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-card__title {
     font-size: 1.75rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-card__subtitle {
   margin-bottom: 0;
   /* [3] */
 }
 
 .c-card__divider {
   margin-top: 24px;
   margin-bottom: 24px;
   padding-top: 0;
   /* [16] */
   padding-bottom: 0;
   /* [16] */
 }
 
 .c-card__body {
   flex-grow: 0;
   flex-shrink: 1;
   flex-basis: auto;
 }
 
 .c-card__body > *:last-child {
   margin-bottom: 0;
   /* [7] */
 }
 
 .c-card__footer {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   display: flex;
   justify-content: flex-start;
   flex-grow: 0;
   flex-shrink: 1;
   flex-basis: auto;
   margin-top: auto;
   /* [8] */
 }
 
 .c-card--states .c-card__icon .c-icon {
   font-size: 3.375rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
 }
 
 .c-card--inactive {
   opacity: 0.6;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-card--scrollable {
   /* stylelint-disable */
   background: linear-gradient(#ffffff 30%, rgba(255, 255, 255, 0)), linear-gradient(rgba(255, 255, 255, 0), #ffffff 70%) 0 100%, radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0)), radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0)) 0 100%;
   background-repeat: no-repeat;
   background-color: #ffffff;
   background-size: 100% 42px, 100% 42px, 100% 14px, 100% 14px;
   background-attachment: local, local, scroll, scroll;
   /* stylelint-enable */
   max-height: 336px;
   overflow-y: auto;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .c-card--scrollable {
     background: radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0)) 0 100%;
     background-repeat: no-repeat;
     background-color: #ffffff;
     background-size: 100% 10px;
     background-attachment: scroll;
   }
 }
 
 @supports (-ms-ime-align: auto) {
   .c-card--scrollable {
     background: radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0)) 0 100%;
     background-repeat: no-repeat;
     background-color: #ffffff;
     background-size: 100% 10px;
     background-attachment: scroll;
   }
 }
 
 /* [1] */
 .c-card--offer {
   align-items: flex-start;
   /* [17] */
 }
 
 .c-card--offer .c-card__footer {
   flex-wrap: wrap;
   /* [19] */
   padding-bottom: 0;
 }
 
 .c-card--expandable {
   /* [20] */
   align-items: flex-start;
   /* [26] */
   text-align: left;
   /* [26] */
 }
 
 .c-card--expandable .is-open .c-btn--card-icon {
   transform: rotateX(180deg);
   /* [23] */
 }
 
 .c-card__header-items {
   display: flex;
   flex-direction: row;
   justify-content: space-between;
 }
 
 @media (max-width: 720px) {
   .c-card__header-items {
     flex-direction: column-reverse;
     align-items: flex-start;
   }
   .c-card__header-items > *:first-child {
     margin-top: 24px;
     /* [21] */
   }
 }
 
 .c-card__expandable {
   display: flex;
   /* [24] */
   flex-direction: column;
   /* [24] */
 }
 
 .c-card__expandable-btn {
   align-self: flex-end;
   /* [25] */
 }
 
 /* ------------------------------------*\
     #LIST-UI
 \*------------------------------------ */
 /**
  * [1] Use flex to vertically center counter and text.
  * [2] Pseudo-element for the numbering of the ordered variant.
  */
 .c-list-ui {
   margin: 0;
   padding: 0;
   list-style: none;
   border-top: 1px solid #697677;
 }
 
 .c-list-ui li {
   display: block;
   margin-bottom: 0;
 }
 
 .c-list-ui--ordered {
   counter-reset: section;
 }
 
 .c-list-ui__item {
   padding: 24px 0;
   border-bottom: 1px solid #697677;
 }
 
 .c-list-ui--ordered .c-list-ui__item {
   display: flex;
   /* [1] */
   align-items: center;
   /* [1] */
 }
 
 .c-list-ui--ordered .c-list-ui__item::before {
   /* [2] */
   font-size: 1.625rem;
   /* stylelint-disable-line order/order */
   margin-right: 24px;
   content: counter(section, decimal-leading-zero);
   counter-increment: section;
 }
 
 @media (min-width: 721px) {
   .c-list-ui--ordered .c-list-ui__item::before {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-list-ui--ordered .c-list-ui__item::before {
     font-size: 2.25rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (max-width: 480px) {
   .c-list-ui--ordered .c-list-ui__item::before {
     margin-right: 16px;
   }
 }
 
 /* ------------------------------------*\
     #TAG
 \*------------------------------------ */
 /**
  * [1] Vertically align close-icon.
  */
 .c-tag {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   display: inline-flex;
   align-items: center;
   padding: 3px 8px;
   border: 1px solid #000000;
   background-color: #000000;
   color: #ffffff;
 }
 
 .c-tag--info {
   border: 1px solid #187085;
   background-color: #187085;
   color: #ffffff;
 }
 
 .c-tag--success {
   border: 1px solid #00783c;
   background-color: #00783c;
   color: #ffffff;
 }
 
 .c-tag--warning {
   border: 1px solid #efc938;
   background-color: #efc938;
   color: #1a1a1a;
 }
 
 .c-tag--error {
   border: 1px solid #ba2525;
   background-color: #ba2525;
   color: #ffffff;
 }
 
 .c-tag--positive {
   border: 1px solid #00783c;
   background-color: #00783c;
   color: #ffffff;
 }
 
 .c-tag--negative {
   border: 1px solid #ba2525;
   background-color: #ba2525;
   color: #ffffff;
 }
 
 .c-tag__label {
   display: block;
   min-height: 18px;
   font-weight: 400;
   line-height: 18px;
 }
 
 .c-tag__close {
   padding: 0;
   border: 0;
   background-color: transparent;
   position: relative;
   /* [1] */
   display: inline-flex;
   /* [1] */
   height: 18px;
   margin-left: 8px;
   color: inherit;
   cursor: pointer;
 }
 
 .c-tag__close:focus {
   outline: 0;
 }
 
 .c-tag__close::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   content: "\e955";
 }
 
 /* ------------------------------------*\
     #TAG-LIST
 \*------------------------------------ */
 /**
  * [1] Reset default list styles.
  * [2] Compensate vertical item spacing.
  * [3] Set font size and line height of list element to the same as the tags in
  *     order to prevent the (larger) base line height from adding spacing on top of
  *     the tags.
  */
 .c-tag-list {
   display: flex;
   flex-wrap: wrap;
   margin: 0;
   /* [1] */
   margin-top: -16px;
   /* [2] */
   padding: 0;
   /* [1] */
   list-style: none;
   /* [1] */
 }
 
 .c-tag-list li {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   /* [3] */
   margin-top: 16px;
   margin-bottom: 0;
   /* [1] */
 }
 
 .c-tag-list li:not(:last-child) {
   margin-right: 16px;
 }
 
 /* ------------------------------------*\
     #TOOLTIP
 \*------------------------------------ */
 /**
  * These are the styles exclusively for the tooltip link, i.e. the trigger for
  * the tooltip popup. The styles for the tooltip popup are handled by Tippy.js
  * to be found in the lib-folder .
  */
 .c-tooltip {
   padding: 0;
   border: 0;
   background-color: transparent;
   text-decoration: underline;
   color: inherit;
   cursor: pointer;
 }
 
 .c-tooltip:focus {
   outline: 0;
 }
 
 /* ------------------------------------*\
     #ITEM-TEASER
 \*------------------------------------ */
 /**
  * [1] Increase specificity, so the declaration also works on grey background.
  * [2] Force item wrapping.
  * [3] Rewrite styles to align icon aside to content.
  * [4] Block layout (stacked icon and content) at breakpoint.
  */
 .c-item-teaser {
   display: flex;
   flex-wrap: wrap;
   /* [2] */
   text-align: center;
 }
 
 .c-item-teaser > * {
   flex-grow: 1;
   flex-shrink: 1;
   flex-basis: 100%;
   /* [2] */
 }
 
 .c-item-teaser__icon {
   font-size: 3.375rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   margin-bottom: 8px;
 }
 
 .c-item-teaser__icon.c-item-teaser__icon {
   /* [1] */
   color: #1a1a1a;
 }
 
 .c-item-teaser--small .c-item-teaser__icon {
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
 }
 
 .c-item-teaser--inline .c-item-teaser__icon {
   /* [3] */
   align-self: baseline;
   margin-right: 24px;
   margin-bottom: 0;
 }
 
 .c-item-teaser__title {
   margin-bottom: 8px;
   line-height: 1.2;
 }
 
 @media (max-width: 720px) {
   .c-item-teaser__title {
     margin-bottom: 8px;
   }
 }
 
 .c-item-teaser--inline .c-item-teaser__title {
   margin-bottom: 16px;
 }
 
 .c-item-teaser--small.c-item-teaser--inline .c-item-teaser__title {
   margin-bottom: 8px;
 }
 
 .c-item-teaser__text {
   margin-bottom: 0;
 }
 
 .c-item-teaser__link {
   margin-top: 8px;
 }
 
 @media (max-width: 720px) {
   .c-item-teaser__link {
     margin-top: 8px;
   }
 }
 
 .c-item-teaser--inline {
   /* [3] */
   display: flex;
   justify-content: flex-start;
   flex-wrap: nowrap;
   align-items: flex-start;
   text-align: left;
 }
 
 .c-item-teaser--inline > * {
   flex-grow: 0;
   flex-shrink: 1;
   flex-basis: auto;
 }
 
 .c-item-teaser--block {
   display: flex;
   flex-wrap: wrap;
   /* [2] */
   text-align: center;
 }
 
 .c-item-teaser--block > * {
   flex-grow: 1;
   flex-shrink: 1;
   flex-basis: 100%;
   /* [2] */
 }
 
 @media (max-width: 720px) {
   .c-item-teaser--inline\@small-screen {
     /* [3] */
     display: flex;
     justify-content: flex-start;
     flex-wrap: nowrap;
     align-items: flex-start;
     text-align: left;
   }
   .c-item-teaser--inline\@small-screen > * {
     flex-grow: 0;
     flex-shrink: 1;
     flex-basis: auto;
   }
   .c-item-teaser--inline\@small-screen .c-item-teaser__icon {
     align-self: baseline;
     margin-right: 24px;
     margin-bottom: 0;
   }
   .c-item-teaser--inline\@small-screen .c-item-teaser__title {
     margin-bottom: 16px;
   }
   .c-item-teaser--block\@small-screen {
     /* [4] */
     display: flex;
     flex-wrap: wrap;
     /* [2] */
     text-align: center;
   }
   .c-item-teaser--block\@small-screen > * {
     flex-grow: 1;
     flex-shrink: 1;
     flex-basis: 100%;
     /* [2] */
   }
 }
 
 /* ------------------------------------*\
     #LOGO
 \*------------------------------------ */
 /**
  * [1] In addition to the logo in the HTML we have to assign the logo via CSS
  *     as a background image fallback for the former version without
  *     `img` or `picture` elements in the markup.
  * [2] To hide the fallback background image when the logo image is placed as
  *     `img` or `picture` in the HTML, an additional modifier class is necessary.
  *     To ensure compatibility with Bronson's multibrand development mode,
  *     the background image must not be removed, but must be pushed out of
  *     the container with 'background-position`. This will be reversed in
  *     `packages/bronson-default/styleguide/theme-overrides/styles/_sg-styles.scss`.
  * [3] Just apply a different logo for the background image fallback,
  *     if the small screen variant differs from the large screen variant.
  * [4] Defensively reset any transition, e.g. when `.c-logo` is on an `<a>`
  *     element, that is carrying any transition.
  * [5] Convert `.c-logo__image` to a block-level element to remove unwanted
  *     spacing around the image.
  * [6] Fix wrong SVG height in IE11 (Windows 8.1)
  */
 .c-logo {
   display: block;
   width: 140px;
   height: 63px;
   background-image: url($cdnUrl + "/img/logo-cupra.svg");
   /* [1] */
   background-size: 100%;
   transition: none;
   /* [4] */
 }
 
 @media (max-width: 720px) {
   .c-logo {
     width: 89px;
     height: 40px;
   }
 }
 
 .c-logo--has-image {
   background-position: 999px;
   /* [2] */
   background-repeat: no-repeat;
   /* [2] */
 }
 
 .c-logo__image {
   display: block;
   /* [5] */
   max-height: 100%;
   /* [6] */
 }
 
 /**
  * [1] Overwrite default to make sure these logos can be wide as they are. No
        need to set images width for responsive positioning like for vehicle
        logos in VW6.
  * [2] Loop through the map to generate the different modifiers and add their
        specific logos as background-image.
  * [3] We need to extend the two configurable logo sizes for Generic.
  * [4] If width is already set to avoid potential image distortions.
  * [5] Make sure to use full image-width.
  * [6] Set a responsive logo width to correctly display the default logo as
  *     background image.
  */
 .c-logo {
   width: 140px;
   display: inline-block;
   /* [1] */
 }
 
 @media (max-width: 720px) {
   .c-logo {
     width: 89px;
   }
 }
 
 .c-logo--bentley {
   /* [2] */
   width: 116px;
   background-image: url($cdnUrl + "/img/logo-bentley.svg");
   /* stylelint-disable-line function-url-quotes */
 }
 
 @media (max-width: 720px) {
   .c-logo--bentley {
     width: 74px;
   }
 }
 
 .c-logo--cupra {
   /* [2] */
   width: 140px;
   background-image: url($cdnUrl + "/img/logo-cupra.svg");
   /* stylelint-disable-line function-url-quotes */
 }
 
 @media (max-width: 720px) {
   .c-logo--cupra {
     width: 89px;
   }
 }
 
 .c-logo--lamborghini {
   /* [2] */
   width: 56px;
   background-image: url($cdnUrl + "/img/logo-lamborghini.png");
   /* stylelint-disable-line function-url-quotes */
 }
 
 @media (max-width: 720px) {
   .c-logo--lamborghini {
     width: 36px;
   }
 }
 
 .c-logo--porsche {
   /* [2] */
   width: 98px;
   background-image: url($cdnUrl + "/img/logo-porsche.png");
   /* stylelint-disable-line function-url-quotes */
 }
 
 @media (max-width: 720px) {
   .c-logo--porsche {
     width: 62px;
   }
 }
 
 .c-logo--dasweltauto {
   /* [2] */
   width: 243px;
   background-image: url($cdnUrl + "/img/logo-dasweltauto.svg");
   /* stylelint-disable-line function-url-quotes */
 }
 
 @media (max-width: 720px) {
   .c-logo--dasweltauto {
     width: 154px;
   }
 }
 
 .c-logo--dasweltauto-es {
   /* [2] */
   width: 243px;
   background-image: url($cdnUrl + "/img/logo-dasweltauto-es.svg");
   /* stylelint-disable-line function-url-quotes */
 }
 
 @media (max-width: 720px) {
   .c-logo--dasweltauto-es {
     width: 154px;
   }
 }
 
 .c-logo__image {
   height: 63px;
   width: auto;
   /* [4] */
   max-width: none;
   /* [5] */
 }
 
 @media (max-width: 720px) {
   .c-logo__image {
     height: 40px;
   }
 }
 
 /* ------------------------------------*\
     #VERTICAL-BAR
 \*------------------------------------ */
 /**
  * This component is VW-specific, so we hide it here and override it
  * in the VW package.
  */
 .c-vertical-bar {
   display: none;
 }
 
 /* ------------------------------------*\
     #PAGINATION
 \*------------------------------------ */
 /**
  * [1] Stepper icon should have same line-height as .c-pagination__link text.
  */
 .c-pagination__list {
   margin: 0;
   padding: 0;
   list-style: none;
   display: flex;
   flex-wrap: wrap;
   align-items: center;
 }
 
 .c-pagination__list li {
   display: block;
   margin-bottom: 0;
 }
 
 .c-pagination__link {
   display: block;
   margin: 0 0;
   padding: 4px 12px;
   text-decoration: none;
   background: #ffffff;
   color: #1a1a1a;
 }
 
 .c-pagination__link:not([href]) {
   cursor: inherit;
 }
 
 .c-pagination__link:not(.is-disabled):not(.is-active):hover, .c-pagination__link:not(.is-disabled):not(.is-active):focus {
   background: #1a1a1a;
   color: #ffffff;
 }
 
 .c-pagination__link.is-active {
   background: #1a1a1a;
   color: #ffffff;
 }
 
 .c-pagination__link.is-disabled {
   background: #ffffff;
   color: #f2f2f2;
 }
 
 .c-pagination__link[class*="c-pagination__link--stepper-"]::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: inherit;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   /* [1] */
   font-size: inherit;
 }
 
 .c-pagination__link[class*="c-pagination__link--stepper-"].is-disabled {
   color: #f2f2f2;
   opacity: 0.5;
 }
 
 .c-pagination__link[class*="c-pagination__link--stepper-"].c-pagination__link--stepper-prev::before {
   content: "\e945";
 }
 
 .c-pagination__link[class*="c-pagination__link--stepper-"].c-pagination__link--stepper-next::before {
   content: "\e946";
 }
 
 /* ------------------------------------*\
     #LICENSE-PLATE (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #LICENSE-PLATE
 \*------------------------------------ */
 /**
  * [1] Make all license plates except "xsmall" variant have the same size for <=s breakpoint.
  * [2] Modify license plate with a country-specific background for Netherlands.
  * [3] Prevent the underlining of the country code when it is inside of an abbr element.
  * [4] Avoid sharp edge overlapping rounded corner on horizontal-strip.
  */
 .c-license-plate {
   display: inline-flex;
   border: 1px solid #c9c9c9;
   border-radius: 3px;
   font-weight: 400;
   background-color: #ffffff;
 }
 
 .c-license-plate--large {
   height: 40px;
   min-width: 200px;
   font-size: 23px;
   /* [1] */
 }
 
 @media (max-width: 720px) {
   .c-license-plate--large {
     height: 32px;
     min-width: 140px;
     font-size: 16px;
   }
 }
 
 .c-license-plate--medium {
   height: 40px;
   min-width: 160px;
   font-size: 18px;
   /* [1] */
 }
 
 @media (max-width: 720px) {
   .c-license-plate--medium {
     height: 32px;
     min-width: 140px;
     font-size: 16px;
   }
 }
 
 .c-license-plate--small {
   height: 32px;
   min-width: 140px;
   font-size: 16px;
   /* [1] */
 }
 
 @media (max-width: 720px) {
   .c-license-plate--small {
     height: 32px;
     min-width: 140px;
     font-size: 16px;
   }
 }
 
 .c-license-plate--xsmall {
   height: 24px;
   min-width: 110px;
   font-size: 12px;
 }
 
 .c-license-plate.c-license-plate--nl {
   /* [2] */
   background-color: #f7ca45;
 }
 
 .c-license-plate.c-license-plate--jp {
   line-height: 1;
   /* [2] */
 }
 
 .c-license-plate.c-license-plate--jp.c-license-plate--large {
   font-size: 21px;
   /* [1] */
 }
 
 @media (max-width: 720px) {
   .c-license-plate.c-license-plate--jp.c-license-plate--large {
     height: 32px;
     min-width: auto;
     font-size: 16px;
   }
 }
 
 .c-license-plate.c-license-plate--jp.c-license-plate--medium {
   height: 40px;
   min-width: auto;
   font-size: 21px;
   /* [1] */
 }
 
 @media (max-width: 720px) {
   .c-license-plate.c-license-plate--jp.c-license-plate--medium {
     height: 32px;
     min-width: auto;
     font-size: 16px;
   }
 }
 
 .c-license-plate.c-license-plate--jp.c-license-plate--small {
   height: 32px;
   min-width: auto;
   font-size: 16px;
 }
 
 .c-license-plate.c-license-plate--jp.c-license-plate--xsmall {
   height: 32px;
   min-width: auto;
   font-size: 12px;
 }
 
 .c-license-plate abbr {
   text-decoration: none;
   /* [3] */
 }
 
 .c-license-plate__registration-number {
   flex-grow: 1;
   flex-shrink: 0;
   flex-basis: auto;
   -ms-grid-row-align: center;
   align-self: center;
   padding: 0 0.2em;
   font-family: inherit;
   text-align: center;
   white-space: nowrap;
 }
 
 .c-license-plate--jp .c-license-plate__registration-number {
   display: flex;
   flex-direction: column;
   margin-top: 0;
   padding-right: 4px;
   padding-left: 0;
   font-weight: 400;
   text-align: left;
 }
 
 .c-license-plate__registration-top-bar {
   margin-bottom: 2px;
   font-weight: 400;
 }
 
 .c-license-plate--large .c-license-plate__registration-top-bar {
   font-size: 9px;
 }
 
 @media (max-width: 720px) {
   .c-license-plate--large .c-license-plate__registration-top-bar {
     font-size: 7px;
   }
 }
 
 .c-license-plate--medium .c-license-plate__registration-top-bar {
   font-size: 9px;
 }
 
 @media (max-width: 720px) {
   .c-license-plate--medium .c-license-plate__registration-top-bar {
     font-size: 7px;
   }
 }
 
 .c-license-plate--small .c-license-plate__registration-top-bar {
   font-size: 7px;
 }
 
 .c-license-plate--xsmall .c-license-plate__registration-top-bar {
   font-size: 7px;
 }
 
 .c-license-plate__horizontal-strip {
   display: flex;
   flex-direction: column;
   justify-content: center;
   -ms-grid-row-align: stretch;
   align-self: stretch;
   overflow: hidden;
   /* [4] */
   text-align: center;
 }
 
 .c-license-plate--large .c-license-plate__horizontal-strip {
   min-width: 30px;
   font-size: 18px;
 }
 
 @media (max-width: 720px) {
   .c-license-plate--large .c-license-plate__horizontal-strip {
     min-width: 20px;
     font-size: 12px;
   }
 }
 
 .c-license-plate--medium .c-license-plate__horizontal-strip {
   min-width: 24px;
   font-size: 14px;
 }
 
 @media (max-width: 720px) {
   .c-license-plate--medium .c-license-plate__horizontal-strip {
     min-width: 20px;
     font-size: 12px;
   }
 }
 
 .c-license-plate--small .c-license-plate__horizontal-strip {
   min-width: 20px;
   font-size: 12px;
 }
 
 @media (max-width: 720px) {
   .c-license-plate--small .c-license-plate__horizontal-strip {
     min-width: 20px;
     font-size: 12px;
   }
 }
 
 .c-license-plate--xsmall .c-license-plate__horizontal-strip {
   min-width: 16px;
   font-size: 10px;
 }
 
 .c-license-plate__horizontal-strip.c-license-plate__horizontal-strip--eu {
   background-color: #003399;
 }
 
 .c-license-plate__horizontal-strip.c-license-plate__horizontal-strip--jp {
   align-items: center;
   justify-content: flex-end;
   padding-bottom: 1em;
 }
 
 .c-license-plate--large .c-license-plate__horizontal-strip.c-license-plate__horizontal-strip--jp {
   min-width: 18px;
   font-size: 9px;
 }
 
 @media (max-width: 720px) {
   .c-license-plate--large .c-license-plate__horizontal-strip.c-license-plate__horizontal-strip--jp {
     min-width: 14px;
     font-size: 7px;
   }
 }
 
 .c-license-plate--medium .c-license-plate__horizontal-strip.c-license-plate__horizontal-strip--jp {
   min-width: 18px;
   font-size: 9px;
 }
 
 @media (max-width: 720px) {
   .c-license-plate--medium .c-license-plate__horizontal-strip.c-license-plate__horizontal-strip--jp {
     min-width: 14px;
     font-size: 7px;
   }
 }
 
 .c-license-plate--small .c-license-plate__horizontal-strip.c-license-plate__horizontal-strip--jp {
   min-width: 14px;
   font-size: 7px;
 }
 
 .c-license-plate--xsmall .c-license-plate__horizontal-strip.c-license-plate__horizontal-strip--jp {
   min-width: 14px;
   font-size: 7px;
 }
 
 .c-license-plate__eu-stars {
   fill: #ffcc00;
   line-height: 1;
 }
 
 .c-license-plate__eu-stars svg {
   width: 0.875em;
   height: 0.875em;
 }
 
 .c-license-plate__country-code {
   line-height: 1;
   color: #ffffff;
 }
 
 /* ------------------------------------*\
     #SITE-NAV
 \*------------------------------------ */
 /**
  * [1] If there is a `.site-nav--right`, preserve space between the two navs.
  * [3] Align the toggle to the right side.
  * [4] Center `.c-site-nav__toggle-icon` and `.c-site-nav__toggle-close-label`.
  * [5] Hide the label only visibly and not from screen readers. Note that the
  *     label is set to `display: none` when the menu is not expanded since the
  *     label is used exclusively for the close action.
  * [6] We can either use an icon from the icon font or use a CSS-built triangle.
  *     Control that with the `$site-nav-link-icon-is-custom` feature flag.
  * [7] Always set the value of `flex-direction` to the opposite value if
  *     `.is-reversed` is used and set it to `row` at the breakpoint.
  * [8] Add spacing between label and icon, depending on the default position
  *      of the icon (before or after the label).
  * [9] Make sure the site nav dropdown is aligned to the `.c-site-nav__item.`
  *     and is not overlapping the header.
  * [10] Place right (last) group on top when collapsed.
  * [11] Place list item on top when collapsed.
  * [12] Reset default list style. Similar to `list-bare` mixin but only
  *      necessary styles for this component and with less generic selectors
  *      and output.
  * [13] Reset default `<button>` styles.
  * [14] If `.c-site-nav__link` is a `button` (triggering a dropdown), hide the
  *      focus outline if the dropdown gets expanded. The focus outline visually
  *      differentiates buttons from links when using a pointing device (such as
  *      a mouse) â€“ which is not wanted here. The transition delay is necessary
  *      to avoid a short flickering of the outline. When navigating by keyboard
  *      the focus outline should be visible for accessibility reasons.
  * [15] Some brands (e.g. VW6) don't need flex-direction.
  * [16] Set margin for reversed link icons, depending on the default position
  *      of the icon (before or after the label). The selector had to be
  *      duplicated because the `site-nav-breakpoint` mixin does not work with
  *      nested selector referencing parent (`&`).
 */
 .c-site-nav {
   display: flex;
   width: 100%;
   height: 100px;
 }
 
 @media (max-width: 720px) {
   .c-site-nav {
     height: 60px;
   }
 }
 
 .c-site-nav__toggle {
   padding: 0;
   border: 0;
   background-color: transparent;
   display: none;
   margin-left: auto;
   /* [3] */
 }
 
 .c-site-nav__toggle:focus {
   outline: 0;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__toggle {
     display: flex;
     /* [4] */
     justify-content: center;
     align-items: center;
     /* [4] */
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__toggle {
     display: flex;
     /* [4] */
     justify-content: center;
     align-items: center;
     /* [4] */
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__toggle {
     display: flex;
     /* [4] */
     justify-content: center;
     align-items: center;
     /* [4] */
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__toggle {
     display: flex;
     /* [4] */
     justify-content: center;
     align-items: center;
     /* [4] */
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__toggle {
     display: flex;
     /* [4] */
     justify-content: center;
     align-items: center;
     /* [4] */
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__toggle {
     display: flex;
     /* [4] */
     justify-content: center;
     align-items: center;
     /* [4] */
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__toggle {
     display: flex;
     /* [4] */
     justify-content: center;
     align-items: center;
     /* [4] */
   }
 }
 
 .c-site-nav__toggle-close-label {
   display: none;
 }
 
 .c-site-nav__toggle-icon {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   color: currentColor;
 }
 
 .c-site-nav__toggle-icon::before {
   content: "\e94d";
 }
 
 .c-site-nav__toggle[aria-expanded='true'] .c-site-nav__toggle-icon ~ .c-site-nav__toggle-close-label {
   display: block;
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
   /* [5] */
 }
 
 .c-site-nav__panel {
   display: flex;
   width: 100%;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__panel {
     display: none;
     position: absolute;
     top: 100%;
     right: 0;
   }
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__panel[aria-hidden='false'] {
     display: flex;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__panel {
     display: none;
     position: absolute;
     top: 100%;
     right: 0;
   }
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__panel[aria-hidden='false'] {
     display: flex;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__panel {
     display: none;
     position: absolute;
     top: 100%;
     right: 0;
   }
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__panel[aria-hidden='false'] {
     display: flex;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__panel {
     display: none;
     position: absolute;
     top: 100%;
     right: 0;
   }
   .c-site-nav.c-site-nav--break\@l .c-site-nav__panel[aria-hidden='false'] {
     display: flex;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__panel {
     display: none;
     position: absolute;
     top: 100%;
     right: 0;
   }
   .c-site-nav.c-site-nav--break\@m .c-site-nav__panel[aria-hidden='false'] {
     display: flex;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__panel {
     display: none;
     position: absolute;
     top: 100%;
     right: 0;
   }
   .c-site-nav.c-site-nav--break\@s .c-site-nav__panel[aria-hidden='false'] {
     display: flex;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__panel {
     display: none;
     position: absolute;
     top: 100%;
     right: 0;
   }
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__panel[aria-hidden='false'] {
     display: flex;
   }
 }
 
 .c-site-nav__navs {
   display: flex;
   justify-content: space-between;
   width: 100%;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__navs {
     padding-top: 24px;
     padding-left: 32px;
     padding-right: 32px;
     padding-bottom: 24px;
     flex-direction: column;
     /* [15] */
     background-color: #1a1a1a;
   }
 }
 
 @media (max-width: 720px) and (max-width: 960px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__navs {
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) and (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__navs {
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 720px) and (max-width: 480px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__navs {
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__navs {
     padding-top: 24px;
     padding-left: 32px;
     padding-right: 32px;
     padding-bottom: 24px;
     flex-direction: column;
     /* [15] */
     background-color: #1a1a1a;
   }
 }
 
 @media (max-width: 1920px) and (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__navs {
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 1920px) and (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__navs {
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 1920px) and (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__navs {
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__navs {
     padding-top: 24px;
     padding-left: 32px;
     padding-right: 32px;
     padding-bottom: 24px;
     flex-direction: column;
     /* [15] */
     background-color: #1a1a1a;
   }
 }
 
 @media (max-width: 1600px) and (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__navs {
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 1600px) and (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__navs {
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 1600px) and (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__navs {
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__navs {
     padding-top: 24px;
     padding-left: 32px;
     padding-right: 32px;
     padding-bottom: 24px;
     flex-direction: column;
     /* [15] */
     background-color: #1a1a1a;
   }
 }
 
 @media (max-width: 1280px) and (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__navs {
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 1280px) and (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__navs {
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 1280px) and (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__navs {
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__navs {
     padding-top: 24px;
     padding-left: 32px;
     padding-right: 32px;
     padding-bottom: 24px;
     flex-direction: column;
     /* [15] */
     background-color: #1a1a1a;
   }
 }
 
 @media (max-width: 960px) and (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__navs {
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 960px) and (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__navs {
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 960px) and (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__navs {
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__navs {
     padding-top: 24px;
     padding-left: 32px;
     padding-right: 32px;
     padding-bottom: 24px;
     flex-direction: column;
     /* [15] */
     background-color: #1a1a1a;
   }
 }
 
 @media (max-width: 720px) and (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__navs {
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) and (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__navs {
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 720px) and (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__navs {
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__navs {
     padding-top: 24px;
     padding-left: 32px;
     padding-right: 32px;
     padding-bottom: 24px;
     flex-direction: column;
     /* [15] */
     background-color: #1a1a1a;
   }
 }
 
 @media (max-width: 480px) and (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__navs {
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 480px) and (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__navs {
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 480px) and (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__navs {
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 .c-site-nav__nav {
   display: flex;
   align-items: center;
   margin: 0;
   /* [12] */
   padding: 0;
   /* [12] */
   list-style: none;
   /* [12] */
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__nav {
     flex-direction: column;
     align-items: flex-end;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__nav {
     flex-direction: column;
     align-items: flex-end;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__nav {
     flex-direction: column;
     align-items: flex-end;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__nav {
     flex-direction: column;
     align-items: flex-end;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__nav {
     flex-direction: column;
     align-items: flex-end;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__nav {
     flex-direction: column;
     align-items: flex-end;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__nav {
     flex-direction: column;
     align-items: flex-end;
   }
 }
 
 .c-site-nav__nav:not(:last-child) {
   margin-right: 16px;
   /* [1] */
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__nav:not(:last-child) {
     margin-right: 0;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__nav:not(:last-child) {
     margin-right: 0;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__nav:not(:last-child) {
     margin-right: 0;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__nav:not(:last-child) {
     margin-right: 0;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__nav:not(:last-child) {
     margin-right: 0;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__nav:not(:last-child) {
     margin-right: 0;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__nav:not(:last-child) {
     margin-right: 0;
   }
 }
 
 .c-site-nav__item.c-site-nav__item {
   position: relative;
   /* [9] */
   display: flex;
   align-items: center;
   margin-bottom: 0;
   /* [12] */
 }
 
 @media (min-width: 721px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__item.c-site-nav__item {
     height: 100%;
     /* [9] */
   }
 }
 
 @media (min-width: 1921px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__item.c-site-nav__item {
     height: 100%;
     /* [9] */
   }
 }
 
 @media (min-width: 1601px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__item.c-site-nav__item {
     height: 100%;
     /* [9] */
   }
 }
 
 @media (min-width: 1281px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__item.c-site-nav__item {
     height: 100%;
     /* [9] */
   }
 }
 
 @media (min-width: 961px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__item.c-site-nav__item {
     height: 100%;
     /* [9] */
   }
 }
 
 @media (min-width: 721px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__item.c-site-nav__item {
     height: 100%;
     /* [9] */
   }
 }
 
 @media (min-width: 481px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__item.c-site-nav__item {
     height: 100%;
     /* [9] */
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__item.c-site-nav__item {
     flex-direction: column;
     width: 100%;
     border-bottom: 1px solid #ffffff;
   }
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__item.c-site-nav__item.c-site-nav__item--top-at-breakpoint {
     order: -1;
     /* [11] */
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__item.c-site-nav__item {
     flex-direction: column;
     width: 100%;
     border-bottom: 1px solid #ffffff;
   }
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__item.c-site-nav__item.c-site-nav__item--top-at-breakpoint {
     order: -1;
     /* [11] */
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__item.c-site-nav__item {
     flex-direction: column;
     width: 100%;
     border-bottom: 1px solid #ffffff;
   }
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__item.c-site-nav__item.c-site-nav__item--top-at-breakpoint {
     order: -1;
     /* [11] */
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__item.c-site-nav__item {
     flex-direction: column;
     width: 100%;
     border-bottom: 1px solid #ffffff;
   }
   .c-site-nav.c-site-nav--break\@l .c-site-nav__item.c-site-nav__item.c-site-nav__item--top-at-breakpoint {
     order: -1;
     /* [11] */
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__item.c-site-nav__item {
     flex-direction: column;
     width: 100%;
     border-bottom: 1px solid #ffffff;
   }
   .c-site-nav.c-site-nav--break\@m .c-site-nav__item.c-site-nav__item.c-site-nav__item--top-at-breakpoint {
     order: -1;
     /* [11] */
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__item.c-site-nav__item {
     flex-direction: column;
     width: 100%;
     border-bottom: 1px solid #ffffff;
   }
   .c-site-nav.c-site-nav--break\@s .c-site-nav__item.c-site-nav__item.c-site-nav__item--top-at-breakpoint {
     order: -1;
     /* [11] */
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__item.c-site-nav__item {
     flex-direction: column;
     width: 100%;
     border-bottom: 1px solid #ffffff;
   }
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__item.c-site-nav__item.c-site-nav__item--top-at-breakpoint {
     order: -1;
     /* [11] */
   }
 }
 
 .c-site-nav__item.c-site-nav__item:not(:last-child) {
   margin-right: 16px;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__item.c-site-nav__item:not(:last-child) {
     margin-right: 0;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__item.c-site-nav__item:not(:last-child) {
     margin-right: 0;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__item.c-site-nav__item:not(:last-child) {
     margin-right: 0;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__item.c-site-nav__item:not(:last-child) {
     margin-right: 0;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__item.c-site-nav__item:not(:last-child) {
     margin-right: 0;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__item.c-site-nav__item:not(:last-child) {
     margin-right: 0;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__item.c-site-nav__item:not(:last-child) {
     margin-right: 0;
   }
 }
 
 .c-site-nav__link {
   padding: 0;
   border: 0;
   background-color: transparent;
   /* [13] */
   display: flex;
   align-items: center;
   flex-direction: row;
   text-decoration: none;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__link {
     padding-top: 8px;
     padding-left: 16px;
     padding-right: 16px;
     padding-bottom: 8px;
     flex-direction: row;
     /* [7] */
     width: 100%;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__link {
     padding-top: 8px;
     padding-left: 16px;
     padding-right: 16px;
     padding-bottom: 8px;
     flex-direction: row;
     /* [7] */
     width: 100%;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__link {
     padding-top: 8px;
     padding-left: 16px;
     padding-right: 16px;
     padding-bottom: 8px;
     flex-direction: row;
     /* [7] */
     width: 100%;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__link {
     padding-top: 8px;
     padding-left: 16px;
     padding-right: 16px;
     padding-bottom: 8px;
     flex-direction: row;
     /* [7] */
     width: 100%;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__link {
     padding-top: 8px;
     padding-left: 16px;
     padding-right: 16px;
     padding-bottom: 8px;
     flex-direction: row;
     /* [7] */
     width: 100%;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__link {
     padding-top: 8px;
     padding-left: 16px;
     padding-right: 16px;
     padding-bottom: 8px;
     flex-direction: row;
     /* [7] */
     width: 100%;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__link {
     padding-top: 8px;
     padding-left: 16px;
     padding-right: 16px;
     padding-bottom: 8px;
     flex-direction: row;
     /* [7] */
     width: 100%;
   }
 }
 
 .c-site-nav__link.is-reversed {
   flex-direction: row-reverse;
   /* [7] */
 }
 
 button.c-site-nav__link {
   outline-width: 0;
   /* [14] */
 }
 
 button.c-site-nav__link:focus {
   outline-width: initial;
   /* [14] */
   transition: 0s outline 0.2s;
   /* [14] */
 }
 
 button.c-site-nav__link[aria-expanded="true"]:focus {
   outline-width: 0;
   /* [14] */
   transition-delay: 0s;
   /* [14] */
 }
 
 .c-site-nav__link-label {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 24px;
   font-weight: 400;
   color: #1a1a1a;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 .c-site-nav__link:hover .c-site-nav__link-label,
 .c-site-nav__link:focus .c-site-nav__link-label {
   color: #1a1a1a;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__link:hover .c-site-nav__link-label, .c-site-nav:not([class*="c-site-nav--break@"])
   .c-site-nav__link:focus .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__link:hover .c-site-nav__link-label, .c-site-nav.c-site-nav--break\@xxl
   .c-site-nav__link:focus .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__link:hover .c-site-nav__link-label, .c-site-nav.c-site-nav--break\@xl
   .c-site-nav__link:focus .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__link:hover .c-site-nav__link-label, .c-site-nav.c-site-nav--break\@l
   .c-site-nav__link:focus .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__link:hover .c-site-nav__link-label, .c-site-nav.c-site-nav--break\@m
   .c-site-nav__link:focus .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__link:hover .c-site-nav__link-label, .c-site-nav.c-site-nav--break\@s
   .c-site-nav__link:focus .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__link:hover .c-site-nav__link-label, .c-site-nav.c-site-nav--break\@xs
   .c-site-nav__link:focus .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 .c-site-nav__link.is-active .c-site-nav__link-label {
   color: #1a1a1a;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__link.is-active .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__link.is-active .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__link.is-active .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__link.is-active .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__link.is-active .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__link.is-active .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__link.is-active .c-site-nav__link-label {
     color: #ffffff;
   }
 }
 
 .c-site-nav__link-icon {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   display: flex;
   /* [8] */
   margin-left: 0;
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   color: #1a1a1a;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 .c-site-nav__link-icon::after {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   content: "\e944";
 }
 
 .c-site-nav__link:hover .c-site-nav__link-icon,
 .c-site-nav__link:focus .c-site-nav__link-icon {
   color: #1a1a1a;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__link:hover .c-site-nav__link-icon, .c-site-nav:not([class*="c-site-nav--break@"])
   .c-site-nav__link:focus .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__link:hover .c-site-nav__link-icon, .c-site-nav.c-site-nav--break\@xxl
   .c-site-nav__link:focus .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__link:hover .c-site-nav__link-icon, .c-site-nav.c-site-nav--break\@xl
   .c-site-nav__link:focus .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__link:hover .c-site-nav__link-icon, .c-site-nav.c-site-nav--break\@l
   .c-site-nav__link:focus .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__link:hover .c-site-nav__link-icon, .c-site-nav.c-site-nav--break\@m
   .c-site-nav__link:focus .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__link:hover .c-site-nav__link-icon, .c-site-nav.c-site-nav--break\@s
   .c-site-nav__link:focus .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__link:hover .c-site-nav__link-icon, .c-site-nav.c-site-nav--break\@xs
   .c-site-nav__link:focus .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 .c-site-nav__link.is-active .c-site-nav__link-icon {
   color: #1a1a1a;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__link.is-active .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__link.is-active .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__link.is-active .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__link.is-active .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__link.is-active .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__link.is-active .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__link.is-active .c-site-nav__link-icon {
     color: #ffffff;
   }
 }
 
 /* stylelint-disable-next-line no-duplicate-selectors */
 .c-site-nav__link.is-reversed {
   /* [16] */
 }
 
 @media (min-width: 721px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__link.is-reversed .c-site-nav__link-icon {
     margin-right: 0;
     margin-left: 0;
   }
 }
 
 @media (min-width: 1921px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__link.is-reversed .c-site-nav__link-icon {
     margin-right: 0;
     margin-left: 0;
   }
 }
 
 @media (min-width: 1601px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__link.is-reversed .c-site-nav__link-icon {
     margin-right: 0;
     margin-left: 0;
   }
 }
 
 @media (min-width: 1281px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__link.is-reversed .c-site-nav__link-icon {
     margin-right: 0;
     margin-left: 0;
   }
 }
 
 @media (min-width: 961px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__link.is-reversed .c-site-nav__link-icon {
     margin-right: 0;
     margin-left: 0;
   }
 }
 
 @media (min-width: 721px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__link.is-reversed .c-site-nav__link-icon {
     margin-right: 0;
     margin-left: 0;
   }
 }
 
 @media (min-width: 481px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__link.is-reversed .c-site-nav__link-icon {
     margin-right: 0;
     margin-left: 0;
   }
 }
 
 /* ------------------------------------*\
     #SITE-NAV-DROPDOWN
 \*------------------------------------ */
 /**
  * [1] If there is more then one `.c-site-nav__nav`, always align the dropdown
  *     of the last `.c-site-nav__nav` to the right.
  * [2] Make the transition just available for viewport width above breakpoint.
  * [3] Change the list's position for fly-in and fly-out effects.
  * [4] At breakpoint, the dropdown always has full width.
  * [5] Defensively reset any default list-style properties.
  */
 .c-site-nav-dropdown {
   max-height: 0;
   visibility: hidden;
   overflow: hidden;
 }
 
 @media (min-width: 721px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav-dropdown {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
     position: absolute;
     top: 100%;
     left: 0;
     width: 312px;
   }
 }
 
 @media (min-width: 1921px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav-dropdown {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
     position: absolute;
     top: 100%;
     left: 0;
     width: 312px;
   }
 }
 
 @media (min-width: 1601px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav-dropdown {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
     position: absolute;
     top: 100%;
     left: 0;
     width: 312px;
   }
 }
 
 @media (min-width: 1281px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav-dropdown {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
     position: absolute;
     top: 100%;
     left: 0;
     width: 312px;
   }
 }
 
 @media (min-width: 961px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav-dropdown {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
     position: absolute;
     top: 100%;
     left: 0;
     width: 312px;
   }
 }
 
 @media (min-width: 721px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav-dropdown {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
     position: absolute;
     top: 100%;
     left: 0;
     width: 312px;
   }
 }
 
 @media (min-width: 481px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav-dropdown {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
     position: absolute;
     top: 100%;
     left: 0;
     width: 312px;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav-dropdown {
     width: 100%;
     /* [4] */
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav-dropdown {
     width: 100%;
     /* [4] */
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav-dropdown {
     width: 100%;
     /* [4] */
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav-dropdown {
     width: 100%;
     /* [4] */
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav-dropdown {
     width: 100%;
     /* [4] */
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav-dropdown {
     width: 100%;
     /* [4] */
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav-dropdown {
     width: 100%;
     /* [4] */
   }
 }
 
 .c-site-nav-dropdown[aria-hidden='false'] {
   max-height: none;
   visibility: visible;
 }
 
 @media (min-width: 721px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav__nav:last-child:not(:only-child) .c-site-nav-dropdown {
     right: 0;
     /* [1] */
     left: auto;
     /* [1] */
   }
 }
 
 @media (min-width: 1921px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav__nav:last-child:not(:only-child) .c-site-nav-dropdown {
     right: 0;
     /* [1] */
     left: auto;
     /* [1] */
   }
 }
 
 @media (min-width: 1601px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav__nav:last-child:not(:only-child) .c-site-nav-dropdown {
     right: 0;
     /* [1] */
     left: auto;
     /* [1] */
   }
 }
 
 @media (min-width: 1281px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav__nav:last-child:not(:only-child) .c-site-nav-dropdown {
     right: 0;
     /* [1] */
     left: auto;
     /* [1] */
   }
 }
 
 @media (min-width: 961px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav__nav:last-child:not(:only-child) .c-site-nav-dropdown {
     right: 0;
     /* [1] */
     left: auto;
     /* [1] */
   }
 }
 
 @media (min-width: 721px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav__nav:last-child:not(:only-child) .c-site-nav-dropdown {
     right: 0;
     /* [1] */
     left: auto;
     /* [1] */
   }
 }
 
 @media (min-width: 481px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav__nav:last-child:not(:only-child) .c-site-nav-dropdown {
     right: 0;
     /* [1] */
     left: auto;
     /* [1] */
   }
 }
 
 .c-site-nav-dropdown__list {
   margin: 0;
   /* [5] */
   padding: 8px 24px;
   transform: translateY(-100%);
   /* [3] */
   list-style: none;
   /* [5] */
   background-color: #1a1a1a;
 }
 
 @media (min-width: 721px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav-dropdown__list {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
   }
 }
 
 @media (min-width: 1921px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav-dropdown__list {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
   }
 }
 
 @media (min-width: 1601px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav-dropdown__list {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
   }
 }
 
 @media (min-width: 1281px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav-dropdown__list {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
   }
 }
 
 @media (min-width: 961px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav-dropdown__list {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
   }
 }
 
 @media (min-width: 721px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav-dropdown__list {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
   }
 }
 
 @media (min-width: 481px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav-dropdown__list {
     transition-property: all;
     transition-duration: 250ms;
     transition-timing-function: ease;
     /* [2] */
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav-dropdown__list {
     padding-top: 0;
     padding-left: 24px;
     padding-right: 24px;
     padding-bottom: 0;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav-dropdown__list {
     padding-top: 0;
     padding-left: 24px;
     padding-right: 24px;
     padding-bottom: 0;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav-dropdown__list {
     padding-top: 0;
     padding-left: 24px;
     padding-right: 24px;
     padding-bottom: 0;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav-dropdown__list {
     padding-top: 0;
     padding-left: 24px;
     padding-right: 24px;
     padding-bottom: 0;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav-dropdown__list {
     padding-top: 0;
     padding-left: 24px;
     padding-right: 24px;
     padding-bottom: 0;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav-dropdown__list {
     padding-top: 0;
     padding-left: 24px;
     padding-right: 24px;
     padding-bottom: 0;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav-dropdown__list {
     padding-top: 0;
     padding-left: 24px;
     padding-right: 24px;
     padding-bottom: 0;
   }
 }
 
 .c-site-nav-dropdown[aria-hidden='false'] .c-site-nav-dropdown__list {
   transform: translateY(0);
   /* [3] */
 }
 
 .c-site-nav-dropdown__title {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   display: block;
   padding: 8px 24px;
   font-weight: 700;
   color: #ffffff;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav-dropdown__title {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav-dropdown__title {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav-dropdown__title {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav-dropdown__title {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav-dropdown__title {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav-dropdown__title {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav-dropdown__title {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 .c-site-nav-dropdown__item {
   border-bottom: 1px solid #495651;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav-dropdown__item:last-child {
     border: 0;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav-dropdown__item:last-child {
     border: 0;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav-dropdown__item:last-child {
     border: 0;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav-dropdown__item:last-child {
     border: 0;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav-dropdown__item:last-child {
     border: 0;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav-dropdown__item:last-child {
     border: 0;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav-dropdown__item:last-child {
     border: 0;
   }
 }
 
 .c-site-nav-dropdown__link {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   display: block;
   padding: 8px 24px;
   font-weight: 700;
   text-decoration: none;
   color: #ffffff;
 }
 
 @media (max-width: 720px) {
   .c-site-nav:not([class*="c-site-nav--break@"]) .c-site-nav-dropdown__link {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 @media (max-width: 1920px) {
   .c-site-nav.c-site-nav--break\@xxl .c-site-nav-dropdown__link {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 @media (max-width: 1600px) {
   .c-site-nav.c-site-nav--break\@xl .c-site-nav-dropdown__link {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 @media (max-width: 1280px) {
   .c-site-nav.c-site-nav--break\@l .c-site-nav-dropdown__link {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 @media (max-width: 960px) {
   .c-site-nav.c-site-nav--break\@m .c-site-nav-dropdown__link {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 @media (max-width: 720px) {
   .c-site-nav.c-site-nav--break\@s .c-site-nav-dropdown__link {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 @media (max-width: 480px) {
   .c-site-nav.c-site-nav--break\@xs .c-site-nav-dropdown__link {
     padding-top: 8px;
     padding-left: 8px;
     padding-right: 8px;
     padding-bottom: 8px;
   }
 }
 
 .c-site-nav-dropdown__link:hover {
   color: #ffffff;
 }
 
 .c-site-nav-dropdown__link.is-active, .c-site-nav-dropdown__link:focus {
   color: #ffffff;
 }
 
 /* ------------------------------------*\
     #CONTEXT BAR (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #CONTEXT BAR
 \*------------------------------------ */
 /**
  * [1] Toggle visibility of label underneath context bar icon.
 */
 .c-context-bar {
   height: 100px;
   display: flex;
 }
 
 @media (max-width: 720px) {
   .c-context-bar {
     height: 60px;
   }
 }
 
 .c-context-bar__panel {
   display: flex;
   width: 100%;
 }
 
 .c-context-bar__navs {
   display: flex;
   justify-content: space-between;
   width: 100%;
 }
 
 .c-context-bar__nav {
   margin: 0;
   padding: 0;
   list-style: none;
   display: flex;
   align-items: center;
 }
 
 .c-context-bar__nav li {
   display: block;
   margin-bottom: 0;
 }
 
 .c-context-bar__title {
   font-weight: 400;
   color: #1a1a1a;
 }
 
 @media (max-width: 720px) {
   .c-context-bar__title {
     display: none;
   }
 }
 
 .c-context-bar__link {
   display: flex;
   flex-direction: column;
   align-items: center;
   margin-left: 16px;
   text-decoration: none;
   color: #1a1a1a;
 }
 
 .c-context-bar__icon {
   color: #1a1a1a;
   font-size: 24px;
 }
 
 .c-context-bar__icon-label {
   display: none;
 }
 
 /* ------------------------------------*\
     #DATA-OVERVIEW (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #DATA-OVERVIEW
 \*------------------------------------ */
 /**
  * [1]  Fix vertical alignment with other elements in header.
  * [2]  Defensively reset any potential margin-bottom that comes with the
  *      elements that are being used as the title.
  * [4]  Defensively reset any trailing margin-bottom at the end of the
  *      component.
  * [5]  Ensure that the icon always just takes up the space equal to its size.
  * [6]  Words can be broken at appropriate hyphenation points either as
  *      determined by hyphenation characters (soft `&shy;` or hard `U+2010`
  *      hyphen) inside the word or as determined automatically by a
  *      language-appropriate hyphenation resource (e.g. the `lang` attribute for
  *      the document or parent element). Setting a language appropriate to the
  *      content seems to be more important in some browsers (e.g. Firefox) than
  *      in others (Chrome). All in all, hyphenation should be considered a
  *      progressive enhancement, which behaves differently in different browsers.
  * [7]  Break a word onto multiple lines if itâ€™s too large to fit.
  * [8]  Allow header items to wrap.
  * [9]  Vertical space between header items have broken under each other.
  * [10] Hide button label for component breakpoint.
  * [11] Always hide the data-overview header icon as per design.
  */
 .c-data-overview {
   padding-top: 24px;
   padding-right: 24px;
   padding-bottom: 24px;
   padding-left: 24px;
   background-color: #f2f2f2;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 @media (max-width: 720px) {
   .c-data-overview {
     padding-top: 16px;
     padding-right: 16px;
     padding-bottom: 16px;
     padding-left: 16px;
   }
 }
 
 /* [1] */
 [data-theme="alternative"] .c-data-overview,
 .u-bg-alternative .c-data-overview {
   background-color: #ffffff;
 }
 
 .c-data-overview__header {
   display: flex;
   flex-wrap: wrap;
   /* [8] */
   justify-content: space-between;
   align-items: center;
   margin-top: -16px;
   /* [9] */
   margin-bottom: 24px;
 }
 
 @media (max-width: 720px) {
   .c-data-overview__header {
     margin-bottom: 16px;
   }
 }
 
 .c-data-overview__header > * {
   margin-top: 16px;
   /* [9] */
 }
 
 .c-data-overview__icon {
   flex-grow: 0;
   /* [5] */
   flex-shrink: 0;
   /* [5] */
   flex-basis: 24px;
   /* [5] */
   margin-right: 16px;
 }
 
 .c-data-overview__icon .c-icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   display: block;
   /* [1] */
   color: #1a1a1a;
 }
 
 .c-data-overview__title {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
   flex-grow: 1;
   flex-shrink: 1;
   flex-basis: 5em;
   max-width: 100%;
   margin-right: 16px;
   margin-bottom: 0;
   /* [2] */
   font-weight: 400;
   -webkit-hyphens: auto;
   -ms-hyphens: auto;
   hyphens: auto;
   /* [6] */
   color: #1a1a1a;
   overflow-wrap: break-word;
   /* [7] */
 }
 
 @media (min-width: 721px) {
   .c-data-overview__title {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-data-overview__title {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-data-overview__button {
   flex-grow: 0;
   flex-shrink: 0;
   flex-basis: auto;
 }
 
 .c-data-overview__button .c-btn__icon::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   content: "\e97e";
   font-size: 24px;
 }
 
 .c-data-overview__body > *:last-child {
   margin-bottom: 0;
   /* [4] */
 }
 
 /* ------------------------------------*\
     #DATEPICKER
 \*------------------------------------ */
 /**
  * [1] This class is currently only a placeholder. It is part of the timepicker's
  *     HTML markup and is designed to prevent changes to the markup. Please refer
  *     to `vendor/flatpickr/flatpickr.scss` and `vendor/flatpickr/flatpickr.settings.scss`
  *     to see the styling of the current timepicker.
  */
 .c-datepicker {
   /* [1] */
 }
 
 /* ------------------------------------*\
     #TIMEPICKER
 \*------------------------------------ */
 /**
  * [1] This class is currently only a placeholder. It is part of the timepicker's
  *     HTML markup and is designed to prevent changes to the markup. Please refer
  *     to `vendor/flatpickr/flatpickr.scss` and `vendor/flatpickr/flatpickr.settings.scss`
  *     to see the styling of the current timepicker.
  */
 .c-timepicker {
   /* [1] */
 }
 
 /* ------------------------------------*\
     #INSTRUCTION-STEPPER
 \*------------------------------------ */
 /**
  * [1] Reset custom numbering.
  * [2] Make all items same-width.
  * [3] Avoid that on the IE the elements are stacked.
  * [4] Reset default margin, padding, and list style type of lists.
  * [5] Horizontal connector.
  * [6] Vertical connector.
  * [7] Move the beginning of the horizontal/vertical connector to the center of
  *     the respective item.
  * [8] Fix overlapping `<div>`s in IE.
  * [9] Stack item above connector.
  * [10] Reset horizontal spacing.
  * [11] Remove spacing to align default and active items.
  */
 .c-instruction-stepper {
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   margin: 0;
   /* [4] */
   padding: 0;
   /* [4] */
   list-style-type: none;
   /* [4] */
 }
 
 @media (min-width: 721px) {
   .c-instruction-stepper:not(.c-instruction-stepper--vertical) {
     flex-direction: row;
   }
 }
 
 .c-instruction-stepper--numbered {
   counter-reset: instruction-stepper-count;
   /* [1] */
 }
 
 .c-instruction-stepper__step {
   position: relative;
   display: flex;
   align-items: center;
   flex-grow: 1;
   /* [2] */
   flex-shrink: 1;
   flex-basis: auto;
   /* [3] */
   min-height: 80px;
   margin-bottom: 16px;
   /**
      * Position logic just changes in orthogonality so we swap out the properties respectively.
      * 1. Controls the thickness property for the line.
      * 2. Controls the dimension property of the line:
      *    `height` for vertical orientation and `width` for horizontal orientation.
      * 3. The property that controls the line dimensional _offset.
      * 4. The property that controls the alignment.
      * 5. A correction buffer for solid lines as `calc()` renders subpixel inefficient
      *    and micro gaps might be noticeable in contrary to dotted lines
      */
 }
 
 .c-instruction-stepper__step::before, .c-instruction-stepper__step::after {
   width: 2px;
   height: calc(50% + 8px);
   left: 40px;
 }
 
 .c-instruction-stepper__step::before {
   top: -8px;
 }
 
 .c-instruction-stepper__step::after {
   top: 50%;
 }
 
 .c-instruction-stepper__step:first-child::before, .c-instruction-stepper__step:last-child::after {
   display: none;
 }
 
 .c-instruction-stepper__step::before, .c-instruction-stepper__step::after {
   background-image: linear-gradient(to bottom, #afb5ab 20%, rgba(255, 255, 255, 0) 0%);
   background-size: 2px 10px;
   background-repeat: repeat;
 }
 
 .c-instruction-stepper__step::after {
   background-position: bottom;
 }
 
 .c-instruction-stepper__step::before, .c-instruction-stepper__step::after {
   content: "";
   position: absolute;
   display: block;
 }
 
 @media (min-width: 721px) {
   :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step {
     /**
      * Position logic just changes in orthogonality so we swap out the properties respectively.
      * 1. Controls the thickness property for the line.
      * 2. Controls the dimension property of the line:
      *    `height` for vertical orientation and `width` for horizontal orientation.
      * 3. The property that controls the line dimensional _offset.
      * 4. The property that controls the alignment.
      * 5. A correction buffer for solid lines as `calc()` renders subpixel inefficient
      *    and micro gaps might be noticeable in contrary to dotted lines
      */
   }
   :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step::before, :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step::after {
     height: 2px;
     width: calc(50% + 8px);
     top: 40px;
   }
   :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step::before {
     left: -8px;
   }
   :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step::after {
     left: 50%;
   }
   :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step:first-child::before, :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step:last-child::after {
     display: none;
   }
   :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step::before, :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step::after {
     background-image: linear-gradient(to right, #afb5ab 20%, rgba(255, 255, 255, 0) 0%);
     background-size: 10px 2px;
     background-repeat: repeat;
   }
   :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step::after {
     background-position: right;
   }
 }
 
 @media (min-width: 721px) {
   :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step {
     flex-direction: column;
     flex-basis: 0;
     /* [2] */
     margin-bottom: 0;
   }
   :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step:not(:last-child) {
     margin-right: 16px;
   }
 }
 
 .c-instruction-stepper__item {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   position: relative;
   z-index: 1;
   /* [9] */
   display: flex;
   align-items: center;
   justify-content: center;
   flex-grow: 0;
   flex-shrink: 0;
   flex-basis: auto;
   width: 64px;
   height: 64px;
   margin-right: 8px;
   margin-left: 8px;
   border: 0 solid transparent;
   border-radius: 50%;
   font-weight: 400;
   text-align: center;
   background-color: #f2f2f2;
   color: #1a1a1a;
 }
 
 @media (min-width: 721px) {
   :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step:not(.is-active) .c-instruction-stepper__item {
     margin-top: 8px;
     margin-right: 0;
     /* [10] */
     margin-bottom: 8px;
     margin-left: 0;
     /* [10] */
   }
 }
 
 .c-instruction-stepper--numbered .c-instruction-stepper__item::before {
   content: counter(instruction-stepper-count);
   counter-increment: instruction-stepper-count;
 }
 
 .c-instruction-stepper__step.is-active .c-instruction-stepper__item {
   font-size: 1.875rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   width: 80px;
   height: 80px;
   margin: 0;
   /* [4] */
   border: 0 solid transparent;
   font-weight: 400;
   background-color: #1a1a1a;
   color: #ffffff;
   /* stylelint-disable selector-max-class */
   /* stylelint-enable */
 }
 
 .c-instruction-stepper__step.is-active .c-instruction-stepper__item .c-icon {
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   color: currentColor;
 }
 
 .c-instruction-stepper__item .c-icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   color: currentColor;
 }
 
 .c-instruction-stepper__detail {
   display: block;
   max-width: 100%;
   /* [8] */
   margin-left: 16px;
   text-align: left;
 }
 
 @media (min-width: 721px) {
   :not(.c-instruction-stepper--vertical) > .c-instruction-stepper__step .c-instruction-stepper__detail {
     margin-top: 16px;
     margin-left: 0;
     text-align: center;
   }
 }
 
 .c-instruction-stepper__title {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   line-height: 1.5;
   display: block;
   font-weight: 400;
   color: #1a1a1a;
 }
 
 .c-instruction-stepper__description {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   line-height: 1.5;
   display: block;
   margin-top: 8px;
   font-weight: 400;
   color: #495651;
 }
 
 /* ------------------------------------*\
     #DEFINITION-TABLE
 \*------------------------------------ */
 /**
  * [1] Reset default margin-bottom of `<dl>` element.
  * [2] Create visual padding via a combination of padding and margin. Because
  *     the visual spacing between two sections is intersected with a border, the
  *     spacing is a combination of padding and margin.
  * [3] Prevent ugly break of data in `.c-definition-table--no-wrap` variant.
  * [4] Prevent any unwanted spacing at the bottom of the component.
  * [5] Clear any left floats in the definition table.
  * [6] Each column should be at least 50% but be allowed to wrap.
  * [7] On smaller viewports we aim for a single column,
  *     except for `.c-definition-table--no-wrap` variant.
  * [8] Use floats for positioning which allows us to use clears to specify row breaks.
  *     Align the definition title and definition data on each side respectively but align
  *     all flush left on smaller viewports.
  * [9] Clear any previous floats so that wrapping definition data gets its own row.
  * [10] In some cases one definition title can have multiple definition data cells.
  *      In order to align those properly we need to push any direct sibling to the
  *      right hand side for large viewports only. For the `.c-definition-table--no-wrap` variant
  *      we always force the left spacing to keep the two column approach.
  * [11] Clear any previous floats for smaller viewports.
  * [12] Enable flex display for definition descriptions in combination
  *      with e.g. a button links.
  * [13] Overwrite the default text alignment for the definition table.
  * [14] Enable right alignment for e.g. a button link when used in
  *      the same row next to a definition description.
  * [15] Position items top when use in combination with a list.
  * [16] Revert [6] in `.c-definition-table--no-wrap` variant for all items
  *      except in `.c-definition-table__section--summary` footer.
  * [17] All items in not `.c-definition-table--no-wrap` variant and also
  *      `.c-definition-table__section--summary` footer should behave the same.
  */
 .c-definition-table__title {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   margin-bottom: 24px;
 }
 
 .c-definition-table__section {
   /* [5] */
   margin-bottom: 0;
   /* [1] */
 }
 
 .c-definition-table__section::after {
   content: "" !important;
   display: block !important;
   clear: both !important;
 }
 
 .c-definition-table__section:not(:last-of-type) {
   margin-bottom: 24px;
   /* [2] */
   padding-bottom: 24px;
   /* [2] */
   border-bottom: 1px solid #f2f2f2;
 }
 
 @media (max-width: 720px) {
   .c-definition-table__section:not(:last-of-type) {
     margin-bottom: 16px;
     /* [2] */
     padding-bottom: 16px;
     /* [2] */
   }
 }
 
 .c-definition-table__item-title,
 .c-definition-table__item-data {
   min-width: 50%;
   /* [6] */
 }
 
 @media (max-width: 720px) {
   .c-definition-table__item-title,
   .c-definition-table__item-data {
     min-width: 100%;
     /* [7] */
   }
 }
 
 .c-definition-table--no-wrap .c-definition-table__section:not(.c-definition-table__section--summary) .c-definition-table__item-title, .c-definition-table--no-wrap .c-definition-table__section:not(.c-definition-table__section--summary)
 .c-definition-table__item-data {
   width: 50%;
   min-width: auto;
   /* [16] */
 }
 
 .c-definition-table__item-title {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   float: left;
   /* [8] */
   clear: both;
   /* [9] */
   font-weight: 700;
 }
 
 .c-definition-table__section.c-definition-table__section--summary .c-definition-table__item-title {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
   font-family: "open-sans", sans-serif;
   font-weight: 700;
 }
 
 @media (min-width: 721px) {
   .c-definition-table__section.c-definition-table__section--summary .c-definition-table__item-title {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-definition-table__section.c-definition-table__section--summary .c-definition-table__item-title {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-definition-table__item-title:not(:last-of-type) {
   margin-bottom: 8px;
 }
 
 @media (max-width: 720px) {
   .c-definition-table:not(.c-definition-table--no-wrap) .c-definition-table__item-title:not(:last-of-type) {
     margin-bottom: 0;
   }
 }
 
 .c-definition-table__item-data {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   float: right;
   /* [8] */
   clear: right;
   font-weight: 400;
   text-align: right;
 }
 
 .c-definition-table__section.c-definition-table__section--summary .c-definition-table__item-data {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
   font-family: "open-sans", sans-serif;
   font-weight: 700;
 }
 
 @media (min-width: 721px) {
   .c-definition-table__section.c-definition-table__section--summary .c-definition-table__item-data {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-definition-table__section.c-definition-table__section--summary .c-definition-table__item-data {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-definition-table:not(.c-definition-table--no-wrap) .c-definition-table__item-data,
 .c-definition-table__section--summary .c-definition-table__item-data {
   /* [17] */
 }
 
 @media (max-width: 720px) {
   .c-definition-table:not(.c-definition-table--no-wrap) .c-definition-table__item-data,
   .c-definition-table__section--summary .c-definition-table__item-data {
     float: left;
     /* [8] */
     margin-left: 0;
     /* [10] */
     text-align: left;
   }
 }
 
 .c-definition-table--with-button .c-definition-table__item-data {
   display: inline-flex;
   /* [12] */
   text-align: left;
   /* [13] */
 }
 
 .c-definition-table--with-button .c-definition-table__item-data .c-definition-table__btn {
   margin-bottom: auto;
   /* 15 */
   margin-left: auto;
   /* [14] */
 }
 
 .c-definition-table__item-data + .c-definition-table__item-data {
   margin-left: 50%;
   /* [10] */
 }
 
 .c-definition-table:not(.c-definition-table--no-wrap) .c-definition-table__item-data + .c-definition-table__item-data {
   margin-left: auto;
   /* [10] */
 }
 
 @media (max-width: 720px) {
   .c-definition-table:not(.c-definition-table--no-wrap) .c-definition-table__item-data + .c-definition-table__item-data {
     clear: left;
     /* [11] */
   }
 }
 
 .c-definition-table__item-data:not(:last-of-type) {
   margin-bottom: 8px;
 }
 
 @media (max-width: 720px) {
   .c-definition-table:not(.c-definition-table--no-wrap) .c-definition-table__item-data:not(:last-of-type) {
     margin-bottom: 8px;
   }
 }
 
 .c-definition-table__item-data-comment {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   display: block;
   width: 100%;
   font-weight: 700;
   text-align: right;
 }
 
 @media (max-width: 720px) {
   .c-definition-table:not(.c-definition-table--no-wrap) .c-definition-table__item-data-comment {
     text-align: left;
   }
 }
 
 .c-definition-table__item-title-comment {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   display: block;
   width: 100%;
   font-weight: 400;
 }
 
 .c-definition-table__inner-title {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   margin-bottom: 16px;
   font-weight: 700;
   text-align: center;
   color: #1a1a1a;
 }
 
 .c-definition-table__information,
 .c-definition-table__information > *:last-child {
   margin-bottom: 0;
   /* [4] */
 }
 
 /* ------------------------------------*\
     #SPINNER
 \*------------------------------------ */
 /**
  * [1] Magic number that places the â€˜cornerâ€™ dots/stripe correctly to form a
  *     perfect circle. If someone can come up with the correct formula of
  *     calculating this properly...you're a freak! But itâ€™ll be nice,
  *     nonetheless.
  * [2] Use an `inset` box shadow, so that the outer border (this box-shadow one)
  *     and the overlaying inner border of the pseudo element are matching
  *     exactly.
  * [3] Set transition to fade in/out the spinner when it is shown/hidden
  *     dynamically.
  * [4] Take up the size from the parent (`.c-spinner__loader`).
  * [5] Create a Pac-Man shape by omitting the bottom border color.
  * [6] Put the spinner of the full-page, text and section variant dead center of the
  *     backdrop.
  * [7] Donâ€™t even ask!
  * [8] Remove margins from any element inside the text container.
  */
 .c-spinner.c-spinner--full-page, .c-spinner.c-spinner--section, .c-spinner.c-spinner--text {
   position: relative;
 }
 
 .c-spinner.c-spinner--full-page::before, .c-spinner.c-spinner--section::before, .c-spinner.c-spinner--text::before {
   position: absolute;
   top: 0;
   right: 0;
   bottom: 0;
   left: 0;
   background-color: rgba(255, 255, 255, 0.6);
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   content: "";
   z-index: 4999;
   opacity: 0;
   visibility: hidden;
 }
 
 .c-spinner.c-spinner--full-page[aria-busy='true']::before, .c-spinner.c-spinner--section[aria-busy='true']::before, .c-spinner.c-spinner--text[aria-busy='true']::before {
   opacity: 1;
   visibility: visible;
 }
 
 .c-spinner.c-spinner--full-page::before, .c-spinner.c-spinner--text::before {
   position: fixed;
 }
 
 .c-spinner.c-spinner--center {
   display: flex;
   justify-content: center;
 }
 
 .c-spinner.c-spinner--text {
   text-align: center;
 }
 
 .c-spinner__loader {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   /* [3] */
   position: relative;
   z-index: 5000;
   display: none;
   width: 80px;
   height: 80px;
 }
 
 .c-spinner__loader::before {
   content: "";
   position: absolute;
   /* [4] */
   top: 0;
   /* [4] */
   left: 0;
   /* [4] */
   display: block;
   width: 80px;
   /* [4] */
   height: 80px;
   /* [4] */
   border-radius: 50%;
   box-shadow: 0 0 0 3px #f2f2f2 inset;
   /* [2] */
 }
 
 .c-spinner--small .c-spinner__loader::before {
   width: 40px;
   height: 40px;
   box-shadow: 0 0 0 2px #f2f2f2 inset;
   /* [2] */
 }
 
 .c-spinner__loader::after {
   content: "";
   position: absolute;
   /* [4] */
   top: 0;
   /* [4] */
   left: 0;
   /* [4] */
   display: block;
   width: 80px;
   /* [4] */
   height: 80px;
   /* [4] */
   border: 3px solid #1a1a1a;
   border-radius: 50%;
   animation: spinner-circle-animation 1s linear infinite;
   border-bottom-color: transparent;
   /* [5] */
 }
 
 .c-spinner--small .c-spinner__loader::after {
   width: 40px;
   height: 40px;
   border-width: 2px;
 }
 
 .c-spinner[aria-busy='true'] .c-spinner__loader {
   display: block;
 }
 
 .c-spinner--small .c-spinner__loader {
   width: 40px;
   height: 40px;
 }
 
 .c-spinner--section .c-spinner__loader,
 .c-spinner--full-page .c-spinner__loader {
   position: absolute;
   top: 50%;
   /* [6] */
   left: 50%;
   /* [6] */
   transform: translate(-50%, -50%);
   /* [6] */
 }
 
 .c-spinner--full-page .c-spinner__loader {
   position: fixed;
   /* [7] */
 }
 
 .c-spinner--text .c-spinner__loader {
   margin-right: auto;
   margin-left: auto;
 }
 
 .c-spinner__content {
   width: 33.33333%;
   position: fixed;
   z-index: 5000;
   top: 50%;
   /* [6] */
   left: 50%;
   /* [6] */
   display: none;
   padding: 24px;
   transform: translate(-50%, -50%);
   /* [6] */
   background-color: #ffffff;
 }
 
 @media (max-width: 1280px) {
   .c-spinner__content {
     width: 50%;
   }
 }
 
 @media (max-width: 960px) {
   .c-spinner__content {
     width: 66.66667%;
   }
 }
 
 @media (max-width: 720px) {
   .c-spinner__content {
     width: calc(100vw - 64px);
   }
 }
 
 .c-spinner[aria-busy='true'] .c-spinner__content {
   display: block;
 }
 
 .c-spinner__text {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   display: inline-block;
   padding-top: 16px;
   padding-right: 24px;
   padding-left: 24px;
   color: #1a1a1a;
 }
 
 .c-spinner__text * {
   margin: 0;
   /* [8] */
 }
 
 .c-spinner__element {
   display: none;
 }
 
 @keyframes spinner-circle-animation {
   from {
     transform: rotate(0turn);
   }
   to {
     transform: rotate(1turn);
   }
 }
 
 @keyframes spinner-dots-animation {
   0% {
     opacity: 0.2;
   }
   50% {
     opacity: 1;
   }
   100% {
     opacity: 0.2;
   }
 }
 
 @keyframes spinner-stripe-animation {
   0% {
     background-color: #495651;
   }
   12.5% {
     background-color: #1a1a1a;
   }
   25% {
     background-color: #495651;
   }
 }
 
 /* ------------------------------------*\
     #CUSTOM-RANGE-SLIDER
 \*------------------------------------ */
 /**
  * [1]  Set the left and right margin of the slider to half the size of the thumb.
  * [2]  Add pseudo element so we can set width and height of the range slider
  *      to the size needed.
  * [3]  Center marker on track.
  * [4]  Show marker above track / connect.
  * [5]  Add transition when tapping on track.
  * [6]  Hide the overflow of the connector to make border radius of the track
  *      visible.
  * [7]  Set the spacing between value and marker.
  * [8]  Markers are now generally set `in-range` via script.
  * [9]  Add pseudo-elements for markers (`::before` element) and their dots
  *      (`::after` element).
  * [10] Align elements, so that the thumb is fully placed inside of the range
  *      slider container.
  * [11] Default tooltip display is top - above the current value.
  * [12] Tooltip is displayed below the current value when variable is set to false.
  * [13] Add spacing when tooltip is present.
  * [14] Defines the positioning of the tooltip container and its indicator.
  * [15] `-0.3px` fixes sometimes visible gaps in IE11.
  * [16] Align first (min) and last (max) with the outer boundaries of the track
  *      and pips.
  * [17] Overwrite inline-style set by plugin.
  * [18] Avoid selector being applied to last (max) value if only 1 pip is displayed.
  * [19] Put pseudo-area above track to increase (touch-)target when interacting
  *      with track.
  */
 .c-custom-range-slider {
   position: relative;
   height: 60px;
   margin-right: 30px;
   /* [1] */
   margin-left: 30px;
   /* [1] */
 }
 
 .c-custom-range-slider::after {
   /* [2] */
   content: "";
   position: absolute;
   top: 50%;
   left: 0;
   width: 100%;
   height: 2px;
   transform: translateY(-50%);
   background-color: #afb5ab;
   border-radius: 10px;
 }
 
 .c-custom-range-slider[disabled]::after {
   background-color: #afb5ab;
 }
 
 .c-custom-range-slider[data-custom-range-slider-pips] {
   height: 86px;
 }
 
 .c-custom-range-slider[data-custom-range-slider-pips]::after {
   top: calc(50% - 10.625px);
   /* [10] */
 }
 
 .c-custom-range-slider__target {
   position: relative;
 }
 
 .c-custom-range-slider__target * {
   -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
   /* [1] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   touch-action: none;
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
 }
 
 .c-custom-range-slider__base {
   position: relative;
   z-index: 1;
   top: 50%;
   width: 100%;
   height: 2px;
   transform: translateY(-50%);
   cursor: pointer;
   /* [16] */
 }
 
 .c-custom-range-slider__base::before {
   content: "";
   position: absolute;
   right: 0;
   left: 0;
   height: 40px;
   transform: translateY(-50%);
 }
 
 .c-custom-range-slider[disabled] .c-custom-range-slider__base {
   cursor: initial;
 }
 
 .c-custom-range-slider[data-custom-range-slider-pips] .c-custom-range-slider__base {
   top: calc(50% - 10.625px);
   /* [10] */
 }
 
 .c-custom-range-slider__origin {
   position: absolute;
   right: 0;
   width: 10%;
   height: 10%;
 }
 
 .c-custom-range-slider--tap .c-custom-range-slider__origin {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   /* [5] */
 }
 
 .c-custom-range-slider__thumb {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   position: absolute;
   top: -1px;
   right: 0;
   width: 60px;
   height: 60px;
   transform: translate(50%, -50%);
   background-color: #ffffff;
   cursor: grab;
   border: 1px solid #187085;
   border-radius: 50%;
 }
 
 .c-custom-range-slider[disabled] .c-custom-range-slider__thumb {
   border-color: #afb5ab;
   background-color: #ffffff;
   pointer-events: none;
   cursor: initial;
 }
 
 .c-custom-range-slider__thumb:focus {
   outline: none;
 }
 
 .c-custom-range-slider__thumb:active {
   cursor: grabbing;
 }
 
 .c-custom-range-slider__thumb::before {
   content: "";
   position: absolute;
   top: 50%;
   left: 50%;
   display: block;
   width: 16px;
   height: 16px;
   transform: translate(-50%, -50%);
   background-color: #1a1a1a;
   border-radius: 50%;
 }
 
 .c-custom-range-slider[disabled] .c-custom-range-slider__thumb::before {
   background-color: #afb5ab;
 }
 
 /**
     * Connects
     */
 .c-custom-range-slider__connect-container {
   position: relative;
   width: 100%;
   height: 100%;
   overflow: hidden;
   /* [6] */
   border-radius: 10px;
   /* [19] */
 }
 
 .c-custom-range-slider__connect-container::before {
   content: "";
   position: absolute;
   right: 0;
   left: 0;
   height: 40px;
   transform: translateY(-50%);
 }
 
 .c-custom-range-slider__connect {
   position: absolute;
   top: 0;
   right: 0;
   width: 100%;
   height: 100%;
   transform-origin: 0 0;
   background-color: #1a1a1a;
 }
 
 .c-custom-range-slider--tap .c-custom-range-slider__connect {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   /* [5] */
 }
 
 .c-custom-range-slider[disabled] .c-custom-range-slider__connect {
   background-color: #afb5ab;
 }
 
 /**
     * Pips, Markers & Values
     */
 .c-custom-range-slider__pips {
   position: absolute;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
 }
 
 .c-custom-range-slider__marker {
   position: absolute;
   z-index: initial;
   /* [4] */
   top: 50%;
   /* [3] */
   display: block;
   width: 40px;
   height: 40px;
   transform: translate(-50%, -50%);
   /* [3] */
   cursor: pointer;
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
 }
 
 .c-custom-range-slider__marker::before, .c-custom-range-slider__marker::after {
   /* [9] */
   content: "";
   position: absolute;
   top: 50%;
   left: 50%;
   display: block;
   transform: translate(-50%, -50%);
   cursor: pointer;
   border-radius: 50%;
 }
 
 .c-custom-range-slider__marker::before {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   width: 8px;
   height: 8px;
   background-color: #afb5ab;
 }
 
 .c-custom-range-slider__marker.is-active:first-of-type::before, .c-custom-range-slider__marker.is-active:first-of-type::after {
   background-color: #1a1a1a;
   /* [8] */
 }
 
 .c-custom-range-slider__marker.in-range::before, .c-custom-range-slider__marker.in-range::after {
   background-color: #1a1a1a;
 }
 
 .c-custom-range-slider[disabled] .c-custom-range-slider__marker, .c-custom-range-slider[disabled] .c-custom-range-slider__marker::before, .c-custom-range-slider[disabled] .c-custom-range-slider__marker::after {
   touch-action: none;
   cursor: initial;
 }
 
 .c-custom-range-slider[disabled] .c-custom-range-slider__marker::before, .c-custom-range-slider[disabled] .c-custom-range-slider__marker::after {
   background-color: #afb5ab;
 }
 
 .c-custom-range-slider[data-custom-range-slider-pips] .c-custom-range-slider__marker {
   top: calc(50% - 10.625px);
   /* [10] */
 }
 
 .c-custom-range-slider__value {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   position: absolute;
   padding-top: 70px;
   /* [7] */
   transform: translateX(-50%);
   white-space: nowrap;
   text-align: center;
   color: #1a1a1a;
   cursor: pointer;
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
 }
 
 .c-custom-range-slider__value:nth-child(2):not(:last-child) {
   /* [18] */
   transform: translateX(-4px);
   /* [16] */
 }
 
 .c-custom-range-slider__value:last-child {
   right: 0;
   left: auto !important;
   /* [17] */
   /* stylelint-disable-line itcss/no-at-important */
   transform: translateX(4px);
   /* [16] */
 }
 
 .c-custom-range-slider[disabled] .c-custom-range-slider__value {
   color: #afb5ab;
   cursor: initial;
   touch-action: none;
 }
 
 .c-custom-range-slider__tooltip-wrapper {
   position: absolute;
   left: 50%;
   display: block;
   padding: 16px;
   transform: translateX(-50%);
   border-radius: 0;
   font-size: 14px;
   line-height: 1;
   text-align: center;
   white-space: nowrap;
   background-color: #1a1a1a;
   color: #ffffff;
   cursor: default;
 }
 
 .c-custom-range-slider__arrow {
   /* [14] */
   content: "";
   position: absolute;
   left: 50%;
   width: 10px;
   height: 10px;
   transform: translateX(-50%);
   border-style: solid;
   border-color: transparent;
   border-width: 10px;
 }
 
 .custom-range-slider-tooltip--top {
   /* [11] */
   margin-top: 65px;
 }
 
 .custom-range-slider-tooltip--top .c-custom-range-slider__tooltip-wrapper {
   bottom: 78px;
 }
 
 .custom-range-slider-tooltip--top .c-custom-range-slider__arrow {
   top: calc(100% - 0.3px);
   /* [15] */
   border-bottom-width: 0;
   border-top-color: #1a1a1a;
 }
 
 .custom-range-slider-tooltip--bottom {
   /* [12] */
   margin-bottom: 65px;
 }
 
 .custom-range-slider-tooltip--bottom .c-custom-range-slider__tooltip-wrapper {
   top: 78px;
 }
 
 .custom-range-slider-tooltip--bottom .c-custom-range-slider__arrow {
   bottom: 100%;
   border-top-width: 0;
   border-bottom-color: #1a1a1a;
 }
 
 /* ------------------------------------*\
    #NOTIFICATIONS (SETTINGS)
 \*------------------------------------ */
 /* ------------------------------------*\
    #NOTIFICATIONS
 \*------------------------------------ */
 /**
  * [1]  Notifications are always sticky.
  * [2]  Notifications are displayed either at the top or at the bottom of the page.
  * [3]  Visually hide notifications as long as JS is not loaded.
  * [4]  To properly animate the opening/closing of the notifications, hide the
  *      overflow.
  * [5]  Add transition after JS is loaded to prevent weird flickering of the
  *      notification on page-load.
  * [6]  Add height of `0` when the notification is closed to be able to
  *      animate the opening/closing.
  * [7]  Animate the positioning on the y-axis for opening/closing animation.
  * [8]  Vertically align the icon with the first line of the notifications text.
  * [9]  Relation for the icon.
  * [10] Spacing for the icon on the right.
  * [11] Make sure that links in notifications are always legible.
  * [12] Modifier for flex-direction behavior on desktop.
  * [13] Modifier for flex-direction behavior on mobile.
  * [14] Remove margin-bottom from paragraph.
  * [15] Set flex shrink to zero avoid button span line break.
  * [16] Add wanted margin for custom notifications.
  * [17] Fixes IE bug stacking flex-items.
  * [18] Create spacing and align with status icon.
  * [19] Add status specific color.
  * [20] Change icon depending on status.
  * [21] Place button on the right, independent of content length.
  * [22] Ensure spacing between button and arbitrary content above.
  * [23] Set `transform` to `none` instead of `translateY(0)` as this would
  *      hide the bottom border in combination with `overflow: hidden` on the
  *      container (only necessary for Firefox).
  * [24] Restrict the height of the container to the viewport height, so it is
  *     scrollable with many items in it.
  * [25] In case of many notifications, ensure scrollability,...
  * [26] ...but prevent on the x-axis.
  */
 .c-notifications-group {
   position: -webkit-sticky;
   position: sticky;
   /* [1] */
   z-index: 2500;
   top: 0;
   width: 100%;
   max-height: 100vh;
   /* [24] */
   visibility: hidden;
   /* [3] */
   overflow-y: auto;
   /* [25] */
   overflow-x: hidden;
   /* [26] */
 }
 
 .c-notifications-group.js-is-ready {
   visibility: inherit;
 }
 
 .c-notification {
   width: 100%;
   padding-top: 24px;
   padding-bottom: 24px;
   transform: none;
   /* [23] */
   background-color: #697677;
   color: inherit;
 }
 
 .c-notification--info {
   background-color: #187085;
   color: #ffffff;
   /* [19] */
 }
 
 .c-notification--info .c-notification__close::before {
   color: #ffffff;
 }
 
 .c-notification--info .c-notification__status-icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-notification--info .c-notification__status-icon::before {
   border-radius: 50%;
   padding: 5px;
 }
 
 .c-notification--info .c-notification__status-icon::before {
   border: 1px solid currentColor;
 }
 
 .c-notification--info .c-notification__status-icon::before {
   content: "\e971";
 }
 
 .c-notification--success {
   background-color: #00783c;
   color: #ffffff;
   /* [19] */
 }
 
 .c-notification--success .c-notification__close::before {
   color: #ffffff;
 }
 
 .c-notification--success .c-notification__status-icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-notification--success .c-notification__status-icon::before {
   border-radius: 50%;
   padding: 5px;
 }
 
 .c-notification--success .c-notification__status-icon::before {
   border: 1px solid currentColor;
 }
 
 .c-notification--success .c-notification__status-icon::before {
   content: "\e952";
 }
 
 .c-notification--warning {
   background-color: #efc938;
   color: #1a1a1a;
   /* [19] */
 }
 
 .c-notification--warning .c-notification__close::before {
   color: #1a1a1a;
 }
 
 .c-notification--warning .c-notification__status-icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-notification--warning .c-notification__status-icon::before {
   border-radius: 50%;
   padding: 5px;
 }
 
 .c-notification--warning .c-notification__status-icon::before {
   border: 1px solid currentColor;
 }
 
 .c-notification--warning .c-notification__status-icon::before {
   content: "\e961";
 }
 
 .c-notification--error {
   background-color: #ba2525;
   color: #ffffff;
   /* [19] */
 }
 
 .c-notification--error .c-notification__close::before {
   color: #ffffff;
 }
 
 .c-notification--error .c-notification__status-icon {
   font-size: 36px;
 }
 
 .c-notification--error .c-notification__status-icon::before {
   content: "\e905";
 }
 
 .c-notification--custom {
   /* [19] */
 }
 
 .c-notification--custom .c-notification__status-icon {
   font-size: 36px;
 }
 
 .c-notifications-group.js-is-ready > .c-notification {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   /* [5] */
 }
 
 .c-notifications__container.is-closed > .c-notification {
   transform: translateY(-100%);
   /* [7] */
 }
 
 .c-notification a {
   color: inherit;
   /* [11] */
 }
 
 .c-notification__container {
   overflow: hidden;
   /* [4] */
 }
 
 .c-notifications-group.js-is-ready .c-notification__container {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   /* [5] */
 }
 
 .c-notification__container.is-closed {
   height: 0;
   /* [6] */
   visibility: hidden;
 }
 
 .c-notification__close {
   padding: 0;
   border: 0;
   background-color: transparent;
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   position: absolute;
   top: 0px;
   /* [8] */
   right: 0;
   height: 24px;
   border-radius: 50%;
   cursor: pointer;
   outline: none;
 }
 
 .c-notification__close:focus {
   outline: 0;
 }
 
 .c-notification__close::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   content: "\e955";
   font-size: 24px;
   vertical-align: middle;
   color: inherit;
 }
 
 .c-notification__status-icon {
   margin-right: 16px;
   font-size: 24px;
 }
 
 .c-notification:not(.c-notification--custom) .c-notification__status-icon::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
 }
 
 .c-notification--custom .c-notification__status-icon {
   display: block;
 }
 
 .c-notification__outer-wrap {
   max-width: calc(1280px + 64px);
   padding-left: 32px;
   padding-right: 32px;
   margin-right: auto;
   margin-left: auto;
 }
 
 @media (max-width: 960px) {
   .c-notification__outer-wrap {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .c-notification__outer-wrap {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .c-notification__outer-wrap {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 .c-notification__inner-wrap {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 24px;
   /* [8] */
   position: relative;
   /* [9] */
   display: flex;
   margin-bottom: 0;
   padding-right: 40px;
   /* [10] */
 }
 
 .c-notification--custom .c-notification__inner-wrap {
   flex-direction: row;
   /* [12] */
   padding-right: 0;
 }
 
 @media (max-width: 960px) {
   .c-notification--custom .c-notification__inner-wrap {
     flex-wrap: wrap;
   }
 }
 
 @media (min-width: 961px) {
   .c-notification--custom .c-notification__content {
     padding-right: 16px;
     /* [22] */
   }
 }
 
 @media (max-width: 960px) {
   .c-notification--custom .c-notification__content {
     flex-basis: calc(100% - 52px);
     /* [18] */
   }
 }
 
 .c-notification__text,
 .c-notification__text > p:last-child {
   margin-bottom: 0;
   /* [14] */
 }
 
 .c-notification__title {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   margin-bottom: 16px;
   font-weight: 700;
   color: inherit;
 }
 
 @media (min-width: 721px) {
   .c-notification__title {
     font-size: 1.25rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-notification__title {
     font-size: 1.75rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-notification__button {
   flex-grow: 0;
   flex-shrink: 0;
   /* [15] */
   flex-basis: auto;
   align-self: baseline;
   /* [17] */
   margin-top: 16px;
   /* [22] */
 }
 
 @media (min-width: 961px) {
   .c-notification__button {
     margin-top: 0;
     margin-left: auto;
     /* [21] */
   }
 }
 
 @media (max-width: 960px) {
   .c-notification__button {
     margin-left: 52px;
     /* [18] */
   }
 }
 
 /* ------------------------------------*\
    #NOTIFICATIONS
 \*------------------------------------ */
 /**
  * [1] The default notification variant needs to display light content on
  *     dark background instead of dark content on light background, which is set in the
  *     Default package.
  * [2] The notification button has to be an inverted primary button. Styles have to
  *     be adapted due to the dark background of the notification component.
  */
 .c-notification:not(.c-notification--info):not(.c-notification--warning):not(.c-notification--success):not(.c-notification--error) {
   /* [1] */
   color: #ffffff;
 }
 
 .c-notification  .c-notification__close {
   color: currentColor;
 }
 
 .c-notification__button {
   /* [2] */
   background-color: #ffffff;
   color: #1a1a1a;
 }
 
 .c-notification__button:active {
   background-color: #ffffff !important;
   color: #1a1a1a !important;
 }
 
 .c-notification__button:hover, .c-notification__button:focus {
   background-color: #187085;
   color: #ffffff;
 }
 
 .c-notification__button[disabled], .c-notification__button.is-disabled {
   background-color: #afb5ab;
   color: #3e4547;
 }
 
 /* ------------------------------------*\
     #WIZARD
 \*------------------------------------ */
 /**
  * [1] Make sure all items are the same width.
  * [2] If the indicator is positioned above the item text, make sure that the
  *     items are aligned to each other at the top.
  * [3] Force collapsing of items on small screen and align it to the left.
  * [4] Create little stroke arrow between items. The arrows are always placed
  *     in front of the items.
  * [5] Upper half of the stroke arrow.
  * [6] Bottom half of the stroke arrow.
  * [7] Add block arrow to items with certain states (disabled, active) by using
  *     two skewed pseudo elements as background.
  * [8] Fix block arrow items not being wide enough for first and last item and
  *     cut them off when they overflow the container.
  * [9] Change background and text colors for the specific states.
  * [10] Change link text colors for the specific states upon hover/focus.
  * [11] The default items (i.e. the future items) are not clickable.
  * [12] The done and active items have to be made clickable again (see [11]).
  * [13] On small screen, the indicator is always aligned in row with the text
  *      and left aligned.
  * [14] Position content above arrows and overlap arrows for states with
  *      background color.
  * [15] Add relative positioning to have a reference for pseudo elements that
  *      need e.g. absolute positioning (used for arrows and such).
  * [16] Add background colors to all states for small screen list.
  * [17] Stretch wizard link to full height to center its content vertically.
  * [18] Use icon as link indicator if the indicator should not be numbered.
  * [19] Add regular font styles if link indicator should not be numbered instead
  *      of being an icon.
  * [20] Change indicator styling for the specific states.
  * [21] Change indicator styling for the specific states upon hover/focus.
  * [22] Fix vertical centering the trigger item text in IE11. In IE11, when using
  *      `display: flex` in combination with `min-height`, the container element
  *      needs be a flex container as well.
  * [23] Optionally revert order of trigger icon, counter and text.
  * [24] Prevent interaction of the element(s), when modifier is given
  *      except on the .c-wizard__trigger on mobile.
  * [25] Set horizontal link content alignment.
  * [26] Set vertical link content alignment, but always reset to `center` for
  *      collapsed layout in small viewports.
  * [27] If `$wizard-page-wrap: true` limit the wizard width to the page wrap
  *      width.
  * [28] Resize the wizard to the full page wrap width.
  * [29] If an icon is used as indicator but it is set to `none`, still use an empty
  *      `content` attribute to show the pseudo element as an empty indicator.
  * [30] Fixes the skewed indicator icon in IE11.
  */
 .c-wizard {
   display: flex;
   /* [22] */
   flex-direction: column;
   /* [22] */
   margin-bottom: 24px;
   background-color: #ffffff;
 }
 
 .c-wizard__list {
   margin: 0;
   padding: 0;
   list-style: none;
   display: flex;
   justify-content: space-between;
   align-items: stretch;
   /* [27] */
   max-width: calc(1280px + 64px);
   padding-left: 32px;
   padding-right: 32px;
   margin-right: auto;
   margin-left: auto;
   /* [27] */
   width: 100%;
   /* [28] */
   overflow: hidden;
   /* [8] */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 .c-wizard__list li {
   display: block;
   margin-bottom: 0;
 }
 
 @media (max-width: 960px) {
   .c-wizard__list {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .c-wizard__list {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .c-wizard__list {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 /* [1] */
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__list {
     flex-direction: column;
     /* [3] */
     align-items: flex-start;
     /* [3] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__list {
     flex-direction: column;
     /* [3] */
     align-items: flex-start;
     /* [3] */
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__list {
     flex-direction: column;
     /* [3] */
     align-items: flex-start;
     /* [3] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__list {
     flex-direction: column;
     /* [3] */
     align-items: flex-start;
     /* [3] */
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__list {
     flex-direction: column;
     /* [3] */
     align-items: flex-start;
     /* [3] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__list {
     flex-direction: column;
     /* [3] */
     align-items: flex-start;
     /* [3] */
   }
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"].js-is-ready .c-wizard__list.is-closed {
     display: none;
   }
 }
 
 /* stylelint-disable-next-line order/order */
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]).js-is-ready .c-wizard__list.is-closed {
     display: none;
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"].js-is-ready .c-wizard__list.is-closed {
     display: none;
   }
 }
 
 /* stylelint-disable-next-line order/order */
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]).js-is-ready .c-wizard__list.is-closed {
     display: none;
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"].js-is-ready .c-wizard__list.is-closed {
     display: none;
   }
 }
 
 /* stylelint-disable-next-line order/order */
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]).js-is-ready .c-wizard__list.is-closed {
     display: none;
   }
 }
 
 .c-wizard__item {
   position: relative;
   /* [15] */
   flex-grow: 1;
   flex-shrink: 1;
   flex-basis: 0;
   /* [1] */
   padding-top: 8px;
   padding-right: 0;
   padding-bottom: 8px;
   padding-left: 0;
   min-height: 60px;
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__item {
     flex-basis: auto;
     width: 100%;
     min-height: auto;
     padding-right: 0;
     padding-left: 0;
     background-color: #ffffff;
     /* [16] */
   }
   [data-wizard-collapse="s"] .c-wizard__item.is-disabled {
     background-color: #ffffff;
     /* [16] */
   }
   [data-wizard-collapse="s"] .c-wizard__item.is-done {
     background-color: transparent;
     /* [16] */
   }
   [data-wizard-collapse="s"] .c-wizard__item.is-active {
     background-color: #ffffff;
     /* [16] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item {
     flex-basis: auto;
     width: 100%;
     min-height: auto;
     padding-right: 0;
     padding-left: 0;
     background-color: #ffffff;
     /* [16] */
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-disabled {
     background-color: #ffffff;
     /* [16] */
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-done {
     background-color: transparent;
     /* [16] */
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-active {
     background-color: #ffffff;
     /* [16] */
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__item {
     flex-basis: auto;
     width: 100%;
     min-height: auto;
     padding-right: 0;
     padding-left: 0;
     background-color: #ffffff;
     /* [16] */
   }
   [data-wizard-collapse="m"] .c-wizard__item.is-disabled {
     background-color: #ffffff;
     /* [16] */
   }
   [data-wizard-collapse="m"] .c-wizard__item.is-done {
     background-color: transparent;
     /* [16] */
   }
   [data-wizard-collapse="m"] .c-wizard__item.is-active {
     background-color: #ffffff;
     /* [16] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item {
     flex-basis: auto;
     width: 100%;
     min-height: auto;
     padding-right: 0;
     padding-left: 0;
     background-color: #ffffff;
     /* [16] */
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-disabled {
     background-color: #ffffff;
     /* [16] */
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-done {
     background-color: transparent;
     /* [16] */
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-active {
     background-color: #ffffff;
     /* [16] */
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__item {
     flex-basis: auto;
     width: 100%;
     min-height: auto;
     padding-right: 0;
     padding-left: 0;
     background-color: #ffffff;
     /* [16] */
   }
   [data-wizard-collapse="l"] .c-wizard__item.is-disabled {
     background-color: #ffffff;
     /* [16] */
   }
   [data-wizard-collapse="l"] .c-wizard__item.is-done {
     background-color: transparent;
     /* [16] */
   }
   [data-wizard-collapse="l"] .c-wizard__item.is-active {
     background-color: #ffffff;
     /* [16] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item {
     flex-basis: auto;
     width: 100%;
     min-height: auto;
     padding-right: 0;
     padding-left: 0;
     background-color: #ffffff;
     /* [16] */
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-disabled {
     background-color: #ffffff;
     /* [16] */
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-done {
     background-color: transparent;
     /* [16] */
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-active {
     background-color: #ffffff;
     /* [16] */
   }
 }
 
 .c-wizard__item.is-highlight, .c-wizard__item.is-active {
   /* [7] */
 }
 
 .c-wizard__item.is-highlight::before, .c-wizard__item.is-highlight::after, .c-wizard__item.is-active::before, .c-wizard__item.is-active::after {
   content: "";
   position: absolute;
   z-index: 2;
   /* [14] */
   right: 0;
   display: block;
   width: 100%;
   height: 50%;
   background-color: #ffffff;
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__item.is-highlight::before, [data-wizard-collapse="s"] .c-wizard__item.is-highlight::after, [data-wizard-collapse="s"] .c-wizard__item.is-active::before, [data-wizard-collapse="s"] .c-wizard__item.is-active::after {
     display: none;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-highlight::before, .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-highlight::after, .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-active::before, .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-active::after {
     display: none;
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__item.is-highlight::before, [data-wizard-collapse="m"] .c-wizard__item.is-highlight::after, [data-wizard-collapse="m"] .c-wizard__item.is-active::before, [data-wizard-collapse="m"] .c-wizard__item.is-active::after {
     display: none;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-highlight::before, .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-highlight::after, .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-active::before, .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-active::after {
     display: none;
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__item.is-highlight::before, [data-wizard-collapse="l"] .c-wizard__item.is-highlight::after, [data-wizard-collapse="l"] .c-wizard__item.is-active::before, [data-wizard-collapse="l"] .c-wizard__item.is-active::after {
     display: none;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-highlight::before, .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-highlight::after, .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-active::before, .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-active::after {
     display: none;
   }
 }
 
 .c-wizard__item.is-highlight::before, .c-wizard__item.is-active::before {
   top: 0;
   transform: skew(15deg, 0deg);
   /* [7] */
 }
 
 .c-wizard__item.is-highlight::after, .c-wizard__item.is-active::after {
   top: auto;
   bottom: 0;
   transform: skew(-15deg, 0deg);
   /* [7] */
 }
 
 .c-wizard__item.is-active::before, .c-wizard__item.is-active::after {
   background-color: #ffffff;
   /* [9] */
 }
 
 .c-wizard__item:first-child.is-active::before, .c-wizard__item:first-child.is-active::after {
   width: 125%;
   /* [8] */
 }
 
 .c-wizard__item:last-child.is-active::before, .c-wizard__item:last-child.is-active::after {
   right: auto;
   left: 0;
   width: 125%;
   /* [8] */
 }
 
 .c-wizard__link {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   position: relative;
   /* [11] */
   z-index: 3;
   /* [14] */
   display: flex;
   flex-direction: row;
   align-items: center;
   /* [26] */
   justify-content: left;
   /* [25] */
   height: 100%;
   /* [17] */
   text-decoration: none;
   text-align: left;
   color: #1a1a1a;
   cursor: default;
   /* [11] */
   pointer-events: none;
   /* [11] */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__link {
     flex-direction: row;
     /* [13] */
     align-items: center;
     /* [26] */
     justify-content: flex-start;
     /* [13] */
     padding-top: 8px;
     padding-bottom: 8px;
     text-align: left;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__link {
     flex-direction: row;
     /* [13] */
     align-items: center;
     /* [26] */
     justify-content: flex-start;
     /* [13] */
     padding-top: 8px;
     padding-bottom: 8px;
     text-align: left;
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__link {
     flex-direction: row;
     /* [13] */
     align-items: center;
     /* [26] */
     justify-content: flex-start;
     /* [13] */
     padding-top: 8px;
     padding-bottom: 8px;
     text-align: left;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__link {
     flex-direction: row;
     /* [13] */
     align-items: center;
     /* [26] */
     justify-content: flex-start;
     /* [13] */
     padding-top: 8px;
     padding-bottom: 8px;
     text-align: left;
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__link {
     flex-direction: row;
     /* [13] */
     align-items: center;
     /* [26] */
     justify-content: flex-start;
     /* [13] */
     padding-top: 8px;
     padding-bottom: 8px;
     text-align: left;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__link {
     flex-direction: row;
     /* [13] */
     align-items: center;
     /* [26] */
     justify-content: flex-start;
     /* [13] */
     padding-top: 8px;
     padding-bottom: 8px;
     text-align: left;
   }
 }
 
 .c-wizard__item.is-disabled .c-wizard__link {
   color: #afb5ab;
   /* [9] */
 }
 
 .c-wizard__item.is-done .c-wizard__link,
 .c-wizard__item.is-active .c-wizard__link,
 .c-wizard__item.is-error .c-wizard__link {
   cursor: pointer;
   /* [12] */
   pointer-events: auto;
   /* [12] */
 }
 
 .c-wizard__item.has-no-interaction .c-wizard__link {
   pointer-events: none;
   /* [24] */
 }
 
 .c-wizard__item.is-done .c-wizard__link:hover, .c-wizard__item.is-done .c-wizard__link:focus {
   color: #1a1a1a;
   /* [10] */
 }
 
 .c-wizard__item.is-done .c-wizard__link:hover, .c-wizard__item.is-done .c-wizard__link:focus {
   /* stylelint-disable-next-line selector-max-specificity */
 }
 
 .c-wizard__item.is-done .c-wizard__link:hover::before, .c-wizard__item.is-done .c-wizard__link:focus::before {
   color: #1a1a1a;
   /* [21] */
 }
 
 .c-wizard__item.is-active .c-wizard__link:hover, .c-wizard__item.is-active .c-wizard__link:focus {
   color: #1a1a1a;
   /* [10] */
 }
 
 .c-wizard__item.is-active .c-wizard__link:hover, .c-wizard__item.is-active .c-wizard__link:focus {
   /* stylelint-disable-next-line selector-max-specificity */
 }
 
 .c-wizard__item.is-active .c-wizard__link:hover::before, .c-wizard__item.is-active .c-wizard__link:focus::before {
   color: #1a1a1a;
   /* [21] */
 }
 
 .c-wizard__item.is-error .c-wizard__link {
   color: #ba2525;
   /* [9] */
 }
 
 .c-wizard__link::before {
   border-radius: 50%;
   padding: 6px;
 }
 
 .c-wizard__link::before {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   flex-grow: 0;
   flex-shrink: 0;
   flex-basis: 36px;
   width: 36px;
   height: 36px;
   margin-right: 4px;
   color: #1a1a1a;
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   /* [18] */
   content: "";
   /* [29] */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .c-wizard__link::before {
     /* [30] */
     flex-basis: auto;
   }
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__link::before {
     margin-right: 4px;
     margin-bottom: 0;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__link::before {
     margin-right: 4px;
     margin-bottom: 0;
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__link::before {
     margin-right: 4px;
     margin-bottom: 0;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__link::before {
     margin-right: 4px;
     margin-bottom: 0;
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__link::before {
     margin-right: 4px;
     margin-bottom: 0;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__link::before {
     margin-right: 4px;
     margin-bottom: 0;
   }
 }
 
 .c-wizard__item.is-disabled .c-wizard__link::before {
   color: #afb5ab;
   /* [20] */
 }
 
 .c-wizard__item.is-done .c-wizard__link::before {
   content: "\e952";
   /* [20] */
 }
 
 .c-wizard__item.is-error .c-wizard__link::before {
   content: "\e962";
   /* [20] */
   color: #ba2525;
   /* [20] */
 }
 
 .c-wizard__link-title {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
 }
 
 .c-wizard__trigger {
   display: none;
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__trigger {
     padding: 0;
     border: 0;
     background-color: transparent;
     display: flex;
     align-items: center;
     /* [27] */
     max-width: calc(1280px + 64px);
     padding-left: 32px;
     padding-right: 32px;
     margin-right: auto;
     margin-left: auto;
     /* [27] */
     width: 100%;
     min-height: 60px;
     padding-top: 8px;
     padding-bottom: 8px;
     color: #1a1a1a;
     background-color: #ffffff;
   }
   [data-wizard-collapse="s"] .c-wizard__trigger:focus {
     outline: 0;
   }
 }
 
 @media (max-width: 720px) and (max-width: 960px) {
   [data-wizard-collapse="s"] .c-wizard__trigger {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) and (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__trigger {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 720px) and (max-width: 480px) {
   [data-wizard-collapse="s"] .c-wizard__trigger {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__trigger:hover, [data-wizard-collapse="s"] .c-wizard__trigger:focus {
     color: #1a1a1a;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger {
     padding: 0;
     border: 0;
     background-color: transparent;
     display: flex;
     align-items: center;
     /* [27] */
     max-width: calc(1280px + 64px);
     padding-left: 32px;
     padding-right: 32px;
     margin-right: auto;
     margin-left: auto;
     /* [27] */
     width: 100%;
     min-height: 60px;
     padding-top: 8px;
     padding-bottom: 8px;
     color: #1a1a1a;
     background-color: #ffffff;
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger:focus {
     outline: 0;
   }
 }
 
 @media (max-width: 960px) and (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 960px) and (max-width: 720px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 960px) and (max-width: 480px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger:hover, .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger:focus {
     color: #1a1a1a;
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__trigger {
     padding: 0;
     border: 0;
     background-color: transparent;
     display: flex;
     align-items: center;
     /* [27] */
     max-width: calc(1280px + 64px);
     padding-left: 32px;
     padding-right: 32px;
     margin-right: auto;
     margin-left: auto;
     /* [27] */
     width: 100%;
     min-height: 60px;
     padding-top: 8px;
     padding-bottom: 8px;
     color: #1a1a1a;
     background-color: #ffffff;
   }
   [data-wizard-collapse="m"] .c-wizard__trigger:focus {
     outline: 0;
   }
 }
 
 @media (max-width: 960px) and (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__trigger {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 960px) and (max-width: 720px) {
   [data-wizard-collapse="m"] .c-wizard__trigger {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 960px) and (max-width: 480px) {
   [data-wizard-collapse="m"] .c-wizard__trigger {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__trigger:hover, [data-wizard-collapse="m"] .c-wizard__trigger:focus {
     color: #1a1a1a;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger {
     padding: 0;
     border: 0;
     background-color: transparent;
     display: flex;
     align-items: center;
     /* [27] */
     max-width: calc(1280px + 64px);
     padding-left: 32px;
     padding-right: 32px;
     margin-right: auto;
     margin-left: auto;
     /* [27] */
     width: 100%;
     min-height: 60px;
     padding-top: 8px;
     padding-bottom: 8px;
     color: #1a1a1a;
     background-color: #ffffff;
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger:focus {
     outline: 0;
   }
 }
 
 @media (max-width: 960px) and (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 960px) and (max-width: 720px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 960px) and (max-width: 480px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger:hover, .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger:focus {
     color: #1a1a1a;
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__trigger {
     padding: 0;
     border: 0;
     background-color: transparent;
     display: flex;
     align-items: center;
     /* [27] */
     max-width: calc(1280px + 64px);
     padding-left: 32px;
     padding-right: 32px;
     margin-right: auto;
     margin-left: auto;
     /* [27] */
     width: 100%;
     min-height: 60px;
     padding-top: 8px;
     padding-bottom: 8px;
     color: #1a1a1a;
     background-color: #ffffff;
   }
   [data-wizard-collapse="l"] .c-wizard__trigger:focus {
     outline: 0;
   }
 }
 
 @media (max-width: 1280px) and (max-width: 960px) {
   [data-wizard-collapse="l"] .c-wizard__trigger {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 1280px) and (max-width: 720px) {
   [data-wizard-collapse="l"] .c-wizard__trigger {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 1280px) and (max-width: 480px) {
   [data-wizard-collapse="l"] .c-wizard__trigger {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__trigger:hover, [data-wizard-collapse="l"] .c-wizard__trigger:focus {
     color: #1a1a1a;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger {
     padding: 0;
     border: 0;
     background-color: transparent;
     display: flex;
     align-items: center;
     /* [27] */
     max-width: calc(1280px + 64px);
     padding-left: 32px;
     padding-right: 32px;
     margin-right: auto;
     margin-left: auto;
     /* [27] */
     width: 100%;
     min-height: 60px;
     padding-top: 8px;
     padding-bottom: 8px;
     color: #1a1a1a;
     background-color: #ffffff;
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger:focus {
     outline: 0;
   }
 }
 
 @media (max-width: 960px) and (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 960px) and (max-width: 720px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 960px) and (max-width: 480px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger:hover, .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger:focus {
     color: #1a1a1a;
   }
 }
 
 .c-wizard__trigger-icon {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   color: inherit;
   margin-right: 4px;
 }
 
 .c-wizard__trigger-icon::before {
   border-radius: 50%;
   padding: 4px;
 }
 
 .c-wizard__trigger-icon::before {
   border: 1px solid transparent;
   background-color: transparent;
 }
 
 .c-wizard__trigger-icon::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   content: "\e913";
 }
 
 .c-wizard__trigger[aria-expanded='false'] .c-wizard__trigger-icon::before {
   content: "\e910";
 }
 
 .c-wizard__trigger-text {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   text-align: left;
 }
 
 .c-wizard__trigger-counter {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   margin-left: 0;
 }
 
 .c-wizard--no-interaction .c-wizard__list * {
   pointer-events: none !important;
   /* stylelint-disable-line itcss/no-at-important */
   /* [24] */
 }
 
 /**
  * [1] Horizontally align text elements with and without icons.
  * [2] Use a linear gradient as bottom border to allow different border widths
  *     without influencing the positioning of item content.
  * [3] Set a minimum height for collapsed links to apply the same height to
  *     items with and without icons.
  * [4] Vertically align link text, regardless if the links have an icon or not.
  * [5] Remove bottom border from collapsed links.
  * [6] Use a linear gradient for the bottom border of the non-expanded trigger
  *     button to allow partial lengths.
  * [7] `$generic-wizard-trigger-border-width-active` is the width of the trigger
  *     button bottom border.
  * [8] Move the trigger button icon to the right.
  * [9] Position the trigger counter on the right below the wizard.
  * [10] Make sure, that ::before elements only gets displayed, if an wizard link
  *      contains an icon.
  */
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] {
     position: relative;
     /* [9] */
     margin-bottom: 24px;
     margin-right: 16px;
     margin-left: 16px;
     border-bottom: 1px solid #afb5ab;
   }
 }
 
 /* stylelint-disable-next-line order/order */
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) {
     position: relative;
     /* [9] */
     margin-bottom: 24px;
     margin-right: 16px;
     margin-left: 16px;
     border-bottom: 1px solid #afb5ab;
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] {
     position: relative;
     /* [9] */
     margin-bottom: 24px;
     margin-right: 16px;
     margin-left: 16px;
     border-bottom: 1px solid #afb5ab;
   }
 }
 
 /* stylelint-disable-next-line order/order */
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) {
     position: relative;
     /* [9] */
     margin-bottom: 24px;
     margin-right: 16px;
     margin-left: 16px;
     border-bottom: 1px solid #afb5ab;
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] {
     position: relative;
     /* [9] */
     margin-bottom: 24px;
     margin-right: 16px;
     margin-left: 16px;
     border-bottom: 1px solid #afb5ab;
   }
 }
 
 /* stylelint-disable-next-line order/order */
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) {
     position: relative;
     /* [9] */
     margin-bottom: 24px;
     margin-right: 16px;
     margin-left: 16px;
     border-bottom: 1px solid #afb5ab;
   }
 }
 
 .c-wizard__item {
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__item:first-child {
     margin-top: 8px;
   }
   [data-wizard-collapse="s"] .c-wizard__item:last-child {
     margin-bottom: 8px;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item:first-child {
     margin-top: 8px;
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item:last-child {
     margin-bottom: 8px;
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__item:first-child {
     margin-top: 8px;
   }
   [data-wizard-collapse="m"] .c-wizard__item:last-child {
     margin-bottom: 8px;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item:first-child {
     margin-top: 8px;
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item:last-child {
     margin-bottom: 8px;
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__item:first-child {
     margin-top: 8px;
   }
   [data-wizard-collapse="l"] .c-wizard__item:last-child {
     margin-bottom: 8px;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item:first-child {
     margin-top: 8px;
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item:last-child {
     margin-bottom: 8px;
   }
 }
 
 /* stylelint-disable selector-max-specificity, selector-max-class */
 .c-wizard__item:not(.c-wizard__item.is-error):not(.c-wizard__item.is-done) .c-wizard__link {
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__item:not(.c-wizard__item.is-error):not(.c-wizard__item.is-done) .c-wizard__link::before {
     display: block;
     /* [1] */
     margin-right: 28px;
     /* [1] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item:not(.c-wizard__item.is-error):not(.c-wizard__item.is-done) .c-wizard__link::before {
     display: block;
     /* [1] */
     margin-right: 28px;
     /* [1] */
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__item:not(.c-wizard__item.is-error):not(.c-wizard__item.is-done) .c-wizard__link::before {
     display: block;
     /* [1] */
     margin-right: 28px;
     /* [1] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item:not(.c-wizard__item.is-error):not(.c-wizard__item.is-done) .c-wizard__link::before {
     display: block;
     /* [1] */
     margin-right: 28px;
     /* [1] */
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__item:not(.c-wizard__item.is-error):not(.c-wizard__item.is-done) .c-wizard__link::before {
     display: block;
     /* [1] */
     margin-right: 28px;
     /* [1] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item:not(.c-wizard__item.is-error):not(.c-wizard__item.is-done) .c-wizard__link::before {
     display: block;
     /* [1] */
     margin-right: 28px;
     /* [1] */
   }
 }
 
 .c-wizard__item.is-done .c-wizard__link.c-wizard__link::before {
   color: #187085;
 }
 
 .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover {
   background-image: linear-gradient(to top, currentColor, currentColor);
   /* [2] */
   background-size: 100% 1px;
   /* [2] */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover {
     background-image: none;
   }
   [data-wizard-collapse="s"] .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover .c-wizard__link-title {
     text-decoration: underline;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover {
     background-image: none;
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover .c-wizard__link-title {
     text-decoration: underline;
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover {
     background-image: none;
   }
   [data-wizard-collapse="m"] .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover .c-wizard__link-title {
     text-decoration: underline;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover {
     background-image: none;
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover .c-wizard__link-title {
     text-decoration: underline;
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover {
     background-image: none;
   }
   [data-wizard-collapse="l"] .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover .c-wizard__link-title {
     text-decoration: underline;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover {
     background-image: none;
   }
   .c-wizard:not([data-wizard-collapse]) .c-wizard__item.is-done .c-wizard__link.c-wizard__link:hover .c-wizard__link-title {
     text-decoration: underline;
   }
 }
 
 /* stylelint-enable selector-max-specificity, selector-max-class */
 .c-wizard__link {
   padding-right: 16px;
   padding-bottom: 16px;
   background-image: linear-gradient(to top, #afb5ab, #afb5ab);
   /* [2] */
   background-size: 100% 1px;
   /* [2] */
   background-repeat: no-repeat;
   /* [2] */
   background-position: bottom;
   /* [2] */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__link {
     min-height: 36px;
     /* [3] */
     padding-bottom: 0;
     padding-left: 40px;
     /* [4] */
     background-image: none;
     /* [5] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__link {
     min-height: 36px;
     /* [3] */
     padding-bottom: 0;
     padding-left: 40px;
     /* [4] */
     background-image: none;
     /* [5] */
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__link {
     min-height: 36px;
     /* [3] */
     padding-bottom: 0;
     padding-left: 40px;
     /* [4] */
     background-image: none;
     /* [5] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__link {
     min-height: 36px;
     /* [3] */
     padding-bottom: 0;
     padding-left: 40px;
     /* [4] */
     background-image: none;
     /* [5] */
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__link {
     min-height: 36px;
     /* [3] */
     padding-bottom: 0;
     padding-left: 40px;
     /* [4] */
     background-image: none;
     /* [5] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__link {
     min-height: 36px;
     /* [3] */
     padding-bottom: 0;
     padding-left: 40px;
     /* [4] */
     background-image: none;
     /* [5] */
   }
 }
 
 .is-active .c-wizard__link {
   background-image: linear-gradient(to top, #187085, #187085);
   /* [2] */
   background-size: 100% 2px;
   /* [2] */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .is-active .c-wizard__link {
     font-weight: 700;
     background-image: none;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .is-active .c-wizard__link {
     font-weight: 700;
     background-image: none;
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .is-active .c-wizard__link {
     font-weight: 700;
     background-image: none;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .is-active .c-wizard__link {
     font-weight: 700;
     background-image: none;
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .is-active .c-wizard__link {
     font-weight: 700;
     background-image: none;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .is-active .c-wizard__link {
     font-weight: 700;
     background-image: none;
   }
 }
 
 .is-error .c-wizard__link {
   background-image: linear-gradient(to top, currentColor, currentColor);
   /* [2] */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .is-error .c-wizard__link {
     background-image: none;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .is-error .c-wizard__link {
     background-image: none;
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .is-error .c-wizard__link {
     background-image: none;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .is-error .c-wizard__link {
     background-image: none;
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .is-error .c-wizard__link {
     background-image: none;
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .is-error .c-wizard__link {
     background-image: none;
   }
 }
 
 .c-wizard__link::before {
   flex-basis: 0;
   /* [10] */
   padding-left: 0;
   padding-right: 0;
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__link::before {
     margin-left: -40px;
     /* [4] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__link::before {
     margin-left: -40px;
     /* [4] */
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__link::before {
     margin-left: -40px;
     /* [4] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__link::before {
     margin-left: -40px;
     /* [4] */
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__link::before {
     margin-left: -40px;
     /* [4] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__link::before {
     margin-left: -40px;
     /* [4] */
   }
 }
 
 .c-wizard__trigger {
   background-image: linear-gradient(to top, #187085, #187085);
   /* [6] */
   background-size: 90% 2px;
   /* [6] */
   /* [7] */
   background-position: bottom left;
   /* [6] */
   background-repeat: no-repeat;
   /* [6] */
 }
 
 .c-wizard__trigger-text {
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
   /* stylelint-disable-next-line order/order */
 }
 
 @media (max-width: 720px) {
   [data-wizard-collapse="s"] .c-wizard__trigger-text {
     margin-left: 28px;
     /* [1] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger-text {
     margin-left: 28px;
     /* [1] */
   }
 }
 
 @media (max-width: 960px) {
   [data-wizard-collapse="m"] .c-wizard__trigger-text {
     margin-left: 28px;
     /* [1] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger-text {
     margin-left: 28px;
     /* [1] */
   }
 }
 
 @media (max-width: 1280px) {
   [data-wizard-collapse="l"] .c-wizard__trigger-text {
     margin-left: 28px;
     /* [1] */
   }
 }
 
 @media (max-width: 960px) {
   .c-wizard:not([data-wizard-collapse]) .c-wizard__trigger-text {
     margin-left: 28px;
     /* [1] */
   }
 }
 
 .c-wizard__trigger-icon {
   position: absolute;
   /* [9] */
   right: 8px;
   /* [9] */
   order: 1;
   /* [8] */
 }
 
 .c-wizard__trigger-counter {
   position: absolute;
   /* [9] */
   top: calc(100% + 8px);
   /* [9] */
   right: 16px;
   /* [9] */
   text-align: right;
 }
 
 /* ------------------------------------*\
     #INFO-ICON
 \*------------------------------------ */
 /**
  * [1] Vertically align icon, if needed.
  * [2] Reduce the height of Info Icon by removing the padding
  *     inherited from the `icon-variant` mixin.
  * [3] Ensure other components are not affected by the Info Icon.
  * [4] Horizontal spacing.
  * [5] Additional styles for brands that need a CSS border.
  * [6] Fix clipping by slightly offsetting (Safari).
  */
 .c-info-icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   color: #187085;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
   position: relative;
   /* [3] */
   margin-top: -100px;
   /* [3] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   margin-bottom: -100px;
   /* [3] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   /* [4] */
   padding: 0.03em;
   /* [6] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   line-height: 1;
   /* [3] */
   vertical-align: middle;
   /* [1] */
 }
 
 .c-info-icon::after {
   border-radius: 50%;
   padding: 5px;
 }
 
 .c-info-icon::after {
   border: 1px solid #1a1a1a;
 }
 
 /* [1] */
 [data-theme="alternative"] .c-info-icon,
 .u-bg-alternative .c-info-icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   color: #1a1a1a;
 }
 
 [data-theme="alternative"] .c-info-icon::after,
 .u-bg-alternative .c-info-icon::after {
   border-radius: 50%;
   padding: 6px;
 }
 
 .c-info-icon::before {
   padding: 0;
   /* [2] */
   line-height: 1;
 }
 
 /* ------------------------------------*\
     #HERO-TEASER
 \*------------------------------------ */
 /**
  * [1]  Reference for the `.c-hero-teaser__image`.
  * [2]  Prepare for worst case: If the text content does not fit the hero-teaser
  *      container, at least cut off its overflow.
  * [3]  Provide anchor point modifiers for the hero-teaser image.
  * [4]  By default, when the image is cropped inside the hero-teaser
  *      container, crop it from the dead center.
  * [5]  Always fill the entire hero-teaser container with the image.
  * [6]  Override standard behaviour, so the image can bleed out over the
  *      viewport edges.
  * [7]  The hero image should not reserve any height, if `.c-hero-teaser--auto`,
         since the content controls the height in this case.
  * [8]  Set position to `relative` so it reserves the necessary height.
  * [9]  Provide the correct spacing between the page-head (i.e. logo) and the
  *      hero-teaser content.
  * [10] Position content on top of image.
  * [11] Reset default spacing.
  * [12] Since the content defines the height of the hero image for
  *      `.c-hero-teaser--auto`, centering the content does not make sense.
  * [14] Provide fallback for existing br tags between title_row spans.
  * [15] If activated (by default), align content horizontally with global
  *      page wrap.
  * [16] Fix wrapping issue of content in IE11.
  * [17] Fixes a vertical offset when `$hero-teaser-content-default-margin-bottom` is set.
  *      The `margin-bottom` of the last child of `.c-hero-teaser__heading` creates
  *      an extra space and thus is resetted here .
  * [18] Set optional max width and center hero teaser horizontally.
  * [19] Conditionally reset the heading utility styles.
  *      @TODO: This should be refactored once the `.u-h4` is removed in the markup via BRON-6121.
  * [20] Set inverted variant button styles.
  *
  */
 .c-hero-teaser {
   position: relative;
   /* [1] */
   overflow: hidden;
   /* [2] */
 }
 
 .c-hero-teaser__image {
   object-fit: cover;
   font-family: "object-fit: cover;";
   /* [3] [4] */
   height: 700px;
   position: relative;
   z-index: 700;
   width: 100%;
   min-width: 100%;
   /* [5] */
   max-width: none;
   /* [6] */
   /* [3] */
   /* [3] */
   /* [3] */
   /* [3] */
   /* [3] */
   /* [3] */
   /* [3] */
   /* [3] */
 }
 
 @media (max-width: 720px) {
   .c-hero-teaser__image {
     height: 540px;
   }
 }
 
 @media (max-width: 480px) {
   .c-hero-teaser__image {
     height: 320px;
   }
 }
 
 .c-hero-teaser--shallow .c-hero-teaser__image {
   height: 540px;
 }
 
 @media (max-width: 720px) {
   .c-hero-teaser--shallow .c-hero-teaser__image {
     height: 480px;
   }
 }
 
 @media (max-width: 480px) {
   .c-hero-teaser--shallow .c-hero-teaser__image {
     height: 280px;
   }
 }
 
 .c-hero-teaser--auto .c-hero-teaser__image {
   height: 100%;
   /* [6] */
 }
 
 @media (min-width: 481px) {
   .c-hero-teaser--auto .c-hero-teaser__image {
     position: absolute;
     /* [7] */
   }
 }
 
 .c-hero-teaser--top-center .c-hero-teaser__image {
   object-fit: cover;
   object-position: top center;
   font-family: "object-fit: cover; object-position: top center;";
 }
 
 .c-hero-teaser--top-left .c-hero-teaser__image {
   object-fit: cover;
   object-position: top left;
   font-family: "object-fit: cover; object-position: top left;";
 }
 
 .c-hero-teaser--top-right .c-hero-teaser__image {
   object-fit: cover;
   object-position: top right;
   font-family: "object-fit: cover; object-position: top right;";
 }
 
 .c-hero-teaser--center-left .c-hero-teaser__image {
   object-fit: cover;
   object-position: center left;
   font-family: "object-fit: cover; object-position: center left;";
 }
 
 .c-hero-teaser--center-right .c-hero-teaser__image {
   object-fit: cover;
   object-position: center right;
   font-family: "object-fit: cover; object-position: center right;";
 }
 
 .c-hero-teaser--bottom-center .c-hero-teaser__image {
   object-fit: cover;
   object-position: bottom center;
   font-family: "object-fit: cover; object-position: bottom center;";
 }
 
 .c-hero-teaser--bottom-left .c-hero-teaser__image {
   object-fit: cover;
   object-position: bottom left;
   font-family: "object-fit: cover; object-position: bottom left;";
 }
 
 .c-hero-teaser--bottom-right .c-hero-teaser__image {
   object-fit: cover;
   object-position: bottom right;
   font-family: "object-fit: cover; object-position: bottom right;";
 }
 
 .c-hero-teaser__play-button.c-hero-teaser__play-button--video {
   position: absolute;
   z-index: 800;
   left: 50%;
   transform: translate(-50%, -50%);
   top: 160px;
 }
 
 @media (min-width: 481px) {
   .c-hero-teaser__play-button.c-hero-teaser__play-button--video {
     display: none;
   }
 }
 
 @media (max-width: 480px) {
   .c-hero-teaser__play-button.c-hero-teaser__play-button--modal {
     display: none;
   }
 }
 
 .c-hero-teaser__content {
   padding-top: 95px;
   padding-bottom: 32px;
   position: absolute;
   /* [10] */
   z-index: 900;
 }
 
 @media (max-width: 480px) {
   .c-hero-teaser__content {
     padding-top: 0;
     padding-bottom: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .c-hero-teaser__content {
     position: relative;
     /* [8] */
     margin-top: 24px;
   }
 }
 
 .c-hero-teaser:not(.c-hero-teaser--auto) .c-hero-teaser__content {
   /* [12] */
 }
 
 @media (min-width: 481px) {
   .c-hero-teaser:not(.c-hero-teaser--auto) .c-hero-teaser__content {
     top: 0;
     right: 0;
     bottom: 0;
     left: 0;
   }
 }
 
 .c-hero-teaser--auto .c-hero-teaser__content {
   position: relative;
 }
 
 .c-hero-teaser__content-inner {
   max-width: calc(1280px + 64px);
   padding-left: 32px;
   padding-right: 32px;
   margin-right: auto;
   margin-left: auto;
   /* [15] */
 }
 
 @media (max-width: 960px) {
   .c-hero-teaser__content-inner {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .c-hero-teaser__content-inner {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .c-hero-teaser__content-inner {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 .c-hero-teaser__heading {
   display: flex;
   flex-direction: column;
   align-items: flex-start;
 }
 
 .c-hero-teaser__heading h1, .c-hero-teaser__heading h2, .c-hero-teaser__heading h3, .c-hero-teaser__heading h4, .c-hero-teaser__heading h5, .c-hero-teaser__heading h6, .c-hero-teaser__heading p {
   /* [11] */
   margin-bottom: 0;
 }
 
 .c-hero-teaser__heading > * {
   max-width: 100%;
   /* [16] */
 }
 
 .c-hero-teaser__title > * {
   display: flex;
   flex-direction: column;
   align-items: flex-start;
 }
 
 .c-hero-teaser__title > * > * {
   max-width: 100%;
   /* [16] */
 }
 
 .c-hero-teaser__title-row + br {
   display: none;
   /* [14] */
 }
 
 .c-hero-teaser__title-row {
   font-size: 2.125rem;
   /* stylelint-disable-line order/order */
 }
 
 @media (min-width: 721px) {
   .c-hero-teaser__title-row {
     font-size: 3rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-hero-teaser__title-row {
     font-size: 3.75rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-hero-teaser__pretitle {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
 }
 
 @media (min-width: 721px) {
   .c-hero-teaser__pretitle {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-hero-teaser__pretitle {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-hero-teaser__subtitle {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
 }
 
 @media (min-width: 721px) {
   .c-hero-teaser__subtitle {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-hero-teaser__subtitle {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-hero-teaser__text {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-hero-teaser__button {
   margin-top: 24px;
 }
 
 @media (min-width: 481px) {
   .c-hero-teaser--inverted {
     /* [20] */
   }
   .c-hero-teaser--inverted .c-hero-teaser__content {
     color: #ffffff;
   }
   .c-hero-teaser--inverted .c-btn {
     border-color: #ffffff;
     background-color: #ffffff;
     color: #1a1a1a;
   }
   .c-hero-teaser--inverted .c-btn:hover {
     border-color: #1a1a1a;
     background-color: #1a1a1a;
     color: #ffffff;
   }
   .c-hero-teaser--inverted .c-btn--link:hover {
     border-color: transparent;
     border-bottom: 1px solid #1a1a1a;
     background-color: transparent;
   }
 }
 
 .c-hero-teaser__guiding-line {
   position: absolute;
   z-index: 901;
   right: 0;
   bottom: 0;
   left: 0;
 }
 
 .c-hero-teaser__title-row * {
   /* [19] */
   display: initial !important;
   /* [19] */
   margin-bottom: initial !important;
   /* [19] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
 }
 
 /* ------------------------------------*\
     #MEDIA-TEASER
 \*------------------------------------ */
 /**
  * [1]  `top` does not have to be aligned, since it's the default.
  * [2]  Convert alignment `bottom` to `flex-end`.
  * [3]  IE11 fix to prevent image from being stretched vertically.
  * [4]  Only align vertically if the ratio is not flexible. If the ratio is
  *      flexible, the image will always take up 100% of the available height and
  *      no alignment is necessary.
  * [5]  Reverse the order of image and the caption.
  * [6]  If inside and outside spacings are the same, there is no need to
  *      overwrite them for the reversed variant.
  * [7]  Add styling for caption elements.
  * [8]  Make both flex-items the same width. Note that setting all flex items
  *      to the same width using `flex: 1 1 0;` will not work here because it
  *      takes paddings into account and will end up with different widths for
  *      some brands.
  * [9]  Remove all bottom-margins from any last element.
  * [10] Make it configurable if top and bottom spacings are set as margins or
  *      paddings.
  * [11] Set the positioning context for the link spanning.
  * [12] Fake a pointer cursor for the full-link variant.
  * [13] Handle both `:hover` and `:focus-within` but add a fallback class for PostCSS.
  * [14] Transform the image when the container receives either a focus-within or hover.
  * [15] This collapses the `.c-media-teaser__media` on content children.
  *      The `0%` is mandatory to make this work on browsers not supporting `align-self`.
  * [16] Clip the image to the `.c-media-teaser__media` when it is scaled.
  * [17] Progressive enhancement for [15].
  * [18] Make the link spanning pseudo from [19] escape its link parent element which has a
  *      relative position context from the normalize styles.
  * [19] This pseudo element makes the parent element spanning across the whole
  *      container set in [11].
  * [20] For the video variant `.c-media-teaser--video` we only span across the
  *      `.c-media-teaser__caption`.
  * [21] Disable transitions for touch devices and for users that prefer reduced motions.
  * [22] Elevate all links and buttons to make them appear on-top of the link span
  *      inside the `.c-media-teaser--full-link` variant.
  */
 .c-media-teaser {
   /* [10] */
 }
 
 @media (min-width: 721px) {
   .c-media-teaser:not(.c-media-teaser--vertical) {
     display: flex;
     /* [4] */
   }
   .c-media-teaser:not(.c-media-teaser--vertical) .c-media-teaser__media,
   .c-media-teaser:not(.c-media-teaser--vertical) .c-media-teaser__caption {
     flex-grow: 0;
     flex-shrink: 1;
     flex-basis: 50%;
     /* [8] */
   }
   .c-media-teaser:not(.c-media-teaser--vertical) .c-media-teaser__image {
     flex-grow: 0;
     flex-shrink: 0;
     /* [3] */
     flex-basis: auto;
   }
   .c-media-teaser:not(.c-media-teaser--vertical) .c-media-teaser__caption {
     /* [1] */
     display: flex;
     flex-direction: column;
     justify-content: center;
     /* [2] */
   }
   .c-media-teaser:not(.c-media-teaser--vertical).c-media-teaser--reversed {
     flex-direction: row-reverse;
     /* [5] */
     /* [6] */
   }
   .c-media-teaser:not(.c-media-teaser--vertical).c-media-teaser--reversed .c-media-teaser__caption {
     padding-right: 24px;
     padding-left: 0;
   }
 }
 
 @media (min-width: 721px) and (max-width: 720px) {
   .c-media-teaser:not(.c-media-teaser--vertical).c-media-teaser--reversed .c-media-teaser__caption {
     padding-right: 0;
   }
 }
 
 .c-media-teaser__caption {
   padding-top: 16px;
   padding-right: 0;
   padding-bottom: 16px;
   padding-left: 24px;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 @media (max-width: 720px) {
   .c-media-teaser__caption {
     padding-top: 24px;
     padding-bottom: 24px;
     padding-left: 0;
   }
 }
 
 /* [1] */
 .c-media-teaser--vertical .c-media-teaser__caption {
   padding-top: 16px;
   padding-right: 0;
   padding-bottom: 16px;
   padding-left: 0;
 }
 
 @media (max-width: 720px) {
   .c-media-teaser--vertical .c-media-teaser__caption {
     padding-top: 24px;
     padding-bottom: 24px;
   }
 }
 
 .c-media-teaser__caption *:last-child {
   margin-bottom: 0;
   /* [9] */
 }
 
 .c-media-teaser__pretitle {
   margin-bottom: 24px;
 }
 
 .c-media-teaser__title {
   margin-bottom: 24px;
 }
 
 .c-media-teaser__body {
   margin-bottom: 24px;
 }
 
 /* [7] */
 .c-media-teaser--full-link {
   position: relative;
   /* [11] */
 }
 
 .c-media-teaser--full-link:hover {
   cursor: pointer;
   /* [12] */
 }
 
 .c-media-teaser--full-link:hover, .c-media-teaser--full-link.focus-within, .c-media-teaser--full-link.focus-within {
   /* [13] */
 }
 
 .c-media-teaser--full-link:hover, .c-media-teaser--full-link:focus-within, .c-media-teaser--full-link.focus-within {
   /* [13] */
 }
 
 .c-media-teaser--full-link:hover .c-media-teaser__image, .c-media-teaser--full-link.focus-within .c-media-teaser__image, .c-media-teaser--full-link.focus-within .c-media-teaser__image {
   transform: scale(1.03);
   /* [14] */
 }
 
 .c-media-teaser--full-link:hover .c-media-teaser__image, .c-media-teaser--full-link:focus-within .c-media-teaser__image, .c-media-teaser--full-link.focus-within .c-media-teaser__image {
   transform: scale(1.03);
   /* [14] */
 }
 
 .c-media-teaser--full-link a,
 .c-media-teaser--full-link button {
   /* [22] */
   position: relative;
   z-index: 1;
 }
 
 .c-media-teaser--full-link .c-media-teaser__media {
   height: 0%;
   /* [15] */
   overflow: hidden;
   /* [16] */
 }
 
 @supports (align-self: flex-start) {
   .c-media-teaser--full-link .c-media-teaser__media {
     /* [17] */
     align-self: flex-start;
     height: auto;
   }
 }
 
 .c-media-teaser--full-link .c-media-teaser__image {
   transition: transform 2.2s cubic-bezier(0.14, 1.12, 0.67, 0.99) 0s;
   /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
 }
 
 @media (prefers-reduced-motion: reduce), (pointer: coarse) {
   .c-media-teaser--full-link .c-media-teaser__image {
     /* [21] */
     transition: none;
   }
 }
 
 .c-media-teaser--full-link .c-media-teaser__link {
   position: static;
   /* [18] */
 }
 
 .c-media-teaser--full-link .c-media-teaser__link::after {
   /* [19] */
   content: "";
   position: absolute;
   left: 0;
   top: 0;
   display: block;
   width: 100%;
   height: 100%;
 }
 
 .c-media-teaser--full-link.c-media-teaser--video .c-media-teaser__caption {
   position: relative;
   /* [20] */
 }
 
 /* ------------------------------------*\
     #MEDIA-GRID (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #MEDIA-GRID
 \*------------------------------------ */
 /**
  * The media grid component places images or icons (with optional text below)
  * next to each other in a smart way, so the amount of items doesn't matter. The
  * items wrap dynamically into new lines, depending on the viewport. It is built
  * with CSS grid and provides a flexbox fallback. The only difference with the
  * flexbox fallback compared to the fully enhanced grid method is that the items
  * that automatically wrap into new lines do not align itself to the left but to
  * the center.
  */
 /**
  * [1] Manage the vertical spacing between items.
  * [2] Manage the horizontal spacing between items.
  * [3] 6 columns on large screen.
  * [4] 4 columns on medium screen.
  * [5] 3 columns on small screen.
  * [6] 2 columns on xsmall screen.
  * [7] Fade out all grid item images except the hovered one on hover and focus.
  * [8] Remove link-border for brands with set border.
  */
 /**
  * Calculate width for Media-Grid items.
  * Used only for the flexbox-based fallback.
  *
  * @param {length} Grid item width.
  * @return {length} Result of width minus the spacings to show the correct count per row.
  */
 .c-media-grid {
   margin: 0;
   padding: 0;
   list-style: none;
   display: flex;
   flex-wrap: wrap;
   justify-content: center;
   margin-top: -24px;
   /* [1] */
   margin-left: -24px;
   /* [2] */
 }
 
 .c-media-grid li {
   display: block;
   margin-bottom: 0;
 }
 
 @supports (display: grid) {
   .c-media-grid {
     display: -ms-grid;
     display: grid;
     /* autoprefixer: ignore next */
     grid-template-columns: repeat(auto-fit, 16.66667%);
     /* [3] */
   }
   @media (max-width: 960px) {
     .c-media-grid {
       /* autoprefixer: ignore next */
       grid-template-columns: repeat(auto-fit, 25%);
       /* [4] */
     }
   }
   @media (max-width: 720px) {
     .c-media-grid {
       /* autoprefixer: ignore next */
       grid-template-columns: repeat(auto-fit, 33.33333%);
       /* [5] */
     }
   }
   @media (max-width: 480px) {
     .c-media-grid {
       /* autoprefixer: ignore next */
       grid-template-columns: repeat(auto-fit, 50%);
       /* [6] */
     }
   }
 }
 
 .c-media-grid:hover .c-media-grid__link .c-media-grid__image,
 .c-media-grid:focus .c-media-grid__link .c-media-grid__image {
   opacity: 0.3;
   /* [7] */
 }
 
 .c-media-grid:hover .c-media-grid__link:hover .c-media-grid__image, .c-media-grid:hover .c-media-grid__link:focus .c-media-grid__image,
 .c-media-grid:focus .c-media-grid__link:hover .c-media-grid__image,
 .c-media-grid:focus .c-media-grid__link:focus .c-media-grid__image {
   /* stylelint-disable-line selector-max-specificity */
   opacity: 1;
   /* [7] */
 }
 
 .c-media-grid .c-media-grid__image {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
 }
 
 .c-media-grid__item {
   flex-grow: 0;
   flex-shrink: 0;
   flex-basis: calc(16.66667% - 24px);
   /* [3] */
   margin-top: 24px;
   /* [1] */
   padding-left: 24px;
   /* [2] */
 }
 
 @media (max-width: 960px) {
   .c-media-grid__item {
     flex-basis: calc(25% - 24px);
     /* [4] */
   }
 }
 
 @media (max-width: 720px) {
   .c-media-grid__item {
     flex-basis: calc(33.33333% - 24px);
     /* [5] */
   }
 }
 
 @media (max-width: 480px) {
   .c-media-grid__item {
     flex-basis: calc(50% - 24px);
     /* [6] */
   }
 }
 
 .c-media-grid__link {
   display: block;
   border: 0;
   /* [8] */
   text-decoration: none;
   text-align: center;
 }
 
 .c-media-grid__label {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   display: block;
   margin-top: 8px;
   font-weight: 400;
   text-transform: uppercase;
 }
 
 /* ------------------------------------*\
    #CAROUSEL
 \*------------------------------------ */
 /**
  * [1] Make sure buttons don't get overlapped by an item.
  * [2] Set the width to 100% to ensure that images always are full width with
  *     their default `max-width: 100%;`.
  * [3] Always center the dots.
  * [4] Add a margin, if the dots are placed outside of the carousel.
  * [5] Center the button vertically.
  * [6] Center the icon and label vertically and horizontally within the button.
  * [7] Center the dots horizontally within the carousel.
  * [8] Transform the dots (e.g. `scale(1.5)`)
  * [9] Add horizontal outer spacing to the carousel items
  *     (e.g. if the design requires space for the buttons)
  * [10] Use opacity in combination with the button transition to fade out
  *      disabled buttons.
  * [11] Center button icons in IE11.
  * [12] Hide component until Flickity is fully loaded and prevent "Flash of
  *      visible button".
  * [13] Transform the prev/next button icons on `:hover`
  * [14] Shift prev/next button labels horizontally on `:hover`
  * [15] Reverse order of icon and label.
  * [16] Anchor `.c-carousel__button-label` for previous and next buttons
  *      in respect to their position.
  * [17] Hide the button labels visually per default.
  * [18] `.flickity-viewport` has no fixed height set in fullscreen mode,
  *      so we need to make sure the items do not exceed the sliderâ€™s boundaries.
  * [19] Make the image always fit inside the fullscreen container.
  * [20] Add pointer target space to the button labels.
  * [21] Always display the buttons with the `.c-carousel--buttons-visible`
  *      modifier class and overwrite package settings.
  * [22] Always hide the buttons with the `.c-carousel--buttons-on-hover`
  *      modifier class and display them only on hover and overwrite package
  *      settings.
  * [23] Always show fullscreen button on "touch" devices.
  * [24] Use `pointer: coarse` media-query to target browsers with
  *      limited precision as primary input device ("touch").
  *      Non-supporting browsers (IE11) can be considered controlled via mouse.
  *      https://caniuse.com/css-media-interaction
  */
 .c-carousel {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   position: relative;
   margin-bottom: 44px;
   /* [4] */
   opacity: 0;
   /* [12] */
 }
 
 .c-carousel.flickity-enabled {
   opacity: 1;
   /* [12] */
 }
 
 .c-carousel.is-fullscreen .c-carousel__item,
 .c-carousel.is-fullscreen .c-carousel__image {
   height: 100%;
   /* [18] */
 }
 
 .c-carousel.is-fullscreen .c-carousel__image {
   object-fit: contain;
   font-family: "object-fit: contain;";
   /* [19] */
 }
 
 .c-carousel .flickity-page-dots {
   position: absolute;
   bottom: -44px;
   left: 50%;
   /* [7] */
   transform: translateX(-50%);
   /* [7] */
 }
 
 .c-carousel .flickity-page-dots .dot {
   /* stylelint-disable-next-line */
 }
 
 .c-carousel .flickity-page-dots .dot::after {
   /* dot circle */
   /* [8] */
 }
 
 .c-carousel .flickity-page-dots .dot.is-selected::after {
   /* selected dot circle */
   /* [8] */
 }
 
 .c-carousel__item {
   width: 100%;
 }
 
 .c-carousel__image {
   object-fit: cover;
   font-family: "object-fit: cover;";
   width: 100%;
   /* [2] */
 }
 
 .c-carousel__button {
   position: absolute;
   z-index: 1;
   /* [1] */
   top: 50%;
   /* [5] */
   display: flex;
   /* [6] */
   align-items: center;
   /* [6] */
   justify-content: center;
   /* [6] */
   width: 44px;
   height: 44px;
   padding: 0;
   /* [11] */
   transform: translateY(-50%);
   /* [5] */
   border: 0;
   background-color: #187085;
   color: #1a1a1a;
   cursor: pointer;
 }
 
 .c-carousel.flickity-enabled .c-carousel__button:not([disabled]) {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   /* [12] */
 }
 
 .c-carousel__button:hover {
   background-color: #2094b0;
 }
 
 .c-carousel__button:focus {
   outline: 0;
 }
 
 .c-carousel__button[disabled] {
   opacity: 0;
   /* [10] */
   pointer-events: none;
   /* [10] */
 }
 
 @media (max-width: 480px) {
   .c-carousel__button {
     display: none;
   }
 }
 
 .c-carousel__button::before {
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   display: block;
 }
 
 .c-carousel__button:hover::before {
   /* prev/next button icon */
   /* [13] */
 }
 
 .c-carousel__button::before,
 .c-carousel__button-label {
   transition: inherit;
 }
 
 .c-carousel__button--next {
   right: 0;
 }
 
 .c-carousel__button--next::before {
   content: "\e946";
 }
 
 .c-carousel__button--prev {
   left: 0;
 }
 
 .c-carousel__button--prev::before {
   content: "\e945";
   display: block;
 }
 
 .c-carousel__button-label {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
   /* [17] */
 }
 
 .c-carousel--buttons-visible {
   /* [21] */
 }
 
 .c-carousel--buttons-visible .c-carousel__button:not([disabled]) {
   opacity: 1;
 }
 
 .c-carousel--buttons-on-hover {
   /* [22] */
   /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
 }
 
 @media (pointer: coarse) {
   .c-carousel--buttons-on-hover {
     /* [24] */
   }
   .c-carousel--buttons-on-hover .flickity-fullscreen-button {
     opacity: 1 !important;
     /* [23] */
   }
 }
 
 .c-carousel--buttons-on-hover .c-carousel__button,
 .c-carousel--buttons-on-hover .flickity-fullscreen-button {
   opacity: 0;
 }
 
 .c-carousel--buttons-on-hover:hover .c-carousel__button:not([disabled]),
 .c-carousel--buttons-on-hover:hover .flickity-fullscreen-button:not([disabled]), .c-carousel--buttons-on-hover:focus .c-carousel__button:not([disabled]),
 .c-carousel--buttons-on-hover:focus .flickity-fullscreen-button:not([disabled]) {
   opacity: 1;
 }
 
 /* ------------------------------------*\
     #STICKY-CONTAINER
 \*------------------------------------ */
 /**
  * [1] As the name suggests, the component is sticky. For browsers that donâ€™t
  *     support `position: sticky`, make sure to provide a JS polyfill. By
  *     default, this is provided in Bronson via the stickyfill polyfill.
  * [2] Ensure that the user is not trapped in scrolling hell when the sticky
  *     container contains lot of content and the vertical space is limited (e.g.
  *     on small screen).
  * [3] Make sure that any potential spacing bottom is eliminated.
  */
 .c-sticky-container {
   position: -webkit-sticky;
   position: sticky;
   /* [1] */
   z-index: 2100;
   top: 0;
   /* [1] */
   max-height: 75vh;
   /* [2] */
   overflow-y: auto;
   /* [2] */
   padding-top: 24px;
   padding-bottom: 24px;
   background-color: #ffffff;
   box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.4);
 }
 
 .c-sticky-container__inner {
   max-width: calc(1280px + 64px);
   padding-left: 32px;
   padding-right: 32px;
   margin-right: auto;
   margin-left: auto;
   width: 100%;
 }
 
 @media (max-width: 960px) {
   .c-sticky-container__inner {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .c-sticky-container__inner {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .c-sticky-container__inner {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 .c-sticky-container__inner > *:last-child {
   margin-bottom: 0;
   /* [3] */
 }
 
 /* ------------------------------------*\
     #FOLD-OUT
 \*------------------------------------ */
 /**
  * [1] Reset default `<button>` styles.
  * [2] Provide vertical spacing when the fold-out is expanded.
  * [3] Display the head and footer icon via pseudo element as it is completely decorative.
  * [4] The footer icon is reversed according to its position.
  * [5] Conditionally display a fold out footer.
  * [6] Make the flex-items collapse on its calculated sizes in IE11 fixing the flex container
  *     take up the intrinsic size of its content rather than the calculated one.
  *     When a tall image for example is used the container takes up the intrinsic image
  *     height instead of the calculated one resulting in a big gap.
  */
 .c-fold-out {
   max-width: calc(1280px + 64px);
   padding-left: 32px;
   padding-right: 32px;
   margin-right: auto;
   margin-left: auto;
 }
 
 @media (max-width: 960px) {
   .c-fold-out {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .c-fold-out {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .c-fold-out {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 .c-fold-out__header {
   padding: 0;
   border: 0;
   background-color: transparent;
   /* [1] */
   display: flex;
   justify-content: space-between;
   align-items: center;
   width: 100%;
   text-align: left;
 }
 
 .c-fold-out__header:focus {
   outline: 0;
 }
 
 @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .c-fold-out__header {
     min-height: 1px;
     /* [6] */
   }
 }
 
 .c-fold-out__header[aria-expanded='true'] {
   margin-bottom: 24px;
   /* [2] */
 }
 
 .c-fold-out__header > * {
   flex-grow: 1;
   flex-shrink: 1;
   flex-basis: auto;
 }
 
 .c-fold-out__header > *:not(:last-child) {
   margin-right: 32px;
 }
 
 @media (max-width: 720px) {
   .c-fold-out__header > *:not(:last-child) {
     margin-right: 16px;
   }
 }
 
 .c-fold-out__content:not([aria-hidden='false']) {
   display: none;
 }
 
 .c-fold-out__content > *:last-child {
   margin-bottom: 0;
 }
 
 .c-fold-out__footer {
   padding: 0;
   border: 0;
   background-color: transparent;
   /* [1] */
   display: none;
   /* [5] */
   text-align: right;
 }
 
 .c-fold-out__footer:focus {
   outline: 0;
 }
 
 .c-fold-out__header,
 .c-fold-out__footer {
   /* [3]  */
 }
 
 .c-fold-out__header::after,
 .c-fold-out__footer::after {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   flex-basis: 36px;
   font-size: 36px;
   margin-left: 32px;
   content: "\e944";
   color: #1a1a1a;
 }
 
 @media (max-width: 720px) {
   .c-fold-out__header::after,
   .c-fold-out__footer::after {
     flex-basis: 24px;
     font-size: 24px;
     margin-left: 16px;
   }
 }
 
 .c-fold-out__header[aria-expanded='false']::after,
 .c-fold-out__footer[aria-expanded='false']::after {
   transform: rotateX(0);
 }
 
 .c-fold-out__header[aria-expanded='true']::after,
 .c-fold-out__footer[aria-expanded='true']::after {
   transform: rotateX(180deg);
 }
 
 /* ------------------------------------*\
     #PRODUCT-INFO
 \*------------------------------------ */
 /**
  * [1] Reset the fixed margins when `grid-gap` is supported.
  * [2] Progressively enhance and half of the grid gutter to pad the children via `margin`.
  * [3] For small viewports we only pad the first elementâ€™s bottom.
  * [4] We are not using the shorthand `grid-gap` because we need to handle the
  *     fallback differently in the default implementation.
  */
 .c-product-info {
   display: -ms-grid;
   display: grid;
   -ms-grid-columns: 1fr 1fr;
   grid-template-columns: 1fr 1fr;
 }
 
 @supports (grid-gap: 1rem) {
   .c-product-info {
     /* autoprefixer: ignore next */
     grid-row-gap: 24px;
     /* [4] */
     /* autoprefixer: ignore next */
     grid-column-gap: 24px;
     /* [4] */
   }
   @media (max-width: 720px) {
     .c-product-info {
       grid-row-gap: 24px;
     }
   }
   @media (max-width: 720px) {
     .c-product-info {
       grid-column-gap: 24px;
     }
   }
   .c-product-info > .c-product-info__media {
     /* [1] */
     margin-right: 0;
     margin-bottom: 0;
   }
   .c-product-info > .c-product-info__aside {
     /* [1] */
     margin-left: 0;
   }
 }
 
 .c-product-info__media {
   -ms-grid-column: 1;
   -ms-grid-column-span: 1;
   grid-column: 1/2;
   margin-right: 12px;
   /* [2] */
 }
 
 @media (max-width: 720px) {
   .c-product-info__media {
     -ms-grid-column: 1;
     -ms-grid-column-span: 2;
     grid-column: 1 / span 2;
     margin-right: 0;
     /* [2] */
     margin-bottom: 24px;
     /* [3] */
   }
 }
 
 .c-product-info__aside {
   -ms-grid-column: 2;
   grid-column: 2/2;
   margin-left: 12px;
   /* [2] */
   background-color: #ffffff;
 }
 
 @media (max-width: 720px) {
   .c-product-info__aside {
     -ms-grid-column: 1;
     -ms-grid-column-span: 2;
     grid-column: 1 / span 2;
     margin-left: 0;
     /* [2] */
   }
 }
 
 .c-product-info__title {
   font-size: 1.625rem;
   /* stylelint-disable-line order/order */
   color: #1a1a1a;
 }
 
 @media (min-width: 721px) {
   .c-product-info__title {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-product-info__title {
     font-size: 2.25rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-product-info__image {
   margin-bottom: 24px;
   display: block;
   max-width: 100%;
 }
 
 .c-product-info__caption {
   color: #1a1a1a;
 }
 
 /* ------------------------------------*\
     #PRODUCT-INFO-SUMMARY (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #PRODUCT-INFO-SUMMARY
 \*------------------------------------ */
 /**
  * [1] In compact mode we remove the bottom spacing from the info label.
  * [2] Pull the info element to the right.
  * [3] Change `flex-direction` to arrange items one below the other.
  */
 .c-product-info-summary {
   display: flex;
   justify-content: space-between;
   align-items: center;
   width: 100%;
   text-align: left;
 }
 
 @media (max-width: 720px) {
   .c-product-info-summary {
     flex-direction: column;
     /* [3] */
     align-items: flex-start;
   }
 }
 
 .c-product-info-summary > * {
   flex-grow: 1;
   flex-shrink: 1;
   flex-basis: auto;
 }
 
 .c-product-info-summary > *:not(:last-child) {
   margin-right: 32px;
 }
 
 @media (max-width: 720px) {
   .c-product-info-summary > *:not(:last-child) {
     margin-right: 16px;
   }
 }
 
 .c-product-info-summary.c-product-info-summary--compact .c-product-info-summary__img {
   display: none;
 }
 
 .c-product-info-summary.c-product-info-summary--compact .c-product-info-summary__info {
   flex-direction: row;
   align-items: baseline;
   justify-content: flex-end;
 }
 
 .c-product-info-summary.c-product-info-summary--compact .c-product-info-summary__info-value {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
   margin-left: 4px;
 }
 
 @media (min-width: 721px) {
   .c-product-info-summary.c-product-info-summary--compact .c-product-info-summary__info-value {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-product-info-summary.c-product-info-summary--compact .c-product-info-summary__info-value {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-product-info-summary.c-product-info-summary--compact .c-product-info-summary__info-label {
   margin-bottom: 0;
   /* [1] */
 }
 
 .c-product-info-summary.c-product-info-summary--compact .c-product-info-summary__heading {
   display: flex;
   align-items: baseline;
   justify-content: flex-start;
 }
 
 .c-product-info-summary.c-product-info-summary--compact .c-product-info-summary__title {
   margin-right: 4px;
   margin-bottom: 0;
 }
 
 .c-product-info-summary__img {
   flex-grow: 0;
   flex-shrink: 1;
   flex-basis: 175px;
 }
 
 @media (max-width: 720px) {
   .c-product-info-summary__img {
     display: none;
   }
 }
 
 @media (max-width: 720px) {
   .c-product-info-summary__heading {
     margin-right: auto;
     margin-left: 0;
   }
 }
 
 .c-product-info-summary__title {
   font-size: 1.625rem;
   /* stylelint-disable-line order/order */
   display: block;
   margin-bottom: 8px;
   font-weight: 400;
 }
 
 @media (min-width: 721px) {
   .c-product-info-summary__title {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-product-info-summary__title {
     font-size: 2.25rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-product-info-summary__subtitle {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   display: block;
   margin-bottom: 0;
 }
 
 @media (max-width: 720px) {
   .c-product-info-summary__subtitle {
     display: none;
   }
 }
 
 .c-product-info-summary__info {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   display: flex;
   flex-direction: column;
   margin-left: auto;
   /* [2] */
   font-weight: 400;
   text-align: right;
 }
 
 @media (min-width: 721px) {
   .c-product-info-summary__info {
     font-size: 1.25rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-product-info-summary__info {
     font-size: 1.75rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (max-width: 720px) {
   .c-product-info-summary__info {
     margin-right: auto;
     margin-left: 0;
     text-align: left;
   }
 }
 
 .c-product-info-summary__info > *:last-child {
   margin-bottom: 0;
 }
 
 /* ------------------------------------*\
     #PLYR-OVERRIDES
 \*------------------------------------ */
 /**
  * This partial overrides the default styles of plyr that couldn't be handled
  * with the variables in `06-vendor/plyr/_vendor.plyr.settings.scss`.
  */
 /**
  * [1]  Remove padding and take care of spacing at another place.
  * [2]  Set the height of the control bar to the correct height.
  * [3]  Initially hide the controls, so you don't see them before
  *      the video started...
  * [4]  ...and show them again when the mouse enters the video container.
  * [5]  The plyr video-player notices, when the mouse hasn't been moved for two
  *      seconds. It then puts the `.plyr--hide-controls` class to the container.
  *      Since we've overridden the basic appearance of the controls with [3]
  *      and [4], we need to override it again here, so that the controls
  *      actually hide after two seconds of no mouse movement.
  * [6]  If you specify voices in the captions, two `<span>`s get generated
  *      inside of each other and both get a half-transparent background and
  *      padding by default which looks kinda odd. This override removes
  *      the background of the inner `<span>`.
  * [7]  Button hover styles for controls.
  * [8]  Play Button hover style.
  * [9]  Unfortunately, we cannot use the `translate` trick to center the icon,
  *      because that doesn't work in older Firefox versions (e.g. v52).
  *      See BRON-828.
  * [10] Position tooltip above control section.
  * [11] Despite set options for volume and mute,
  *      the elements get an `[hidden]` attribute resulting in `display:none`.
  * [12] Change the default control-item order: Play, Volume, ...
  * [13] Target area to bridge gap between volume button and volume slider.
  * [14] Fade-in volume slider.
  * [15] Remove spacing when volume slider is vertical.
  * [16] Override specificity set by plugin styles.
  * [17] Prevent interaction with non-visible poster.
  * [18] Prevent overwrite of width declaration from plyr vendor styles.
  * [19] Remove the transparency of the play button.
  * [20] Use `transition-duration: 0s` instead of `transition: none`.
  *      By default the browser set the `transition-property` to `all`
  *      for each element. Setting the `transition-duration` to the default `0s`
  *      renders the `transition-property` irrelevant.
  * [21] Replace the dotted outline with a visual border as a keyboard-only
  *      focus style. The visual border is accomplished with `box-shadow`.
  * [22] Focus styles of all controls.
  * [23] Handles the track color of the `input[type="range"]`.
  *      Already defined in `plyr/src/sass/components/sliders.scss`.
  *      Since we have disabled CSS custom properties within the plyr styles,
  *      we need to reset the track color here. CSS custom properties are
  *      necessary at this point.
  * [24] Specify `transition-property` to avoid performance issues.
  */
 .plyr--video .plyr__controls {
   height: 60px;
   /* [2] */
   padding: 16px;
   /* [1] */
   background: rgba(0, 0, 0, 0.9);
   opacity: 0;
   /* [3] */
 }
 
 .plyr--video .plyr__controls .plyr__control:hover {
   /* [7] */
   color: #ffffff;
   /* [7] */
 }
 
 .plyr--video .plyr__control:focus {
   outline-color: #ffffff;
   outline-offset: 0;
   outline-style: solid;
   outline-width: 2px;
   transition-duration: 0s;
   /* [20] */
 }
 
 .plyr--video .plyr__control.plyr__tab-focus {
   box-shadow: 0 0 0 5px rgba(24, 112, 133, 0.5);
   /* [21] */
 }
 
 .plyr__captions {
   padding: 24px;
 }
 
 .plyr__captions span span {
   background: transparent;
   /* [6] */
 }
 
 .plyr--video .plyr__progress__buffer {
   box-shadow: none;
 }
 
 @media (max-width: 720px) {
   .plyr__controls {
     height: 30px;
   }
 }
 
 .plyr:hover .plyr__controls {
   opacity: 1;
   /* [4] */
 }
 
 .plyr.plyr--hide-controls:hover .plyr__controls {
   opacity: 0;
   /* [5] */
 }
 
 .c-hero-teaser--video .plyr__controls {
   display: none;
 }
 
 .plyr__controls .plyr__controls__item {
   margin-left: 8px;
 }
 
 .plyr__controls .plyr__controls__item:first-child {
   margin-right: auto;
   margin-left: 0;
 }
 
 .plyr__controls .plyr__time {
   margin-left: 32px;
 }
 
 @media (max-width: 480px) {
   .plyr__controls .plyr__time {
     margin-left: 16px;
   }
 }
 
 .plyr__time--current {
   color: #ffffff;
 }
 
 .plyr__tooltip {
   margin-bottom: 20px;
   /* [10] */
   padding: 16px;
 }
 
 .plyr__control {
   -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
   /* [1] */
   /* stylelint-disable-line sh-waqar/declaration-use-variable */
   width: auto;
   height: auto;
   min-width: auto;
   /* [18] */
   padding: 0;
   border: 0 solid transparent;
   border-radius: 50%;
 }
 
 .plyr__menu__container .plyr__control {
   border: 0;
   border-radius: initial;
 }
 
 .plyr .plyr__control--overlaid {
   width: 60px;
   height: 60px;
   padding: 0;
   border: 2px solid #187085;
   background: #ffffff;
   color: #000000;
   box-shadow: none;
   opacity: 1;
   /* [19] */
 }
 
 .plyr .plyr__control--overlaid:hover, .plyr .plyr__control--overlaid:focus {
   background: #ffffff;
   /* [8] */
   color: #000000;
   /* [8] */
 }
 
 .plyr .plyr__control--overlaid.plyr__tab-focus {
   box-shadow: none;
 }
 
 .c-hero-teaser--video .plyr .plyr__control--overlaid {
   display: none;
 }
 
 .plyr .plyr__control--overlaid svg {
   position: absolute;
   top: 50%;
   left: 50%;
   width: 24px;
   height: 24px;
   margin-top: -12px;
   /* [9] */
   margin-left: -12px;
   /* [9] */
 }
 
 .plyr__poster {
   visibility: hidden;
   /* [17] */
 }
 
 .plyr--stopped.plyr__poster-enabled .plyr__poster {
   visibility: visible;
 }
 
 /* stylelint-disable selector-max-specificity */
 .plyr--full-ui.plyr--video input[type='range']:active::-webkit-slider-thumb {
   transform: scale(1.3);
 }
 
 .plyr--full-ui.plyr--video input[type='range']:active::-moz-range-thumb {
   transform: scale(1.3);
 }
 
 .plyr--full-ui.plyr--video input[type='range']:active::-ms-thumb {
   transform: scale(1.3);
 }
 
 .plyr--full-ui.plyr--video input[type="range"]:focus {
   outline-color: #ffffff;
   outline-offset: 0;
   outline-style: solid;
   outline-width: 2px;
 }
 
 .plyr--full-ui.plyr--video input[type='range']::-webkit-slider-runnable-track {
   background-image: linear-gradient(to right, currentColor var(--value, 0%), transparent var(--value, 0%));
   /* [23] */
 }
 
 .plyr--full-ui.plyr--video input[type="range"].plyr__tab-focus::-webkit-slider-runnable-track {
   box-shadow: 0 0 0 5px rgba(24, 112, 133, 0.5);
   /* [21] */
   outline: 0;
   /* [21] */
   transition-duration: 0s;
   /* [20] */
 }
 
 .plyr--full-ui.plyr--video input[type="range"].plyr__tab-focus::-moz-range-track {
   box-shadow: 0 0 0 5px rgba(24, 112, 133, 0.5);
   /* [21] */
   outline: 0;
   /* [21] */
   transition-duration: 0s;
   /* [20] */
 }
 
 .plyr--full-ui.plyr--video input[type="range"].plyr__tab-focus::-ms-track {
   box-shadow: 0 0 0 5px rgba(24, 112, 133, 0.5);
   /* [21] */
   outline: 0;
   /* [21] */
   transition-duration: 0s;
   /* [20] */
 }
 
 .plyr .plyr__volume {
   /* [11] */
   display: flex;
   flex-grow: 0;
   flex-shrink: 1;
   flex-basis: auto;
 }
 
 @media (max-width: 720px) {
   .plyr .plyr__volume {
     display: none;
   }
 }
 
 .plyr .plyr__volume.plyr__controls__item {
   /* [16] */
   padding-right: 0;
   /* [15] */
 }
 
 .plyr .plyr__volume:hover input[type="range"], .plyr .plyr__volume.focus-within input[type="range"] {
   opacity: 1;
   /* [14] */
   visibility: visible;
   /* [14] */
 }
 
 .plyr .plyr__volume:hover input[type="range"], .plyr .plyr__volume:focus-within input[type="range"] {
   opacity: 1;
   /* [14] */
   visibility: visible;
   /* [14] */
 }
 
 /* stylelint-enable selector-max-specificity */
 .plyr [data-plyr="mute"] {
   /* [11] */
   display: inline-block;
 }
 
 /* ------------------------------------*\
     #FAV-BUTTON
 \*------------------------------------ */
 /**
  * A component to render a toggle-like favorite button.
  */
 /**
  * [1] Reset the default browser button styles.
  * [2] Align the button children and center them vertically.
  * [3] Remove unwanted text-decoration.
  * [4] Handles the _off_ state.
  * [5] Handles the _on_ state.
  * [6] Hide the labels visually but keep them accessible for assistive technology.
  * [7] Prevent click shifts in IE.
  * [8] Disable `flex-shrink` on the icon to maintain its dimensions.
  * [9] Always span the inline SVG to the full width/height of the parent.
  */
 .c-fav-button {
   padding: 0;
   border: 0;
   background-color: transparent;
   /* [1] */
   display: inline-flex;
   /* [2] */
   align-items: center;
   /* [2] */
   text-decoration: none;
   /* [3] */
 }
 
 .c-fav-button:focus {
   outline: 0;
 }
 
 .c-fav-button[aria-pressed="false"] {
   /* [4] */
 }
 
 .c-fav-button[aria-pressed="false"] .c-fav-button__label--on {
   display: none;
 }
 
 .c-fav-button[aria-pressed="false"] .c-fav-button__label--off {
   display: block;
 }
 
 .c-fav-button[aria-pressed="false"] .c-fav-button__icon {
   fill: transparent;
   stroke: #1a1a1a;
 }
 
 .c-fav-button[aria-pressed="true"] {
   /* [5] */
 }
 
 .c-fav-button[aria-pressed="true"] .c-fav-button__label--on {
   display: block;
 }
 
 .c-fav-button[aria-pressed="true"] .c-fav-button__label--off {
   display: none;
 }
 
 .c-fav-button[aria-pressed="true"] .c-fav-button__icon {
   fill: #1a1a1a;
   stroke: #1a1a1a;
 }
 
 .c-fav-button__icon {
   position: relative;
   /* [7] */
   flex-grow: 0;
   flex-shrink: 0;
   /* [8] */
   flex-basis: auto;
   width: 24px;
   height: 24px;
 }
 
 .c-fav-button__label {
   position: relative;
   /* [7] */
   margin-left: 8px;
   text-align: left;
   color: #1a1a1a;
 }
 
 .c-fav-button--icon-only .c-fav-button__label {
   /* [6] */
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px !important;
   height: 1px !important;
   overflow: hidden !important;
   clip: rect(1px, 1px, 1px, 1px) !important;
 }
 
 .c-fav-button__svg {
   width: 100%;
   /* [9] */
   height: 100%;
   /* [9] */
   stroke-width: 1px;
 }
 
 /* ------------------------------------*\
     #BLOCKQUOTE
 \*------------------------------------ */
 .c-blockquote {
   margin-bottom: 0;
 }
 
 .c-blockquote__text {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 @media (min-width: 721px) {
   .c-blockquote__text {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-blockquote__text {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 /* [1] */
 /* [1] */
 .c-blockquote__footer {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 /* [1] */
 .c-blockquote__cite {
   font-style: normal;
 }
 
 /* ------------------------------------*\
     #FLOATING-BUTTON
 \*------------------------------------ */
 /**
  * [1] Allow click-through events if click-targets are behind the sticky
  *     back-to-top container.
  * [2] Reset default button padding to prevent issues with size.
  * [3] Ensure correct positioning, independent of parent's spacings etc.
  */
 .c-floating-button {
   max-width: calc(1280px + 64px);
   padding-left: 32px;
   padding-right: 32px;
   margin-right: auto;
   margin-left: auto;
 }
 
 @media (max-width: 960px) {
   .c-floating-button {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .c-floating-button {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .c-floating-button {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 .c-floating-button__wrapper {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   position: fixed;
   z-index: 1200;
   bottom: 24px;
   left: 0;
   /* [3] */
   width: 100%;
   text-align: right;
   pointer-events: none;
   /* [1] */
 }
 
 .c-floating-button__button {
   width: 60px;
   height: 60px;
   padding: 0;
   /* [2] */
   border-radius: 50%;
   pointer-events: auto;
   /* [1] */
 }
 
 .c-floating-button__icon {
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   color: inherit;
 }
 
 .c-floating-button__label {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
   color: inherit;
 }
 
 /* ------------------------------------*\
     #FLOATING-BAR
 \*------------------------------------ */
 /**
  * [1] FLIP the transform to hoist element in the transform context to optimise transition. https://aerotwist.com/blog/flip-your-animations/
  * [2] Disable potential links styles.
  * [3] Display the action icon here flush-right aligned with the page-wrap.
  */
 .c-floating-bar {
   padding-top: 16px;
   padding-bottom: 16px;
   position: fixed;
   z-index: 1800;
   top: 0;
   right: 0;
   left: 0;
   width: 100%;
   transform: translateY(-100%);
   /* [1] */
   border-bottom: none;
   /* [2] */
   text-decoration: none;
   /* [2] */
   background-color: #ffffff;
   transition: opacity 250ms ease, transform 250ms ease;
   opacity: 0;
   box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.4);
 }
 
 @media (max-width: 720px) {
   .c-floating-bar {
     padding-top: 8px;
     padding-bottom: 8px;
   }
 }
 
 .c-floating-bar.has-target-outside-view.has-target-leave-above-view {
   transform: translateY(0);
   /* [1] */
   opacity: 1;
 }
 
 .c-floating-bar__inner {
   max-width: calc(1280px + 64px);
   padding-left: 32px;
   padding-right: 32px;
   margin-right: auto;
   margin-left: auto;
   display: flex;
   justify-content: space-between;
   align-items: center;
 }
 
 @media (max-width: 960px) {
   .c-floating-bar__inner {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .c-floating-bar__inner {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .c-floating-bar__inner {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 .c-floating-bar__inner::after {
   /* [3] */
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   flex-basis: 36px;
   font-size: 36px;
   margin-left: 32px;
   content: "\e947";
   color: #1a1a1a;
 }
 
 @media (max-width: 720px) {
   .c-floating-bar__inner::after {
     flex-basis: 24px;
     font-size: 24px;
     margin-left: 16px;
   }
 }
 
 /* ------------------------------------*\
     #EXPANDABLE-CONTENT
 \*------------------------------------ */
 /* ------------------------------------*\
     #EXPANDABLE-CONTENT
 \*------------------------------------ */
 /* stylelint-disable-line number-no-trailing-zeros */
 /**
  * [1]  Use pseudo element for collapsible background so it can be animated
  *      (also see [15]).
  * [2]  Default background-color when the background section container is white.
  * [3]  Make sure to just reveal the differing background-color when the extra-
  *      content is visible. Unfortunately, `!important` is necessary so that
  *      the declaration also applies, if the expandable-content component also carries
  *      the `.u-bg-brand` class.
  * [4]  Initially hide the element and set `display: block` by JS on page-load to
  *      show it again. This ensures that in case JS isn't executed for whatever
  *      reason, the trigger is not shown (because a trigger triggers nothing,
  *      when it's lacking the necessary JS-function).
  * [5] The closed-styling needs to be added differently if the Javascript is
  *      not used for the animation.
  * [6]  Pulling the text up above the icon. The amount comprises of the text-
  *      size plus spacing between the text and the icon
  *      ($expandable-content-trigger-text-icon-gap).
  * [7]  Make sure the line-height equals the font-size so the math is correct.
  *      This will ever only work, if the trigger text is a one-liner!
  * [8]  In case the trigger text is exceedingly long, this ensures the text
  *      will never wrap...
  * [9]  ...and prevent horizontal scrollbar...
  * [10] ...and instead just show an ellipsis.
  * [11] Also hide the overflow on the y-axis, because IE-issues.
  * [12] Animate the icon when triggering the expandable-content.
  * [13] Make the icon box round.
  * [14] Hide the overflowing content, when animating the expandable-content.
  * [15] The animation of the pseudo element needs to have a shorter duration
  *      than the expandable-content itself. Just dividing it by two makes sure it
  *      always is without creating an extra variable.
  * [16] The animation of the trigger text should be sequentially before the
  *      animation of the expandable-content itself. Dividing it by two with the
  *      default transition duration prevents us from creating a separate
  *      variable.
  * [17] Microsoft Edge has a weird issue (BRON-637): `position: sticky` and
  *      `translate` are not the best friends. If an element is set to
  *      `position: sticky`, the `translate` does not work. This results in the
  *      expandable-content trigger to be too low in this case. Setting it to
  *      `position: relative` for Edge fixes it, but the close button in the
  *      expandable-content is not sticky anymore.
  * [18] The specificity needs to be raised to trump the selector making the
  *      element visible after the JavaScript was loaded.
  * [19] Disable (an re-establish) pointer-events if trigger button is invisible.
  * [20] We need to set the height of the trigger button in order to add a height
  *      animation to it. The height is a combination of font-size (which is a
  *      responsive map), height of the icon and the gap between icon and text.
  */
 .c-expandable-content {
   position: relative;
   z-index: 2;
   top: 0;
   margin-top: 32px;
   margin-bottom: 32px;
 }
 
 .c-expandable-content::before {
   /* [1] */
   content: "";
   position: absolute;
   z-index: -1;
   top: 0;
   right: 0;
   bottom: 0;
   left: 0;
   display: block;
   background-color: #f2f2f2;
   /* [2] */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="alternative"] .c-expandable-content::before,
 .u-bg-alternative .c-expandable-content::before {
   background-color: #ffffff;
 }
 
 .c-expandable-content.js-is-ready {
   transition: 650ms;
 }
 
 .c-expandable-content.js-is-ready::before {
   transition: 325ms;
   /* [15] */
 }
 
 .c-expandable-content.c-expandable-content--no-background::before {
   background-color: transparent;
 }
 
 .c-expandable-content.is-closed-within {
   top: 95px;
 }
 
 .c-expandable-content.is-closed-within.js-is-ready {
   transition: 650ms;
 }
 
 .c-expandable-content.is-closed-within::before {
   background-color: transparent !important;
   /* [3] */
   /* stylelint-disable-line itcss/no-at-important */
 }
 
 .c-expandable-content__trigger {
   padding: 0;
   border: 0;
   background-color: transparent;
   display: none;
   /* [4] */
   width: 100%;
 }
 
 .c-expandable-content__trigger:focus {
   outline: 0;
 }
 
 @supports (-ms-ime-align: auto) {
   .c-expandable-content__trigger {
     position: relative;
     /* [17] */
   }
 }
 
 .c-expandable-content.js-is-ready .c-expandable-content__trigger {
   display: block;
   /* [4] */
 }
 
 .c-expandable-content__trigger-open {
   height: 0;
   transform: translateY(0);
   opacity: 0;
 }
 
 .c-expandable-content.js-is-ready .c-expandable-content__trigger-open {
   transition: 650ms;
 }
 
 .c-expandable-content.is-closed-within .c-expandable-content__trigger-open {
   transform: translateY(-95px);
 }
 
 .c-expandable-content__trigger-open,
 .c-expandable-content__trigger-open > * {
   pointer-events: none;
   /* [19] */
 }
 
 .c-expandable-content.is-closed-within .c-expandable-content__trigger-open {
   height: 52px;
   opacity: 1;
 }
 
 .c-expandable-content.is-closed-within .c-expandable-content__trigger-open,
 .c-expandable-content.is-closed-within .c-expandable-content__trigger-open > * {
   pointer-events: auto;
   /* [19] */
 }
 
 .c-expandable-content__trigger-text {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   /* [7] */
   display: block;
   width: 100%;
   overflow: hidden;
   /* [9] */
   /* [11] */
   font-weight: 400;
   text-overflow: ellipsis;
   /* [10] */
   text-transform: none;
   text-align: center;
   white-space: nowrap;
   /* [8] */
   color: #1a1a1a;
 }
 
 .c-expandable-content__trigger-text-open {
   top: -24px;
   /* [6] */
   opacity: 0;
 }
 
 .c-expandable-content.js-is-ready .c-expandable-content__trigger-text-open {
   transition: 325ms;
   /* [16] */
 }
 
 .c-expandable-content.is-closed-within .c-expandable-content__trigger-text-open {
   opacity: 1;
 }
 
 .c-expandable-content__icon {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   color: #1a1a1a;
   display: block;
   margin-top: 8px;
   text-align: center;
 }
 
 .c-expandable-content__icon::before {
   border-radius: 50%;
   padding: 4px;
 }
 
 .c-expandable-content__icon::before {
   border: 1px solid transparent;
   background-color: transparent;
 }
 
 .c-expandable-content__icon::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   content: "\e944";
   /* [12] */
   transition: 325ms;
 }
 
 .c-expandable-content__trigger:hover .c-expandable-content__icon::before {
   border-color: transparent;
   background-color: transparent;
   color: #1a1a1a;
 }
 
 .c-expandable-content.js-is-fx .c-expandable-content__collapse.is-closed,
 .c-expandable-content:not(.js-is-fx) .c-expandable-content__collapse[aria-hidden='true'] {
   /* [5] */
   height: 0;
   overflow-y: hidden;
   padding-top: 0;
   opacity: 0;
   visibility: hidden;
 }
 
 .c-expandable-content.js-is-fx .c-expandable-content__collapse {
   opacity: 1;
   overflow-y: hidden;
   /* [14] */
   transition-property: opacity, height, visibility;
   transition-duration: 650ms;
   transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);
 }
 
 .c-expandable-content:not(.js-is-fx) .c-expandable-content__collapse[aria-hidden='true'] {
   /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
 }
 
 @media screen and (prefers-reduced-motion: reduce), (update: slow) {
   .c-expandable-content:not(.js-is-fx) .c-expandable-content__collapse[aria-hidden='true'] {
     /* stylelint-disable-next-line declaration-no-important */
     animation: none !important;
   }
 }
 
 .c-expandable-content:not(.js-is-fx) .c-expandable-content__collapse[aria-hidden='true'] {
   max-height: 100vh;
 }
 
 .c-expandable-content:not(.js-is-fx) .c-expandable-content__collapse[aria-hidden='true'] {
   max-height: 0;
   animation-name: animateheight4;
   animation-duration: 650ms;
   animation-timing-function: ease-in;
   animation-fill-mode: forwards;
 }
 
 @keyframes animateheight4 {
   0% {
     max-height: 100vh;
   }
   100% {
     max-height: 0;
   }
 }
 
 .c-expandable-content:not(.js-is-fx) .c-expandable-content__collapse[aria-hidden='false'] {
   /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
 }
 
 @media screen and (prefers-reduced-motion: reduce), (update: slow) {
   .c-expandable-content:not(.js-is-fx) .c-expandable-content__collapse[aria-hidden='false'] {
     /* stylelint-disable-next-line declaration-no-important */
     animation: none !important;
   }
 }
 
 .c-expandable-content:not(.js-is-fx) .c-expandable-content__collapse[aria-hidden='false'] {
   max-height: 0;
 }
 
 .c-expandable-content:not(.js-is-fx) .c-expandable-content__collapse[aria-hidden='false'] {
   max-height: 100%;
   animation-name: animateheight5;
   animation-duration: 650ms;
   animation-timing-function: ease-out;
   animation-fill-mode: none;
 }
 
 @keyframes animateheight5 {
   0% {
     max-height: 0;
   }
   100% {
     max-height: 100vh;
   }
 }
 
 .c-expandable-content__content {
   padding-top: 24px;
   padding-bottom: 24px;
 }
 
 .c-expandable-content__trigger-close {
   padding-bottom: 32px;
 }
 
 .c-expandable-content__trigger-close .c-expandable-content__icon::before {
   content: "\e955";
 }
 
 /* ------------------------------------*\
     #GUIDING-LINE
 \*------------------------------------ */
 /**
  * [1] Border radius of the line container.
  * [2] Border radius of the line.
 */
 .c-guiding-line {
   display: none;
 }
 
 /**
  * Use generic play-button styles.
  * Include mixin here to keep source order (tools, ..., components).
  */
 .c-play-button {
   display: inline-flex !important;
   /* [1][2] */
   /* stylelint-disable-line itcss/no-at-important */
   align-items: center;
   /* [1] */
   justify-content: center;
   /* [2] */
   width: 60px;
   height: 60px;
   padding: 0;
   border: 2px solid #187085;
   border-radius: 100%;
   background: #ffffff;
   color: #1a1a1a;
   box-shadow: none;
 }
 
 @media (max-width: 720px) {
   .c-play-button {
     width: 36px;
     height: 36px;
   }
 }
 
 .c-play-button:hover, .c-play-button:focus {
   background: #ffffff;
   color: #1a1a1a;
 }
 
 .c-play-button__icon {
   font-size: 24px;
 }
 
 .c-play-button__label {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
 }
 
 /* ------------------------------------*\
     #LABELED-CONTENT-SECTION
 \*------------------------------------ */
 /**
  * [1] Use the same paddings as the content section object.
  */
 .c-labeled-content-section {
   padding-top: 32px;
   /* [1] */
   padding-bottom: 32px;
   /* [1] */
 }
 
 .c-labeled-content-section__label {
   margin-bottom: 8px;
 }
 
 /* ------------------------------------*\
     #COMPARE-AND-SELECT (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #COMPARE-AND-SELECT
 \*------------------------------------ */
 /**
  * [1] Only add padding and border to the top if this element is not a
  *     direct sibling of the header element.
  * [2] Hide native input element and do not act as a "scroll anchor"
  *     when the associated label is clicked.
  * [3] Center the icon and title text. `display: flex` is set by `.o-media`.
  * [4] Reset default `margin-bottom`.
  * [5] The button stretches across the full width by default. Optionally it can
  *      be centered via flexbox and `auto` margins.
  * [6] Eliminate the spacing bottom below the very last
  *     element in the container.
  * [7] Although the `margin` property is used here, what it actually does
  *     **visually** is setting a padding. That's why our
  *     `$compare-and-select-padding` variable is used.
  * [8] To align the slider dots and the slider arrows properly, we set the
  *     container to flex and reposition the items with the `order` property.
  *     This prevents us from using `position: absolute` plus magic numbers.
  * [9] Center the dots and the arrows horizontally.
  * [10] Center the dots and the arrows vertically.
  * [11] Force the slider items to take up all horizontal space.
  * [12] Hack to prevent a cut-off of the box-shadow by the necessary
  *      `overflow: hidden` of the slider container.
  * [13] Hide the dots and arrows, if there is nothing to slide.
  * [14] Compensate only above breakpoint. Smaller breakpoints go edge-to-edge,
  *      no compensation required.
  * [15] The actual arrow icons of the slider. The size of the icons has to be
  *      done directly on the pseudo element.
  * [16] `box-shadow` can be used for real box shadow effects or simulated
  *      borders that do not affect the inner elementËšs widths.
  * [17] Use flexbox to allow reversed order of total and suffix.
  * [18] Set the spacing between value total and value suffix depending on the
  *      visual order of both elements.
  * [19] Set `position` to allow positioning of inner elements like the label.
  * [20] Increase the radio button label width to the full component width.
  * [22] Display the items side by side when not positioned by Flickity and center
  *      them horizontally.
  * [23] Create (responsive) gutter between the slider elements while still
  *      aligning the content correctly horizontally. That is why we need the
  *      negative padding "trick" here.
  * [24] Make all slider elements the same height while pushing the radio addon
  *      and legal text to the bottom.
  * [25] Calculate correct spacing between slider and navigation controls by
  *      substracting the bottom offset if needed. This makes sure that the spacing
  *      in total is always the value we set for the vertical spacing.
  * [26] Hide label without content. Selector only matches for NO content,
  *      whitespaces & comments are not considered as empty.
  * [27] Match selector even with whitespaces & comments,
  *      analogue to `:blank` (firefox only).
  * [28] Move title down if a label is present in order to align titles of items
  *      with and without label side-by-side. We account for the label height using
  *      an offset value.
  * [29] Fixes a bug in IE11 where the compare and select button stretches from edge to edge of the card which is
  *      not intended in the following brands: Default, Generic, VW5, VW6, SEAT and Å KODA.
  * [30] Enables child elements to work with utility class `u-text-truncate`.
  * [31] Make sure when the background has a brand color, the `.c-icon` inherits the parent's color.
  * [32] Allow component to break out of page-wrap to go from edge-to-edge.
  */
 /* stylelint-disable selector-max-compound-selectors, selector-max-combinators, selector-max-class, selector-max-specificity */
 .c-compare-and-select-container {
   /**
      * @deprecated start
      * Include page-wrap for old markup not following page-structure.
      */
   /**
      * @deprecated end
      */
 }
 
 @media (min-width: 961px) {
   .c-compare-and-select-container {
     max-width: calc(1280px + 64px);
     padding-left: 32px;
     padding-right: 32px;
     margin-right: auto;
     margin-left: auto;
   }
 }
 
 @media (min-width: 961px) and (max-width: 960px) {
   .c-compare-and-select-container {
     max-width: calc(1280px + 48px);
     padding-left: 24px;
     padding-right: 24px;
   }
 }
 
 @media (min-width: 961px) and (max-width: 720px) {
   .c-compare-and-select-container {
     max-width: calc(1280px + 32px);
     padding-left: 16px;
     padding-right: 16px;
   }
 }
 
 @media (min-width: 961px) and (max-width: 480px) {
   .c-compare-and-select-container {
     max-width: calc(1280px + 16px);
     padding-left: 8px;
     padding-right: 8px;
   }
 }
 
 .o-page-wrap .c-compare-and-select-container {
   max-width: none;
   margin-left: 0;
   margin-right: 0;
   padding-left: 0;
   padding-right: 0;
   /* [32] */
   /* [32] */
 }
 
 @media (max-width: 960px) {
   .o-page-wrap .c-compare-and-select-container {
     margin-left: -24px;
   }
 }
 
 @media (max-width: 720px) {
   .o-page-wrap .c-compare-and-select-container {
     margin-left: -16px;
   }
 }
 
 @media (max-width: 480px) {
   .o-page-wrap .c-compare-and-select-container {
     margin-left: -8px;
   }
 }
 
 @media (max-width: 960px) {
   .o-page-wrap .c-compare-and-select-container {
     margin-right: -24px;
   }
 }
 
 @media (max-width: 720px) {
   .o-page-wrap .c-compare-and-select-container {
     margin-right: -16px;
   }
 }
 
 @media (max-width: 480px) {
   .o-page-wrap .c-compare-and-select-container {
     margin-right: -8px;
   }
 }
 
 .c-compare-and-select-container .flickity-enabled {
   display: flex;
   /* [8] */
   flex-direction: row;
   /* [8] */
   flex-wrap: wrap;
   /* [8] */
   justify-content: center;
   /* [9] */
 }
 
 .c-compare-and-select-container .flickity-viewport {
   order: 0;
   /* [8] */
   width: 100%;
   /* [11] */
 }
 
 .c-compare-and-select-container .flickity-prev-next-button {
   display: none;
   /* [2] */
 }
 
 .c-compare-and-select-container .flickity-prev-next-button.is-slideable {
   position: relative;
   /* [11] */
   display: block;
   /* [13] */
   transform: none;
   /* [11] */
   /* [25] */
 }
 
 .c-compare-and-select-container .flickity-prev-next-button.is-slideable::before {
   /* [15] */
   font-size: 24px;
   vertical-align: middle;
   /* [10] */
 }
 
 .c-compare-and-select-container .flickity-prev-next-button.is-slideable.previous {
   order: 1;
   /* [8] */
 }
 
 .c-compare-and-select-container .flickity-prev-next-button.is-slideable.next {
   order: 3;
   /* [8] */
 }
 
 .c-compare-and-select-container .flickity-page-dots {
   display: none;
   /* [13] */
 }
 
 .c-compare-and-select-container .flickity-page-dots.is-slideable {
   display: flex;
   /* [13] */
   order: 2;
   /* [8] */
   /* [25] */
 }
 
 .c-compare-and-select-container__inner {
   display: flex;
   /* [22] */
   justify-content: center;
   /* [22] */
 }
 
 .c-compare-and-select-container__inner.flickity-resize {
   margin-left: -16px;
   /* [23] */
   margin-right: -16px;
   /* [23] */
 }
 
 @media (max-width: 1280px) {
   .c-compare-and-select-container__inner.flickity-resize {
     margin-left: -12px;
   }
 }
 
 @media (max-width: 960px) {
   .c-compare-and-select-container__inner.flickity-resize {
     margin-left: -8px;
   }
 }
 
 @media (max-width: 720px) {
   .c-compare-and-select-container__inner.flickity-resize {
     margin-left: -4px;
   }
 }
 
 @media (max-width: 1280px) {
   .c-compare-and-select-container__inner.flickity-resize {
     margin-right: -12px;
   }
 }
 
 @media (max-width: 960px) {
   .c-compare-and-select-container__inner.flickity-resize {
     margin-right: -8px;
   }
 }
 
 @media (max-width: 720px) {
   .c-compare-and-select-container__inner.flickity-resize {
     margin-right: -4px;
   }
 }
 
 @media (max-width: 960px) {
   .c-compare-and-select-container__inner.flickity-resize {
     margin-left: 0 !important;
     /* [14] */
     margin-right: 0 !important;
     /* [14] */
   }
 }
 
 .c-compare-and-select-container__inner.flickity-resize .c-compare-and-select__item,
 .c-compare-and-select-container__inner.flickity-resize .c-compare-and-select {
   height: 100%;
   /* [24] */
 }
 
 .c-compare-and-select-item,
 .c-compare-and-select__item {
   width: 33.33333%;
   padding-top: 5px;
   /* [12] */
   padding-bottom: 5px;
   /* [12] */
 }
 
 @media (max-width: 960px) {
   .c-compare-and-select-item,
   .c-compare-and-select__item {
     width: 41.66667%;
   }
 }
 
 @media (max-width: 720px) {
   .c-compare-and-select-item,
   .c-compare-and-select__item {
     width: 66.66667%;
   }
 }
 
 @media (max-width: 480px) {
   .c-compare-and-select-item,
   .c-compare-and-select__item {
     width: 83.33333%;
   }
 }
 
 .c-compare-and-select {
   transition-property: all;
   transition-duration: 250ms;
   transition-timing-function: ease;
   margin-left: 16px;
   /* [23] */
   margin-right: 16px;
   /* [23] */
   position: relative;
   /* [19] */
   display: flex;
   flex-direction: column;
   padding-top: 24px;
   background-color: #ffffff;
   box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.4);
   /* [16] */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 @media (max-width: 1280px) {
   .c-compare-and-select {
     margin-left: 12px;
   }
 }
 
 @media (max-width: 960px) {
   .c-compare-and-select {
     margin-left: 8px;
   }
 }
 
 @media (max-width: 720px) {
   .c-compare-and-select {
     margin-left: 4px;
   }
 }
 
 @media (max-width: 1280px) {
   .c-compare-and-select {
     margin-right: 12px;
   }
 }
 
 @media (max-width: 960px) {
   .c-compare-and-select {
     margin-right: 8px;
   }
 }
 
 @media (max-width: 720px) {
   .c-compare-and-select {
     margin-right: 4px;
   }
 }
 
 /* [1] */
 .c-compare-and-select__hidden-input {
   display: none;
 }
 
 .c-compare-and-select__label {
   position: absolute;
   top: 24px;
   -ms-grid-row-align: center;
   align-self: center;
   font-weight: 400;
   left: 50%;
   transform: translateX(-50%);
   text-align: center;
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-compare-and-select__label:empty, .c-compare-and-select__label:-moz-only-whitespace {
   display: none;
 }
 
 .c-compare-and-select__title {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   /* [3] */
   padding-right: 24px;
   padding-left: 24px;
   margin-bottom: 24px;
 }
 
 .c-compare-and-select__label + .c-compare-and-select__title {
   margin-top: 24px;
   /* [28] */
 }
 
 .c-compare-and-select__icon {
   font-size: 3.375rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   margin-bottom: 8px;
   color: #1a1a1a;
 }
 
 .c-compare-and-select__title-text {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   max-width: 100%;
   /* [30] */
   margin-bottom: 0;
   /* [4] */
   text-align: center;
 }
 
 .c-compare-and-select__title-indicator-text {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-compare-and-select__description {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   margin-right: 24px;
   /* [7] */
   margin-bottom: 24px;
   margin-left: 24px;
   /* [7] */
 }
 
 .c-compare-and-select__value {
   display: flex;
   /* [17] */
   flex-direction: column;
   /* [17] */
   align-items: center;
   margin-bottom: 24px;
   margin-right: 24px;
   /* [7] */
   margin-left: 24px;
   /* [7] */
 }
 
 @media (max-width: 960px) {
   .c-compare-and-select__value {
     margin-right: 0;
     margin-left: 0;
     padding-right: 24px;
     /* [7] */
     padding-left: 24px;
     /* [7] */
   }
 }
 
 .c-compare-and-select__value-total {
   font-size: 1.625rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   /* [17] */
   /* [18] */
   margin-bottom: 0;
   /* [4] */
   font-weight: 400;
 }
 
 @media (min-width: 721px) {
   .c-compare-and-select__value-total {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
     line-height: 1;
   }
 }
 
 @media (min-width: 1921px) {
   .c-compare-and-select__value-total {
     font-size: 2.25rem;
     /* stylelint-disable-line order/order */
     line-height: 1;
   }
 }
 
 .c-compare-and-select__value-suffix {
   margin-top: 8px;
   /* [18] */
   margin-bottom: 0;
   /* [4] */
   font-weight: 400;
 }
 
 .c-compare-and-select__pricing {
   margin-right: 24px;
   /* [7] */
   margin-left: 24px;
   /* [7] */
 }
 
 .c-compare-and-select__button {
   -ms-grid-row-align: center;
   align-self: center;
   /* [29] */
   margin-top: auto;
   /* [24] */
   margin-right: auto;
   /* [5] */
   margin-left: auto;
   /* [5] */
 }
 
 .c-compare-and-select > .c-compare-and-select__button {
   margin-bottom: 24px;
 }
 
 .c-compare-and-select__legal {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   margin-top: auto;
   /* [24] */
   margin-right: 24px;
   /* [7] */
   margin-bottom: 24px;
   margin-left: 24px;
   /* [7] */
 }
 
 .c-compare-and-select__list {
   margin-right: 24px;
   /* [7] */
   margin-bottom: 24px;
   margin-left: 24px;
   /* [7] */
 }
 
 .c-compare-and-select__list.c-icon-list li:last-child {
   margin-bottom: 0;
   /* [6] */
 }
 
 .c-compare-and-select__checkbox {
   margin-right: 24px;
   /* [7] */
   margin-bottom: 24px;
   margin-left: 24px;
   /* [7] */
 }
 
 .c-compare-and-select__checkbox .c-checkbox {
   color: inherit;
 }
 
 .c-compare-and-select__radio {
   display: block;
   /* [20] */
   margin-top: auto;
   /* [24] */
   padding-top: 24px;
   padding-right: 24px;
   /* [7] */
   padding-bottom: 24px;
   padding-left: 24px;
   /* [7] */
   color: inherit;
 }
 
 :not(.c-compare-and-select__legal) + .c-compare-and-select__radio {
   margin-top: auto;
   /* [24] */
 }
 
 .c-compare-and-select__radio-label {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   font-weight: 400;
 }
 
 @media (min-width: 721px) {
   .c-compare-and-select__radio-label {
     font-size: 1.25rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-compare-and-select__radio-label {
     font-size: 1.75rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-compare-and-select__radio-label, .c-compare-and-select__radio-label:hover {
   color: inherit;
 }
 
 .c-compare-and-select__radio-description {
   display: block;
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   font-weight: 400;
 }
 
 .c-compare-and-select--selected,
 .c-compare-and-select__hidden-input:checked + .c-compare-and-select {
   box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.4);
   /* [16] */
   background-color: #f2f2f2;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-compare-and-select--selected .c-compare-and-select__label,
 .c-compare-and-select__hidden-input:checked + .c-compare-and-select .c-compare-and-select__label {
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 .c-compare-and-select--selected .c-checkbox__label,
 .c-compare-and-select__hidden-input:checked + .c-compare-and-select .c-checkbox__label {
   color: inherit;
 }
 
 /* stylelint-enable */
 .c-compare-and-select--selected .c-icon,
 .c-compare-and-select__hidden-input:checked + .c-compare-and-select .c-icon,
 .c-compare-and-select__radio .c-icon {
   /* [31] */
 }
 
 /* ------------------------------------*\
     #INBOX-FILTER (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #INBOX-FILTER
 \*------------------------------------ */
 .c-inbox-filter {
   margin-bottom: 32px;
 }
 
 .c-inbox-filter__title {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 1.5;
   margin: 0;
   margin-bottom: 24px;
   padding: 0;
   font-weight: 400;
 }
 
 @media (min-width: 721px) {
   .c-inbox-filter__title {
     font-size: 1.125rem;
     /* stylelint-disable-line order/order */
     line-height: 1.5;
   }
 }
 
 @media (min-width: 1921px) {
   .c-inbox-filter__title {
     font-size: 1.5rem;
     /* stylelint-disable-line order/order */
     line-height: 1.5;
   }
 }
 
 .c-inbox-filter__badge {
   margin-left: 4px;
 }
 
 .c-inbox-filter__body {
   padding: 0;
 }
 
 /* ------------------------------------*\
     #INBOX-TABLE (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
     #INBOX-TABLE
 \*------------------------------------ */
 /**
  * [1] Nest `.c-inbox-table` elements to increase specificity that let it
  *     overwrite `.c-table` styles.
  * [2] Define a minimum height to have same table cell heights, regardless of
  *     whether the content is one or two lines long.
  * [3] The date cell should have a `min-width` so that this column is always the
  *     same width in separate tables.
  * [4] Stretch the subject column to the widest possible width.
  * [5] Small viewports: Remove `table` related behavior from all table elements
  *     and format everything as a block-level element.
  * [6] Small viewports: Hide table head row in an accessibly.
  * [7] Small viewports: Position action buttons/icons into the top right corner.
  * [8] Small viewports: Remove bottom table cell borders except for the last
  *     cell.
  * [9] Reset some table link styles for the normal, non-hover state.
 */
 .c-inbox-table {
   /**
      * Responsive variant for small viewports
      */
   /* stylelint-disable-next-line order/order */
 }
 
 .c-inbox-table .c-inbox-table__subheading {
   /* [1] */
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   margin-top: 32px;
   margin-bottom: 16px;
   padding-top: 16px;
   padding-bottom: 16px;
   font-weight: 400;
 }
 
 .c-inbox-table .c-inbox-table__body .c-table__btn {
   margin-right: 8px;
   margin-left: 8px;
 }
 
 .c-inbox-table .c-inbox-table__tr.is-unread {
   font-weight: 400;
 }
 
 .c-inbox-table .c-inbox-table__td {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 1.5;
   height: 32px;
   /* [2] */
   vertical-align: middle;
 }
 
 .c-inbox-table .c-inbox-table__td--date {
   min-width: 8em;
   /* [3] */
   white-space: nowrap;
 }
 
 .c-inbox-table .c-inbox-table__td--action {
   padding-top: 0;
   padding-bottom: 0;
 }
 
 .c-inbox-table .c-inbox-table__td--subject {
   width: 100%;
   /* [4] */
 }
 
 @media (max-width: 720px) {
   .c-inbox-table.c-inbox-table {
     /* stylelint-disable-next-line selector-max-class */
   }
   .c-inbox-table.c-inbox-table table {
     min-width: auto;
   }
   .c-inbox-table.c-inbox-table table, .c-inbox-table.c-inbox-table thead, .c-inbox-table.c-inbox-table tbody, .c-inbox-table.c-inbox-table tr, .c-inbox-table.c-inbox-table th, .c-inbox-table.c-inbox-table td {
     display: block;
     /* [5] */
   }
   .c-inbox-table.c-inbox-table thead tr {
     position: absolute !important;
     /* stylelint-disable-line itcss/no-at-important */
     width: 1px;
     height: 1px;
     overflow: hidden;
     clip: rect(1px, 1px, 1px, 1px);
     /* [6] */
   }
   .c-inbox-table.c-inbox-table tr {
     position: relative;
     /* [7] */
     margin-top: 24px;
   }
   .c-inbox-table.c-inbox-table th, .c-inbox-table.c-inbox-table td {
     position: static;
     /* [7] */
     height: auto;
     padding: 0;
   }
   .c-inbox-table.c-inbox-table th::after, .c-inbox-table.c-inbox-table td::after {
     left: 0;
   }
   .c-inbox-table.c-inbox-table th::after:not(:last-child), .c-inbox-table.c-inbox-table td::after:not(:last-child) {
     border: none;
     /* [8] */
   }
   .c-inbox-table.c-inbox-table th:last-child, .c-inbox-table.c-inbox-table td:last-child {
     padding-bottom: 24px;
   }
   .c-inbox-table.c-inbox-table .c-inbox-table__td--action .c-table__btn {
     position: absolute;
     /* [7] */
     top: 0;
     /* [7] */
     right: 0;
     /* [7] */
     width: auto;
     height: auto;
     margin-right: 0;
     margin-left: 0;
   }
   .c-inbox-table.c-inbox-table .c-inbox-table__td--date {
     margin-bottom: 24px;
   }
 }
 
 .c-inbox-table__extra-info {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   margin-bottom: 0;
   font-weight: 400;
 }
 
 .c-inbox-table__link:not(:hover) {
   border-bottom: none;
   /* [9] */
   text-decoration: none;
   /* [9] */
   color: inherit;
   /* [9] */
 }
 
 /* ------------------------------------*\
    #TOAST-NOTIFICATION
 \*------------------------------------ */
 /**
  * [1] Restrict the height of the container to the viewport height, so it is
  *     scrollable with many items in it.
  * [2] Provide offset spacing for small screens, when the notifications would
  *     otherwise touch the left viewport edge.
  * [3] Offset the notifications to the right with `padding-right` instead of
  *     the `right` property, so the slide-right animation looks authentic.
  * [4] In case of many notifications, ensure scrollability,...
  * [5] ...but prevent on the x-axis.
  * [6] Delay the vertical animation, so the horizontal animation runs first.
  * [7] If there are any elements in notifications that bring spacing with it,
  *     prevent it from screwing up the padding.
  * [8] Shrink size to zero.
  * [9] Also reset margin-bottom as this contributes to the compound height.
  * [10] Reference for the close button.
  * [11] Push the notification out of screen when closed.
  * [12] Preserve space for the close button.
  * [13] Delay the horizontal animation when an item should be added, so the
  *      vertical animation runs first and gives up its space for the new item.
  * [14] Reset the transition-delay for the reversed animation, i.e. the adding
  *      of new notification items.
  * [15] Prevents the notifications to take up any space when itâ€™s closed and
  *      takes care of eliminating any potential scroll bars.
  * [16] Provide a default text color.
  * [17] Make sure the icon color is the same as the text color, hence prevent
  *      any override from the `$ICON-COLOR` settings.
  */
 .c-toast-notifications {
   position: fixed;
   z-index: 6000;
   top: 24px;
   right: 0;
   /* [3] */
   max-height: 100vh;
   /* [1] */
   overflow-x: hidden;
   /* [5] */
   overflow-y: auto;
   /* [4] */
   margin-left: 24px;
   /* [2] */
   padding-right: 24px;
   /* [3] */
 }
 
 .c-toast-notification {
   transition-property: all;
   transition-duration: 500ms;
   transition-timing-function: ease;
   position: relative;
   overflow: hidden;
   /* [15] */
   transition-delay: 0s;
   /* [14] */
 }
 
 @media (min-width: 721px) {
   .c-toast-notification {
     max-width: 300px;
   }
 }
 
 .c-toast-notification:not(:last-child) {
   margin-bottom: 8px;
 }
 
 .c-toast-notification *:last-child {
   margin-bottom: 0;
   /* [7] */
 }
 
 .c-toast-notification.is-closed {
   height: 0;
   /* [8] */
   margin-bottom: 0;
   /* [9] */
   transition-delay: 500ms;
   /* [6] */
   visibility: hidden;
 }
 
 .c-toast-notification__content {
   transition-property: all;
   transition-duration: 500ms;
   transition-timing-function: ease;
   position: relative;
   /* [10] */
   padding: 24px 24px;
   background-color: #697677;
   color: #ffffff;
   /* [16] */
   transition-delay: 500ms;
   /* [13] */
 }
 
 .c-toast-notification--info .c-toast-notification__content {
   background-color: #187085;
   color: #ffffff;
 }
 
 .c-toast-notification--success .c-toast-notification__content {
   background-color: #00783c;
   color: #ffffff;
 }
 
 .c-toast-notification--warning .c-toast-notification__content {
   background-color: #efc938;
   color: #1a1a1a;
 }
 
 .c-toast-notification--error .c-toast-notification__content {
   background-color: #ba2525;
   color: #ffffff;
 }
 
 .c-toast-notification.is-closed .c-toast-notification__content {
   transform: translateX(200%);
   /* [11] */
   transition-delay: 0s;
   /* [14] */
 }
 
 .c-toast-notification__body {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 24px;
   padding-right: 32px;
   /* [12] */
 }
 
 .c-toast-notification__close {
   padding: 0;
   border: 0;
   background-color: transparent;
   position: absolute;
   top: 24px;
   right: 24px;
   color: currentColor;
   /* [17] */
 }
 
 .c-toast-notification__close:focus {
   outline: 0;
 }
 
 .c-toast-notification__close::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   content: "\e955";
   font-size: 24px;
 }
 
 /* ----------------------------------------*\
     #DESCRIPTION-LIST-ACCORDION (Settings)
 \*---------------------------------------- */
 /* ------------------------------------*\
     #DESCRIPTION-LIST-ACCORDION
 \*------------------------------------ */
 /**
  * [1] The bottom accordion border separates the accordion and the total section.
  * [2] Align item label and value to the left and right via flexbox.
  * [3] Reset `dl` margins.
  * [4] Stack item label and value vertically in small viewports.
  * [5] Increase specificity to overrule specificity of
  *     `.c-accordion:not(:only-child)`.
  * [6] Increase specificity to overrule specificity of
  *     `.c-accordion--header-split .c-accordion__header`.
  * [7] Make sure to not use the default `<dt>` color.
  */
 .c-description-list-accordion__accordion.c-description-list-accordion__accordion {
   /* [5] */
   border-top: none;
   border-bottom: 2px solid #697677;
   /* [1] */
 }
 
 .c-description-list-accordion__header.c-description-list-accordion__header {
   /* [6] */
 }
 
 * + .c-description-list-accordion__header.c-description-list-accordion__header {
   border-top: 2px solid #1a1a1a;
 }
 
 .c-description-list-accordion__title-label {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   font-weight: 400;
 }
 
 @media (min-width: 721px) {
   .c-description-list-accordion__title-label {
     font-size: 1.25rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-description-list-accordion__title-label {
     font-size: 1.75rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-description-list-accordion__title-value {
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   font-weight: 400;
 }
 
 @media (min-width: 721px) {
   .c-description-list-accordion__title-value {
     font-size: 1.25rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-description-list-accordion__title-value {
     font-size: 1.75rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (max-width: 720px) {
   .c-description-list-accordion__title-value {
     margin-top: 4px;
   }
 }
 
 .c-description-list-accordion__content,
 .c-description-list-accordion__item--total {
   padding-right: 72px;
   padding-left: 0;
 }
 
 .c-description-list-accordion__item {
   display: flex;
   /* [2] */
   flex-direction: row;
   /* [2] */
   justify-content: space-between;
   /* [2] */
   align-items: flex-start;
   /* [2] */
   margin-top: 0;
   /* [3] */
   margin-bottom: 0;
   /* [3] */
 }
 
 @media (max-width: 720px) {
   .c-description-list-accordion__item {
     display: block;
     /* [4] */
   }
 }
 
 .c-description-list-accordion__item + .c-description-list-accordion__item {
   margin-top: 16px;
 }
 
 .c-description-list-accordion__item__label {
   color: inherit;
   /* [7] */
 }
 
 .c-description-list-accordion__item__label-text {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   font-weight: 400;
 }
 
 .c-description-list-accordion__item__label-note {
   font-size: 0.875rem;
   /* stylelint-disable-line order/order */
   font-weight: 400;
 }
 
 @media (max-width: 720px) {
   .c-description-list-accordion__item__label-note {
     margin-bottom: 4px;
   }
 }
 
 .c-description-list-accordion__item__value {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   font-weight: 400;
 }
 
 .c-description-list-accordion__item--total {
   padding-top: 16px;
 }
 
 .c-description-list-accordion__item--total .c-description-list-accordion__item__label-text {
   font-size: 1.625rem;
   /* stylelint-disable-line order/order */
   font-weight: 400;
 }
 
 @media (min-width: 721px) {
   .c-description-list-accordion__item--total .c-description-list-accordion__item__label-text {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-description-list-accordion__item--total .c-description-list-accordion__item__label-text {
     font-size: 2.25rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 .c-description-list-accordion__item--total .c-description-list-accordion__item__value {
   font-size: 1.625rem;
   /* stylelint-disable-line order/order */
   font-weight: 400;
 }
 
 @media (min-width: 721px) {
   .c-description-list-accordion__item--total .c-description-list-accordion__item__value {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-description-list-accordion__item--total .c-description-list-accordion__item__value {
     font-size: 2.25rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 /* ------------------------------------*\
    #NOTIFICATION CENTER (Settings)
 \*------------------------------------ */
 /* ------------------------------------*\
    #NOTIFICATION-CENTER
 \*------------------------------------ */
 /**
  * [1] Position the Notification Center toggle in the header.
  * [2] Spacing to other header items (e.g. the context bar).
  * [3] Add space for the badge in smaller viewports so that it will not overlap
  *     the navigation toggle â€œhamburgerâ€ icon.
  * [4] Remove unwanted vertical space by making the icon a block element.
  * [5] Position the badge absolutely inside the toggle.
  * [6] Shift the badge horizontally or vertically if necessary. This can also be
  *     set separately for smaller viewports.
  * [7] Add shadow to the bottom or top if content is outside of the viewport.
  * [8] Make panel scrollable.
  * [9] Set panel `z-index` to overlay other elements (e.g. VW6 navigation layers).
  * [10] Fade panel in with a smooth transition in small viewports.
  *      `pointer-events` are disabled in the collapsed state.
  * [11] Push the first item down by the height of the fixed positioned panel
  *      heading.
  * [12] Fixate the panel header to the top and increase `z-index` so it always
  *      stays in front of the panel items.
  * [13] Set panel header padding to a responsive map or fixed value
  *      (default is `$page-wrap-padding-horizontal`)
  * [14] Increase specificity to allow button styles to be overwritten.
  * [15] Display all items below each other, no matter if they are block or
  *      inline elements.
  * [16] Set same spacings between inner item elements.
  * [17] Animate panel items in with a smooth transition in small viewports.
  * [18] Only show a visible dot if the item is not marked as read.
  * [19] Position the status point vertically centered to the first line of the
  *      article heading by dividing the responsive font size of the heading in
  *      half considering its line spacing.
  * [20] Change heading `font-weight` for read items.
  * [21] Remove bottom margin of last child element (e.g. a paragraph).
  * [22] Overwrite `.c-btn` font size.
  * [23] Push link to the left in flexbox context for brands (VW6) that use a
  *      border as link decoration.
  * [24] Show item overlay on hovering/focusing the
  *      `.c-notification-center__item__mark-read-toggle` button.
  * [25] Use `mix-blend-mode` so that the underlying elements remain fully
  *      visible. For browsers that to do not support `mix-blend-mode` (IE11) the
  *      overlay will not be shown on hover/focus.
  * [26] Fixes misplacement, as `translate` does not work with
  *      `display: inline-flex` IE11. Might cause minor spacing issue
  *      in IE11 but...IE11 - who cares.
  */
 .c-notification-center {
   display: flex;
   /* [1] */
   align-items: center;
   /* [1] */
   height: 100%;
   /* [1] */
 }
 
 .c-notification-center__toggle {
   padding: 0;
   border: 0;
   background-color: transparent;
   position: relative;
   /* [5] */
   margin-left: 16px;
   /* [2] */
 }
 
 @media (max-width: 720px) {
   .c-notification-center__toggle {
     margin-right: 12px;
     /* [3] */
   }
 }
 
 .c-notification-center__toggle::after {
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 1.5rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   content: "\e906";
   display: block;
   /* [4] */
   color: #1a1a1a;
 }
 
 .c-notification-center__toggle__label {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
 }
 
 .c-notification-center__toggle__badge {
   position: absolute;
   /* [5] */
   top: 50%;
   /* [5] */
   left: 100%;
   /* [5] */
   /* [6] */
   /* [6] */
   transform: translate(-50%, -50%);
   /* [5] */
 }
 
 @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .c-notification-center__toggle__badge {
     display: inline-block;
     /* [26] */
   }
 }
 
 @media (max-width: 720px) {
   .c-notification-center__toggle__badge {
     /* [6] */
     /* [6] */
   }
 }
 
 .c-notification-center__panel {
   /* stylelint-disable */
   background: linear-gradient(#ffffff 30%, rgba(255, 255, 255, 0)), linear-gradient(rgba(255, 255, 255, 0), #ffffff 70%) 0 100%, linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0)), linear-gradient(to top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0)) 0 100%;
   background-repeat: no-repeat;
   background-color: #ffffff;
   background-size: 100% 90px, 100% 90px, 100% 30px, 100% 30px;
   background-attachment: local, local, scroll, scroll;
   /* stylelint-enable */
   max-height: 100%;
   overflow-y: auto;
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   overflow: auto;
   /* [8] */
 }
 
 @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .c-notification-center__panel {
     background: linear-gradient(to top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0)) 0 100%;
     background-repeat: no-repeat;
     background-color: #ffffff;
     background-size: 100% 30px;
     background-attachment: scroll;
   }
 }
 
 @supports (-ms-ime-align: auto) {
   .c-notification-center__panel {
     background: linear-gradient(to top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0)) 0 100%;
     background-repeat: no-repeat;
     background-color: #ffffff;
     background-size: 100% 30px;
     background-attachment: scroll;
   }
 }
 
 @media (min-width: 721px) {
   .c-notification-center__panel {
     position: absolute;
     top: 100%;
     right: 0;
     display: none;
     width: 38em;
     max-height: calc(100vh - 100px - 80px);
     box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.4);
   }
   .c-notification-center__panel[aria-hidden='false'] {
     display: block;
   }
 }
 
 @media (max-width: 720px) {
   .c-notification-center__panel {
     position: fixed;
     z-index: 2500;
     /* [9] */
     top: 0;
     right: 0;
     bottom: 0;
     left: 0;
     transition: opacity 250ms ease;
     /* [10] */
     pointer-events: none;
     /* [10] */
     opacity: 0;
     /* [10] */
   }
   .c-notification-center__panel[aria-hidden='false'] {
     pointer-events: auto;
     /* [10] */
     opacity: 1;
     /* [10] */
   }
   .c-notification-center__panel > .c-notification-center__item:first-of-type {
     margin-top: 60px;
     /* [11] */
   }
 }
 
 .c-notification-center__panel__header {
   position: fixed;
   /* [12] */
   z-index: 1;
   /* [12] */
   top: 0;
   /* [12] */
   display: flex;
   align-items: center;
   justify-content: space-between;
   width: 100%;
   height: 60px;
   background-color: #f2f2f2;
   color: #1a1a1a;
   padding-right: 32px;
   padding-left: 32px;
   /* [13] */
 }
 
 @media (max-width: 960px) {
   .c-notification-center__panel__header {
     padding-right: 24px;
     padding-left: 24px;
   }
 }
 
 @media (max-width: 720px) {
   .c-notification-center__panel__header {
     padding-right: 16px;
     padding-left: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .c-notification-center__panel__header {
     padding-right: 8px;
     padding-left: 8px;
   }
 }
 
 @media (min-width: 721px) {
   .c-notification-center__panel__header {
     display: none;
   }
 }
 
 .c-notification-center__panel__heading {
   font-size: 1.625rem;
   /* stylelint-disable-line order/order */
   margin: 0;
 }
 
 @media (min-width: 721px) {
   .c-notification-center__panel__heading {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 @media (min-width: 1921px) {
   .c-notification-center__panel__heading {
     font-size: 2.25rem;
     /* stylelint-disable-line order/order */
   }
 }
 
 /* stylelint-disable selector-max-class, selector-max-specificity */
 .c-notification-center__panel__close.c-notification-center__panel__close.c-notification-center__panel__close {
   /* [14] */
 }
 
 .c-notification-center__panel__close.c-notification-center__panel__close.c-notification-center__panel__close .c-btn__icon::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   content: "\e955";
 }
 
 .c-notification-center__panel__close.c-notification-center__panel__close.c-notification-center__panel__close .c-btn__text {
   /* [14] */
 }
 
 /* stylelint-enable */
 .c-notification-center__item {
   position: relative;
   display: flex;
   /* [15] */
   flex-direction: column;
   /* [15] */
   padding: 16px 32px;
 }
 
 @media (max-width: 720px) {
   .c-notification-center__item {
     transform: translateY(-30px);
     /* [17] */
     transition: all 250ms ease;
     /* [17] */
   }
   .c-notification-center__panel[aria-hidden='false'] .c-notification-center__item {
     transform: translateY(0);
     /* [17] */
   }
 }
 
 .c-notification-center__item + .c-notification-center__item {
   border-top: 1px solid #495651;
 }
 
 .c-notification-center__item > * + * {
   margin-top: 8px;
   /* [16] */
   margin-bottom: 0;
   /* [16] */
 }
 
 .c-notification-center__item:not(.c-notification-center__item--read) .c-notification-center__item__status {
   /* [18] */
   margin-top: 9.6px;
   /* [19] */
   position: absolute;
   top: 16px;
   /* [19] */
   left: 16px;
   padding: 4px;
   transform: translate(-50%, -50%);
   /* [19] */
   border-radius: 50%;
   background-color: #1a1a1a;
 }
 
 .c-notification-center__item__status-label {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
 }
 
 .c-notification-center__item__heading {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   line-height: 1.2;
   margin-top: 0;
   margin-bottom: 0;
   font-weight: 700;
 }
 
 .c-notification-center__item--read .c-notification-center__item__heading {
   font-weight: 400;
   /* [20] */
 }
 
 .c-notification-center__item__heading-link {
   border-style: none;
   text-decoration: none;
 }
 
 .c-notification-center__item__body > :last-child {
   margin-bottom: 0;
   /* [21] */
 }
 
 .c-notification-center__item__timestamp {
   font-size: 0.625rem;
   /* stylelint-disable-line order/order */
 }
 
 .c-notification-center__item__mark-read-toggle {
   font-size: 0.8125rem;
   /* stylelint-disable-line order/order */
   /* [22] */
   margin-right: auto;
   /* [23] */
 }
 
 @supports (mix-blend-mode: darken) {
   .c-notification-center__item__mark-read-toggle {
     /* [25] */
     position: static;
   }
   .c-notification-center__item__mark-read-toggle::before {
     /* [24] */
     content: "";
     position: absolute;
     top: 0;
     right: 0;
     bottom: 0;
     left: 0;
     background-color: #f2f2f2;
     transition: all 250ms ease;
     pointer-events: none;
     opacity: 0;
     mix-blend-mode: darken;
     /* [25] */
   }
   .c-notification-center__item__mark-read-toggle:hover, .c-notification-center__item__mark-read-toggle:focus {
     mix-blend-mode: darken;
     /* [25] */
   }
   .c-notification-center__item__mark-read-toggle:hover::before, .c-notification-center__item__mark-read-toggle:focus::before {
     opacity: 1;
     /* [24] */
   }
 }
 
 .c-notification-content-center__item__close {
   padding: 0;
   border: 0;
   background-color: transparent;
   width: auto;
   overflow: visible;
   margin: 0;
   font: inherit;
   line-height: normal;
   text-align: inherit;
   text-transform: inherit;
   color: inherit;
   -webkit-font-smoothing: inherit;
   -moz-osx-font-smoothing: inherit;
   -webkit-appearance: none;
   position: absolute;
   top: 16px;
   right: 16px;
   transform: translateX(50%);
   color: #1a1a1a;
 }
 
 .c-notification-content-center__item__close::-moz-focus-inner {
   padding: 0;
   border: 0;
 }
 
 .c-notification-content-center__item__close::before {
   display: inline-block;
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   line-height: 1;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   content: "\e955";
   font-size: 18px;
 }
 
 .c-notification-content-center__item__close-label {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px;
   height: 1px;
   overflow: hidden;
   clip: rect(1px, 1px, 1px, 1px);
 }
 
 /* ------------------------------------*\
     #CARDS-SLIDER
 \*------------------------------------ */
 /**
  * [1] The flickity slider used for this component creates an
  *     `overflow: hidden` which cuts-off the shadow of the cards. Adding the
  *     same amount of padding as the box-shadow spread of the cards
  *     compensates this.
  * [2] Set equal content heights for sliders cells.
  * [3] Reset default flickity next/prev button styles.
  * [4] Soft fade left and right of the slider to prevent a hard overflow/cutoff.
  * [5] Show shadow above slides.
  */
 .c-cards-slider-container {
   opacity: 0;
   transition: opacity 250ms ease;
 }
 
 .c-cards-slider-container.is-initialized {
   opacity: 1;
 }
 
 .c-cards-slider.flickity-resize .c-cards-slider__item,
 .c-cards-slider.flickity-resize .c-cards-slider__card-wrapper,
 .c-cards-slider.flickity-resize .c-card {
   height: 100%;
   /* [2] */
 }
 
 /**
      * On large screens, the cards are shown completely (4 default cards and 5
      * small cards). On smaller screens, the last visible card is always shown
      * half to indicate to the user that there are more cards to scroll to.
      */
 .c-cards-slider__item {
   width: 25%;
 }
 
 @media (max-width: 960px) {
   .c-cards-slider__item {
     width: 33.33333%;
   }
 }
 
 @media (max-width: 720px) {
   .c-cards-slider__item {
     width: 50%;
   }
 }
 
 @media (max-width: 480px) {
   .c-cards-slider__item {
     width: 100%;
   }
 }
 
 .c-cards-slider__card-wrapper {
   padding: 4px 4px;
   /* [1] */
 }
 
 .c-cards-slider__item:not(:last-child) .c-cards-slider__card-wrapper {
   margin-right: 12px;
 }
 
 .c-cards-slider__item:not(:first-child) .c-cards-slider__card-wrapper {
   margin-left: 12px;
 }
 
 .c-cards-slider__controls {
   display: none;
   justify-content: center;
   align-items: center;
   margin-top: 24px;
   color: #1a1a1a;
 }
 
 .c-cards-slider__controls.is-slideable {
   display: flex;
 }
 
 .c-cards-slider__controls__button {
   position: relative;
   /* [3] */
   transform: none;
   /* [3] */
 }
 
 .c-cards-slider__controls__button::before {
   font-size: 2.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
 }
 
 .c-cards-slider__counter {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   margin-right: 16px;
   margin-left: 16px;
   color: #1a1a1a;
 }
 
 /* ------------------------------------*\
     #TREE-VIEW
 \*------------------------------------ */
 /**
  * [1] We need to clip the horizontal bounds at root level
  *     to cut off the pseudo-element from [5].
  * [2] Handle the collapse and expanded state of nested lists via the
  *     `aria-expanded` attribute from the parent tree list item.
  * [3] Disable focus styles on the focusable element and pass them down
  *     to the contained tree-view body.
  * [4] Only enable pointer for expandable tree list items.
  * [5] State is handled via tree list item parent but the styles are applied to the
  *     `.c-tree-view__body` and its `::before` pseudo-element. The pseudo-element
  *     carries the background and border state colors.
  * [6] If the parent tree list item receives focus, hover or has the
  *     `.is-selected`, `.is-accented` or `.is-alt-accented` class
  *     style the element accordingly.
  * [7] Display the tree view icon as `::after` pseudo-element of the `.c-tree-view__body`.
  * [8] Change the tree view icon depending on the parent tree list item state from [2].
  * [9] Reset default list styles.
  * [10] Offset the icon by its site which is the itemâ€™s margin.
  * [11] The pseudo-element spans across the double of the viewport and is pulled back
  *      by the width of the viewport (-100vw) to be independent of position context and nesting.
  *      The pseudo-element should always cover the whole row.
  * [12] Lower the positioning layer to make the pseudo-element from [5] appear below the row content.
  * [13] Indent nested tree view items.
  */
 .c-tree-view {
   margin: 0;
   /* [9] */
   padding: 0;
   /* [9] */
   list-style: none;
   /* [9] */
 }
 
 .c-tree-view.is-tree-view-root-node {
   overflow-x: hidden;
   /* [1] */
   border-bottom: 1px #697677 solid;
 }
 
 [aria-expanded='false'] > .c-tree-view {
   display: none;
   /* [2] */
 }
 
 [aria-expanded='true'] > .c-tree-view {
   display: block;
   /* [2] */
 }
 
 .c-tree-view__item {
   outline-color: transparent;
   outline-style: solid;
   outline-width: 0;
   /* [3] */
   position: relative;
   margin: 0;
 }
 
 .c-tree-view__item[aria-expanded].is-hovered {
   cursor: pointer;
   /* [4] */
 }
 
 .c-tree-view__item[aria-expanded].is-disabled {
   cursor: default;
 }
 
 .c-tree-view__item .c-tree-view__item {
   /* [13] */
   padding-left: 32px;
 }
 
 @media (max-width: 720px) {
   .c-tree-view__item .c-tree-view__item {
     padding-left: 16px;
   }
 }
 
 .c-tree-view__body {
   position: relative;
   display: flex;
   flex-direction: column;
   width: 100%;
   padding-top: 24px;
   padding-bottom: 24px;
   padding-left: 32px;
   /* stylelint-disable selector-max-class, selector-max-specificity */
   /* stylelint-enable */
   /* stylelint-disable selector-max-class, selector-max-specificity */
   /* stylelint-enable */
 }
 
 @media (max-width: 720px) {
   .c-tree-view__body {
     padding-top: 8px;
     padding-bottom: 8px;
     padding-left: 16px;
   }
 }
 
 .c-tree-view__body::before {
   /* [5] */
   content: "";
   position: absolute;
   z-index: -1;
   /* [12] */
   top: 0;
   left: -100vw;
   /* [11] */
   display: block;
   width: 200vw;
   /* [11] */
   height: 100%;
   border-top: 1px #697677 solid;
   transition: background-color 250ms ease;
 }
 
 .c-tree-view__item:focus > .c-tree-view__body {
   /* [6] */
   outline-color: #1a1a1a;
   outline-offset: -2px;
   outline-style: solid;
   outline-width: 2px;
 }
 
 .c-tree-view__item.is-hovered > .c-tree-view__body::before {
   /* [6] */
   background-color: #f2f2f2;
 }
 
 .c-tree-view__item.is-selected > .c-tree-view__body::before {
   /* [6] */
   background-color: #187085;
 }
 
 .c-tree-view__item.is-accented > .c-tree-view__body::before {
   /* [6] */
 }
 
 .c-tree-view__item.is-alt-accented > .c-tree-view__body::before {
   /* [6] */
 }
 
 .c-tree-view__item.is-selected.is-accented > .c-tree-view__body::before,
 .c-tree-view__item.is-hovered.is-accented > .c-tree-view__body::before {
   /* [6] */
 }
 
 .c-tree-view__item.is-selected.is-alt-accented > .c-tree-view__body::before,
 .c-tree-view__item.is-hovered.is-alt-accented > .c-tree-view__body::before {
   /* [6] */
 }
 
 .c-tree-view__item.is-disabled > .c-tree-view__body::before {
   /* [6] */
   background-color: transparent;
 }
 
 .c-tree-view__item.is-selected.is-disabled > .c-tree-view__body::before {
   /* [6] */
   background-color: #f2f2f2;
 }
 
 .c-tree-view__item.is-tree-view-parent-node > .c-tree-view__body {
   /* [7] */
   position: relative;
 }
 
 .c-tree-view__item.is-tree-view-parent-node > .c-tree-view__body::after {
   font-family: "bronson-default" !important;
   /* [1] */
   /* stylelint-disable-line itcss/no-at-important */
   font-weight: normal;
   font-style: normal;
   font-variant: normal;
   text-transform: none;
   -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
   font-size: 1.125rem;
   /* stylelint-disable-line order/order */
   line-height: 1;
   content: "\e944";
   position: absolute;
   top: 24px;
   left: auto;
   display: flex;
   align-items: center;
   justify-content: center;
   width: 32px;
   height: 32px;
   margin-left: -32px;
   /* [10] */
   transform-origin: center;
   color: #1a1a1a;
   transition: transform 250ms ease;
 }
 
 @media (max-width: 720px) {
   .c-tree-view__item.is-tree-view-parent-node > .c-tree-view__body::after {
     top: 8px;
     width: 16px;
     height: 16px;
     margin-left: -16px;
     /* [10] */
   }
 }
 
 .c-tree-view__item.is-accented > .c-tree-view__body::after {
   color: #1a1a1a;
 }
 
 .c-tree-view__item.is-alt-accented > .c-tree-view__body::after {
   color: #1a1a1a;
 }
 
 .c-tree-view__item.is-disabled > .c-tree-view__body::after {
   color: #afb5ab;
 }
 
 .c-tree-view__item[aria-expanded='true'] > .c-tree-view__body::after {
   /* [8] */
   transform: rotate(0);
 }
 
 .c-tree-view__item[aria-expanded='false'] > .c-tree-view__body::after {
   /* [8] */
   transform: rotate(-90deg);
 }
 
 .c-tree-view__title {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   color: #1a1a1a;
   /* stylelint-disable selector-max-class */
   /* stylelint-enable */
 }
 
 .c-tree-view__item.is-hovered > .c-tree-view__body .c-tree-view__title {
   color: #1a1a1a;
 }
 
 .c-tree-view__item.is-selected > .c-tree-view__body .c-tree-view__title {
   color: #1a1a1a;
 }
 
 .c-tree-view__item.is-accented > .c-tree-view__body .c-tree-view__title {
   color: #1a1a1a;
 }
 
 .c-tree-view__item.is-alt-accented > .c-tree-view__body .c-tree-view__title {
   color: #1a1a1a;
 }
 
 .c-tree-view__item.is-disabled > .c-tree-view__body .c-tree-view__title {
   color: #afb5ab;
 }
 
 .c-tree-view__subtitle {
   font-size: 1rem;
   /* stylelint-disable-line order/order */
   color: #1a1a1a;
   /* stylelint-disable selector-max-class */
   /* stylelint-enable */
 }
 
 .c-tree-view__item.is-hovered > .c-tree-view__body .c-tree-view__subtitle {
   color: #1a1a1a;
 }
 
 .c-tree-view__item.is-selected > .c-tree-view__body .c-tree-view__subtitle {
   color: #1a1a1a;
 }
 
 .c-tree-view__item.is-accented > .c-tree-view__body .c-tree-view__subtitle {
   color: #1a1a1a;
 }
 
 .c-tree-view__item.is-alt-accented > .c-tree-view__body .c-tree-view__subtitle {
   color: #1a1a1a;
 }
 
 .c-tree-view__item.is-disabled > .c-tree-view__body .c-tree-view__subtitle {
   color: #afb5ab;
 }
 
 /* ------------------------------------*\
     #CALLOUT
 \*------------------------------------ */
 /**
  * Use a callout to display a prominent message with a call to action.
  */
 .c-callout {
   padding: 32px 64px;
   text-align: center;
   background-color: #1a1a1a;
   color: #ffffff;
 }
 
 @media (max-width: 480px) {
   .c-callout {
     padding: 32px 32px;
   }
 }
 
 .c-callout__title {
   font-size: 1.25rem;
   /* stylelint-disable-line order/order */
   line-height: 1.2;
 }
 
 @media (min-width: 721px) {
   .c-callout__title {
     font-size: 1.375rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 @media (min-width: 1921px) {
   .c-callout__title {
     font-size: 1.875rem;
     /* stylelint-disable-line order/order */
     line-height: 1.2;
   }
 }
 
 /* ------------------------------------*\
     #BUTTONS (Scopes)
 \*------------------------------------ */
 /*
  * [1] Set the button width to 100% on media teaser breakpoint.
  * [2] The vertical media teaser's button is always 100% width.
  */
 @media (max-width: 720px) {
   .c-media-teaser .c-media-teaser__footer .c-btn {
     width: 100%;
     /* [1] */
   }
 }
 
 .c-media-teaser--vertical .c-media-teaser__footer .c-btn {
   width: 100%;
   /* [2] */
 }
 
 /* ------------------------------------*\
     #INPUT (Scopes)
 \*------------------------------------ */
 /**
  * [1] Hide placeholder texts if floating labels are activated.
  */
 /* ------------------------------------*\
     #ACCORDION (Scopes)
 \*------------------------------------ */
 /**
  * [1] Styling of a single accordion component within a card component.
  * [2] If an accordion with only one child element is placed in a card collapsible
  *     component, paddings have to be removed.
  */
 .c-card .c-accordion {
   /* [1] */
   border-top: none;
   border-bottom: none;
 }
 
 .c-card .c-accordion:only-child {
   /* [1] */
   text-align: left;
 }
 
 .c-card .c-accordion:only-child .c-accordion__header {
   padding-right: 48px;
   padding-left: 0;
 }
 
 .c-card .c-accordion:only-child .c-accordion__content {
   padding-top: 16px;
 }
 
 .c-card:not(.c-card--expandable) .c-accordion {
   /* [2] */
   /* stylelint-disable selector-max-specificity */
   /* stylelint-enable */
 }
 
 .c-card:not(.c-card--expandable) .c-accordion:only-child .c-accordion__header {
   padding-top: 0;
   padding-bottom: 0;
 }
 
 .c-card:not(.c-card--expandable) .c-accordion:only-child .c-accordion__title-icon {
   top: 0;
   right: 0;
 }
 
 .c-card:not(.c-card--expandable) .c-accordion:only-child .c-accordion__content {
   padding-right: 0;
   padding-bottom: 0;
   padding-left: 0;
 }
 
 /* ------------------------------------*\
     #PRODUCT-INFO-SUMMARY (Scopes)
 \*------------------------------------ */
 /**
  * [1] Styling of a product info summary in a fold out.
  */
 .c-fold-out__header[aria-expanded='true'] .c-product-info-summary .c-product-info-summary__heading, .c-fold-out__header[aria-expanded='true']
 .c-product-info-summary .c-product-info-summary__img, .c-fold-out__header[aria-expanded='true']
 .c-product-info-summary .c-product-info-summary__info {
   display: none;
 }
 
 /* ------------------------------------*\
     #INFO-ICON (Scopes)
 \*------------------------------------ */
 /**
  * Hotfix for Info Icon layout issues when the icon is a direct child of
  * `.c-form-field` The size and position of the info icon was affected by the
  * flexbox context. `.c-form-field > .c-info-icon` is not a recommended markup
  * order. Ideally `.c-info-icon` should be inside of `.c-form-field__label`.
  * But we ourselves have wrongly demonstrated this in
  * https://bronson.vwfs.tools/default/v/7.14.0/components/preview/bronson-calculation-page--calculation-page.html)
  * Bug report: https://jira.platform.vwfs.io/browse/BRONSD-135?focusedCommentId=49997&page=com.atlassian.jira.plugin.system.issuetabpanels%3Acomment-tabpanel#comment-49997
  *
  * @TODO: Refactor Info Icon CSS for all brands by simplifying SCSS and making it more robust.
  *
  * [hf-1] Reset negative margins. See [3].
  * [hf-2] Override the default `align-items` value (`stretch`).
  */
 .c-form-field > .c-info-icon {
   -ms-grid-row-align: center;
   align-self: center;
   /* [hf-2] */
   margin-top: 0;
   /* [hf-1] */
   margin-bottom: 0;
   /* [hf-1] */
 }
 
 /**
  * Fix incorrect positioning in various contexts due to negative margin "hack".
  * This occurs only in IE11.
  * To keep the side-effect manageable, scope it to IE11 only.
  */
 @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .c-info-icon {
     margin-top: 0;
     margin-bottom: 0;
   }
 }
 
 /* ------------------------------------*\
     #HEADER (Scopes)
 \*------------------------------------ */
 /**
  * [1] Push to right side.
  * [2] No spacing between context-bar & notification-center
  *     to visually group them.
  * [3] Fallback for old markup (context-bar nested in header-nav) for positioning.
  * [4] Layout context-bar with only logo & context-bar in header.
  */
 @media (min-width: 721px) {
   .c-header__content-wrapper .c-header__logo:not(:last-child),
   .c-header__content-wrapper .c-header__nav:not(:last-child) {
     margin-right: 32px;
   }
 }
 
 @media (max-width: 720px) {
   .c-header__content-wrapper .c-header__nav {
     margin-left: 16px;
   }
   .c-header__content-wrapper .c-header__nav > .c-context-bar {
     order: -1;
     /* [3] */
     margin-right: 16px;
   }
 }
 
 .c-header__content-wrapper .c-context-bar,
 .c-header__content-wrapper .c-header__notification-center {
   margin-left: auto;
   /* [1] */
 }
 
 .c-header__content-wrapper .c-header__logo + .c-context-bar {
   /* [4] */
   flex-grow: 1;
   flex-shrink: 1;
   flex-basis: auto;
 }
 
 @media (max-width: 720px) {
   .c-context-bar ~ .c-header__notification-center {
     margin-left: 0;
     /* [2] */
   }
 }
 
 /* ------------------------------------*\
     #FOOTER (Scopes)
 \*------------------------------------ */
 .c-footer .c-footnotes {
   color: #ffffff;
 }
 
 /* ------------------------------------*\
     #BLOCK
 \*------------------------------------ */
 /**
  * Utility class to make an element `display: block;`.
  */
 .u-block {
   display: block !important;
 }
 
 /* ------------------------------------*\
     #BORDER
 \*------------------------------------ */
 /**
  * Utility class to make an element have borders like `border: 1px solid red;`.
  */
 .u-border {
   border: 1px solid #697677 !important;
 }
 
 .u-border-t {
   border-top: 1px solid #697677 !important;
 }
 
 .u-border-r {
   border-right: 1px solid #697677 !important;
 }
 
 .u-border-b {
   border-bottom: 1px solid #697677 !important;
 }
 
 .u-border-l {
   border-left: 1px solid #697677 !important;
 }
 
 .u-border-v {
   border-left: 1px solid #697677 !important;
   border-right: 1px solid #697677 !important;
 }
 
 .u-border-h {
   border-top: 1px solid #697677 !important;
   border-bottom: 1px solid #697677 !important;
 }
 
 /* ------------------------------------*\
     #CLEARFIX
 \*------------------------------------ */
 /**
  * Clearfix utility class.
  */
 .u-clearfix::after {
   content: "" !important;
   display: block !important;
   clear: both !important;
 }
 
 /* ------------------------------------*\
     #DEBUG
 \*------------------------------------ */
 /* stylelint-disable */
 /* stylelint-enable */
 /**
  * Disable debug on Plyr video controls. The used plugin (Plyr) does not follow
  * the "no modifier without base class" BEM rule.
  *
  * @TODO: find better solution to exclude Plyr.
  */
 .plyr__control > svg {
   outline: none !important;
 }
 
 /* ------------------------------------*\
     #FLOAT
 \*------------------------------------ */
 /**
  * Helper classes to float elements either left, right or none.
  */
 .u-float-left {
   float: left !important;
 }
 
 .u-float-right {
   float: right !important;
 }
 
 .u-float-none {
   float: none !important;
 }
 
 @media (max-width: 1920px) {
   .u-float-left\@xxl {
     float: left !important;
   }
   .u-float-right\@xxl {
     float: right !important;
   }
   .u-float-none\@xxl {
     float: none !important;
   }
 }
 
 @media (min-width: 1921px) {
   .u-float-left\@xxl-up {
     float: left !important;
   }
   .u-float-right\@xxl-up {
     float: right !important;
   }
   .u-float-none\@xxl-up {
     float: none !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-float-left\@xl {
     float: left !important;
   }
   .u-float-right\@xl {
     float: right !important;
   }
   .u-float-none\@xl {
     float: none !important;
   }
 }
 
 @media (min-width: 1601px) {
   .u-float-left\@xl-up {
     float: left !important;
   }
   .u-float-right\@xl-up {
     float: right !important;
   }
   .u-float-none\@xl-up {
     float: none !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-float-left\@l {
     float: left !important;
   }
   .u-float-right\@l {
     float: right !important;
   }
   .u-float-none\@l {
     float: none !important;
   }
 }
 
 @media (min-width: 1281px) {
   .u-float-left\@l-up {
     float: left !important;
   }
   .u-float-right\@l-up {
     float: right !important;
   }
   .u-float-none\@l-up {
     float: none !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-float-left\@m {
     float: left !important;
   }
   .u-float-right\@m {
     float: right !important;
   }
   .u-float-none\@m {
     float: none !important;
   }
 }
 
 @media (min-width: 961px) {
   .u-float-left\@m-up {
     float: left !important;
   }
   .u-float-right\@m-up {
     float: right !important;
   }
   .u-float-none\@m-up {
     float: none !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-float-left\@s {
     float: left !important;
   }
   .u-float-right\@s {
     float: right !important;
   }
   .u-float-none\@s {
     float: none !important;
   }
 }
 
 @media (min-width: 721px) {
   .u-float-left\@s-up {
     float: left !important;
   }
   .u-float-right\@s-up {
     float: right !important;
   }
   .u-float-none\@s-up {
     float: none !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-float-left\@xs {
     float: left !important;
   }
   .u-float-right\@xs {
     float: right !important;
   }
   .u-float-none\@xs {
     float: none !important;
   }
 }
 
 @media (min-width: 481px) {
   .u-float-left\@xs-up {
     float: left !important;
   }
   .u-float-right\@xs-up {
     float: right !important;
   }
   .u-float-none\@xs-up {
     float: none !important;
   }
 }
 
 /* ------------------------------------*\
     #HIDE
 \*------------------------------------ */
 /**
  * Hide helper classes to hide elements on certain veiwports.
  */
 .u-hide {
   display: none !important;
 }
 
 /**
  * Breakpoints specific hide classes.
  */
 @media (max-width: 1920px) {
   .u-hide\@xxl {
     display: none !important;
   }
 }
 
 @media (min-width: 1921px) {
   .u-hide\@xxl-up {
     display: none !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-hide\@xl {
     display: none !important;
   }
 }
 
 @media (min-width: 1601px) {
   .u-hide\@xl-up {
     display: none !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-hide\@l {
     display: none !important;
   }
 }
 
 @media (min-width: 1281px) {
   .u-hide\@l-up {
     display: none !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-hide\@m {
     display: none !important;
   }
 }
 
 @media (min-width: 961px) {
   .u-hide\@m-up {
     display: none !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-hide\@s {
     display: none !important;
   }
 }
 
 @media (min-width: 721px) {
   .u-hide\@s-up {
     display: none !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-hide\@xs {
     display: none !important;
   }
 }
 
 @media (min-width: 481px) {
   .u-hide\@xs-up {
     display: none !important;
   }
 }
 
 /* ------------------------------------*\
     #NO-CARPET
 \*------------------------------------ */
 /**
  * A utility class to eliminate the `text-decoration: underline`, set by the
  * `<a>` element.
  */
 .u-no-carpet {
   text-decoration: none !important;
 }
 
 /* ------------------------------------*\
     #OFFSETS
 \*------------------------------------ */
 /**
  * A series of offset helper classes that you can use to push and pull items in
  * a grid. Classes take a fraction-like format (e.g. `.u-push-2/3`).
  */
 /* ------------------------------------*\
     #ROUND
 \*------------------------------------ */
 /**
  * A utility class to make elements â€˜roundâ€™.
  */
 .u-round {
   border-radius: 50%;
 }
 
 /* ------------------------------------*\
     #SPACING SETTINGS
 \*------------------------------------ */
 /* ------------------------------------*\
     #SPACINGS
 \*------------------------------------ */
 /**
  * Margin and padding helper classes. Use these to tweak layout on a micro level.
  */
 .u-m-xxsmall {
   margin: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-m-xxsmall\@xxl {
     margin: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-m-xxsmall\@xl {
     margin: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-m-xxsmall\@l {
     margin: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-m-xxsmall\@m {
     margin: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-m-xxsmall\@s {
     margin: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-m-xxsmall\@xs {
     margin: 4px !important;
   }
 }
 
 .u-m-xsmall {
   margin: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-m-xsmall\@xxl {
     margin: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-m-xsmall\@xl {
     margin: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-m-xsmall\@l {
     margin: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-m-xsmall\@m {
     margin: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-m-xsmall\@s {
     margin: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-m-xsmall\@xs {
     margin: 8px !important;
   }
 }
 
 .u-m-small {
   margin: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-m-small\@xxl {
     margin: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-m-small\@xl {
     margin: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-m-small\@l {
     margin: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-m-small\@m {
     margin: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-m-small\@s {
     margin: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-m-small\@xs {
     margin: 16px !important;
   }
 }
 
 .u-m {
   margin: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-m\@xxl {
     margin: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-m\@xl {
     margin: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-m\@l {
     margin: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-m\@m {
     margin: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-m\@s {
     margin: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-m\@xs {
     margin: 24px !important;
   }
 }
 
 .u-m-large {
   margin: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-m-large\@xxl {
     margin: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-m-large\@xl {
     margin: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-m-large\@l {
     margin: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-m-large\@m {
     margin: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-m-large\@s {
     margin: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-m-large\@xs {
     margin: 32px !important;
   }
 }
 
 .u-m-xlarge {
   margin: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-m-xlarge\@xxl {
     margin: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-m-xlarge\@xl {
     margin: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-m-xlarge\@l {
     margin: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-m-xlarge\@m {
     margin: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-m-xlarge\@s {
     margin: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-m-xlarge\@xs {
     margin: 64px !important;
   }
 }
 
 .u-m-none {
   margin: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-m-none\@xxl {
     margin: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-m-none\@xl {
     margin: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-m-none\@l {
     margin: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-m-none\@m {
     margin: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-m-none\@s {
     margin: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-m-none\@xs {
     margin: 0 !important;
   }
 }
 
 .u-mt-xxsmall {
   margin-top: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mt-xxsmall\@xxl {
     margin-top: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mt-xxsmall\@xl {
     margin-top: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mt-xxsmall\@l {
     margin-top: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mt-xxsmall\@m {
     margin-top: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mt-xxsmall\@s {
     margin-top: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mt-xxsmall\@xs {
     margin-top: 4px !important;
   }
 }
 
 .u-mt-xsmall {
   margin-top: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mt-xsmall\@xxl {
     margin-top: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mt-xsmall\@xl {
     margin-top: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mt-xsmall\@l {
     margin-top: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mt-xsmall\@m {
     margin-top: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mt-xsmall\@s {
     margin-top: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mt-xsmall\@xs {
     margin-top: 8px !important;
   }
 }
 
 .u-mt-small {
   margin-top: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mt-small\@xxl {
     margin-top: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mt-small\@xl {
     margin-top: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mt-small\@l {
     margin-top: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mt-small\@m {
     margin-top: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mt-small\@s {
     margin-top: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mt-small\@xs {
     margin-top: 16px !important;
   }
 }
 
 .u-mt {
   margin-top: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mt\@xxl {
     margin-top: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mt\@xl {
     margin-top: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mt\@l {
     margin-top: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mt\@m {
     margin-top: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mt\@s {
     margin-top: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mt\@xs {
     margin-top: 24px !important;
   }
 }
 
 .u-mt-large {
   margin-top: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mt-large\@xxl {
     margin-top: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mt-large\@xl {
     margin-top: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mt-large\@l {
     margin-top: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mt-large\@m {
     margin-top: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mt-large\@s {
     margin-top: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mt-large\@xs {
     margin-top: 32px !important;
   }
 }
 
 .u-mt-xlarge {
   margin-top: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mt-xlarge\@xxl {
     margin-top: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mt-xlarge\@xl {
     margin-top: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mt-xlarge\@l {
     margin-top: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mt-xlarge\@m {
     margin-top: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mt-xlarge\@s {
     margin-top: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mt-xlarge\@xs {
     margin-top: 64px !important;
   }
 }
 
 .u-mt-none {
   margin-top: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-mt-none\@xxl {
     margin-top: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mt-none\@xl {
     margin-top: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mt-none\@l {
     margin-top: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mt-none\@m {
     margin-top: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mt-none\@s {
     margin-top: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mt-none\@xs {
     margin-top: 0 !important;
   }
 }
 
 .u-mr-xxsmall {
   margin-right: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mr-xxsmall\@xxl {
     margin-right: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mr-xxsmall\@xl {
     margin-right: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mr-xxsmall\@l {
     margin-right: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mr-xxsmall\@m {
     margin-right: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mr-xxsmall\@s {
     margin-right: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mr-xxsmall\@xs {
     margin-right: 4px !important;
   }
 }
 
 .u-mr-xsmall {
   margin-right: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mr-xsmall\@xxl {
     margin-right: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mr-xsmall\@xl {
     margin-right: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mr-xsmall\@l {
     margin-right: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mr-xsmall\@m {
     margin-right: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mr-xsmall\@s {
     margin-right: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mr-xsmall\@xs {
     margin-right: 8px !important;
   }
 }
 
 .u-mr-small {
   margin-right: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mr-small\@xxl {
     margin-right: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mr-small\@xl {
     margin-right: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mr-small\@l {
     margin-right: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mr-small\@m {
     margin-right: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mr-small\@s {
     margin-right: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mr-small\@xs {
     margin-right: 16px !important;
   }
 }
 
 .u-mr {
   margin-right: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mr\@xxl {
     margin-right: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mr\@xl {
     margin-right: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mr\@l {
     margin-right: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mr\@m {
     margin-right: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mr\@s {
     margin-right: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mr\@xs {
     margin-right: 24px !important;
   }
 }
 
 .u-mr-large {
   margin-right: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mr-large\@xxl {
     margin-right: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mr-large\@xl {
     margin-right: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mr-large\@l {
     margin-right: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mr-large\@m {
     margin-right: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mr-large\@s {
     margin-right: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mr-large\@xs {
     margin-right: 32px !important;
   }
 }
 
 .u-mr-xlarge {
   margin-right: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mr-xlarge\@xxl {
     margin-right: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mr-xlarge\@xl {
     margin-right: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mr-xlarge\@l {
     margin-right: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mr-xlarge\@m {
     margin-right: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mr-xlarge\@s {
     margin-right: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mr-xlarge\@xs {
     margin-right: 64px !important;
   }
 }
 
 .u-mr-none {
   margin-right: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-mr-none\@xxl {
     margin-right: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mr-none\@xl {
     margin-right: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mr-none\@l {
     margin-right: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mr-none\@m {
     margin-right: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mr-none\@s {
     margin-right: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mr-none\@xs {
     margin-right: 0 !important;
   }
 }
 
 .u-mb-xxsmall {
   margin-bottom: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mb-xxsmall\@xxl {
     margin-bottom: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mb-xxsmall\@xl {
     margin-bottom: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mb-xxsmall\@l {
     margin-bottom: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mb-xxsmall\@m {
     margin-bottom: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mb-xxsmall\@s {
     margin-bottom: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mb-xxsmall\@xs {
     margin-bottom: 4px !important;
   }
 }
 
 .u-mb-xsmall {
   margin-bottom: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mb-xsmall\@xxl {
     margin-bottom: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mb-xsmall\@xl {
     margin-bottom: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mb-xsmall\@l {
     margin-bottom: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mb-xsmall\@m {
     margin-bottom: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mb-xsmall\@s {
     margin-bottom: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mb-xsmall\@xs {
     margin-bottom: 8px !important;
   }
 }
 
 .u-mb-small {
   margin-bottom: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mb-small\@xxl {
     margin-bottom: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mb-small\@xl {
     margin-bottom: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mb-small\@l {
     margin-bottom: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mb-small\@m {
     margin-bottom: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mb-small\@s {
     margin-bottom: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mb-small\@xs {
     margin-bottom: 16px !important;
   }
 }
 
 .u-mb {
   margin-bottom: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mb\@xxl {
     margin-bottom: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mb\@xl {
     margin-bottom: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mb\@l {
     margin-bottom: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mb\@m {
     margin-bottom: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mb\@s {
     margin-bottom: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mb\@xs {
     margin-bottom: 24px !important;
   }
 }
 
 .u-mb-large {
   margin-bottom: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mb-large\@xxl {
     margin-bottom: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mb-large\@xl {
     margin-bottom: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mb-large\@l {
     margin-bottom: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mb-large\@m {
     margin-bottom: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mb-large\@s {
     margin-bottom: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mb-large\@xs {
     margin-bottom: 32px !important;
   }
 }
 
 .u-mb-xlarge {
   margin-bottom: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mb-xlarge\@xxl {
     margin-bottom: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mb-xlarge\@xl {
     margin-bottom: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mb-xlarge\@l {
     margin-bottom: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mb-xlarge\@m {
     margin-bottom: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mb-xlarge\@s {
     margin-bottom: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mb-xlarge\@xs {
     margin-bottom: 64px !important;
   }
 }
 
 .u-mb-none {
   margin-bottom: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-mb-none\@xxl {
     margin-bottom: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mb-none\@xl {
     margin-bottom: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mb-none\@l {
     margin-bottom: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mb-none\@m {
     margin-bottom: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mb-none\@s {
     margin-bottom: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mb-none\@xs {
     margin-bottom: 0 !important;
   }
 }
 
 .u-ml-xxsmall {
   margin-left: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-ml-xxsmall\@xxl {
     margin-left: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ml-xxsmall\@xl {
     margin-left: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ml-xxsmall\@l {
     margin-left: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ml-xxsmall\@m {
     margin-left: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ml-xxsmall\@s {
     margin-left: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ml-xxsmall\@xs {
     margin-left: 4px !important;
   }
 }
 
 .u-ml-xsmall {
   margin-left: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-ml-xsmall\@xxl {
     margin-left: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ml-xsmall\@xl {
     margin-left: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ml-xsmall\@l {
     margin-left: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ml-xsmall\@m {
     margin-left: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ml-xsmall\@s {
     margin-left: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ml-xsmall\@xs {
     margin-left: 8px !important;
   }
 }
 
 .u-ml-small {
   margin-left: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-ml-small\@xxl {
     margin-left: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ml-small\@xl {
     margin-left: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ml-small\@l {
     margin-left: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ml-small\@m {
     margin-left: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ml-small\@s {
     margin-left: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ml-small\@xs {
     margin-left: 16px !important;
   }
 }
 
 .u-ml {
   margin-left: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-ml\@xxl {
     margin-left: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ml\@xl {
     margin-left: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ml\@l {
     margin-left: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ml\@m {
     margin-left: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ml\@s {
     margin-left: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ml\@xs {
     margin-left: 24px !important;
   }
 }
 
 .u-ml-large {
   margin-left: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-ml-large\@xxl {
     margin-left: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ml-large\@xl {
     margin-left: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ml-large\@l {
     margin-left: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ml-large\@m {
     margin-left: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ml-large\@s {
     margin-left: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ml-large\@xs {
     margin-left: 32px !important;
   }
 }
 
 .u-ml-xlarge {
   margin-left: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-ml-xlarge\@xxl {
     margin-left: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ml-xlarge\@xl {
     margin-left: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ml-xlarge\@l {
     margin-left: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ml-xlarge\@m {
     margin-left: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ml-xlarge\@s {
     margin-left: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ml-xlarge\@xs {
     margin-left: 64px !important;
   }
 }
 
 .u-ml-none {
   margin-left: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-ml-none\@xxl {
     margin-left: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ml-none\@xl {
     margin-left: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ml-none\@l {
     margin-left: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ml-none\@m {
     margin-left: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ml-none\@s {
     margin-left: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ml-none\@xs {
     margin-left: 0 !important;
   }
 }
 
 .u-mh-xxsmall {
   margin-left: 4px !important;
   margin-right: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mh-xxsmall\@xxl {
     margin-left: 4px !important;
     margin-right: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mh-xxsmall\@xl {
     margin-left: 4px !important;
     margin-right: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mh-xxsmall\@l {
     margin-left: 4px !important;
     margin-right: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mh-xxsmall\@m {
     margin-left: 4px !important;
     margin-right: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mh-xxsmall\@s {
     margin-left: 4px !important;
     margin-right: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mh-xxsmall\@xs {
     margin-left: 4px !important;
     margin-right: 4px !important;
   }
 }
 
 .u-mh-xsmall {
   margin-left: 8px !important;
   margin-right: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mh-xsmall\@xxl {
     margin-left: 8px !important;
     margin-right: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mh-xsmall\@xl {
     margin-left: 8px !important;
     margin-right: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mh-xsmall\@l {
     margin-left: 8px !important;
     margin-right: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mh-xsmall\@m {
     margin-left: 8px !important;
     margin-right: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mh-xsmall\@s {
     margin-left: 8px !important;
     margin-right: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mh-xsmall\@xs {
     margin-left: 8px !important;
     margin-right: 8px !important;
   }
 }
 
 .u-mh-small {
   margin-left: 16px !important;
   margin-right: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mh-small\@xxl {
     margin-left: 16px !important;
     margin-right: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mh-small\@xl {
     margin-left: 16px !important;
     margin-right: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mh-small\@l {
     margin-left: 16px !important;
     margin-right: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mh-small\@m {
     margin-left: 16px !important;
     margin-right: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mh-small\@s {
     margin-left: 16px !important;
     margin-right: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mh-small\@xs {
     margin-left: 16px !important;
     margin-right: 16px !important;
   }
 }
 
 .u-mh {
   margin-left: 24px !important;
   margin-right: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mh\@xxl {
     margin-left: 24px !important;
     margin-right: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mh\@xl {
     margin-left: 24px !important;
     margin-right: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mh\@l {
     margin-left: 24px !important;
     margin-right: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mh\@m {
     margin-left: 24px !important;
     margin-right: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mh\@s {
     margin-left: 24px !important;
     margin-right: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mh\@xs {
     margin-left: 24px !important;
     margin-right: 24px !important;
   }
 }
 
 .u-mh-large {
   margin-left: 32px !important;
   margin-right: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mh-large\@xxl {
     margin-left: 32px !important;
     margin-right: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mh-large\@xl {
     margin-left: 32px !important;
     margin-right: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mh-large\@l {
     margin-left: 32px !important;
     margin-right: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mh-large\@m {
     margin-left: 32px !important;
     margin-right: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mh-large\@s {
     margin-left: 32px !important;
     margin-right: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mh-large\@xs {
     margin-left: 32px !important;
     margin-right: 32px !important;
   }
 }
 
 .u-mh-xlarge {
   margin-left: 64px !important;
   margin-right: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mh-xlarge\@xxl {
     margin-left: 64px !important;
     margin-right: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mh-xlarge\@xl {
     margin-left: 64px !important;
     margin-right: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mh-xlarge\@l {
     margin-left: 64px !important;
     margin-right: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mh-xlarge\@m {
     margin-left: 64px !important;
     margin-right: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mh-xlarge\@s {
     margin-left: 64px !important;
     margin-right: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mh-xlarge\@xs {
     margin-left: 64px !important;
     margin-right: 64px !important;
   }
 }
 
 .u-mh-none {
   margin-left: 0 !important;
   margin-right: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-mh-none\@xxl {
     margin-left: 0 !important;
     margin-right: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mh-none\@xl {
     margin-left: 0 !important;
     margin-right: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mh-none\@l {
     margin-left: 0 !important;
     margin-right: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mh-none\@m {
     margin-left: 0 !important;
     margin-right: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mh-none\@s {
     margin-left: 0 !important;
     margin-right: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mh-none\@xs {
     margin-left: 0 !important;
     margin-right: 0 !important;
   }
 }
 
 .u-mv-xxsmall {
   margin-top: 4px !important;
   margin-bottom: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mv-xxsmall\@xxl {
     margin-top: 4px !important;
     margin-bottom: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mv-xxsmall\@xl {
     margin-top: 4px !important;
     margin-bottom: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mv-xxsmall\@l {
     margin-top: 4px !important;
     margin-bottom: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mv-xxsmall\@m {
     margin-top: 4px !important;
     margin-bottom: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mv-xxsmall\@s {
     margin-top: 4px !important;
     margin-bottom: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mv-xxsmall\@xs {
     margin-top: 4px !important;
     margin-bottom: 4px !important;
   }
 }
 
 .u-mv-xsmall {
   margin-top: 8px !important;
   margin-bottom: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mv-xsmall\@xxl {
     margin-top: 8px !important;
     margin-bottom: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mv-xsmall\@xl {
     margin-top: 8px !important;
     margin-bottom: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mv-xsmall\@l {
     margin-top: 8px !important;
     margin-bottom: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mv-xsmall\@m {
     margin-top: 8px !important;
     margin-bottom: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mv-xsmall\@s {
     margin-top: 8px !important;
     margin-bottom: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mv-xsmall\@xs {
     margin-top: 8px !important;
     margin-bottom: 8px !important;
   }
 }
 
 .u-mv-small {
   margin-top: 16px !important;
   margin-bottom: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mv-small\@xxl {
     margin-top: 16px !important;
     margin-bottom: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mv-small\@xl {
     margin-top: 16px !important;
     margin-bottom: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mv-small\@l {
     margin-top: 16px !important;
     margin-bottom: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mv-small\@m {
     margin-top: 16px !important;
     margin-bottom: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mv-small\@s {
     margin-top: 16px !important;
     margin-bottom: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mv-small\@xs {
     margin-top: 16px !important;
     margin-bottom: 16px !important;
   }
 }
 
 .u-mv {
   margin-top: 24px !important;
   margin-bottom: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mv\@xxl {
     margin-top: 24px !important;
     margin-bottom: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mv\@xl {
     margin-top: 24px !important;
     margin-bottom: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mv\@l {
     margin-top: 24px !important;
     margin-bottom: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mv\@m {
     margin-top: 24px !important;
     margin-bottom: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mv\@s {
     margin-top: 24px !important;
     margin-bottom: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mv\@xs {
     margin-top: 24px !important;
     margin-bottom: 24px !important;
   }
 }
 
 .u-mv-large {
   margin-top: 32px !important;
   margin-bottom: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mv-large\@xxl {
     margin-top: 32px !important;
     margin-bottom: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mv-large\@xl {
     margin-top: 32px !important;
     margin-bottom: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mv-large\@l {
     margin-top: 32px !important;
     margin-bottom: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mv-large\@m {
     margin-top: 32px !important;
     margin-bottom: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mv-large\@s {
     margin-top: 32px !important;
     margin-bottom: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mv-large\@xs {
     margin-top: 32px !important;
     margin-bottom: 32px !important;
   }
 }
 
 .u-mv-xlarge {
   margin-top: 64px !important;
   margin-bottom: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-mv-xlarge\@xxl {
     margin-top: 64px !important;
     margin-bottom: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mv-xlarge\@xl {
     margin-top: 64px !important;
     margin-bottom: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mv-xlarge\@l {
     margin-top: 64px !important;
     margin-bottom: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mv-xlarge\@m {
     margin-top: 64px !important;
     margin-bottom: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mv-xlarge\@s {
     margin-top: 64px !important;
     margin-bottom: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mv-xlarge\@xs {
     margin-top: 64px !important;
     margin-bottom: 64px !important;
   }
 }
 
 .u-mv-none {
   margin-top: 0 !important;
   margin-bottom: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-mv-none\@xxl {
     margin-top: 0 !important;
     margin-bottom: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-mv-none\@xl {
     margin-top: 0 !important;
     margin-bottom: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-mv-none\@l {
     margin-top: 0 !important;
     margin-bottom: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-mv-none\@m {
     margin-top: 0 !important;
     margin-bottom: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-mv-none\@s {
     margin-top: 0 !important;
     margin-bottom: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-mv-none\@xs {
     margin-top: 0 !important;
     margin-bottom: 0 !important;
   }
 }
 
 .u-p-xxsmall {
   padding: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-p-xxsmall\@xxl {
     padding: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-p-xxsmall\@xl {
     padding: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-p-xxsmall\@l {
     padding: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-p-xxsmall\@m {
     padding: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-p-xxsmall\@s {
     padding: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-p-xxsmall\@xs {
     padding: 4px !important;
   }
 }
 
 .u-p-xsmall {
   padding: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-p-xsmall\@xxl {
     padding: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-p-xsmall\@xl {
     padding: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-p-xsmall\@l {
     padding: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-p-xsmall\@m {
     padding: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-p-xsmall\@s {
     padding: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-p-xsmall\@xs {
     padding: 8px !important;
   }
 }
 
 .u-p-small {
   padding: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-p-small\@xxl {
     padding: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-p-small\@xl {
     padding: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-p-small\@l {
     padding: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-p-small\@m {
     padding: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-p-small\@s {
     padding: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-p-small\@xs {
     padding: 16px !important;
   }
 }
 
 .u-p {
   padding: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-p\@xxl {
     padding: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-p\@xl {
     padding: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-p\@l {
     padding: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-p\@m {
     padding: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-p\@s {
     padding: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-p\@xs {
     padding: 24px !important;
   }
 }
 
 .u-p-large {
   padding: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-p-large\@xxl {
     padding: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-p-large\@xl {
     padding: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-p-large\@l {
     padding: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-p-large\@m {
     padding: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-p-large\@s {
     padding: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-p-large\@xs {
     padding: 32px !important;
   }
 }
 
 .u-p-xlarge {
   padding: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-p-xlarge\@xxl {
     padding: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-p-xlarge\@xl {
     padding: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-p-xlarge\@l {
     padding: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-p-xlarge\@m {
     padding: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-p-xlarge\@s {
     padding: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-p-xlarge\@xs {
     padding: 64px !important;
   }
 }
 
 .u-p-none {
   padding: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-p-none\@xxl {
     padding: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-p-none\@xl {
     padding: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-p-none\@l {
     padding: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-p-none\@m {
     padding: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-p-none\@s {
     padding: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-p-none\@xs {
     padding: 0 !important;
   }
 }
 
 .u-pt-xxsmall {
   padding-top: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pt-xxsmall\@xxl {
     padding-top: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pt-xxsmall\@xl {
     padding-top: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pt-xxsmall\@l {
     padding-top: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pt-xxsmall\@m {
     padding-top: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pt-xxsmall\@s {
     padding-top: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pt-xxsmall\@xs {
     padding-top: 4px !important;
   }
 }
 
 .u-pt-xsmall {
   padding-top: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pt-xsmall\@xxl {
     padding-top: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pt-xsmall\@xl {
     padding-top: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pt-xsmall\@l {
     padding-top: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pt-xsmall\@m {
     padding-top: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pt-xsmall\@s {
     padding-top: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pt-xsmall\@xs {
     padding-top: 8px !important;
   }
 }
 
 .u-pt-small {
   padding-top: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pt-small\@xxl {
     padding-top: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pt-small\@xl {
     padding-top: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pt-small\@l {
     padding-top: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pt-small\@m {
     padding-top: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pt-small\@s {
     padding-top: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pt-small\@xs {
     padding-top: 16px !important;
   }
 }
 
 .u-pt {
   padding-top: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pt\@xxl {
     padding-top: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pt\@xl {
     padding-top: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pt\@l {
     padding-top: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pt\@m {
     padding-top: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pt\@s {
     padding-top: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pt\@xs {
     padding-top: 24px !important;
   }
 }
 
 .u-pt-large {
   padding-top: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pt-large\@xxl {
     padding-top: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pt-large\@xl {
     padding-top: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pt-large\@l {
     padding-top: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pt-large\@m {
     padding-top: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pt-large\@s {
     padding-top: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pt-large\@xs {
     padding-top: 32px !important;
   }
 }
 
 .u-pt-xlarge {
   padding-top: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pt-xlarge\@xxl {
     padding-top: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pt-xlarge\@xl {
     padding-top: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pt-xlarge\@l {
     padding-top: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pt-xlarge\@m {
     padding-top: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pt-xlarge\@s {
     padding-top: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pt-xlarge\@xs {
     padding-top: 64px !important;
   }
 }
 
 .u-pt-none {
   padding-top: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-pt-none\@xxl {
     padding-top: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pt-none\@xl {
     padding-top: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pt-none\@l {
     padding-top: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pt-none\@m {
     padding-top: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pt-none\@s {
     padding-top: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pt-none\@xs {
     padding-top: 0 !important;
   }
 }
 
 .u-pr-xxsmall {
   padding-right: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pr-xxsmall\@xxl {
     padding-right: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pr-xxsmall\@xl {
     padding-right: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pr-xxsmall\@l {
     padding-right: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pr-xxsmall\@m {
     padding-right: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pr-xxsmall\@s {
     padding-right: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pr-xxsmall\@xs {
     padding-right: 4px !important;
   }
 }
 
 .u-pr-xsmall {
   padding-right: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pr-xsmall\@xxl {
     padding-right: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pr-xsmall\@xl {
     padding-right: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pr-xsmall\@l {
     padding-right: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pr-xsmall\@m {
     padding-right: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pr-xsmall\@s {
     padding-right: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pr-xsmall\@xs {
     padding-right: 8px !important;
   }
 }
 
 .u-pr-small {
   padding-right: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pr-small\@xxl {
     padding-right: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pr-small\@xl {
     padding-right: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pr-small\@l {
     padding-right: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pr-small\@m {
     padding-right: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pr-small\@s {
     padding-right: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pr-small\@xs {
     padding-right: 16px !important;
   }
 }
 
 .u-pr {
   padding-right: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pr\@xxl {
     padding-right: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pr\@xl {
     padding-right: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pr\@l {
     padding-right: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pr\@m {
     padding-right: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pr\@s {
     padding-right: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pr\@xs {
     padding-right: 24px !important;
   }
 }
 
 .u-pr-large {
   padding-right: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pr-large\@xxl {
     padding-right: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pr-large\@xl {
     padding-right: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pr-large\@l {
     padding-right: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pr-large\@m {
     padding-right: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pr-large\@s {
     padding-right: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pr-large\@xs {
     padding-right: 32px !important;
   }
 }
 
 .u-pr-xlarge {
   padding-right: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pr-xlarge\@xxl {
     padding-right: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pr-xlarge\@xl {
     padding-right: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pr-xlarge\@l {
     padding-right: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pr-xlarge\@m {
     padding-right: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pr-xlarge\@s {
     padding-right: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pr-xlarge\@xs {
     padding-right: 64px !important;
   }
 }
 
 .u-pr-none {
   padding-right: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-pr-none\@xxl {
     padding-right: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pr-none\@xl {
     padding-right: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pr-none\@l {
     padding-right: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pr-none\@m {
     padding-right: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pr-none\@s {
     padding-right: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pr-none\@xs {
     padding-right: 0 !important;
   }
 }
 
 .u-pb-xxsmall {
   padding-bottom: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pb-xxsmall\@xxl {
     padding-bottom: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pb-xxsmall\@xl {
     padding-bottom: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pb-xxsmall\@l {
     padding-bottom: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pb-xxsmall\@m {
     padding-bottom: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pb-xxsmall\@s {
     padding-bottom: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pb-xxsmall\@xs {
     padding-bottom: 4px !important;
   }
 }
 
 .u-pb-xsmall {
   padding-bottom: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pb-xsmall\@xxl {
     padding-bottom: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pb-xsmall\@xl {
     padding-bottom: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pb-xsmall\@l {
     padding-bottom: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pb-xsmall\@m {
     padding-bottom: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pb-xsmall\@s {
     padding-bottom: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pb-xsmall\@xs {
     padding-bottom: 8px !important;
   }
 }
 
 .u-pb-small {
   padding-bottom: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pb-small\@xxl {
     padding-bottom: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pb-small\@xl {
     padding-bottom: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pb-small\@l {
     padding-bottom: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pb-small\@m {
     padding-bottom: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pb-small\@s {
     padding-bottom: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pb-small\@xs {
     padding-bottom: 16px !important;
   }
 }
 
 .u-pb {
   padding-bottom: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pb\@xxl {
     padding-bottom: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pb\@xl {
     padding-bottom: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pb\@l {
     padding-bottom: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pb\@m {
     padding-bottom: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pb\@s {
     padding-bottom: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pb\@xs {
     padding-bottom: 24px !important;
   }
 }
 
 .u-pb-large {
   padding-bottom: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pb-large\@xxl {
     padding-bottom: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pb-large\@xl {
     padding-bottom: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pb-large\@l {
     padding-bottom: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pb-large\@m {
     padding-bottom: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pb-large\@s {
     padding-bottom: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pb-large\@xs {
     padding-bottom: 32px !important;
   }
 }
 
 .u-pb-xlarge {
   padding-bottom: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pb-xlarge\@xxl {
     padding-bottom: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pb-xlarge\@xl {
     padding-bottom: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pb-xlarge\@l {
     padding-bottom: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pb-xlarge\@m {
     padding-bottom: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pb-xlarge\@s {
     padding-bottom: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pb-xlarge\@xs {
     padding-bottom: 64px !important;
   }
 }
 
 .u-pb-none {
   padding-bottom: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-pb-none\@xxl {
     padding-bottom: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pb-none\@xl {
     padding-bottom: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pb-none\@l {
     padding-bottom: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pb-none\@m {
     padding-bottom: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pb-none\@s {
     padding-bottom: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pb-none\@xs {
     padding-bottom: 0 !important;
   }
 }
 
 .u-pl-xxsmall {
   padding-left: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pl-xxsmall\@xxl {
     padding-left: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pl-xxsmall\@xl {
     padding-left: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pl-xxsmall\@l {
     padding-left: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pl-xxsmall\@m {
     padding-left: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pl-xxsmall\@s {
     padding-left: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pl-xxsmall\@xs {
     padding-left: 4px !important;
   }
 }
 
 .u-pl-xsmall {
   padding-left: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pl-xsmall\@xxl {
     padding-left: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pl-xsmall\@xl {
     padding-left: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pl-xsmall\@l {
     padding-left: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pl-xsmall\@m {
     padding-left: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pl-xsmall\@s {
     padding-left: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pl-xsmall\@xs {
     padding-left: 8px !important;
   }
 }
 
 .u-pl-small {
   padding-left: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pl-small\@xxl {
     padding-left: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pl-small\@xl {
     padding-left: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pl-small\@l {
     padding-left: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pl-small\@m {
     padding-left: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pl-small\@s {
     padding-left: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pl-small\@xs {
     padding-left: 16px !important;
   }
 }
 
 .u-pl {
   padding-left: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pl\@xxl {
     padding-left: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pl\@xl {
     padding-left: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pl\@l {
     padding-left: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pl\@m {
     padding-left: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pl\@s {
     padding-left: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pl\@xs {
     padding-left: 24px !important;
   }
 }
 
 .u-pl-large {
   padding-left: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pl-large\@xxl {
     padding-left: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pl-large\@xl {
     padding-left: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pl-large\@l {
     padding-left: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pl-large\@m {
     padding-left: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pl-large\@s {
     padding-left: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pl-large\@xs {
     padding-left: 32px !important;
   }
 }
 
 .u-pl-xlarge {
   padding-left: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pl-xlarge\@xxl {
     padding-left: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pl-xlarge\@xl {
     padding-left: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pl-xlarge\@l {
     padding-left: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pl-xlarge\@m {
     padding-left: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pl-xlarge\@s {
     padding-left: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pl-xlarge\@xs {
     padding-left: 64px !important;
   }
 }
 
 .u-pl-none {
   padding-left: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-pl-none\@xxl {
     padding-left: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pl-none\@xl {
     padding-left: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pl-none\@l {
     padding-left: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pl-none\@m {
     padding-left: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pl-none\@s {
     padding-left: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pl-none\@xs {
     padding-left: 0 !important;
   }
 }
 
 .u-ph-xxsmall {
   padding-left: 4px !important;
   padding-right: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-ph-xxsmall\@xxl {
     padding-left: 4px !important;
     padding-right: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ph-xxsmall\@xl {
     padding-left: 4px !important;
     padding-right: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ph-xxsmall\@l {
     padding-left: 4px !important;
     padding-right: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ph-xxsmall\@m {
     padding-left: 4px !important;
     padding-right: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ph-xxsmall\@s {
     padding-left: 4px !important;
     padding-right: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ph-xxsmall\@xs {
     padding-left: 4px !important;
     padding-right: 4px !important;
   }
 }
 
 .u-ph-xsmall {
   padding-left: 8px !important;
   padding-right: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-ph-xsmall\@xxl {
     padding-left: 8px !important;
     padding-right: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ph-xsmall\@xl {
     padding-left: 8px !important;
     padding-right: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ph-xsmall\@l {
     padding-left: 8px !important;
     padding-right: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ph-xsmall\@m {
     padding-left: 8px !important;
     padding-right: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ph-xsmall\@s {
     padding-left: 8px !important;
     padding-right: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ph-xsmall\@xs {
     padding-left: 8px !important;
     padding-right: 8px !important;
   }
 }
 
 .u-ph-small {
   padding-left: 16px !important;
   padding-right: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-ph-small\@xxl {
     padding-left: 16px !important;
     padding-right: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ph-small\@xl {
     padding-left: 16px !important;
     padding-right: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ph-small\@l {
     padding-left: 16px !important;
     padding-right: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ph-small\@m {
     padding-left: 16px !important;
     padding-right: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ph-small\@s {
     padding-left: 16px !important;
     padding-right: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ph-small\@xs {
     padding-left: 16px !important;
     padding-right: 16px !important;
   }
 }
 
 .u-ph {
   padding-left: 24px !important;
   padding-right: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-ph\@xxl {
     padding-left: 24px !important;
     padding-right: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ph\@xl {
     padding-left: 24px !important;
     padding-right: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ph\@l {
     padding-left: 24px !important;
     padding-right: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ph\@m {
     padding-left: 24px !important;
     padding-right: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ph\@s {
     padding-left: 24px !important;
     padding-right: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ph\@xs {
     padding-left: 24px !important;
     padding-right: 24px !important;
   }
 }
 
 .u-ph-large {
   padding-left: 32px !important;
   padding-right: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-ph-large\@xxl {
     padding-left: 32px !important;
     padding-right: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ph-large\@xl {
     padding-left: 32px !important;
     padding-right: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ph-large\@l {
     padding-left: 32px !important;
     padding-right: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ph-large\@m {
     padding-left: 32px !important;
     padding-right: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ph-large\@s {
     padding-left: 32px !important;
     padding-right: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ph-large\@xs {
     padding-left: 32px !important;
     padding-right: 32px !important;
   }
 }
 
 .u-ph-xlarge {
   padding-left: 64px !important;
   padding-right: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-ph-xlarge\@xxl {
     padding-left: 64px !important;
     padding-right: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ph-xlarge\@xl {
     padding-left: 64px !important;
     padding-right: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ph-xlarge\@l {
     padding-left: 64px !important;
     padding-right: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ph-xlarge\@m {
     padding-left: 64px !important;
     padding-right: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ph-xlarge\@s {
     padding-left: 64px !important;
     padding-right: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ph-xlarge\@xs {
     padding-left: 64px !important;
     padding-right: 64px !important;
   }
 }
 
 .u-ph-none {
   padding-left: 0 !important;
   padding-right: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-ph-none\@xxl {
     padding-left: 0 !important;
     padding-right: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-ph-none\@xl {
     padding-left: 0 !important;
     padding-right: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-ph-none\@l {
     padding-left: 0 !important;
     padding-right: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-ph-none\@m {
     padding-left: 0 !important;
     padding-right: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-ph-none\@s {
     padding-left: 0 !important;
     padding-right: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-ph-none\@xs {
     padding-left: 0 !important;
     padding-right: 0 !important;
   }
 }
 
 .u-pv-xxsmall {
   padding-top: 4px !important;
   padding-bottom: 4px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pv-xxsmall\@xxl {
     padding-top: 4px !important;
     padding-bottom: 4px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pv-xxsmall\@xl {
     padding-top: 4px !important;
     padding-bottom: 4px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pv-xxsmall\@l {
     padding-top: 4px !important;
     padding-bottom: 4px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pv-xxsmall\@m {
     padding-top: 4px !important;
     padding-bottom: 4px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pv-xxsmall\@s {
     padding-top: 4px !important;
     padding-bottom: 4px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pv-xxsmall\@xs {
     padding-top: 4px !important;
     padding-bottom: 4px !important;
   }
 }
 
 .u-pv-xsmall {
   padding-top: 8px !important;
   padding-bottom: 8px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pv-xsmall\@xxl {
     padding-top: 8px !important;
     padding-bottom: 8px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pv-xsmall\@xl {
     padding-top: 8px !important;
     padding-bottom: 8px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pv-xsmall\@l {
     padding-top: 8px !important;
     padding-bottom: 8px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pv-xsmall\@m {
     padding-top: 8px !important;
     padding-bottom: 8px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pv-xsmall\@s {
     padding-top: 8px !important;
     padding-bottom: 8px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pv-xsmall\@xs {
     padding-top: 8px !important;
     padding-bottom: 8px !important;
   }
 }
 
 .u-pv-small {
   padding-top: 16px !important;
   padding-bottom: 16px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pv-small\@xxl {
     padding-top: 16px !important;
     padding-bottom: 16px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pv-small\@xl {
     padding-top: 16px !important;
     padding-bottom: 16px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pv-small\@l {
     padding-top: 16px !important;
     padding-bottom: 16px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pv-small\@m {
     padding-top: 16px !important;
     padding-bottom: 16px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pv-small\@s {
     padding-top: 16px !important;
     padding-bottom: 16px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pv-small\@xs {
     padding-top: 16px !important;
     padding-bottom: 16px !important;
   }
 }
 
 .u-pv {
   padding-top: 24px !important;
   padding-bottom: 24px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pv\@xxl {
     padding-top: 24px !important;
     padding-bottom: 24px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pv\@xl {
     padding-top: 24px !important;
     padding-bottom: 24px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pv\@l {
     padding-top: 24px !important;
     padding-bottom: 24px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pv\@m {
     padding-top: 24px !important;
     padding-bottom: 24px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pv\@s {
     padding-top: 24px !important;
     padding-bottom: 24px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pv\@xs {
     padding-top: 24px !important;
     padding-bottom: 24px !important;
   }
 }
 
 .u-pv-large {
   padding-top: 32px !important;
   padding-bottom: 32px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pv-large\@xxl {
     padding-top: 32px !important;
     padding-bottom: 32px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pv-large\@xl {
     padding-top: 32px !important;
     padding-bottom: 32px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pv-large\@l {
     padding-top: 32px !important;
     padding-bottom: 32px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pv-large\@m {
     padding-top: 32px !important;
     padding-bottom: 32px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pv-large\@s {
     padding-top: 32px !important;
     padding-bottom: 32px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pv-large\@xs {
     padding-top: 32px !important;
     padding-bottom: 32px !important;
   }
 }
 
 .u-pv-xlarge {
   padding-top: 64px !important;
   padding-bottom: 64px !important;
 }
 
 @media (max-width: 1920px) {
   .u-pv-xlarge\@xxl {
     padding-top: 64px !important;
     padding-bottom: 64px !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pv-xlarge\@xl {
     padding-top: 64px !important;
     padding-bottom: 64px !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pv-xlarge\@l {
     padding-top: 64px !important;
     padding-bottom: 64px !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pv-xlarge\@m {
     padding-top: 64px !important;
     padding-bottom: 64px !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pv-xlarge\@s {
     padding-top: 64px !important;
     padding-bottom: 64px !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pv-xlarge\@xs {
     padding-top: 64px !important;
     padding-bottom: 64px !important;
   }
 }
 
 .u-pv-none {
   padding-top: 0 !important;
   padding-bottom: 0 !important;
 }
 
 @media (max-width: 1920px) {
   .u-pv-none\@xxl {
     padding-top: 0 !important;
     padding-bottom: 0 !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-pv-none\@xl {
     padding-top: 0 !important;
     padding-bottom: 0 !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-pv-none\@l {
     padding-top: 0 !important;
     padding-bottom: 0 !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-pv-none\@m {
     padding-top: 0 !important;
     padding-bottom: 0 !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-pv-none\@s {
     padding-top: 0 !important;
     padding-bottom: 0 !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-pv-none\@xs {
     padding-top: 0 !important;
     padding-bottom: 0 !important;
   }
 }
 
 /* ------------------------------------*\
     #TEXT-ALIGN
 \*------------------------------------ */
 /**
  * Helper classes to align elements either left, right or center.
  */
 .u-text-left {
   text-align: left !important;
 }
 
 .u-text-right {
   text-align: right !important;
 }
 
 .u-text-center {
   text-align: center !important;
 }
 
 @media (max-width: 1920px) {
   .u-text-left\@xxl {
     text-align: left !important;
   }
   .u-text-right\@xxl {
     text-align: right !important;
   }
   .u-text-center\@xxl {
     text-align: center !important;
   }
 }
 
 @media (min-width: 1921px) {
   .u-text-left\@xxl-up {
     text-align: left !important;
   }
   .u-text-right\@xxl-up {
     text-align: right !important;
   }
   .u-text-center\@xxl-up {
     text-align: center !important;
   }
 }
 
 @media (max-width: 1600px) {
   .u-text-left\@xl {
     text-align: left !important;
   }
   .u-text-right\@xl {
     text-align: right !important;
   }
   .u-text-center\@xl {
     text-align: center !important;
   }
 }
 
 @media (min-width: 1601px) {
   .u-text-left\@xl-up {
     text-align: left !important;
   }
   .u-text-right\@xl-up {
     text-align: right !important;
   }
   .u-text-center\@xl-up {
     text-align: center !important;
   }
 }
 
 @media (max-width: 1280px) {
   .u-text-left\@l {
     text-align: left !important;
   }
   .u-text-right\@l {
     text-align: right !important;
   }
   .u-text-center\@l {
     text-align: center !important;
   }
 }
 
 @media (min-width: 1281px) {
   .u-text-left\@l-up {
     text-align: left !important;
   }
   .u-text-right\@l-up {
     text-align: right !important;
   }
   .u-text-center\@l-up {
     text-align: center !important;
   }
 }
 
 @media (max-width: 960px) {
   .u-text-left\@m {
     text-align: left !important;
   }
   .u-text-right\@m {
     text-align: right !important;
   }
   .u-text-center\@m {
     text-align: center !important;
   }
 }
 
 @media (min-width: 961px) {
   .u-text-left\@m-up {
     text-align: left !important;
   }
   .u-text-right\@m-up {
     text-align: right !important;
   }
   .u-text-center\@m-up {
     text-align: center !important;
   }
 }
 
 @media (max-width: 720px) {
   .u-text-left\@s {
     text-align: left !important;
   }
   .u-text-right\@s {
     text-align: right !important;
   }
   .u-text-center\@s {
     text-align: center !important;
   }
 }
 
 @media (min-width: 721px) {
   .u-text-left\@s-up {
     text-align: left !important;
   }
   .u-text-right\@s-up {
     text-align: right !important;
   }
   .u-text-center\@s-up {
     text-align: center !important;
   }
 }
 
 @media (max-width: 480px) {
   .u-text-left\@xs {
     text-align: left !important;
   }
   .u-text-right\@xs {
     text-align: right !important;
   }
   .u-text-center\@xs {
     text-align: center !important;
   }
 }
 
 @media (min-width: 481px) {
   .u-text-left\@xs-up {
     text-align: left !important;
   }
   .u-text-right\@xs-up {
     text-align: right !important;
   }
   .u-text-center\@xs-up {
     text-align: center !important;
   }
 }
 
 /* ------------------------------------*\
     #TEXT-SIZES
 \*------------------------------------ */
 /**
  * Utility classes for differing text-sizes.
  *
  * These classes are based on our modular font-sizes (`_settings.font-sizes.scss`)
  * and provide a way of achieving varying font-sizes for any HTML elements.
  */
 .u-text-fs0 {
   /* stylelint-disable-line order/order */
   font-size: 1rem !important;
   /* stylelint-disable-line order/order */
   line-height: 1.5 !important;
 }
 
 .u-text-fs-1 {
   /* stylelint-disable-line order/order */
   font-size: 0.875rem !important;
   /* stylelint-disable-line order/order */
   line-height: 1.71429 !important;
 }
 
 .u-text-fs-2 {
   /* stylelint-disable-line order/order */
   font-size: 0.8125rem !important;
   /* stylelint-disable-line order/order */
   line-height: 1.84615 !important;
 }
 
 .u-text-fs-3 {
   /* stylelint-disable-line order/order */
   font-size: 0.625rem !important;
   /* stylelint-disable-line order/order */
   line-height: 2.4 !important;
 }
 
 /* ------------------------------------*\
     #TEXT-TRANSFORM
 \*------------------------------------ */
 /**
  * The following classes will transform text into
  * uppercased, capitalized or lowercased characters.
  */
 .u-text-lowercase {
   text-transform: lowercase !important;
 }
 
 .u-text-uppercase {
   text-transform: uppercase !important;
 }
 
 .u-text-capitalize {
   text-transform: capitalize !important;
 }
 
 /* ------------------------------------*\
     #TEXT-TRUNCATE
 \*------------------------------------ */
 /**
  * A utility class to truncate text with "..." when content is wider than the available space.
  * Works only for single-line truncation
  */
 .u-text-truncate {
   display: inline-block;
   max-width: 100%;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
 }
 
 /* ------------------------------------*\
     #VISUALLY-HIDDEN
 \*------------------------------------ */
 /**
  * A utility class to hide elements visually
  * but keep the element text available to be announced by a screen reader.
  */
 .u-visually-hidden {
   position: absolute !important;
   /* stylelint-disable-line itcss/no-at-important */
   width: 1px !important;
   height: 1px !important;
   overflow: hidden !important;
   clip: rect(1px, 1px, 1px, 1px) !important;
 }
 
 /* ------------------------------------*\
    #WHITE-SPACE
 \*------------------------------------ */
 .u-ws-nowrap {
   white-space: nowrap !important;
 }
 
 /* ------------------------------------*\
     #WIDTHS
 \*------------------------------------ */
 /**
  * A series of widths helper classes that you can use to size things like grid
  * systems. Classes take a fraction-like format (e.g. `.u-2/3`).
  */
 .u-1\/1 {
   width: 100%;
 }
 
 .u-1\/2 {
   width: 50%;
 }
 
 .u-2\/2 {
   width: 100%;
 }
 
 .u-1\/3 {
   width: 33.33333%;
 }
 
 .u-2\/3 {
   width: 66.66667%;
 }
 
 .u-3\/3 {
   width: 100%;
 }
 
 .u-1\/4 {
   width: 25%;
 }
 
 .u-2\/4 {
   width: 50%;
 }
 
 .u-3\/4 {
   width: 75%;
 }
 
 .u-4\/4 {
   width: 100%;
 }
 
 .u-1\/5 {
   width: 20%;
 }
 
 .u-2\/5 {
   width: 40%;
 }
 
 .u-3\/5 {
   width: 60%;
 }
 
 .u-4\/5 {
   width: 80%;
 }
 
 .u-5\/5 {
   width: 100%;
 }
 
 .u-1\/6 {
   width: 16.66667%;
 }
 
 .u-2\/6 {
   width: 33.33333%;
 }
 
 .u-3\/6 {
   width: 50%;
 }
 
 .u-4\/6 {
   width: 66.66667%;
 }
 
 .u-5\/6 {
   width: 83.33333%;
 }
 
 .u-6\/6 {
   width: 100%;
 }
 
 .u-1\/12 {
   width: 8.33333%;
 }
 
 .u-2\/12 {
   width: 16.66667%;
 }
 
 .u-3\/12 {
   width: 25%;
 }
 
 .u-4\/12 {
   width: 33.33333%;
 }
 
 .u-5\/12 {
   width: 41.66667%;
 }
 
 .u-6\/12 {
   width: 50%;
 }
 
 .u-7\/12 {
   width: 58.33333%;
 }
 
 .u-8\/12 {
   width: 66.66667%;
 }
 
 .u-9\/12 {
   width: 75%;
 }
 
 .u-10\/12 {
   width: 83.33333%;
 }
 
 .u-11\/12 {
   width: 91.66667%;
 }
 
 .u-12\/12 {
   width: 100%;
 }
 
 @media (max-width: 1920px) {
   .u-1\/1\@xxl {
     width: 100%;
   }
   .u-1\/2\@xxl {
     width: 50%;
   }
   .u-2\/2\@xxl {
     width: 100%;
   }
   .u-1\/3\@xxl {
     width: 33.33333%;
   }
   .u-2\/3\@xxl {
     width: 66.66667%;
   }
   .u-3\/3\@xxl {
     width: 100%;
   }
   .u-1\/4\@xxl {
     width: 25%;
   }
   .u-2\/4\@xxl {
     width: 50%;
   }
   .u-3\/4\@xxl {
     width: 75%;
   }
   .u-4\/4\@xxl {
     width: 100%;
   }
   .u-1\/5\@xxl {
     width: 20%;
   }
   .u-2\/5\@xxl {
     width: 40%;
   }
   .u-3\/5\@xxl {
     width: 60%;
   }
   .u-4\/5\@xxl {
     width: 80%;
   }
   .u-5\/5\@xxl {
     width: 100%;
   }
   .u-1\/6\@xxl {
     width: 16.66667%;
   }
   .u-2\/6\@xxl {
     width: 33.33333%;
   }
   .u-3\/6\@xxl {
     width: 50%;
   }
   .u-4\/6\@xxl {
     width: 66.66667%;
   }
   .u-5\/6\@xxl {
     width: 83.33333%;
   }
   .u-6\/6\@xxl {
     width: 100%;
   }
   .u-1\/12\@xxl {
     width: 8.33333%;
   }
   .u-2\/12\@xxl {
     width: 16.66667%;
   }
   .u-3\/12\@xxl {
     width: 25%;
   }
   .u-4\/12\@xxl {
     width: 33.33333%;
   }
   .u-5\/12\@xxl {
     width: 41.66667%;
   }
   .u-6\/12\@xxl {
     width: 50%;
   }
   .u-7\/12\@xxl {
     width: 58.33333%;
   }
   .u-8\/12\@xxl {
     width: 66.66667%;
   }
   .u-9\/12\@xxl {
     width: 75%;
   }
   .u-10\/12\@xxl {
     width: 83.33333%;
   }
   .u-11\/12\@xxl {
     width: 91.66667%;
   }
   .u-12\/12\@xxl {
     width: 100%;
   }
 }
 
 @media (max-width: 1600px) {
   .u-1\/1\@xl {
     width: 100%;
   }
   .u-1\/2\@xl {
     width: 50%;
   }
   .u-2\/2\@xl {
     width: 100%;
   }
   .u-1\/3\@xl {
     width: 33.33333%;
   }
   .u-2\/3\@xl {
     width: 66.66667%;
   }
   .u-3\/3\@xl {
     width: 100%;
   }
   .u-1\/4\@xl {
     width: 25%;
   }
   .u-2\/4\@xl {
     width: 50%;
   }
   .u-3\/4\@xl {
     width: 75%;
   }
   .u-4\/4\@xl {
     width: 100%;
   }
   .u-1\/5\@xl {
     width: 20%;
   }
   .u-2\/5\@xl {
     width: 40%;
   }
   .u-3\/5\@xl {
     width: 60%;
   }
   .u-4\/5\@xl {
     width: 80%;
   }
   .u-5\/5\@xl {
     width: 100%;
   }
   .u-1\/6\@xl {
     width: 16.66667%;
   }
   .u-2\/6\@xl {
     width: 33.33333%;
   }
   .u-3\/6\@xl {
     width: 50%;
   }
   .u-4\/6\@xl {
     width: 66.66667%;
   }
   .u-5\/6\@xl {
     width: 83.33333%;
   }
   .u-6\/6\@xl {
     width: 100%;
   }
   .u-1\/12\@xl {
     width: 8.33333%;
   }
   .u-2\/12\@xl {
     width: 16.66667%;
   }
   .u-3\/12\@xl {
     width: 25%;
   }
   .u-4\/12\@xl {
     width: 33.33333%;
   }
   .u-5\/12\@xl {
     width: 41.66667%;
   }
   .u-6\/12\@xl {
     width: 50%;
   }
   .u-7\/12\@xl {
     width: 58.33333%;
   }
   .u-8\/12\@xl {
     width: 66.66667%;
   }
   .u-9\/12\@xl {
     width: 75%;
   }
   .u-10\/12\@xl {
     width: 83.33333%;
   }
   .u-11\/12\@xl {
     width: 91.66667%;
   }
   .u-12\/12\@xl {
     width: 100%;
   }
 }
 
 @media (max-width: 1280px) {
   .u-1\/1\@l {
     width: 100%;
   }
   .u-1\/2\@l {
     width: 50%;
   }
   .u-2\/2\@l {
     width: 100%;
   }
   .u-1\/3\@l {
     width: 33.33333%;
   }
   .u-2\/3\@l {
     width: 66.66667%;
   }
   .u-3\/3\@l {
     width: 100%;
   }
   .u-1\/4\@l {
     width: 25%;
   }
   .u-2\/4\@l {
     width: 50%;
   }
   .u-3\/4\@l {
     width: 75%;
   }
   .u-4\/4\@l {
     width: 100%;
   }
   .u-1\/5\@l {
     width: 20%;
   }
   .u-2\/5\@l {
     width: 40%;
   }
   .u-3\/5\@l {
     width: 60%;
   }
   .u-4\/5\@l {
     width: 80%;
   }
   .u-5\/5\@l {
     width: 100%;
   }
   .u-1\/6\@l {
     width: 16.66667%;
   }
   .u-2\/6\@l {
     width: 33.33333%;
   }
   .u-3\/6\@l {
     width: 50%;
   }
   .u-4\/6\@l {
     width: 66.66667%;
   }
   .u-5\/6\@l {
     width: 83.33333%;
   }
   .u-6\/6\@l {
     width: 100%;
   }
   .u-1\/12\@l {
     width: 8.33333%;
   }
   .u-2\/12\@l {
     width: 16.66667%;
   }
   .u-3\/12\@l {
     width: 25%;
   }
   .u-4\/12\@l {
     width: 33.33333%;
   }
   .u-5\/12\@l {
     width: 41.66667%;
   }
   .u-6\/12\@l {
     width: 50%;
   }
   .u-7\/12\@l {
     width: 58.33333%;
   }
   .u-8\/12\@l {
     width: 66.66667%;
   }
   .u-9\/12\@l {
     width: 75%;
   }
   .u-10\/12\@l {
     width: 83.33333%;
   }
   .u-11\/12\@l {
     width: 91.66667%;
   }
   .u-12\/12\@l {
     width: 100%;
   }
 }
 
 @media (max-width: 960px) {
   .u-1\/1\@m {
     width: 100%;
   }
   .u-1\/2\@m {
     width: 50%;
   }
   .u-2\/2\@m {
     width: 100%;
   }
   .u-1\/3\@m {
     width: 33.33333%;
   }
   .u-2\/3\@m {
     width: 66.66667%;
   }
   .u-3\/3\@m {
     width: 100%;
   }
   .u-1\/4\@m {
     width: 25%;
   }
   .u-2\/4\@m {
     width: 50%;
   }
   .u-3\/4\@m {
     width: 75%;
   }
   .u-4\/4\@m {
     width: 100%;
   }
   .u-1\/5\@m {
     width: 20%;
   }
   .u-2\/5\@m {
     width: 40%;
   }
   .u-3\/5\@m {
     width: 60%;
   }
   .u-4\/5\@m {
     width: 80%;
   }
   .u-5\/5\@m {
     width: 100%;
   }
   .u-1\/6\@m {
     width: 16.66667%;
   }
   .u-2\/6\@m {
     width: 33.33333%;
   }
   .u-3\/6\@m {
     width: 50%;
   }
   .u-4\/6\@m {
     width: 66.66667%;
   }
   .u-5\/6\@m {
     width: 83.33333%;
   }
   .u-6\/6\@m {
     width: 100%;
   }
   .u-1\/12\@m {
     width: 8.33333%;
   }
   .u-2\/12\@m {
     width: 16.66667%;
   }
   .u-3\/12\@m {
     width: 25%;
   }
   .u-4\/12\@m {
     width: 33.33333%;
   }
   .u-5\/12\@m {
     width: 41.66667%;
   }
   .u-6\/12\@m {
     width: 50%;
   }
   .u-7\/12\@m {
     width: 58.33333%;
   }
   .u-8\/12\@m {
     width: 66.66667%;
   }
   .u-9\/12\@m {
     width: 75%;
   }
   .u-10\/12\@m {
     width: 83.33333%;
   }
   .u-11\/12\@m {
     width: 91.66667%;
   }
   .u-12\/12\@m {
     width: 100%;
   }
 }
 
 @media (max-width: 720px) {
   .u-1\/1\@s {
     width: 100%;
   }
   .u-1\/2\@s {
     width: 50%;
   }
   .u-2\/2\@s {
     width: 100%;
   }
   .u-1\/3\@s {
     width: 33.33333%;
   }
   .u-2\/3\@s {
     width: 66.66667%;
   }
   .u-3\/3\@s {
     width: 100%;
   }
   .u-1\/4\@s {
     width: 25%;
   }
   .u-2\/4\@s {
     width: 50%;
   }
   .u-3\/4\@s {
     width: 75%;
   }
   .u-4\/4\@s {
     width: 100%;
   }
   .u-1\/5\@s {
     width: 20%;
   }
   .u-2\/5\@s {
     width: 40%;
   }
   .u-3\/5\@s {
     width: 60%;
   }
   .u-4\/5\@s {
     width: 80%;
   }
   .u-5\/5\@s {
     width: 100%;
   }
   .u-1\/6\@s {
     width: 16.66667%;
   }
   .u-2\/6\@s {
     width: 33.33333%;
   }
   .u-3\/6\@s {
     width: 50%;
   }
   .u-4\/6\@s {
     width: 66.66667%;
   }
   .u-5\/6\@s {
     width: 83.33333%;
   }
   .u-6\/6\@s {
     width: 100%;
   }
   .u-1\/12\@s {
     width: 8.33333%;
   }
   .u-2\/12\@s {
     width: 16.66667%;
   }
   .u-3\/12\@s {
     width: 25%;
   }
   .u-4\/12\@s {
     width: 33.33333%;
   }
   .u-5\/12\@s {
     width: 41.66667%;
   }
   .u-6\/12\@s {
     width: 50%;
   }
   .u-7\/12\@s {
     width: 58.33333%;
   }
   .u-8\/12\@s {
     width: 66.66667%;
   }
   .u-9\/12\@s {
     width: 75%;
   }
   .u-10\/12\@s {
     width: 83.33333%;
   }
   .u-11\/12\@s {
     width: 91.66667%;
   }
   .u-12\/12\@s {
     width: 100%;
   }
 }
 
 @media (max-width: 480px) {
   .u-1\/1\@xs {
     width: 100%;
   }
   .u-1\/2\@xs {
     width: 50%;
   }
   .u-2\/2\@xs {
     width: 100%;
   }
   .u-1\/3\@xs {
     width: 33.33333%;
   }
   .u-2\/3\@xs {
     width: 66.66667%;
   }
   .u-3\/3\@xs {
     width: 100%;
   }
   .u-1\/4\@xs {
     width: 25%;
   }
   .u-2\/4\@xs {
     width: 50%;
   }
   .u-3\/4\@xs {
     width: 75%;
   }
   .u-4\/4\@xs {
     width: 100%;
   }
   .u-1\/5\@xs {
     width: 20%;
   }
   .u-2\/5\@xs {
     width: 40%;
   }
   .u-3\/5\@xs {
     width: 60%;
   }
   .u-4\/5\@xs {
     width: 80%;
   }
   .u-5\/5\@xs {
     width: 100%;
   }
   .u-1\/6\@xs {
     width: 16.66667%;
   }
   .u-2\/6\@xs {
     width: 33.33333%;
   }
   .u-3\/6\@xs {
     width: 50%;
   }
   .u-4\/6\@xs {
     width: 66.66667%;
   }
   .u-5\/6\@xs {
     width: 83.33333%;
   }
   .u-6\/6\@xs {
     width: 100%;
   }
   .u-1\/12\@xs {
     width: 8.33333%;
   }
   .u-2\/12\@xs {
     width: 16.66667%;
   }
   .u-3\/12\@xs {
     width: 25%;
   }
   .u-4\/12\@xs {
     width: 33.33333%;
   }
   .u-5\/12\@xs {
     width: 41.66667%;
   }
   .u-6\/12\@xs {
     width: 50%;
   }
   .u-7\/12\@xs {
     width: 58.33333%;
   }
   .u-8\/12\@xs {
     width: 66.66667%;
   }
   .u-9\/12\@xs {
     width: 75%;
   }
   .u-10\/12\@xs {
     width: 83.33333%;
   }
   .u-11\/12\@xs {
     width: 91.66667%;
   }
   .u-12\/12\@xs {
     width: 100%;
   }
 }
 
 /* ------------------------------------*\
     #SPACING-ITEM
 \*------------------------------------ */
 .u-spacing-item-flush {
   padding-right: 0;
   padding-left: 0;
 }
 
 .u-spacing-item-flush:first-child {
   padding-top: 0;
 }
 
 .u-spacing-item-flush:last-child {
   padding-bottom: 0;
 }
 
 .u-spacing-item-flush-all.u-spacing-item-flush-all {
   padding: 0;
   /* [2] */
 }
 
 /* ------------------------------------*\
     #BACKGROUND-COLORS
 \*------------------------------------ */
 [data-theme="alternative"],
 .u-bg-alternative {
   background-color: #f2f2f2 !important;
 }
 
 [data-theme="brand"],
 .u-bg-brand {
   background-color: #1a1a1a !important;
 }
 
 [data-theme="white"],
 .u-bg-white {
   background-color: #ffffff !important;
 }
 
 /* ------------------------------------*\
     #TEXT-COLORS
 \*------------------------------------ */
 .u-text-base {
   color: #1a1a1a !important;
 }
 
 .u-text-muted {
   color: #495651 !important;
 }
 
 /* ------------------------------------*\
     #TEXT-COLORS
 \*------------------------------------ */
 .u-text-subtle {
   color: #495651 !important;
 }
 
 /* ------------------------------------*\
     #BLOCK-CENTER
 \*------------------------------------ */
 .u-block-center {
   margin-right: auto !important;
   margin-left: auto !important;
 }
 
 /* ------------------------------------*\
     #BASE-LINK
 \*------------------------------------ */
 /**
  * Makes it possible to style arbitrary elements and components as inline link.
  * [1] Reset all possible vendor button styles except focus styles.
  * [2] Add the shared link styles to the utility.
  * [3] Make sure to always inline the element.
  * [4] Reset submit input styles.
  */
 .u-base-link {
   padding: 0;
   border: 0;
   background-color: transparent;
   /* [1] */
   text-decoration: underline !important;
   color: inherit !important;
   cursor: pointer !important;
   /* [2] */
   /* [2] */
   display: inline !important;
   /* [3] */
 }
 
 .u-base-link:hover {
   /* [2] */
 }
 
 .u-base-link:focus {
   /* [2] */
 }
 
 .u-base-link:active {
   /* [2] */
 }
 
 .u-base-link[type="submit"] {
   -webkit-appearance: none;
   appearance: none;
   /* [4] */
   font-family: inherit;
   /* [4] */
 }
 
 /* ------------------------------------*\
     #HEADINGS
 \*------------------------------------ */
 /**
  * Headings 1â€“6's corresponding classes for double-stranded heading hierarchy:
  * https://csswizardry.com/2012/02/pragmatic-practical-font-sizing-in-css
  *
  * Use these helper classes to cause heading elements to adopt the font-size of
  * another respective heading level, e.g.:
  *
  * `<h3 class="u-h1">Semantic h3, looks like h1<h3>`
  *
  */
 .u-h1,
 .u-alpha {
   /* stylelint-disable-line order/order */
   font-size: 2.125rem !important;
   /* stylelint-disable-line order/order */
   line-height: 1.2 !important;
 }
 
 @media (min-width: 721px) {
   .u-h1,
   .u-alpha {
     /* stylelint-disable-line order/order */
     font-size: 3rem !important;
     /* stylelint-disable-line order/order */
     line-height: 1.2 !important;
   }
 }
 
 @media (min-width: 1921px) {
   .u-h1,
   .u-alpha {
     /* stylelint-disable-line order/order */
     font-size: 3.75rem !important;
     /* stylelint-disable-line order/order */
     line-height: 1.2 !important;
   }
 }
 
 .u-h2,
 .u-beta {
   /* stylelint-disable-line order/order */
   font-size: 1.875rem !important;
   /* stylelint-disable-line order/order */
   line-height: 1.2 !important;
 }
 
 @media (min-width: 721px) {
   .u-h2,
   .u-beta {
     /* stylelint-disable-line order/order */
     font-size: 2.25rem !important;
     /* stylelint-disable-line order/order */
     line-height: 1.2 !important;
   }
 }
 
 @media (min-width: 1921px) {
   .u-h2,
   .u-beta {
     /* stylelint-disable-line order/order */
     font-size: 3rem !important;
     /* stylelint-disable-line order/order */
     line-height: 1.2 !important;
   }
 }
 
 .u-h3,
 .u-gamma {
   /* stylelint-disable-line order/order */
   font-size: 1.625rem !important;
   /* stylelint-disable-line order/order */
   line-height: 1.2 !important;
 }
 
 @media (min-width: 721px) {
   .u-h3,
   .u-gamma {
     /* stylelint-disable-line order/order */
     font-size: 1.875rem !important;
     /* stylelint-disable-line order/order */
     line-height: 1.2 !important;
   }
 }
 
 @media (min-width: 1921px) {
   .u-h3,
   .u-gamma {
     /* stylelint-disable-line order/order */
     font-size: 2.25rem !important;
     /* stylelint-disable-line order/order */
     line-height: 1.2 !important;
   }
 }
 
 .u-h4,
 .u-delta {
   /* stylelint-disable-line order/order */
   font-size: 1.25rem !important;
   /* stylelint-disable-line order/order */
   line-height: 1.2 !important;
 }
 
 @media (min-width: 721px) {
   .u-h4,
   .u-delta {
     /* stylelint-disable-line order/order */
     font-size: 1.375rem !important;
     /* stylelint-disable-line order/order */
     line-height: 1.2 !important;
   }
 }
 
 @media (min-width: 1921px) {
   .u-h4,
   .u-delta {
     /* stylelint-disable-line order/order */
     font-size: 1.875rem !important;
     /* stylelint-disable-line order/order */
     line-height: 1.2 !important;
   }
 }
 
 .u-h5,
 .u-epsilon {
   /* stylelint-disable-line order/order */
   font-size: 1.25rem !important;
   /* stylelint-disable-line order/order */
   line-height: 1.2 !important;
 }
 
 @media (min-width: 721px) {
   .u-h5,
   .u-epsilon {
     /* stylelint-disable-line order/order */
     font-size: 1.375rem !important;
     /* stylelint-disable-line order/order */
     line-height: 1.2 !important;
   }
 }
 
 @media (min-width: 1921px) {
   .u-h5,
   .u-epsilon {
     /* stylelint-disable-line order/order */
     font-size: 1.875rem !important;
     /* stylelint-disable-line order/order */
     line-height: 1.2 !important;
   }
 }
 
 .u-h6,
 .u-zeta {
   /* stylelint-disable-line order/order */
   font-size: 1.125rem !important;
   /* stylelint-disable-line order/order */
   line-height: 1.2 !important;
 }
 
 @media (min-width: 721px) {
   .u-h6,
   .u-zeta {
     /* stylelint-disable-line order/order */
     font-size: 1.25rem !important;
     /* stylelint-disable-line order/order */
     line-height: 1.2 !important;
   }
 }
 
 @media (min-width: 1921px) {
   .u-h6,
   .u-zeta {
     /* stylelint-disable-line order/order */
     font-size: 1.75rem !important;
     /* stylelint-disable-line order/order */
     line-height: 1.2 !important;
   }
 }
 
 .u-h1,
 .u-alpha,
 .u-h2,
 .u-beta,
 .u-h3,
 .u-gamma,
 .u-h4,
 .u-delta,
 .u-h5,
 .u-epsilon,
 .u-h6,
 .u-zeta {
   display: block;
   /* stylelint-disable-next-line order/order */
   margin-bottom: 24px !important;
   font-weight: 300 !important;
   /**
    * [1] Check if a theme is set or if the default theme (null) is used.
    *     If the `default` theme is used we execute the already present logic,
    *     else we just return the content unwrapped.
    */
 }
 
 /* [1] */
 [data-theme="brand"] .u-h1,
 .u-bg-brand .u-h1, [data-theme="brand"]
 .u-alpha,
 .u-bg-brand
 .u-alpha, [data-theme="brand"]
 .u-h2,
 .u-bg-brand
 .u-h2, [data-theme="brand"]
 .u-beta,
 .u-bg-brand
 .u-beta, [data-theme="brand"]
 .u-h3,
 .u-bg-brand
 .u-h3, [data-theme="brand"]
 .u-gamma,
 .u-bg-brand
 .u-gamma, [data-theme="brand"]
 .u-h4,
 .u-bg-brand
 .u-h4, [data-theme="brand"]
 .u-delta,
 .u-bg-brand
 .u-delta, [data-theme="brand"]
 .u-h5,
 .u-bg-brand
 .u-h5, [data-theme="brand"]
 .u-epsilon,
 .u-bg-brand
 .u-epsilon, [data-theme="brand"]
 .u-h6,
 .u-bg-brand
 .u-h6, [data-theme="brand"]
 .u-zeta,
 .u-bg-brand
 .u-zeta {
   color: #ffffff !important;
 }
 
 /* ------------------------------------*\
     #SHAME
 \*------------------------------------ */
 /**
  * Hacky, nasty code. These bits have to be repaired!
  *
  * Guidelines:
  * - Ticket Reference
  * - Document why this fix is needed
  */
 /**
  * Custom icon size to match size and "complexity" with
  * (control) icons in context bar.
  * BRON-6475
  */
 .c-notification-center__toggle::after {
   font-size: 32px;
 }
 
 /**
  * Reset specificity for secondary buttons in
  * tables added for button theming.
  * @see https://jira.platform.vwfs.io/browse/BRON-6709
  */
 .c-table__btn.c-table__btn.c-table__btn {
   /* stylelint-disable */
   background-color: transparent !important;
   box-shadow: none !important;
   /* stylelint-enable */
 }
}